//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), s = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, c = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, l = (n, r, a) => (a = n == null ? {} : e(i(n)), c(r || !n || !n.__esModule ? t(a, "default", {
	value: n,
	enumerable: !0
}) : a, n)), u = /* @__PURE__ */ ((e) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(e, { get: (e, t) => (typeof require < "u" ? require : e)[t] }) : e)(function(e) {
	if (typeof require < "u") return require.apply(this, arguments);
	throw Error("Calling `require` for \"" + e + "\" in an environment that doesn't expose the `require` function. See https://rolldown.rs/in-depth/bundling-cjs#require-external-modules for more details.");
}), d = (/* @__PURE__ */ o(((e, t) => {
	(function(e, n) {
		typeof define == "function" && define.amd ? define(n) : typeof t == "object" && t.exports ? t.exports = n() : e.log = n();
	})(e, function() {
		var e = function() {}, t = "undefined", n = typeof window !== t && typeof window.navigator !== t && /Trident\/|MSIE /.test(window.navigator.userAgent), r = [
			"trace",
			"debug",
			"info",
			"warn",
			"error"
		], i = {}, a = null;
		function o(e, t) {
			var n = e[t];
			if (typeof n.bind == "function") return n.bind(e);
			try {
				return Function.prototype.bind.call(n, e);
			} catch {
				return function() {
					return Function.prototype.apply.apply(n, [e, arguments]);
				};
			}
		}
		function s() {
			console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
		}
		function c(r) {
			return r === "debug" && (r = "log"), typeof console === t ? !1 : r === "trace" && n ? s : console[r] === void 0 ? console.log === void 0 ? e : o(console, "log") : o(console, r);
		}
		function l() {
			for (var n = this.getLevel(), i = 0; i < r.length; i++) {
				var a = r[i];
				this[a] = i < n ? e : this.methodFactory(a, n, this.name);
			}
			if (this.log = this.debug, typeof console === t && n < this.levels.SILENT) return "No console available for logging";
		}
		function u(e) {
			return function() {
				typeof console !== t && (l.call(this), this[e].apply(this, arguments));
			};
		}
		function d(e, t, n) {
			return c(e) || u.apply(this, arguments);
		}
		function f(e, n) {
			var o = this, s, c, u, f = "loglevel";
			typeof e == "string" ? f += ":" + e : typeof e == "symbol" && (f = void 0);
			function p(e) {
				var n = (r[e] || "silent").toUpperCase();
				if (!(typeof window === t || !f)) {
					try {
						window.localStorage[f] = n;
						return;
					} catch {}
					try {
						window.document.cookie = encodeURIComponent(f) + "=" + n + ";";
					} catch {}
				}
			}
			function m() {
				var e;
				if (!(typeof window === t || !f)) {
					try {
						e = window.localStorage[f];
					} catch {}
					if (typeof e === t) try {
						var n = window.document.cookie, r = encodeURIComponent(f), i = n.indexOf(r + "=");
						i !== -1 && (e = /^([^;]+)/.exec(n.slice(i + r.length + 1))[1]);
					} catch {}
					return o.levels[e] === void 0 && (e = void 0), e;
				}
			}
			function h() {
				if (!(typeof window === t || !f)) {
					try {
						window.localStorage.removeItem(f);
					} catch {}
					try {
						window.document.cookie = encodeURIComponent(f) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
					} catch {}
				}
			}
			function g(e) {
				var t = e;
				if (typeof t == "string" && o.levels[t.toUpperCase()] !== void 0 && (t = o.levels[t.toUpperCase()]), typeof t == "number" && t >= 0 && t <= o.levels.SILENT) return t;
				throw TypeError("log.setLevel() called with invalid level: " + e);
			}
			o.name = e, o.levels = {
				TRACE: 0,
				DEBUG: 1,
				INFO: 2,
				WARN: 3,
				ERROR: 4,
				SILENT: 5
			}, o.methodFactory = n || d, o.getLevel = function() {
				return u ?? c ?? s;
			}, o.setLevel = function(e, t) {
				return u = g(e), t !== !1 && p(u), l.call(o);
			}, o.setDefaultLevel = function(e) {
				c = g(e), m() || o.setLevel(e, !1);
			}, o.resetLevel = function() {
				u = null, h(), l.call(o);
			}, o.enableAll = function(e) {
				o.setLevel(o.levels.TRACE, e);
			}, o.disableAll = function(e) {
				o.setLevel(o.levels.SILENT, e);
			}, o.rebuild = function() {
				if (a !== o && (s = g(a.getLevel())), l.call(o), a === o) for (var e in i) i[e].rebuild();
			}, s = g(a ? a.getLevel() : "WARN");
			var _ = m();
			_ != null && (u = g(_)), l.call(o);
		}
		a = new f(), a.getLogger = function(e) {
			if (typeof e != "symbol" && typeof e != "string" || e === "") throw TypeError("You must supply a name when creating a logger.");
			var t = i[e];
			return t ||= i[e] = new f(e, a.methodFactory), t;
		};
		var p = typeof window === t ? void 0 : window.log;
		return a.noConflict = function() {
			return typeof window !== t && window.log === a && (window.log = p), a;
		}, a.getLoggers = function() {
			return i;
		}, a.default = a, a;
	});
})))(), f = /* @__PURE__ */ function(e) {
	return e.CONNECTED = "CONNECTED", e.DISCONNECTED_FOREVER = "DISCONNECTED_FOREVER", e.INITIAL = "INITIAL", e.PINGING_SERVER = "PINGING_SERVER", e.CONNECTING = "CONNECTING", e.STATIC_CONNECTING = "STATIC_CONNECTING", e.STATIC_CONNECTED = "STATIC_CONNECTED", e;
}({}), p = "https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS", m = "_stcore/stream", h = "_stcore/health", g = "_stcore/host-config", _ = 2e3, v = !(typeof navigator > "u") && /Android/i.test(navigator.userAgent) ? 60 * 1e3 : 15 * 1e3, y = 15 * 1e3, b = !1, x = /* @__PURE__ */ o(((e, t) => {
	t.exports = n;
	function n(e, t) {
		for (var n = Array(arguments.length - 1), r = 0, i = 2, a = !0; i < arguments.length;) n[r++] = arguments[i++];
		return new Promise(function(i, o) {
			n[r] = function(e) {
				if (a) if (a = !1, e) o(e);
				else {
					for (var t = Array(arguments.length - 1), n = 0; n < t.length;) t[n++] = arguments[n];
					i.apply(null, t);
				}
			};
			try {
				e.apply(t || null, n);
			} catch (e) {
				a && (a = !1, o(e));
			}
		});
	}
})), S = /* @__PURE__ */ o(((e) => {
	var t = e;
	t.length = function(e) {
		var t = e.length;
		if (!t) return 0;
		for (; t > 0 && e.charAt(t - 1) === "=";) --t;
		return Math.floor(t * 3 / 4);
	};
	for (var n = Array(64), r = Array(123), i = 0; i < 64;) r[n[i] = i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i - 59 | 43] = i++;
	r[45] = 62, r[95] = 63, t.encode = function(e, t, r) {
		for (var i = null, a = [], o = 0, s = 0, c; t < r;) {
			var l = e[t++];
			switch (s) {
				case 0:
					a[o++] = n[l >> 2], c = (l & 3) << 4, s = 1;
					break;
				case 1:
					a[o++] = n[c | l >> 4], c = (l & 15) << 2, s = 2;
					break;
				case 2:
					a[o++] = n[c | l >> 6], a[o++] = n[l & 63], s = 0;
					break;
			}
			o > 8191 && ((i ||= []).push(String.fromCharCode.apply(String, a)), o = 0);
		}
		return s && (a[o++] = n[c], a[o++] = 61, s === 1 && (a[o++] = 61)), i ? (o && i.push(String.fromCharCode.apply(String, a.slice(0, o))), i.join("")) : String.fromCharCode.apply(String, a.slice(0, o));
	};
	var a = "invalid encoding";
	t.decode = function(e, t, n) {
		for (var i = n, o = 0, s, c = 0; c < e.length;) {
			var l = e.charCodeAt(c++);
			if (l === 61 && o > 1) break;
			if ((l = r[l]) === void 0) throw Error(a);
			switch (o) {
				case 0:
					s = l, o = 1;
					break;
				case 1:
					t[n++] = s << 2 | (l & 48) >> 4, s = l, o = 2;
					break;
				case 2:
					t[n++] = (s & 15) << 4 | (l & 60) >> 2, s = l, o = 3;
					break;
				case 3:
					t[n++] = (s & 3) << 6 | l, o = 0;
					break;
			}
		}
		if (o === 1) throw Error(a);
		return n - i;
	};
	var o = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/, s = /[-_]/, c = /^(?:[A-Za-z0-9_-]{4})*(?:[A-Za-z0-9_-]{2}(?:==)?|[A-Za-z0-9_-]{3}=?)?$/;
	t.test = function(e) {
		return o.test(e) || s.test(e) && c.test(e);
	};
})), C = /* @__PURE__ */ o(((e, t) => {
	t.exports = n;
	function n() {
		this._listeners = Object.create(null);
	}
	n.prototype.on = function(e, t, n) {
		return (this._listeners[e] || (this._listeners[e] = [])).push({
			fn: t,
			ctx: n || this
		}), this;
	}, n.prototype.off = function(e, t) {
		if (e === void 0) this._listeners = Object.create(null);
		else if (t === void 0) this._listeners[e] = [];
		else {
			var n = this._listeners[e];
			if (!n) return this;
			for (var r = 0; r < n.length;) n[r].fn === t ? n.splice(r, 1) : ++r;
		}
		return this;
	}, n.prototype.emit = function(e) {
		var t = this._listeners[e];
		if (t) {
			for (var n = [], r = 1; r < arguments.length;) n.push(arguments[r++]);
			for (r = 0; r < t.length;) t[r].fn.apply(t[r++].ctx, n);
		}
		return this;
	};
})), w = /* @__PURE__ */ o(((e, t) => {
	t.exports = n(n);
	function n(e) {
		return typeof Float32Array < "u" ? (function() {
			var t = new Float32Array([-0]), n = new Uint8Array(t.buffer), r = n[3] === 128;
			function i(e, r, i) {
				t[0] = e, r[i] = n[0], r[i + 1] = n[1], r[i + 2] = n[2], r[i + 3] = n[3];
			}
			function a(e, r, i) {
				t[0] = e, r[i] = n[3], r[i + 1] = n[2], r[i + 2] = n[1], r[i + 3] = n[0];
			}
			/* istanbul ignore next */
			e.writeFloatLE = r ? i : a, e.writeFloatBE = r ? a : i;
			function o(e, r) {
				return n[0] = e[r], n[1] = e[r + 1], n[2] = e[r + 2], n[3] = e[r + 3], t[0];
			}
			function s(e, r) {
				return n[3] = e[r], n[2] = e[r + 1], n[1] = e[r + 2], n[0] = e[r + 3], t[0];
			}
			/* istanbul ignore next */
			e.readFloatLE = r ? o : s, e.readFloatBE = r ? s : o;
		})() : (function() {
			function t(e, t, n, r) {
				var i = +(t < 0);
				if (i && (t = -t), t === 0) e(1 / t > 0 ? 0 : 2147483648, n, r);
				else if (isNaN(t)) e(2143289344, n, r);
				else if (t > 34028234663852886e22) e((i << 31 | 2139095040) >>> 0, n, r);
				else if (t < 11754943508222875e-54) e((i << 31 | Math.round(t / 1401298464324817e-60)) >>> 0, n, r);
				else {
					var a = Math.floor(Math.log(t) / Math.LN2), o = Math.round(t * 2 ** -a * 8388608) & 8388607;
					e((i << 31 | a + 127 << 23 | o) >>> 0, n, r);
				}
			}
			e.writeFloatLE = t.bind(null, r), e.writeFloatBE = t.bind(null, i);
			function n(e, t, n) {
				var r = e(t, n), i = (r >> 31) * 2 + 1, a = r >>> 23 & 255, o = r & 8388607;
				return a === 255 ? o ? NaN : i * Infinity : a === 0 ? i * 1401298464324817e-60 * o : i * 2 ** (a - 150) * (o + 8388608);
			}
			e.readFloatLE = n.bind(null, a), e.readFloatBE = n.bind(null, o);
		})(), typeof Float64Array < "u" ? (function() {
			var t = new Float64Array([-0]), n = new Uint8Array(t.buffer), r = n[7] === 128;
			function i(e, r, i) {
				t[0] = e, r[i] = n[0], r[i + 1] = n[1], r[i + 2] = n[2], r[i + 3] = n[3], r[i + 4] = n[4], r[i + 5] = n[5], r[i + 6] = n[6], r[i + 7] = n[7];
			}
			function a(e, r, i) {
				t[0] = e, r[i] = n[7], r[i + 1] = n[6], r[i + 2] = n[5], r[i + 3] = n[4], r[i + 4] = n[3], r[i + 5] = n[2], r[i + 6] = n[1], r[i + 7] = n[0];
			}
			/* istanbul ignore next */
			e.writeDoubleLE = r ? i : a, e.writeDoubleBE = r ? a : i;
			function o(e, r) {
				return n[0] = e[r], n[1] = e[r + 1], n[2] = e[r + 2], n[3] = e[r + 3], n[4] = e[r + 4], n[5] = e[r + 5], n[6] = e[r + 6], n[7] = e[r + 7], t[0];
			}
			function s(e, r) {
				return n[7] = e[r], n[6] = e[r + 1], n[5] = e[r + 2], n[4] = e[r + 3], n[3] = e[r + 4], n[2] = e[r + 5], n[1] = e[r + 6], n[0] = e[r + 7], t[0];
			}
			/* istanbul ignore next */
			e.readDoubleLE = r ? o : s, e.readDoubleBE = r ? s : o;
		})() : (function() {
			function t(e, t, n, r, i, a) {
				var o = +(r < 0);
				if (o && (r = -r), r === 0) e(0, i, a + t), e(1 / r > 0 ? 0 : 2147483648, i, a + n);
				else if (isNaN(r)) e(0, i, a + t), e(2146959360, i, a + n);
				else if (r > 17976931348623157e292) e(0, i, a + t), e((o << 31 | 2146435072) >>> 0, i, a + n);
				else {
					var s;
					if (r < 22250738585072014e-324) s = r / 5e-324, e(s >>> 0, i, a + t), e((o << 31 | s / 4294967296) >>> 0, i, a + n);
					else {
						var c = Math.floor(Math.log(r) / Math.LN2);
						c === 1024 && (c = 1023), s = r * 2 ** -c, e(s * 4503599627370496 >>> 0, i, a + t), e((o << 31 | c + 1023 << 20 | s * 1048576 & 1048575) >>> 0, i, a + n);
					}
				}
			}
			e.writeDoubleLE = t.bind(null, r, 0, 4), e.writeDoubleBE = t.bind(null, i, 4, 0);
			function n(e, t, n, r, i) {
				var a = e(r, i + t), o = e(r, i + n), s = (o >> 31) * 2 + 1, c = o >>> 20 & 2047, l = 4294967296 * (o & 1048575) + a;
				return c === 2047 ? l ? NaN : s * Infinity : c === 0 ? s * 5e-324 * l : s * 2 ** (c - 1075) * (l + 4503599627370496);
			}
			e.readDoubleLE = n.bind(null, a, 0, 4), e.readDoubleBE = n.bind(null, o, 4, 0);
		})(), e;
	}
	function r(e, t, n) {
		t[n] = e & 255, t[n + 1] = e >>> 8 & 255, t[n + 2] = e >>> 16 & 255, t[n + 3] = e >>> 24;
	}
	function i(e, t, n) {
		t[n] = e >>> 24, t[n + 1] = e >>> 16 & 255, t[n + 2] = e >>> 8 & 255, t[n + 3] = e & 255;
	}
	function a(e, t) {
		return (e[t] | e[t + 1] << 8 | e[t + 2] << 16 | e[t + 3] << 24) >>> 0;
	}
	function o(e, t) {
		return (e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3]) >>> 0;
	}
})), T = /* @__PURE__ */ o(((e, t) => {
	t.exports = n;
	function n(e) {
		try {
			if (typeof u != "function") return null;
			var t = u(e);
			return t && (t.length || Object.keys(t).length) ? t : null;
		} catch {
			return null;
		}
	}
})), E = /* @__PURE__ */ o(((e) => {
	var t = e, n = "�";
	t.length = function(e) {
		for (var t = 0, n = 0, r = 0; r < e.length; ++r) n = e.charCodeAt(r), n < 128 ? t += 1 : n < 2048 ? t += 2 : (n & 64512) == 55296 && (e.charCodeAt(r + 1) & 64512) == 56320 ? (++r, t += 4) : t += 3;
		return t;
	};
	function r(e, t, r, i) {
		for (var a = t; a < r;) {
			var o = e[a++];
			if (o <= 127) i += String.fromCharCode(o);
			else if (o >= 192 && o < 224) {
				var s = (o & 31) << 6 | e[a++] & 63;
				i += s >= 128 ? String.fromCharCode(s) : n;
			} else if (o >= 224 && o < 240) {
				var c = (o & 15) << 12 | (e[a++] & 63) << 6 | e[a++] & 63;
				i += c >= 2048 ? String.fromCharCode(c) : n;
			} else if (o >= 240) {
				var l = (o & 7) << 18 | (e[a++] & 63) << 12 | (e[a++] & 63) << 6 | e[a++] & 63;
				l < 65536 || l > 1114111 ? i += n : (l -= 65536, i += String.fromCharCode(55296 + (l >> 10)), i += String.fromCharCode(56320 + (l & 1023)));
			}
		}
		return i;
	}
	t.read = function(e, t, n) {
		if (n - t < 1) return "";
		for (var i = "", a = t, o, s, c, l, u, d, f, p; a + 7 < n; a += 8) {
			if (o = e[a], s = e[a + 1], c = e[a + 2], l = e[a + 3], u = e[a + 4], d = e[a + 5], f = e[a + 6], p = e[a + 7], (o | s | c | l | u | d | f | p) & 128) return r(e, a, n, i);
			i += String.fromCharCode(o, s, c, l, u, d, f, p);
		}
		for (; a < n; ++a) {
			if (o = e[a], o & 128) return r(e, a, n, i);
			i += String.fromCharCode(o);
		}
		return i;
	}, t.write = function(e, t, n) {
		for (var r = n, i, a, o = 0; o < e.length; ++o) i = e.charCodeAt(o), i < 128 ? t[n++] = i : i < 2048 ? (t[n++] = i >> 6 | 192, t[n++] = i & 63 | 128) : (i & 64512) == 55296 && ((a = e.charCodeAt(o + 1)) & 64512) == 56320 ? (i = 65536 + ((i & 1023) << 10) + (a & 1023), ++o, t[n++] = i >> 18 | 240, t[n++] = i >> 12 & 63 | 128, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128) : (t[n++] = i >> 12 | 224, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128);
		return n - r;
	};
})), D = /* @__PURE__ */ o(((e, t) => {
	t.exports = n;
	function n(e, t, n) {
		var r = n || 8192, i = r >>> 1, a = null, o = r;
		return function(n) {
			if (n < 1 || n > i) return e(n);
			o + n > r && (a = e(r), o = 0);
			var s = t.call(a, o, o += n);
			return o & 7 && (o = (o | 7) + 1), s;
		};
	}
})), ee = /* @__PURE__ */ o(((e, t) => {
	t.exports = r;
	var n = O();
	function r(e, t) {
		this.lo = e >>> 0, this.hi = t >>> 0;
	}
	var i = r.zero = new r(0, 0);
	i.toNumber = function() {
		return 0;
	}, i.zzEncode = i.zzDecode = function() {
		return this;
	}, i.length = function() {
		return 1;
	};
	var a = r.zeroHash = "\0\0\0\0\0\0\0\0";
	r.fromNumber = function(e) {
		if (e === 0) return i;
		var t = e < 0;
		t && (e = -e);
		var n = e >>> 0, a = (e - n) / 4294967296 >>> 0;
		return t && (a = ~a >>> 0, n = ~n >>> 0, ++n > 4294967295 && (n = 0, ++a > 4294967295 && (a = 0))), new r(n, a);
	}, r.from = function(e) {
		if (typeof e == "number") return r.fromNumber(e);
		if (n.isString(e))
 /* istanbul ignore else */
		if (n.Long) e = n.Long.fromString(e);
		else return r.fromNumber(parseInt(e, 10));
		return e.low || e.high ? new r(e.low >>> 0, e.high >>> 0) : i;
	}, r.prototype.toNumber = function(e) {
		if (!e && this.hi >>> 31) {
			var t = ~this.lo + 1 >>> 0, n = ~this.hi >>> 0;
			return t || (n = n + 1 >>> 0), -(t + n * 4294967296);
		}
		return this.lo + this.hi * 4294967296;
	}, r.prototype.toLong = function(e) {
		return n.Long ? new n.Long(this.lo | 0, this.hi | 0, !!e) : {
			low: this.lo | 0,
			high: this.hi | 0,
			unsigned: !!e
		};
	};
	var o = String.prototype.charCodeAt;
	r.fromHash = function(e) {
		return e === a ? i : new r((o.call(e, 0) | o.call(e, 1) << 8 | o.call(e, 2) << 16 | o.call(e, 3) << 24) >>> 0, (o.call(e, 4) | o.call(e, 5) << 8 | o.call(e, 6) << 16 | o.call(e, 7) << 24) >>> 0);
	}, r.prototype.toHash = function() {
		return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
	}, r.prototype.zzEncode = function() {
		var e = this.hi >> 31;
		return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ e) >>> 0, this.lo = (this.lo << 1 ^ e) >>> 0, this;
	}, r.prototype.zzDecode = function() {
		var e = -(this.lo & 1);
		return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ e) >>> 0, this.hi = (this.hi >>> 1 ^ e) >>> 0, this;
	}, r.prototype.length = function() {
		var e = this.lo, t = (this.lo >>> 28 | this.hi << 4) >>> 0, n = this.hi >>> 24;
		return n === 0 ? t === 0 ? e < 16384 ? e < 128 ? 1 : 2 : e < 2097152 ? 3 : 4 : t < 16384 ? t < 128 ? 5 : 6 : t < 2097152 ? 7 : 8 : n < 128 ? 9 : 10;
	};
})), te = /* @__PURE__ */ o(((e, t) => {
	(function(n, r) {
		function i(e) {
			return e.default || e;
		}
		typeof define == "function" && define.amd ? define([], function() {
			var e = {};
			return r(e), i(e);
		}) : typeof e == "object" ? (r(e), typeof t == "object" && (t.exports = i(e))) : (function() {
			var e = {};
			r(e), n.Long = i(e);
		})();
	})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : e, function(e) {
		Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
		var t = null;
		try {
			t = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
				0,
				97,
				115,
				109,
				1,
				0,
				0,
				0,
				1,
				13,
				2,
				96,
				0,
				1,
				127,
				96,
				4,
				127,
				127,
				127,
				127,
				1,
				127,
				3,
				7,
				6,
				0,
				1,
				1,
				1,
				1,
				1,
				6,
				6,
				1,
				127,
				1,
				65,
				0,
				11,
				7,
				50,
				6,
				3,
				109,
				117,
				108,
				0,
				1,
				5,
				100,
				105,
				118,
				95,
				115,
				0,
				2,
				5,
				100,
				105,
				118,
				95,
				117,
				0,
				3,
				5,
				114,
				101,
				109,
				95,
				115,
				0,
				4,
				5,
				114,
				101,
				109,
				95,
				117,
				0,
				5,
				8,
				103,
				101,
				116,
				95,
				104,
				105,
				103,
				104,
				0,
				0,
				10,
				191,
				1,
				6,
				4,
				0,
				35,
				0,
				11,
				36,
				1,
				1,
				126,
				32,
				0,
				173,
				32,
				1,
				173,
				66,
				32,
				134,
				132,
				32,
				2,
				173,
				32,
				3,
				173,
				66,
				32,
				134,
				132,
				126,
				34,
				4,
				66,
				32,
				135,
				167,
				36,
				0,
				32,
				4,
				167,
				11,
				36,
				1,
				1,
				126,
				32,
				0,
				173,
				32,
				1,
				173,
				66,
				32,
				134,
				132,
				32,
				2,
				173,
				32,
				3,
				173,
				66,
				32,
				134,
				132,
				127,
				34,
				4,
				66,
				32,
				135,
				167,
				36,
				0,
				32,
				4,
				167,
				11,
				36,
				1,
				1,
				126,
				32,
				0,
				173,
				32,
				1,
				173,
				66,
				32,
				134,
				132,
				32,
				2,
				173,
				32,
				3,
				173,
				66,
				32,
				134,
				132,
				128,
				34,
				4,
				66,
				32,
				135,
				167,
				36,
				0,
				32,
				4,
				167,
				11,
				36,
				1,
				1,
				126,
				32,
				0,
				173,
				32,
				1,
				173,
				66,
				32,
				134,
				132,
				32,
				2,
				173,
				32,
				3,
				173,
				66,
				32,
				134,
				132,
				129,
				34,
				4,
				66,
				32,
				135,
				167,
				36,
				0,
				32,
				4,
				167,
				11,
				36,
				1,
				1,
				126,
				32,
				0,
				173,
				32,
				1,
				173,
				66,
				32,
				134,
				132,
				32,
				2,
				173,
				32,
				3,
				173,
				66,
				32,
				134,
				132,
				130,
				34,
				4,
				66,
				32,
				135,
				167,
				36,
				0,
				32,
				4,
				167,
				11
			])), {}).exports;
		} catch {}
		function n(e, t, n) {
			this.low = e | 0, this.high = t | 0, this.unsigned = !!n;
		}
		n.prototype.__isLong__, Object.defineProperty(n.prototype, "__isLong__", { value: !0 });
		function r(e) {
			return (e && e.__isLong__) === !0;
		}
		function i(e) {
			var t = Math.clz32(e & -e);
			return e ? 31 - t : t;
		}
		n.isLong = r;
		var a = {}, o = {};
		function s(e, t) {
			var n, r, i;
			return t ? (e >>>= 0, (i = 0 <= e && e < 256) && (r = o[e], r) ? r : (n = l(e, 0, !0), i && (o[e] = n), n)) : (e |= 0, (i = -128 <= e && e < 128) && (r = a[e], r) ? r : (n = l(e, e < 0 ? -1 : 0, !1), i && (a[e] = n), n));
		}
		n.fromInt = s;
		function c(e, t) {
			if (isNaN(e)) return t ? b : y;
			if (t) {
				if (e < 0) return b;
				if (e >= g) return T;
			} else {
				if (e <= -_) return E;
				if (e + 1 >= _) return w;
			}
			return e < 0 ? c(-e, t).neg() : l(e % h | 0, e / h | 0, t);
		}
		n.fromNumber = c;
		function l(e, t, r) {
			return new n(e, t, r);
		}
		n.fromBits = l;
		var u = Math.pow;
		function d(e, t, n) {
			if (e.length === 0) throw Error("empty string");
			if (typeof t == "number" ? (n = t, t = !1) : t = !!t, e === "NaN" || e === "Infinity" || e === "+Infinity" || e === "-Infinity") return t ? b : y;
			if (n ||= 10, n < 2 || 36 < n) throw RangeError("radix");
			var r;
			if ((r = e.indexOf("-")) > 0) throw Error("interior hyphen");
			if (r === 0) return d(e.substring(1), t, n).neg();
			for (var i = c(u(n, 8)), a = y, o = 0; o < e.length; o += 8) {
				var s = Math.min(8, e.length - o), l = parseInt(e.substring(o, o + s), n);
				if (s < 8) {
					var f = c(u(n, s));
					a = a.mul(f).add(c(l));
				} else a = a.mul(i), a = a.add(c(l));
			}
			return a.unsigned = t, a;
		}
		n.fromString = d;
		function f(e, t) {
			return typeof e == "number" ? c(e, t) : typeof e == "string" ? d(e, t) : l(e.low, e.high, typeof t == "boolean" ? t : e.unsigned);
		}
		n.fromValue = f;
		var p = 65536, m = 1 << 24, h = p * p, g = h * h, _ = g / 2, v = s(m), y = s(0);
		n.ZERO = y;
		var b = s(0, !0);
		n.UZERO = b;
		var x = s(1);
		n.ONE = x;
		var S = s(1, !0);
		n.UONE = S;
		var C = s(-1);
		n.NEG_ONE = C;
		var w = l(-1, 2147483647, !1);
		n.MAX_VALUE = w;
		var T = l(-1, -1, !0);
		n.MAX_UNSIGNED_VALUE = T;
		var E = l(0, -2147483648, !1);
		n.MIN_VALUE = E;
		var D = n.prototype;
		D.toInt = function() {
			return this.unsigned ? this.low >>> 0 : this.low;
		}, D.toNumber = function() {
			return this.unsigned ? (this.high >>> 0) * h + (this.low >>> 0) : this.high * h + (this.low >>> 0);
		}, D.toString = function(e) {
			if (e ||= 10, e < 2 || 36 < e) throw RangeError("radix");
			if (this.isZero()) return "0";
			if (this.isNegative()) if (this.eq(E)) {
				var t = c(e), n = this.div(t), r = n.mul(t).sub(this);
				return n.toString(e) + r.toInt().toString(e);
			} else return "-" + this.neg().toString(e);
			for (var i = c(u(e, 6), this.unsigned), a = this, o = "";;) {
				var s = a.div(i), l = (a.sub(s.mul(i)).toInt() >>> 0).toString(e);
				if (a = s, a.isZero()) return l + o;
				for (; l.length < 6;) l = "0" + l;
				o = "" + l + o;
			}
		}, D.getHighBits = function() {
			return this.high;
		}, D.getHighBitsUnsigned = function() {
			return this.high >>> 0;
		}, D.getLowBits = function() {
			return this.low;
		}, D.getLowBitsUnsigned = function() {
			return this.low >>> 0;
		}, D.getNumBitsAbs = function() {
			if (this.isNegative()) return this.eq(E) ? 64 : this.neg().getNumBitsAbs();
			for (var e = this.high == 0 ? this.low : this.high, t = 31; t > 0 && !(e & 1 << t); t--);
			return this.high == 0 ? t + 1 : t + 33;
		}, D.isSafeInteger = function() {
			var e = this.high >> 21;
			return e ? this.unsigned ? !1 : e === -1 && !(this.low === 0 && this.high === -2097152) : !0;
		}, D.isZero = function() {
			return this.high === 0 && this.low === 0;
		}, D.eqz = D.isZero, D.isNegative = function() {
			return !this.unsigned && this.high < 0;
		}, D.isPositive = function() {
			return this.unsigned || this.high >= 0;
		}, D.isOdd = function() {
			return (this.low & 1) == 1;
		}, D.isEven = function() {
			return (this.low & 1) == 0;
		}, D.equals = function(e) {
			return r(e) || (e = f(e)), this.unsigned !== e.unsigned && this.high >>> 31 == 1 && e.high >>> 31 == 1 ? !1 : this.high === e.high && this.low === e.low;
		}, D.eq = D.equals, D.notEquals = function(e) {
			return !this.eq(e);
		}, D.neq = D.notEquals, D.ne = D.notEquals, D.lessThan = function(e) {
			return this.comp(e) < 0;
		}, D.lt = D.lessThan, D.lessThanOrEqual = function(e) {
			return this.comp(e) <= 0;
		}, D.lte = D.lessThanOrEqual, D.le = D.lessThanOrEqual, D.greaterThan = function(e) {
			return this.comp(e) > 0;
		}, D.gt = D.greaterThan, D.greaterThanOrEqual = function(e) {
			return this.comp(e) >= 0;
		}, D.gte = D.greaterThanOrEqual, D.ge = D.greaterThanOrEqual, D.compare = function(e) {
			if (r(e) || (e = f(e)), this.eq(e)) return 0;
			var t = this.isNegative(), n = e.isNegative();
			return t && !n ? -1 : !t && n ? 1 : this.unsigned ? e.high >>> 0 > this.high >>> 0 || e.high === this.high && e.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(e).isNegative() ? -1 : 1;
		}, D.comp = D.compare, D.negate = function() {
			return !this.unsigned && this.eq(E) ? E : this.not().add(x);
		}, D.neg = D.negate, D.add = function(e) {
			r(e) || (e = f(e));
			var t = this.high >>> 16, n = this.high & 65535, i = this.low >>> 16, a = this.low & 65535, o = e.high >>> 16, s = e.high & 65535, c = e.low >>> 16, u = e.low & 65535, d = 0, p = 0, m = 0, h = 0;
			return h += a + u, m += h >>> 16, h &= 65535, m += i + c, p += m >>> 16, m &= 65535, p += n + s, d += p >>> 16, p &= 65535, d += t + o, d &= 65535, l(m << 16 | h, d << 16 | p, this.unsigned);
		}, D.subtract = function(e) {
			return r(e) || (e = f(e)), this.add(e.neg());
		}, D.sub = D.subtract, D.multiply = function(e) {
			if (this.isZero()) return this;
			if (r(e) || (e = f(e)), t) return l(t.mul(this.low, this.high, e.low, e.high), t.get_high(), this.unsigned);
			if (e.isZero()) return this.unsigned ? b : y;
			if (this.eq(E)) return e.isOdd() ? E : y;
			if (e.eq(E)) return this.isOdd() ? E : y;
			if (this.isNegative()) return e.isNegative() ? this.neg().mul(e.neg()) : this.neg().mul(e).neg();
			if (e.isNegative()) return this.mul(e.neg()).neg();
			if (this.lt(v) && e.lt(v)) return c(this.toNumber() * e.toNumber(), this.unsigned);
			var n = this.high >>> 16, i = this.high & 65535, a = this.low >>> 16, o = this.low & 65535, s = e.high >>> 16, u = e.high & 65535, d = e.low >>> 16, p = e.low & 65535, m = 0, h = 0, g = 0, _ = 0;
			return _ += o * p, g += _ >>> 16, _ &= 65535, g += a * p, h += g >>> 16, g &= 65535, g += o * d, h += g >>> 16, g &= 65535, h += i * p, m += h >>> 16, h &= 65535, h += a * d, m += h >>> 16, h &= 65535, h += o * u, m += h >>> 16, h &= 65535, m += n * p + i * d + a * u + o * s, m &= 65535, l(g << 16 | _, m << 16 | h, this.unsigned);
		}, D.mul = D.multiply, D.divide = function(e) {
			if (r(e) || (e = f(e)), e.isZero()) throw Error("division by zero");
			if (t) return !this.unsigned && this.high === -2147483648 && e.low === -1 && e.high === -1 ? this : l((this.unsigned ? t.div_u : t.div_s)(this.low, this.high, e.low, e.high), t.get_high(), this.unsigned);
			if (this.isZero()) return this.unsigned ? b : y;
			var n, i, a;
			if (this.unsigned) {
				if (e.unsigned || (e = e.toUnsigned()), e.gt(this)) return b;
				if (e.gt(this.shru(1))) return S;
				a = b;
			} else {
				if (this.eq(E)) return e.eq(x) || e.eq(C) ? E : e.eq(E) ? x : (n = this.shr(1).div(e).shl(1), n.eq(y) ? e.isNegative() ? x : C : (i = this.sub(e.mul(n)), a = n.add(i.div(e)), a));
				if (e.eq(E)) return this.unsigned ? b : y;
				if (this.isNegative()) return e.isNegative() ? this.neg().div(e.neg()) : this.neg().div(e).neg();
				if (e.isNegative()) return this.div(e.neg()).neg();
				a = y;
			}
			for (i = this; i.gte(e);) {
				n = Math.max(1, Math.floor(i.toNumber() / e.toNumber()));
				for (var o = Math.ceil(Math.log(n) / Math.LN2), s = o <= 48 ? 1 : u(2, o - 48), d = c(n), p = d.mul(e); p.isNegative() || p.gt(i);) n -= s, d = c(n, this.unsigned), p = d.mul(e);
				d.isZero() && (d = x), a = a.add(d), i = i.sub(p);
			}
			return a;
		}, D.div = D.divide, D.modulo = function(e) {
			return r(e) || (e = f(e)), t ? l((this.unsigned ? t.rem_u : t.rem_s)(this.low, this.high, e.low, e.high), t.get_high(), this.unsigned) : this.sub(this.div(e).mul(e));
		}, D.mod = D.modulo, D.rem = D.modulo, D.not = function() {
			return l(~this.low, ~this.high, this.unsigned);
		}, D.countLeadingZeros = function() {
			return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
		}, D.clz = D.countLeadingZeros, D.countTrailingZeros = function() {
			return this.low ? i(this.low) : i(this.high) + 32;
		}, D.ctz = D.countTrailingZeros, D.and = function(e) {
			return r(e) || (e = f(e)), l(this.low & e.low, this.high & e.high, this.unsigned);
		}, D.or = function(e) {
			return r(e) || (e = f(e)), l(this.low | e.low, this.high | e.high, this.unsigned);
		}, D.xor = function(e) {
			return r(e) || (e = f(e)), l(this.low ^ e.low, this.high ^ e.high, this.unsigned);
		}, D.shiftLeft = function(e) {
			return r(e) && (e = e.toInt()), (e &= 63) == 0 ? this : e < 32 ? l(this.low << e, this.high << e | this.low >>> 32 - e, this.unsigned) : l(0, this.low << e - 32, this.unsigned);
		}, D.shl = D.shiftLeft, D.shiftRight = function(e) {
			return r(e) && (e = e.toInt()), (e &= 63) == 0 ? this : e < 32 ? l(this.low >>> e | this.high << 32 - e, this.high >> e, this.unsigned) : l(this.high >> e - 32, this.high >= 0 ? 0 : -1, this.unsigned);
		}, D.shr = D.shiftRight, D.shiftRightUnsigned = function(e) {
			return r(e) && (e = e.toInt()), (e &= 63) == 0 ? this : e < 32 ? l(this.low >>> e | this.high << 32 - e, this.high >>> e, this.unsigned) : l(e === 32 ? this.high : this.high >>> e - 32, 0, this.unsigned);
		}, D.shru = D.shiftRightUnsigned, D.shr_u = D.shiftRightUnsigned, D.rotateLeft = function(e) {
			var t;
			return r(e) && (e = e.toInt()), (e &= 63) == 0 ? this : e === 32 ? l(this.high, this.low, this.unsigned) : e < 32 ? (t = 32 - e, l(this.low << e | this.high >>> t, this.high << e | this.low >>> t, this.unsigned)) : (e -= 32, t = 32 - e, l(this.high << e | this.low >>> t, this.low << e | this.high >>> t, this.unsigned));
		}, D.rotl = D.rotateLeft, D.rotateRight = function(e) {
			var t;
			return r(e) && (e = e.toInt()), (e &= 63) == 0 ? this : e === 32 ? l(this.high, this.low, this.unsigned) : e < 32 ? (t = 32 - e, l(this.high << t | this.low >>> e, this.low << t | this.high >>> e, this.unsigned)) : (e -= 32, t = 32 - e, l(this.low << t | this.high >>> e, this.high << t | this.low >>> e, this.unsigned));
		}, D.rotr = D.rotateRight, D.toSigned = function() {
			return this.unsigned ? l(this.low, this.high, !1) : this;
		}, D.toUnsigned = function() {
			return this.unsigned ? this : l(this.low, this.high, !0);
		}, D.toBytes = function(e) {
			return e ? this.toBytesLE() : this.toBytesBE();
		}, D.toBytesLE = function() {
			var e = this.high, t = this.low;
			return [
				t & 255,
				t >>> 8 & 255,
				t >>> 16 & 255,
				t >>> 24,
				e & 255,
				e >>> 8 & 255,
				e >>> 16 & 255,
				e >>> 24
			];
		}, D.toBytesBE = function() {
			var e = this.high, t = this.low;
			return [
				e >>> 24,
				e >>> 16 & 255,
				e >>> 8 & 255,
				e & 255,
				t >>> 24,
				t >>> 16 & 255,
				t >>> 8 & 255,
				t & 255
			];
		}, n.fromBytes = function(e, t, r) {
			return r ? n.fromBytesLE(e, t) : n.fromBytesBE(e, t);
		}, n.fromBytesLE = function(e, t) {
			return new n(e[0] | e[1] << 8 | e[2] << 16 | e[3] << 24, e[4] | e[5] << 8 | e[6] << 16 | e[7] << 24, t);
		}, n.fromBytesBE = function(e, t) {
			return new n(e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7], e[0] << 24 | e[1] << 16 | e[2] << 8 | e[3], t);
		}, typeof BigInt == "function" && (n.fromBigInt = function(e, t) {
			return l(Number(BigInt.asIntN(32, e)), Number(BigInt.asIntN(32, e >> BigInt(32))), t);
		}, n.fromValue = function(e, t) {
			return typeof e == "bigint" ? n.fromBigInt(e, t) : f(e, t);
		}, D.toBigInt = function() {
			var e = BigInt(this.low >>> 0);
			return BigInt(this.unsigned ? this.high >>> 0 : this.high) << BigInt(32) | e;
		}), e.default = n;
	});
})), O = /* @__PURE__ */ o(((e) => {
	var t = e;
	t.asPromise = x(), t.base64 = S(), t.EventEmitter = C(), t.float = w(), t.inquire = T(), t.utf8 = E(), t.pool = D(), t.LongBits = ee();
	function n(e) {
		return e === "__proto__" || e === "prototype" || e === "constructor";
	}
	t.isUnsafeProperty = n, t.isNode = !!(typeof global < "u" && global && global.process && global.process.versions && global.process.versions.node), t.global = t.isNode && global || typeof window < "u" && window || typeof self < "u" && self || e, t.emptyArray = Object.freeze ? Object.freeze([]) : 	/* istanbul ignore next */ [], t.emptyObject = Object.freeze ? Object.freeze({}) : 	/* istanbul ignore next */ {}, t.isInteger = Number.isInteger || function(e) {
		return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
	}, t.isString = function(e) {
		return typeof e == "string" || e instanceof String;
	}, t.isObject = function(e) {
		return e && typeof e == "object";
	}, t.isset = t.isSet = function(e, t) {
		var n = e[t];
		return n != null && e.hasOwnProperty(t) ? typeof n != "object" || (Array.isArray(n) ? n.length : Object.keys(n).length) > 0 : !1;
	}, t.Buffer = (function() {
		try {
			var e = t.global.Buffer;
			return e.prototype.utf8Write ? e : 			/* istanbul ignore next */ null;
		} catch {
			/* istanbul ignore next */
			return null;
		}
	})(), t._Buffer_from = null, t._Buffer_allocUnsafe = null, t.newBuffer = function(e) {
		/* istanbul ignore next */
		return typeof e == "number" ? t.Buffer ? t._Buffer_allocUnsafe(e) : new t.Array(e) : t.Buffer ? t._Buffer_from(e) : typeof Uint8Array > "u" ? e : new Uint8Array(e);
	}, t.Array = typeof Uint8Array < "u" ? Uint8Array : Array, t.Long = t.global.dcodeIO && t.global.dcodeIO.Long || t.global.Long || (function() {
		try {
			var e = te();
			return e && e.isLong ? e : null;
		} catch {
			/* istanbul ignore next */
			return null;
		}
	})(), t.key2Re = /^(?:true|false|0|1)$/, t.key32Re = /^-?(?:0|[1-9][0-9]*)$/, t.key64Re = /^(?:[\x00-\xff]{8}|-?(?:0|[1-9][0-9]*))$/, t.longToHash = function(e) {
		return e ? t.LongBits.from(e).toHash() : t.LongBits.zeroHash;
	}, t.longFromHash = function(e, n) {
		var r = t.LongBits.fromHash(e);
		return t.Long ? t.Long.fromBits(r.lo, r.hi, n) : r.toNumber(!!n);
	}, t.longFromKey = function(e, n) {
		return t.key64Re.test(e) && !t.key32Re.test(e) ? t.longFromHash(e, n) : e;
	}, t.boolFromKey = function(e) {
		return e === "true" || e === "1";
	};
	function r(e) {
		var t = typeof arguments[arguments.length - 1] == "boolean", r = t ? arguments.length - 1 : arguments.length;
		t &&= arguments[arguments.length - 1];
		for (var i = 1; i < r; ++i) {
			var a = arguments[i];
			if (a) for (var o = Object.keys(a), s = 0; s < o.length; ++s) !n(o[s]) && (e[o[s]] === void 0 || !t) && (e[o[s]] = a[o[s]]);
		}
		return e;
	}
	t.merge = r, t.nestingLimit = 32, t.recursionLimit = 100, t.makeProp = function(e, t, n) {
		Object.prototype.hasOwnProperty.call(e, t) || Object.defineProperty(e, t, {
			enumerable: n === void 0 ? !0 : n,
			configurable: !0,
			writable: !0
		});
	}, t.lcFirst = function(e) {
		return e.charAt(0).toLowerCase() + e.substring(1);
	};
	function i(e) {
		function t(e, n) {
			if (!(this instanceof t)) return new t(e, n);
			Object.defineProperty(this, "message", { get: function() {
				return e;
			} }), Error.captureStackTrace ? Error.captureStackTrace(this, t) : Object.defineProperty(this, "stack", { value: (/* @__PURE__ */ Error()).stack || "" }), n && r(this, n);
		}
		return t.prototype = Object.create(Error.prototype, {
			constructor: {
				value: t,
				writable: !0,
				enumerable: !1,
				configurable: !0
			},
			name: {
				get: function() {
					return e;
				},
				set: void 0,
				enumerable: !1,
				configurable: !0
			},
			toString: {
				value: function() {
					return this.name + ": " + this.message;
				},
				writable: !0,
				enumerable: !1,
				configurable: !0
			}
		}), t;
	}
	t.newError = i, t.ProtocolError = i("ProtocolError"), t.oneOfGetter = function(e) {
		for (var t = {}, n = 0; n < e.length; ++n) t[e[n]] = 1;
		return function() {
			for (var e = Object.keys(this), n = e.length - 1; n > -1; --n) if (t[e[n]] === 1 && this[e[n]] !== void 0 && this[e[n]] !== null) return e[n];
		};
	}, t.oneOfSetter = function(e) {
		return function(t) {
			for (var n = 0; n < e.length; ++n) e[n] !== t && delete this[e[n]];
		};
	}, t.toJSONOptions = {
		longs: String,
		enums: String,
		bytes: String,
		json: !0
	}, t._configure = function() {
		var e = t.Buffer;
		/* istanbul ignore if */
		if (!e) {
			t._Buffer_from = t._Buffer_allocUnsafe = null;
			return;
		}
		t._Buffer_from = e.from !== Uint8Array.from && e.from || function(t, n) {
			return new e(t, n);
		}, t._Buffer_allocUnsafe = e.allocUnsafe || function(t) {
			return new e(t);
		};
	};
})), ne = /* @__PURE__ */ o(((e, t) => {
	t.exports = u;
	var n = O(), r, i = n.LongBits, a = n.base64, o = n.utf8;
	function s(e, t, n) {
		this.fn = e, this.len = t, this.next = void 0, this.val = n;
	}
	/* istanbul ignore next */
	function c() {}
	function l(e) {
		this.head = e.head, this.tail = e.tail, this.len = e.len, this.next = e.states;
	}
	function u() {
		this.len = 0, this.head = new s(c, 0, 0), this.tail = this.head, this.states = null;
	}
	var d = function() {
		return n.Buffer ? function() {
			return (u.create = function() {
				return new r();
			})();
		} : function() {
			return new u();
		};
	};
	u.create = d(), u.alloc = function(e) {
		return new n.Array(e);
	}, n.Array !== Array && (u.alloc = n.pool(u.alloc, n.Array.prototype.subarray)), u.prototype._push = function(e, t, n) {
		return this.tail = this.tail.next = new s(e, t, n), this.len += t, this;
	};
	function f(e, t, n) {
		t[n] = e & 255;
	}
	function p(e, t, n) {
		for (var r = 0; r < e.length;) t[n++] = e.charCodeAt(r++);
	}
	function m(e, t, n) {
		for (; e > 127;) t[n++] = e & 127 | 128, e >>>= 7;
		t[n] = e;
	}
	function h(e, t) {
		this.len = e, this.next = void 0, this.val = t;
	}
	h.prototype = Object.create(s.prototype), h.prototype.fn = m, u.prototype.uint32 = function(e) {
		return this.len += (this.tail = this.tail.next = new h((e >>>= 0) < 128 ? 1 : e < 16384 ? 2 : e < 2097152 ? 3 : e < 268435456 ? 4 : 5, e)).len, this;
	}, u.prototype.int32 = function(e) {
		return (e |= 0) < 0 ? this._push(g, 10, i.fromNumber(e)) : this.uint32(e);
	}, u.prototype.sint32 = function(e) {
		return this.uint32((e << 1 ^ e >> 31) >>> 0);
	};
	function g(e, t, n) {
		for (var r = e.lo, i = e.hi; i;) t[n++] = r & 127 | 128, r = (r >>> 7 | i << 25) >>> 0, i >>>= 7;
		for (; r > 127;) t[n++] = r & 127 | 128, r >>>= 7;
		t[n++] = r;
	}
	u.prototype.uint64 = function(e) {
		var t = i.from(e);
		return this._push(g, t.length(), t);
	}, u.prototype.int64 = u.prototype.uint64, u.prototype.sint64 = function(e) {
		var t = i.from(e).zzEncode();
		return this._push(g, t.length(), t);
	}, u.prototype.bool = function(e) {
		return this._push(f, 1, +!!e);
	};
	function _(e, t, n) {
		t[n] = e & 255, t[n + 1] = e >>> 8 & 255, t[n + 2] = e >>> 16 & 255, t[n + 3] = e >>> 24;
	}
	u.prototype.fixed32 = function(e) {
		return this._push(_, 4, e >>> 0);
	}, u.prototype.sfixed32 = u.prototype.fixed32, u.prototype.fixed64 = function(e) {
		var t = i.from(e);
		return this._push(_, 4, t.lo)._push(_, 4, t.hi);
	}, u.prototype.sfixed64 = u.prototype.fixed64, u.prototype.float = function(e) {
		return this._push(n.float.writeFloatLE, 4, e);
	}, u.prototype.double = function(e) {
		return this._push(n.float.writeDoubleLE, 8, e);
	};
	var v = n.Array.prototype.set ? function(e, t, n) {
		t.set(e, n);
	} : function(e, t, n) {
		for (var r = 0; r < e.length; ++r) t[n + r] = e[r];
	};
	u.prototype.bytes = function(e) {
		var t = e.length >>> 0;
		if (!t) return this._push(f, 1, 0);
		if (n.isString(e)) {
			var r = u.alloc(t = a.length(e));
			a.decode(e, r, 0), e = r;
		}
		return this.uint32(t)._push(v, t, e);
	}, u.prototype.raw = function(e) {
		var t = e.length >>> 0;
		return t ? this._push(v, t, e) : this;
	}, u.prototype.string = function(e) {
		var t = o.length(e);
		return t ? this.uint32(t)._push(t === e.length ? p : o.write, t, e) : this._push(f, 1, 0);
	}, u.prototype.fork = function() {
		return this.states = new l(this), this.head = this.tail = new s(c, 0, 0), this.len = 0, this;
	}, u.prototype.reset = function() {
		return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new s(c, 0, 0), this.len = 0), this;
	}, u.prototype.ldelim = function() {
		var e = this.head, t = this.tail, n = this.len;
		return this.reset().uint32(n), n && (this.tail.next = e.next, this.tail = t, this.len += n), this;
	}, u.prototype.finish = function() {
		return this.finishInto(this.constructor.alloc(this.len), 0);
	}, u.prototype.finishInto = function(e, t) {
		t === void 0 && (t = 0);
		for (var n = this.head.next, r = t; n;) n.fn(n.val, e, r), r += n.len, n = n.next;
		return e;
	}, u._configure = function(e) {
		r = e, u.create = d(), r._configure();
	};
})), re = /* @__PURE__ */ o(((e, t) => {
	t.exports = i;
	var n = ne();
	(i.prototype = Object.create(n.prototype)).constructor = i;
	var r = O();
	function i() {
		n.call(this);
	}
	i._configure = function() {
		i.alloc = r._Buffer_allocUnsafe, i.writeBytesBuffer = r.Buffer && r.Buffer.prototype instanceof Uint8Array && r.Buffer.prototype.set.name === "set" ? function(e, t, n) {
			t.set(e, n);
		} : function(e, t, n) {
			if (e.copy) e.copy(t, n, 0, e.length);
			else for (var r = 0; r < e.length;) t[n++] = e[r++];
		};
	}, i.prototype.bytes = function(e) {
		r.isString(e) && (e = r._Buffer_from(e, "base64"));
		var t = e.length >>> 0;
		return this.uint32(t), t && this._push(i.writeBytesBuffer, t, e), this;
	}, i.prototype.raw = function(e) {
		var t = e.length >>> 0;
		return t ? this._push(i.writeBytesBuffer, t, e) : this;
	};
	function a(e, t, n) {
		for (var r = 0; r < e.length;) t[n++] = e.charCodeAt(r++);
	}
	function o(e, t, n) {
		e.length < 40 ? r.utf8.write(e, t, n) : t.utf8Write ? t.utf8Write(e, n) : t.write(e, n);
	}
	i.prototype.string = function(e) {
		var t = r.Buffer.byteLength(e);
		return this.uint32(t), t && this._push(t === e.length && t < 40 ? a : o, t, e), this;
	}, i._configure();
})), ie = /* @__PURE__ */ o(((e, t) => {
	t.exports = s;
	var n = O(), r, i = n.LongBits, a = n.utf8;
	/* istanbul ignore next */
	function o(e, t) {
		return RangeError("index out of range: " + e.pos + " + " + (t || 1) + " > " + e.len);
	}
	function s(e) {
		this.buf = e, this.pos = 0, this.len = e.length;
	}
	var c = typeof Uint8Array < "u" ? function(e) {
		if (e instanceof Uint8Array || Array.isArray(e)) return new s(e);
		throw Error("illegal buffer");
	} : function(e) {
		if (Array.isArray(e)) return new s(e);
		throw Error("illegal buffer");
	}, l = function() {
		return n.Buffer ? function(e) {
			return (s.create = function(e) {
				return n.Buffer.isBuffer(e) ? new r(e) : c(e);
			})(e);
		} : c;
	};
	s.create = l(), s.prototype._slice = n.Array.prototype.subarray || n.Array.prototype.slice, s.prototype.raw = function(e, t) {
		return Array.isArray(this.buf) ? this.buf.slice(e, t) : e === t ? new this.buf.constructor(0) : this._slice.call(this.buf, e, t);
	}, s.prototype.uint32 = function() {
		var e = this.buf, t = this.pos, n = (e[t] & 127) >>> 0;
		if (e[t++] < 128 || (n = (n | (e[t] & 127) << 7) >>> 0, e[t++] < 128) || (n = (n | (e[t] & 127) << 14) >>> 0, e[t++] < 128) || (n = (n | (e[t] & 127) << 21) >>> 0, e[t++] < 128) || (n = (n | (e[t] & 15) << 28) >>> 0, e[t++] < 128)) return this.pos = t, n;
		for (var r = 0; r < 5; ++r) {
			/* istanbul ignore if */
			if (t >= this.len) throw this.pos = t, o(this);
			if (e[t++] < 128) return this.pos = t, n;
		}
		throw this.pos = t, Error("invalid varint encoding");
	}, s.prototype.tag = function() {
		var e = this.buf, t = this.pos, n = (e[t] & 127) >>> 0;
		if (e[t++] < 128 || (n = (n | (e[t] & 127) << 7) >>> 0, e[t++] < 128) || (n = (n | (e[t] & 127) << 14) >>> 0, e[t++] < 128) || (n = (n | (e[t] & 127) << 21) >>> 0, e[t++] < 128)) return this.pos = t, n;
		if (n = (n | (e[t] & 15) << 28) >>> 0, e[t] < 128 && !(e[t] & 112)) return this.pos = t + 1, n;
		throw this.pos = t + 1, Error("invalid tag encoding");
	}, s.prototype.int32 = function() {
		return this.uint32() | 0;
	}, s.prototype.sint32 = function() {
		var e = this.uint32();
		return e >>> 1 ^ -(e & 1) | 0;
	};
	function u() {
		var e = new i(0, 0), t = 0;
		if (this.len - this.pos > 4) {
			for (; t < 4; ++t) if (e.lo = (e.lo | (this.buf[this.pos] & 127) << t * 7) >>> 0, this.buf[this.pos++] < 128) return e;
			if (e.lo = (e.lo | (this.buf[this.pos] & 127) << 28) >>> 0, e.hi = (e.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128) return e;
			t = 0;
		} else {
			for (; t < 3; ++t) {
				/* istanbul ignore if */
				if (this.pos >= this.len) throw o(this);
				if (e.lo = (e.lo | (this.buf[this.pos] & 127) << t * 7) >>> 0, this.buf[this.pos++] < 128) return e;
			}
			return e.lo = (e.lo | (this.buf[this.pos++] & 127) << t * 7) >>> 0, e;
		}
		if (this.len - this.pos > 4) {
			for (; t < 5; ++t) if (e.hi = (e.hi | (this.buf[this.pos] & 127) << t * 7 + 3) >>> 0, this.buf[this.pos++] < 128) return e;
		} else for (; t < 5; ++t) {
			/* istanbul ignore if */
			if (this.pos >= this.len) throw o(this);
			if (e.hi = (e.hi | (this.buf[this.pos] & 127) << t * 7 + 3) >>> 0, this.buf[this.pos++] < 128) return e;
		}
		/* istanbul ignore next */
		throw Error("invalid varint encoding");
	}
	s.prototype.bool = function() {
		for (var e = !1, t, n = 0; n < 10; ++n) {
			/* istanbul ignore if */
			if (this.pos >= this.len) throw o(this);
			if (t = this.buf[this.pos++], t & 127 && (e = !0), t < 128) return e;
		}
		/* istanbul ignore next */
		throw Error("invalid varint encoding");
	};
	function d(e, t) {
		return (e[t - 4] | e[t - 3] << 8 | e[t - 2] << 16 | e[t - 1] << 24) >>> 0;
	}
	s.prototype.fixed32 = function() {
		/* istanbul ignore if */
		if (this.pos + 4 > this.len) throw o(this, 4);
		return d(this.buf, this.pos += 4);
	}, s.prototype.sfixed32 = function() {
		/* istanbul ignore if */
		if (this.pos + 4 > this.len) throw o(this, 4);
		return d(this.buf, this.pos += 4) | 0;
	};
	function f() {
		/* istanbul ignore if */
		if (this.pos + 8 > this.len) throw o(this, 8);
		return new i(d(this.buf, this.pos += 4), d(this.buf, this.pos += 4));
	}
	s.prototype.float = function() {
		/* istanbul ignore if */
		if (this.pos + 4 > this.len) throw o(this, 4);
		var e = n.float.readFloatLE(this.buf, this.pos);
		return this.pos += 4, e;
	}, s.prototype.double = function() {
		/* istanbul ignore if */
		if (this.pos + 8 > this.len) throw o(this, 4);
		var e = n.float.readDoubleLE(this.buf, this.pos);
		return this.pos += 8, e;
	}, s.prototype.bytes = function() {
		var e = this.uint32(), t = this.pos, n = this.pos + e;
		/* istanbul ignore if */
		if (n > this.len) throw o(this, e);
		return this.pos = n, this.raw(t, n);
	}, s.prototype.string = function() {
		var e = this.uint32(), t = this.pos, n = this.pos + e;
		/* istanbul ignore if */
		if (n > this.len) throw o(this, e);
		return this.pos = n, a.read(this.buf, t, n);
	}, s.prototype.skip = function(e) {
		if (typeof e == "number") {
			/* istanbul ignore if */
			if (this.pos + e > this.len) throw o(this, e);
			this.pos += e;
		} else do
			/* istanbul ignore if */
			if (this.pos >= this.len) throw o(this);
		while (this.buf[this.pos++] & 128);
		return this;
	}, s.recursionLimit = n.recursionLimit, s.prototype.skipType = function(e, t, n) {
		if (t === void 0 && (t = 0), t > s.recursionLimit) throw Error("max depth exceeded");
		if (n === 0) throw Error("illegal tag: field number 0");
		switch (e) {
			case 0:
				this.skip();
				break;
			case 1:
				this.skip(8);
				break;
			case 2:
				this.skip(this.uint32());
				break;
			case 3:
				for (;;) {
					var r = this.tag(), i = r >>> 3;
					if (e = r & 7, !i) throw Error("illegal tag: field number 0");
					if (e === 4) {
						if (n !== void 0 && i !== n) throw Error("invalid end group tag");
						break;
					}
					this.skipType(e, t + 1, i);
				}
				break;
			case 5:
				this.skip(4);
				break;
			/* istanbul ignore next */
			default: throw Error("invalid wire type " + e + " at offset " + this.pos);
		}
		return this;
	}, s._configure = function(e) {
		r = e, s.create = l(), r._configure();
		var t = n.Long ? "toLong" : 		/* istanbul ignore next */ "toNumber";
		n.merge(s.prototype, {
			int64: function() {
				return u.call(this)[t](!1);
			},
			uint64: function() {
				return u.call(this)[t](!0);
			},
			sint64: function() {
				return u.call(this).zzDecode()[t](!1);
			},
			fixed64: function() {
				return f.call(this)[t](!0);
			},
			sfixed64: function() {
				return f.call(this)[t](!1);
			}
		});
	};
})), ae = /* @__PURE__ */ o(((e, t) => {
	t.exports = i;
	var n = ie();
	(i.prototype = Object.create(n.prototype)).constructor = i;
	var r = O();
	function i(e) {
		n.call(this, e);
	}
	i._configure = function() {
		/* istanbul ignore else */
		r.Buffer && (i.prototype._slice = r.Buffer.prototype.slice);
	}, i.prototype.raw = function(e, t) {
		return e === t ? r.Buffer.alloc(0) : this._slice.call(this.buf, e, t);
	}, i.prototype.string = function() {
		var e = this.uint32(), t = this.pos, n = this.pos + e;
		/* istanbul ignore if */
		if (n > this.len) throw RangeError("index out of range: " + this.pos + " + " + e + " > " + this.len);
		return this.pos = n, this.buf.utf8Slice ? this.buf.utf8Slice(t, n) : this.buf.toString("utf-8", t, n);
	}, i._configure();
})), oe = /* @__PURE__ */ o(((e, t) => {
	t.exports = r;
	var n = O();
	(r.prototype = Object.create(n.EventEmitter.prototype)).constructor = r;
	function r(e, t, r) {
		if (typeof e != "function") throw TypeError("rpcImpl must be a function");
		n.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = !!t, this.responseDelimited = !!r;
	}
	r.prototype.rpcCall = function e(t, r, i, a, o) {
		if (!a) throw TypeError("request must be specified");
		var s = this;
		if (!o) return n.asPromise(e, s, t, r, i, a);
		if (!s.rpcImpl) {
			setTimeout(function() {
				o(Error("already ended"));
			}, 0);
			return;
		}
		try {
			return s.rpcImpl(t, r[s.requestDelimited ? "encodeDelimited" : "encode"](a).finish(), function(e, n) {
				if (e) return s.emit("error", e, t), o(e);
				if (n === null) {
					s.end(!0);
					return;
				}
				if (!(n instanceof i)) try {
					n = i[s.responseDelimited ? "decodeDelimited" : "decode"](n);
				} catch (e) {
					return s.emit("error", e, t), o(e);
				}
				return s.emit("data", n, t), o(null, n);
			});
		} catch (e) {
			s.emit("error", e, t), setTimeout(function() {
				o(e);
			}, 0);
			return;
		}
	}, r.prototype.end = function(e) {
		return this.rpcImpl && (e || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
	};
})), se = /* @__PURE__ */ o(((e) => {
	var t = e;
	t.Service = oe();
})), ce = /* @__PURE__ */ o(((e, t) => {
	t.exports = {};
})), le = /* @__PURE__ */ o(((e) => {
	var t = e;
	t.build = "minimal", t.Writer = ne(), t.BufferWriter = re(), t.Reader = ie(), t.BufferReader = ae(), t.util = O(), t.rpc = se(), t.roots = ce(), t.configure = n;
	/* istanbul ignore next */
	function n() {
		t.util._configure(), t.Writer._configure(t.BufferWriter), t.Reader._configure(t.BufferReader);
	}
	n();
})), k = /* @__PURE__ */ l((/* @__PURE__ */ o(((e, t) => {
	t.exports = le();
})))(), 1), A = k.default.Reader, j = k.default.Writer, M = k.default.util, N = k.default.roots.default || (k.default.roots.default = {});
N.Alert = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.body = "", e.prototype.format = 0, e.prototype.icon = "", e.prototype.widthConfig = null, e.prototype.title = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.body != null && Object.hasOwnProperty.call(e, "body") && t.uint32(10).string(e.body), e.format != null && Object.hasOwnProperty.call(e, "format") && t.uint32(16).int32(e.format), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(26).string(e.icon), e.widthConfig != null && Object.hasOwnProperty.call(e, "widthConfig") && N.streamlit.WidthConfig.encode(e.widthConfig, t.uint32(34).fork(), n + 1).ldelim(), e.title != null && Object.hasOwnProperty.call(e, "title") && t.uint32(42).string(e.title), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Alert(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.body = s : delete o.body;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.int32()) ? o.format = s : delete o.format;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.icon = s : delete o.icon;
					continue;
				case 4:
					if (a !== 2) break;
					o.widthConfig = N.streamlit.WidthConfig.decode(e, e.uint32(), void 0, r + 1, o.widthConfig);
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.title = s : delete o.title;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Alert) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Alert();
		if (e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = String(e.body)), e.format !== 0 && (typeof e.format != "string" || N.Alert.Format[e.format] !== 0)) switch (e.format) {
			default:
				if (typeof e.format == "number") {
					n.format = e.format;
					break;
				}
				break;
			case "UNUSED":
			case 0:
				n.format = 0;
				break;
			case "ERROR":
			case 1:
				n.format = 1;
				break;
			case "WARNING":
			case 2:
				n.format = 2;
				break;
			case "INFO":
			case 3:
				n.format = 3;
				break;
			case "SUCCESS":
			case 4:
				n.format = 4;
				break;
		}
		if (e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = String(e.icon)), e.widthConfig != null) {
			if (typeof e.widthConfig != "object") throw TypeError(".Alert.widthConfig: object expected");
			n.widthConfig = N.streamlit.WidthConfig.fromObject(e.widthConfig, t + 1);
		}
		return e.title != null && (typeof e.title != "string" || e.title.length) && (n.title = String(e.title)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.body = "", r.format = t.enums === String ? "UNUSED" : 0, r.icon = "", r.widthConfig = null, r.title = ""), e.body != null && e.hasOwnProperty("body") && (r.body = e.body), e.format != null && e.hasOwnProperty("format") && (r.format = t.enums === String ? N.Alert.Format[e.format] === void 0 ? e.format : N.Alert.Format[e.format] : e.format), e.icon != null && e.hasOwnProperty("icon") && (r.icon = e.icon), e.widthConfig != null && e.hasOwnProperty("widthConfig") && (r.widthConfig = N.streamlit.WidthConfig.toObject(e.widthConfig, t, n + 1)), e.title != null && e.hasOwnProperty("title") && (r.title = e.title), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Alert";
	}, e.Format = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "UNUSED"] = 0, t[e[1] = "ERROR"] = 1, t[e[2] = "WARNING"] = 2, t[e[3] = "INFO"] = 3, t[e[4] = "SUCCESS"] = 4, t;
	})(), e;
})(), N.streamlit = (() => {
	let e = {};
	return e.WidthConfig = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.useStretch = null, e.prototype.useContent = null, e.prototype.pixelWidth = null, e.prototype.remWidth = null;
		let t;
		return Object.defineProperty(e.prototype, "widthSpec", {
			get: M.oneOfGetter(t = [
				"useStretch",
				"useContent",
				"pixelWidth",
				"remWidth"
			]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.useStretch != null && Object.hasOwnProperty.call(e, "useStretch") && t.uint32(8).bool(e.useStretch), e.useContent != null && Object.hasOwnProperty.call(e, "useContent") && t.uint32(16).bool(e.useContent), e.pixelWidth != null && Object.hasOwnProperty.call(e, "pixelWidth") && t.uint32(24).uint32(e.pixelWidth), e.remWidth != null && Object.hasOwnProperty.call(e, "remWidth") && t.uint32(37).float(e.remWidth), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.streamlit.WidthConfig();
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						o.useStretch = e.bool(), o.widthSpec = "useStretch";
						continue;
					case 2:
						if (a !== 0) break;
						o.useContent = e.bool(), o.widthSpec = "useContent";
						continue;
					case 3:
						if (a !== 0) break;
						o.pixelWidth = e.uint32(), o.widthSpec = "pixelWidth";
						continue;
					case 4:
						if (a !== 5) break;
						o.remWidth = e.float(), o.widthSpec = "remWidth";
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.streamlit.WidthConfig) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.streamlit.WidthConfig();
			return e.useStretch != null && (n.useStretch = !!e.useStretch), e.useContent != null && (n.useContent = !!e.useContent), e.pixelWidth != null && (n.pixelWidth = e.pixelWidth >>> 0), e.remWidth != null && (n.remWidth = Number(e.remWidth)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return e.useStretch != null && e.hasOwnProperty("useStretch") && (r.useStretch = e.useStretch, t.oneofs && (r.widthSpec = "useStretch")), e.useContent != null && e.hasOwnProperty("useContent") && (r.useContent = e.useContent, t.oneofs && (r.widthSpec = "useContent")), e.pixelWidth != null && e.hasOwnProperty("pixelWidth") && (r.pixelWidth = e.pixelWidth, t.oneofs && (r.widthSpec = "pixelWidth")), e.remWidth != null && e.hasOwnProperty("remWidth") && (r.remWidth = t.json && !isFinite(e.remWidth) ? String(e.remWidth) : e.remWidth, t.oneofs && (r.widthSpec = "remWidth")), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/streamlit.WidthConfig";
		}, e;
	})(), e.GapSize = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "GAP_UNDEFINED"] = 0, t[e[1] = "SMALL"] = 1, t[e[2] = "MEDIUM"] = 2, t[e[3] = "LARGE"] = 3, t[e[4] = "NONE"] = 4, t[e[5] = "XXSMALL"] = 5, t[e[6] = "XSMALL"] = 6, t[e[7] = "XLARGE"] = 7, t[e[8] = "XXLARGE"] = 8, t;
	})(), e.GapConfig = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.gapSize = null;
		let t;
		return Object.defineProperty(e.prototype, "gapSpec", {
			get: M.oneOfGetter(t = ["gapSize"]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.gapSize != null && Object.hasOwnProperty.call(e, "gapSize") && t.uint32(8).int32(e.gapSize), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.streamlit.GapConfig();
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						o.gapSize = e.int32(), o.gapSpec = "gapSize";
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.streamlit.GapConfig) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.streamlit.GapConfig();
			switch (e.gapSize) {
				default:
					if (typeof e.gapSize == "number") {
						n.gapSize = e.gapSize;
						break;
					}
					break;
				case "GAP_UNDEFINED":
				case 0:
					n.gapSize = 0;
					break;
				case "SMALL":
				case 1:
					n.gapSize = 1;
					break;
				case "MEDIUM":
				case 2:
					n.gapSize = 2;
					break;
				case "LARGE":
				case 3:
					n.gapSize = 3;
					break;
				case "NONE":
				case 4:
					n.gapSize = 4;
					break;
				case "XXSMALL":
				case 5:
					n.gapSize = 5;
					break;
				case "XSMALL":
				case 6:
					n.gapSize = 6;
					break;
				case "XLARGE":
				case 7:
					n.gapSize = 7;
					break;
				case "XXLARGE":
				case 8:
					n.gapSize = 8;
					break;
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return e.gapSize != null && e.hasOwnProperty("gapSize") && (r.gapSize = t.enums === String ? N.streamlit.GapSize[e.gapSize] === void 0 ? e.gapSize : N.streamlit.GapSize[e.gapSize] : e.gapSize, t.oneofs && (r.gapSpec = "gapSize")), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/streamlit.GapConfig";
		}, e;
	})(), e.HeightConfig = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.useStretch = null, e.prototype.useContent = null, e.prototype.pixelHeight = null, e.prototype.remHeight = null;
		let t;
		return Object.defineProperty(e.prototype, "heightSpec", {
			get: M.oneOfGetter(t = [
				"useStretch",
				"useContent",
				"pixelHeight",
				"remHeight"
			]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.useStretch != null && Object.hasOwnProperty.call(e, "useStretch") && t.uint32(8).bool(e.useStretch), e.useContent != null && Object.hasOwnProperty.call(e, "useContent") && t.uint32(16).bool(e.useContent), e.pixelHeight != null && Object.hasOwnProperty.call(e, "pixelHeight") && t.uint32(24).uint32(e.pixelHeight), e.remHeight != null && Object.hasOwnProperty.call(e, "remHeight") && t.uint32(37).float(e.remHeight), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.streamlit.HeightConfig();
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						o.useStretch = e.bool(), o.heightSpec = "useStretch";
						continue;
					case 2:
						if (a !== 0) break;
						o.useContent = e.bool(), o.heightSpec = "useContent";
						continue;
					case 3:
						if (a !== 0) break;
						o.pixelHeight = e.uint32(), o.heightSpec = "pixelHeight";
						continue;
					case 4:
						if (a !== 5) break;
						o.remHeight = e.float(), o.heightSpec = "remHeight";
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.streamlit.HeightConfig) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.streamlit.HeightConfig();
			return e.useStretch != null && (n.useStretch = !!e.useStretch), e.useContent != null && (n.useContent = !!e.useContent), e.pixelHeight != null && (n.pixelHeight = e.pixelHeight >>> 0), e.remHeight != null && (n.remHeight = Number(e.remHeight)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return e.useStretch != null && e.hasOwnProperty("useStretch") && (r.useStretch = e.useStretch, t.oneofs && (r.heightSpec = "useStretch")), e.useContent != null && e.hasOwnProperty("useContent") && (r.useContent = e.useContent, t.oneofs && (r.heightSpec = "useContent")), e.pixelHeight != null && e.hasOwnProperty("pixelHeight") && (r.pixelHeight = e.pixelHeight, t.oneofs && (r.heightSpec = "pixelHeight")), e.remHeight != null && e.hasOwnProperty("remHeight") && (r.remHeight = t.json && !isFinite(e.remHeight) ? String(e.remHeight) : e.remHeight, t.oneofs && (r.heightSpec = "remHeight")), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/streamlit.HeightConfig";
		}, e;
	})(), e.ButtonLikeIconPosition = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "LEFT"] = 0, t[e[1] = "RIGHT"] = 1, t;
	})(), e.SelectWidgetFilterMode = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "FILTER_MODE_FUZZY"] = 0, t[e[1] = "FILTER_MODE_CONTAINS"] = 1, t[e[2] = "FILTER_MODE_PREFIX"] = 2, t[e[3] = "FILTER_MODE_NONE"] = 3, t;
	})(), e.TextAlignmentConfig = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.alignment = 0, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.alignment != null && Object.hasOwnProperty.call(e, "alignment") && t.uint32(8).int32(e.alignment), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.streamlit.TextAlignmentConfig(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						(s = e.int32()) ? o.alignment = s : delete o.alignment;
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.streamlit.TextAlignmentConfig) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.streamlit.TextAlignmentConfig();
			if (e.alignment !== 0 && (typeof e.alignment != "string" || N.streamlit.TextAlignmentConfig.Alignment[e.alignment] !== 0)) switch (e.alignment) {
				default:
					if (typeof e.alignment == "number") {
						n.alignment = e.alignment;
						break;
					}
					break;
				case "UNSPECIFIED":
				case 0:
					n.alignment = 0;
					break;
				case "LEFT":
				case 1:
					n.alignment = 1;
					break;
				case "CENTER":
				case 2:
					n.alignment = 2;
					break;
				case "RIGHT":
				case 3:
					n.alignment = 3;
					break;
				case "JUSTIFY":
				case 4:
					n.alignment = 4;
					break;
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.alignment = t.enums === String ? "UNSPECIFIED" : 0), e.alignment != null && e.hasOwnProperty("alignment") && (r.alignment = t.enums === String ? N.streamlit.TextAlignmentConfig.Alignment[e.alignment] === void 0 ? e.alignment : N.streamlit.TextAlignmentConfig.Alignment[e.alignment] : e.alignment), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/streamlit.TextAlignmentConfig";
		}, e.Alignment = (function() {
			let e = {}, t = Object.create(e);
			return t[e[0] = "UNSPECIFIED"] = 0, t[e[1] = "LEFT"] = 1, t[e[2] = "CENTER"] = 2, t[e[3] = "RIGHT"] = 3, t[e[4] = "JUSTIFY"] = 4, t;
		})(), e;
	})(), e;
})(), N.AppPage = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.pageScriptHash = "", e.prototype.pageName = "", e.prototype.icon = "", e.prototype.isDefault = !1, e.prototype.sectionHeader = "", e.prototype.urlPathname = "", e.prototype.isHidden = !1, e.prototype.externalUrl = null;
	let t;
	return Object.defineProperty(e.prototype, "_externalUrl", {
		get: M.oneOfGetter(t = ["externalUrl"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.pageScriptHash != null && Object.hasOwnProperty.call(e, "pageScriptHash") && t.uint32(10).string(e.pageScriptHash), e.pageName != null && Object.hasOwnProperty.call(e, "pageName") && t.uint32(18).string(e.pageName), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(26).string(e.icon), e.isDefault != null && Object.hasOwnProperty.call(e, "isDefault") && t.uint32(32).bool(e.isDefault), e.sectionHeader != null && Object.hasOwnProperty.call(e, "sectionHeader") && t.uint32(42).string(e.sectionHeader), e.urlPathname != null && Object.hasOwnProperty.call(e, "urlPathname") && t.uint32(50).string(e.urlPathname), e.isHidden != null && Object.hasOwnProperty.call(e, "isHidden") && t.uint32(56).bool(e.isHidden), e.externalUrl != null && Object.hasOwnProperty.call(e, "externalUrl") && t.uint32(66).string(e.externalUrl), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.AppPage(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.pageScriptHash = s : delete o.pageScriptHash;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.pageName = s : delete o.pageName;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.icon = s : delete o.icon;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.isDefault = s : delete o.isDefault;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.sectionHeader = s : delete o.sectionHeader;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.urlPathname = s : delete o.urlPathname;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.isHidden = s : delete o.isHidden;
					continue;
				case 8:
					if (a !== 2) break;
					o.externalUrl = e.string(), o._externalUrl = "externalUrl";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.AppPage) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.AppPage();
		return e.pageScriptHash != null && (typeof e.pageScriptHash != "string" || e.pageScriptHash.length) && (n.pageScriptHash = String(e.pageScriptHash)), e.pageName != null && (typeof e.pageName != "string" || e.pageName.length) && (n.pageName = String(e.pageName)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = String(e.icon)), e.isDefault != null && e.isDefault && (n.isDefault = !!e.isDefault), e.sectionHeader != null && (typeof e.sectionHeader != "string" || e.sectionHeader.length) && (n.sectionHeader = String(e.sectionHeader)), e.urlPathname != null && (typeof e.urlPathname != "string" || e.urlPathname.length) && (n.urlPathname = String(e.urlPathname)), e.isHidden != null && e.isHidden && (n.isHidden = !!e.isHidden), e.externalUrl != null && (n.externalUrl = String(e.externalUrl)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.pageScriptHash = "", r.pageName = "", r.icon = "", r.isDefault = !1, r.sectionHeader = "", r.urlPathname = "", r.isHidden = !1), e.pageScriptHash != null && e.hasOwnProperty("pageScriptHash") && (r.pageScriptHash = e.pageScriptHash), e.pageName != null && e.hasOwnProperty("pageName") && (r.pageName = e.pageName), e.icon != null && e.hasOwnProperty("icon") && (r.icon = e.icon), e.isDefault != null && e.hasOwnProperty("isDefault") && (r.isDefault = e.isDefault), e.sectionHeader != null && e.hasOwnProperty("sectionHeader") && (r.sectionHeader = e.sectionHeader), e.urlPathname != null && e.hasOwnProperty("urlPathname") && (r.urlPathname = e.urlPathname), e.isHidden != null && e.hasOwnProperty("isHidden") && (r.isHidden = e.isHidden), e.externalUrl != null && e.hasOwnProperty("externalUrl") && (r.externalUrl = e.externalUrl), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/AppPage";
	}, e;
})(), N.ArrowData = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.data = M.newBuffer([]), e.prototype.styler = null, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.data != null && Object.hasOwnProperty.call(e, "data") && t.uint32(10).bytes(e.data), e.styler != null && Object.hasOwnProperty.call(e, "styler") && N.ArrowData.PandasStyler.encode(e.styler, t.uint32(18).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ArrowData(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.bytes()).length ? o.data = s : delete o.data;
					continue;
				case 2:
					if (a !== 2) break;
					o.styler = N.ArrowData.PandasStyler.decode(e, e.uint32(), void 0, r + 1, o.styler);
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ArrowData) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ArrowData();
		if (e.data != null && e.data.length && (typeof e.data == "string" ? M.base64.decode(e.data, n.data = M.newBuffer(M.base64.length(e.data)), 0) : e.data.length >= 0 && (n.data = e.data)), e.styler != null) {
			if (typeof e.styler != "object") throw TypeError(".ArrowData.styler: object expected");
			n.styler = N.ArrowData.PandasStyler.fromObject(e.styler, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (t.bytes === String ? r.data = "" : (r.data = [], t.bytes !== Array && (r.data = M.newBuffer(r.data))), r.styler = null), e.data != null && e.hasOwnProperty("data") && (r.data = t.bytes === String ? M.base64.encode(e.data, 0, e.data.length) : t.bytes === Array ? Array.prototype.slice.call(e.data) : e.data), e.styler != null && e.hasOwnProperty("styler") && (r.styler = N.ArrowData.PandasStyler.toObject(e.styler, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ArrowData";
	}, e.PandasStyler = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.uuid = "", e.prototype.caption = "", e.prototype.styles = "", e.prototype.displayValues = M.newBuffer([]), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.uuid != null && Object.hasOwnProperty.call(e, "uuid") && t.uint32(10).string(e.uuid), e.caption != null && Object.hasOwnProperty.call(e, "caption") && t.uint32(18).string(e.caption), e.styles != null && Object.hasOwnProperty.call(e, "styles") && t.uint32(26).string(e.styles), e.displayValues != null && Object.hasOwnProperty.call(e, "displayValues") && t.uint32(34).bytes(e.displayValues), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ArrowData.PandasStyler(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.string()).length ? o.uuid = s : delete o.uuid;
						continue;
					case 2:
						if (a !== 2) break;
						(s = e.string()).length ? o.caption = s : delete o.caption;
						continue;
					case 3:
						if (a !== 2) break;
						(s = e.string()).length ? o.styles = s : delete o.styles;
						continue;
					case 4:
						if (a !== 2) break;
						(s = e.bytes()).length ? o.displayValues = s : delete o.displayValues;
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.ArrowData.PandasStyler) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.ArrowData.PandasStyler();
			return e.uuid != null && (typeof e.uuid != "string" || e.uuid.length) && (n.uuid = String(e.uuid)), e.caption != null && (typeof e.caption != "string" || e.caption.length) && (n.caption = String(e.caption)), e.styles != null && (typeof e.styles != "string" || e.styles.length) && (n.styles = String(e.styles)), e.displayValues != null && e.displayValues.length && (typeof e.displayValues == "string" ? M.base64.decode(e.displayValues, n.displayValues = M.newBuffer(M.base64.length(e.displayValues)), 0) : e.displayValues.length >= 0 && (n.displayValues = e.displayValues)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.uuid = "", r.caption = "", r.styles = "", t.bytes === String ? r.displayValues = "" : (r.displayValues = [], t.bytes !== Array && (r.displayValues = M.newBuffer(r.displayValues)))), e.uuid != null && e.hasOwnProperty("uuid") && (r.uuid = e.uuid), e.caption != null && e.hasOwnProperty("caption") && (r.caption = e.caption), e.styles != null && e.hasOwnProperty("styles") && (r.styles = e.styles), e.displayValues != null && e.hasOwnProperty("displayValues") && (r.displayValues = t.bytes === String ? M.base64.encode(e.displayValues, 0, e.displayValues.length) : t.bytes === Array ? Array.prototype.slice.call(e.displayValues) : e.displayValues), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/ArrowData.PandasStyler";
		}, e;
	})(), e;
})(), N.ArrowNamedDataSet = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.name = "", e.prototype.hasName = !1, e.prototype.data = null, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(10).string(e.name), e.data != null && Object.hasOwnProperty.call(e, "data") && N.ArrowData.encode(e.data, t.uint32(18).fork(), n + 1).ldelim(), e.hasName != null && Object.hasOwnProperty.call(e, "hasName") && t.uint32(24).bool(e.hasName), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ArrowNamedDataSet(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.name = s : delete o.name;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.hasName = s : delete o.hasName;
					continue;
				case 2:
					if (a !== 2) break;
					o.data = N.ArrowData.decode(e, e.uint32(), void 0, r + 1, o.data);
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ArrowNamedDataSet) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ArrowNamedDataSet();
		if (e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = String(e.name)), e.hasName != null && e.hasName && (n.hasName = !!e.hasName), e.data != null) {
			if (typeof e.data != "object") throw TypeError(".ArrowNamedDataSet.data: object expected");
			n.data = N.ArrowData.fromObject(e.data, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.name = "", r.data = null, r.hasName = !1), e.name != null && e.hasOwnProperty("name") && (r.name = e.name), e.data != null && e.hasOwnProperty("data") && (r.data = N.ArrowData.toObject(e.data, t, n + 1)), e.hasName != null && e.hasOwnProperty("hasName") && (r.hasName = e.hasName), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ArrowNamedDataSet";
	}, e;
})(), N.Audio = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.url = "", e.prototype.startTime = 0, e.prototype.endTime = 0, e.prototype.loop = !1, e.prototype.autoplay = !1, e.prototype.id = "", e.prototype.widthConfig = null;
	let t;
	return Object.defineProperty(e.prototype, "_widthConfig", {
		get: M.oneOfGetter(t = ["widthConfig"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.startTime != null && Object.hasOwnProperty.call(e, "startTime") && t.uint32(24).int32(e.startTime), e.url != null && Object.hasOwnProperty.call(e, "url") && t.uint32(42).string(e.url), e.endTime != null && Object.hasOwnProperty.call(e, "endTime") && t.uint32(48).int32(e.endTime), e.loop != null && Object.hasOwnProperty.call(e, "loop") && t.uint32(56).bool(e.loop), e.autoplay != null && Object.hasOwnProperty.call(e, "autoplay") && t.uint32(64).bool(e.autoplay), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(74).string(e.id), e.widthConfig != null && Object.hasOwnProperty.call(e, "widthConfig") && N.streamlit.WidthConfig.encode(e.widthConfig, t.uint32(82).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Audio(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.url = s : delete o.url;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.int32()) ? o.startTime = s : delete o.startTime;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.int32()) ? o.endTime = s : delete o.endTime;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.loop = s : delete o.loop;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.autoplay = s : delete o.autoplay;
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 10:
					if (a !== 2) break;
					o.widthConfig = N.streamlit.WidthConfig.decode(e, e.uint32(), void 0, r + 1, o.widthConfig), o._widthConfig = "widthConfig";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Audio) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Audio();
		if (e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = String(e.url)), e.startTime != null && Number(e.startTime) !== 0 && (n.startTime = e.startTime | 0), e.endTime != null && Number(e.endTime) !== 0 && (n.endTime = e.endTime | 0), e.loop != null && e.loop && (n.loop = !!e.loop), e.autoplay != null && e.autoplay && (n.autoplay = !!e.autoplay), e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.widthConfig != null) {
			if (typeof e.widthConfig != "object") throw TypeError(".Audio.widthConfig: object expected");
			n.widthConfig = N.streamlit.WidthConfig.fromObject(e.widthConfig, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.startTime = 0, r.url = "", r.endTime = 0, r.loop = !1, r.autoplay = !1, r.id = ""), e.startTime != null && e.hasOwnProperty("startTime") && (r.startTime = e.startTime), e.url != null && e.hasOwnProperty("url") && (r.url = e.url), e.endTime != null && e.hasOwnProperty("endTime") && (r.endTime = e.endTime), e.loop != null && e.hasOwnProperty("loop") && (r.loop = e.loop), e.autoplay != null && e.hasOwnProperty("autoplay") && (r.autoplay = e.autoplay), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.widthConfig != null && e.hasOwnProperty("widthConfig") && (r.widthConfig = N.streamlit.WidthConfig.toObject(e.widthConfig, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Audio";
	}, e;
})(), N.AudioInput = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.label = "", e.prototype.help = "", e.prototype.formId = "", e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.sampleRate = null;
	let t;
	return Object.defineProperty(e.prototype, "_sampleRate", {
		get: M.oneOfGetter(t = ["sampleRate"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(26).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(34).string(e.formId), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(40).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(50).fork(), n + 1).ldelim(), e.sampleRate != null && Object.hasOwnProperty.call(e, "sampleRate") && t.uint32(56).int32(e.sampleRate), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.AudioInput(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 6:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 7:
					if (a !== 0) break;
					o.sampleRate = e.int32(), o._sampleRate = "sampleRate";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.AudioInput) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.AudioInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".AudioInput.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.sampleRate != null && (n.sampleRate = e.sampleRate | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.help = "", r.formId = "", r.disabled = !1, r.labelVisibility = null), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.sampleRate != null && e.hasOwnProperty("sampleRate") && (r.sampleRate = e.sampleRate), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/AudioInput";
	}, e;
})(), N.LabelVisibility = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.value = 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(8).int32(e.value), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.LabelVisibility(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					(s = e.int32()) ? o.value = s : delete o.value;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.LabelVisibility) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.LabelVisibility();
		if (e.value !== 0 && (typeof e.value != "string" || N.LabelVisibility.LabelVisibilityOptions[e.value] !== 0)) switch (e.value) {
			default:
				if (typeof e.value == "number") {
					n.value = e.value;
					break;
				}
				break;
			case "VISIBLE":
			case 0:
				n.value = 0;
				break;
			case "HIDDEN":
			case 1:
				n.value = 1;
				break;
			case "COLLAPSED":
			case 2:
				n.value = 2;
				break;
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.value = t.enums === String ? "VISIBLE" : 0), e.value != null && e.hasOwnProperty("value") && (r.value = t.enums === String ? N.LabelVisibility.LabelVisibilityOptions[e.value] === void 0 ? e.value : N.LabelVisibility.LabelVisibilityOptions[e.value] : e.value), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/LabelVisibility";
	}, e.LabelVisibilityOptions = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "VISIBLE"] = 0, t[e[1] = "HIDDEN"] = 1, t[e[2] = "COLLAPSED"] = 2, t;
	})(), e;
})(), N.AuthRedirect = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.url = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.url != null && Object.hasOwnProperty.call(e, "url") && t.uint32(10).string(e.url), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.AuthRedirect(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.url = s : delete o.url;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.AuthRedirect) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.AuthRedirect();
		return e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = String(e.url)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.url = ""), e.url != null && e.hasOwnProperty("url") && (r.url = e.url), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/AuthRedirect";
	}, e;
})(), N.AutoRerun = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.interval = 0, e.prototype.fragmentId = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.interval != null && Object.hasOwnProperty.call(e, "interval") && t.uint32(13).float(e.interval), e.fragmentId != null && Object.hasOwnProperty.call(e, "fragmentId") && t.uint32(18).string(e.fragmentId), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.AutoRerun(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 5) break;
					(s = e.float()) === 0 ? delete o.interval : o.interval = s;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.fragmentId = s : delete o.fragmentId;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.AutoRerun) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.AutoRerun();
		return e.interval != null && Number(e.interval) !== 0 && (n.interval = Number(e.interval)), e.fragmentId != null && (typeof e.fragmentId != "string" || e.fragmentId.length) && (n.fragmentId = String(e.fragmentId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.interval = 0, r.fragmentId = ""), e.interval != null && e.hasOwnProperty("interval") && (r.interval = t.json && !isFinite(e.interval) ? String(e.interval) : e.interval), e.fragmentId != null && e.hasOwnProperty("fragmentId") && (r.fragmentId = e.fragmentId), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/AutoRerun";
	}, e;
})();
var ue = N.BackMsg = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.clearCache = null, e.prototype.setRunOnSave = null, e.prototype.stopScript = null, e.prototype.rerunScript = null, e.prototype.loadGitInfo = null, e.prototype.debugDisconnectWebsocket = null, e.prototype.debugShutdownRuntime = null, e.prototype.fileUrlsRequest = null, e.prototype.appHeartbeat = null, e.prototype.deferredFileRequest = null, e.prototype.debugLastBackmsgId = "";
	let t;
	return Object.defineProperty(e.prototype, "type", {
		get: M.oneOfGetter(t = [
			"clearCache",
			"setRunOnSave",
			"stopScript",
			"rerunScript",
			"loadGitInfo",
			"debugDisconnectWebsocket",
			"debugShutdownRuntime",
			"fileUrlsRequest",
			"appHeartbeat",
			"deferredFileRequest"
		]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.clearCache != null && Object.hasOwnProperty.call(e, "clearCache") && t.uint32(40).bool(e.clearCache), e.setRunOnSave != null && Object.hasOwnProperty.call(e, "setRunOnSave") && t.uint32(48).bool(e.setRunOnSave), e.stopScript != null && Object.hasOwnProperty.call(e, "stopScript") && t.uint32(56).bool(e.stopScript), e.rerunScript != null && Object.hasOwnProperty.call(e, "rerunScript") && N.ClientState.encode(e.rerunScript, t.uint32(90).fork(), n + 1).ldelim(), e.loadGitInfo != null && Object.hasOwnProperty.call(e, "loadGitInfo") && t.uint32(96).bool(e.loadGitInfo), e.debugLastBackmsgId != null && Object.hasOwnProperty.call(e, "debugLastBackmsgId") && t.uint32(106).string(e.debugLastBackmsgId), e.debugDisconnectWebsocket != null && Object.hasOwnProperty.call(e, "debugDisconnectWebsocket") && t.uint32(112).bool(e.debugDisconnectWebsocket), e.debugShutdownRuntime != null && Object.hasOwnProperty.call(e, "debugShutdownRuntime") && t.uint32(120).bool(e.debugShutdownRuntime), e.fileUrlsRequest != null && Object.hasOwnProperty.call(e, "fileUrlsRequest") && N.FileURLsRequest.encode(e.fileUrlsRequest, t.uint32(130).fork(), n + 1).ldelim(), e.appHeartbeat != null && Object.hasOwnProperty.call(e, "appHeartbeat") && t.uint32(136).bool(e.appHeartbeat), e.deferredFileRequest != null && Object.hasOwnProperty.call(e, "deferredFileRequest") && N.DeferredFileRequest.encode(e.deferredFileRequest, t.uint32(146).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.BackMsg(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 5:
					if (a !== 0) break;
					o.clearCache = e.bool(), o.type = "clearCache";
					continue;
				case 6:
					if (a !== 0) break;
					o.setRunOnSave = e.bool(), o.type = "setRunOnSave";
					continue;
				case 7:
					if (a !== 0) break;
					o.stopScript = e.bool(), o.type = "stopScript";
					continue;
				case 11:
					if (a !== 2) break;
					o.rerunScript = N.ClientState.decode(e, e.uint32(), void 0, r + 1, o.rerunScript), o.type = "rerunScript";
					continue;
				case 12:
					if (a !== 0) break;
					o.loadGitInfo = e.bool(), o.type = "loadGitInfo";
					continue;
				case 14:
					if (a !== 0) break;
					o.debugDisconnectWebsocket = e.bool(), o.type = "debugDisconnectWebsocket";
					continue;
				case 15:
					if (a !== 0) break;
					o.debugShutdownRuntime = e.bool(), o.type = "debugShutdownRuntime";
					continue;
				case 16:
					if (a !== 2) break;
					o.fileUrlsRequest = N.FileURLsRequest.decode(e, e.uint32(), void 0, r + 1, o.fileUrlsRequest), o.type = "fileUrlsRequest";
					continue;
				case 17:
					if (a !== 0) break;
					o.appHeartbeat = e.bool(), o.type = "appHeartbeat";
					continue;
				case 18:
					if (a !== 2) break;
					o.deferredFileRequest = N.DeferredFileRequest.decode(e, e.uint32(), void 0, r + 1, o.deferredFileRequest), o.type = "deferredFileRequest";
					continue;
				case 13:
					if (a !== 2) break;
					(s = e.string()).length ? o.debugLastBackmsgId = s : delete o.debugLastBackmsgId;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.BackMsg) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.BackMsg();
		if (e.clearCache != null && (n.clearCache = !!e.clearCache), e.setRunOnSave != null && (n.setRunOnSave = !!e.setRunOnSave), e.stopScript != null && (n.stopScript = !!e.stopScript), e.rerunScript != null) {
			if (typeof e.rerunScript != "object") throw TypeError(".BackMsg.rerunScript: object expected");
			n.rerunScript = N.ClientState.fromObject(e.rerunScript, t + 1);
		}
		if (e.loadGitInfo != null && (n.loadGitInfo = !!e.loadGitInfo), e.debugDisconnectWebsocket != null && (n.debugDisconnectWebsocket = !!e.debugDisconnectWebsocket), e.debugShutdownRuntime != null && (n.debugShutdownRuntime = !!e.debugShutdownRuntime), e.fileUrlsRequest != null) {
			if (typeof e.fileUrlsRequest != "object") throw TypeError(".BackMsg.fileUrlsRequest: object expected");
			n.fileUrlsRequest = N.FileURLsRequest.fromObject(e.fileUrlsRequest, t + 1);
		}
		if (e.appHeartbeat != null && (n.appHeartbeat = !!e.appHeartbeat), e.deferredFileRequest != null) {
			if (typeof e.deferredFileRequest != "object") throw TypeError(".BackMsg.deferredFileRequest: object expected");
			n.deferredFileRequest = N.DeferredFileRequest.fromObject(e.deferredFileRequest, t + 1);
		}
		return e.debugLastBackmsgId != null && (typeof e.debugLastBackmsgId != "string" || e.debugLastBackmsgId.length) && (n.debugLastBackmsgId = String(e.debugLastBackmsgId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.debugLastBackmsgId = ""), e.clearCache != null && e.hasOwnProperty("clearCache") && (r.clearCache = e.clearCache, t.oneofs && (r.type = "clearCache")), e.setRunOnSave != null && e.hasOwnProperty("setRunOnSave") && (r.setRunOnSave = e.setRunOnSave, t.oneofs && (r.type = "setRunOnSave")), e.stopScript != null && e.hasOwnProperty("stopScript") && (r.stopScript = e.stopScript, t.oneofs && (r.type = "stopScript")), e.rerunScript != null && e.hasOwnProperty("rerunScript") && (r.rerunScript = N.ClientState.toObject(e.rerunScript, t, n + 1), t.oneofs && (r.type = "rerunScript")), e.loadGitInfo != null && e.hasOwnProperty("loadGitInfo") && (r.loadGitInfo = e.loadGitInfo, t.oneofs && (r.type = "loadGitInfo")), e.debugLastBackmsgId != null && e.hasOwnProperty("debugLastBackmsgId") && (r.debugLastBackmsgId = e.debugLastBackmsgId), e.debugDisconnectWebsocket != null && e.hasOwnProperty("debugDisconnectWebsocket") && (r.debugDisconnectWebsocket = e.debugDisconnectWebsocket, t.oneofs && (r.type = "debugDisconnectWebsocket")), e.debugShutdownRuntime != null && e.hasOwnProperty("debugShutdownRuntime") && (r.debugShutdownRuntime = e.debugShutdownRuntime, t.oneofs && (r.type = "debugShutdownRuntime")), e.fileUrlsRequest != null && e.hasOwnProperty("fileUrlsRequest") && (r.fileUrlsRequest = N.FileURLsRequest.toObject(e.fileUrlsRequest, t, n + 1), t.oneofs && (r.type = "fileUrlsRequest")), e.appHeartbeat != null && e.hasOwnProperty("appHeartbeat") && (r.appHeartbeat = e.appHeartbeat, t.oneofs && (r.type = "appHeartbeat")), e.deferredFileRequest != null && e.hasOwnProperty("deferredFileRequest") && (r.deferredFileRequest = N.DeferredFileRequest.toObject(e.deferredFileRequest, t, n + 1), t.oneofs && (r.type = "deferredFileRequest")), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/BackMsg";
	}, e;
})();
N.DeferredFileRequest = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.fileId = "", e.prototype.sessionId = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.fileId != null && Object.hasOwnProperty.call(e, "fileId") && t.uint32(10).string(e.fileId), e.sessionId != null && Object.hasOwnProperty.call(e, "sessionId") && t.uint32(18).string(e.sessionId), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.DeferredFileRequest(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.fileId = s : delete o.fileId;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.sessionId = s : delete o.sessionId;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.DeferredFileRequest) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.DeferredFileRequest();
		return e.fileId != null && (typeof e.fileId != "string" || e.fileId.length) && (n.fileId = String(e.fileId)), e.sessionId != null && (typeof e.sessionId != "string" || e.sessionId.length) && (n.sessionId = String(e.sessionId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.fileId = "", r.sessionId = ""), e.fileId != null && e.hasOwnProperty("fileId") && (r.fileId = e.fileId), e.sessionId != null && e.hasOwnProperty("sessionId") && (r.sessionId = e.sessionId), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/DeferredFileRequest";
	}, e;
})(), N.ContextInfo = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.timezone = null, e.prototype.timezoneOffset = null, e.prototype.locale = null, e.prototype.url = null, e.prototype.isEmbedded = null, e.prototype.colorScheme = null;
	let t;
	return Object.defineProperty(e.prototype, "_timezone", {
		get: M.oneOfGetter(t = ["timezone"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_timezoneOffset", {
		get: M.oneOfGetter(t = ["timezoneOffset"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_locale", {
		get: M.oneOfGetter(t = ["locale"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_url", {
		get: M.oneOfGetter(t = ["url"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_isEmbedded", {
		get: M.oneOfGetter(t = ["isEmbedded"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_colorScheme", {
		get: M.oneOfGetter(t = ["colorScheme"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.timezone != null && Object.hasOwnProperty.call(e, "timezone") && t.uint32(10).string(e.timezone), e.timezoneOffset != null && Object.hasOwnProperty.call(e, "timezoneOffset") && t.uint32(16).int32(e.timezoneOffset), e.locale != null && Object.hasOwnProperty.call(e, "locale") && t.uint32(26).string(e.locale), e.url != null && Object.hasOwnProperty.call(e, "url") && t.uint32(34).string(e.url), e.isEmbedded != null && Object.hasOwnProperty.call(e, "isEmbedded") && t.uint32(40).bool(e.isEmbedded), e.colorScheme != null && Object.hasOwnProperty.call(e, "colorScheme") && t.uint32(50).string(e.colorScheme), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ContextInfo();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.timezone = e.string(), o._timezone = "timezone";
					continue;
				case 2:
					if (a !== 0) break;
					o.timezoneOffset = e.int32(), o._timezoneOffset = "timezoneOffset";
					continue;
				case 3:
					if (a !== 2) break;
					o.locale = e.string(), o._locale = "locale";
					continue;
				case 4:
					if (a !== 2) break;
					o.url = e.string(), o._url = "url";
					continue;
				case 5:
					if (a !== 0) break;
					o.isEmbedded = e.bool(), o._isEmbedded = "isEmbedded";
					continue;
				case 6:
					if (a !== 2) break;
					o.colorScheme = e.string(), o._colorScheme = "colorScheme";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ContextInfo) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ContextInfo();
		return e.timezone != null && (n.timezone = String(e.timezone)), e.timezoneOffset != null && (n.timezoneOffset = e.timezoneOffset | 0), e.locale != null && (n.locale = String(e.locale)), e.url != null && (n.url = String(e.url)), e.isEmbedded != null && (n.isEmbedded = !!e.isEmbedded), e.colorScheme != null && (n.colorScheme = String(e.colorScheme)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return e.timezone != null && e.hasOwnProperty("timezone") && (r.timezone = e.timezone), e.timezoneOffset != null && e.hasOwnProperty("timezoneOffset") && (r.timezoneOffset = e.timezoneOffset), e.locale != null && e.hasOwnProperty("locale") && (r.locale = e.locale), e.url != null && e.hasOwnProperty("url") && (r.url = e.url), e.isEmbedded != null && e.hasOwnProperty("isEmbedded") && (r.isEmbedded = e.isEmbedded), e.colorScheme != null && e.hasOwnProperty("colorScheme") && (r.colorScheme = e.colorScheme), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ContextInfo";
	}, e;
})(), N.ClientState = (() => {
	function e(e) {
		if (this.cachedMessageHashes = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.queryString = "", e.prototype.widgetStates = null, e.prototype.pageScriptHash = "", e.prototype.pageName = "", e.prototype.fragmentId = "", e.prototype.isAutoRerun = !1, e.prototype.cachedMessageHashes = M.emptyArray, e.prototype.contextInfo = null, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.queryString != null && Object.hasOwnProperty.call(e, "queryString") && t.uint32(10).string(e.queryString), e.widgetStates != null && Object.hasOwnProperty.call(e, "widgetStates") && N.WidgetStates.encode(e.widgetStates, t.uint32(18).fork(), n + 1).ldelim(), e.pageScriptHash != null && Object.hasOwnProperty.call(e, "pageScriptHash") && t.uint32(26).string(e.pageScriptHash), e.pageName != null && Object.hasOwnProperty.call(e, "pageName") && t.uint32(34).string(e.pageName), e.fragmentId != null && Object.hasOwnProperty.call(e, "fragmentId") && t.uint32(42).string(e.fragmentId), e.isAutoRerun != null && Object.hasOwnProperty.call(e, "isAutoRerun") && t.uint32(48).bool(e.isAutoRerun), e.cachedMessageHashes != null && e.cachedMessageHashes.length) for (let n = 0; n < e.cachedMessageHashes.length; ++n) t.uint32(58).string(e.cachedMessageHashes[n]);
		if (e.contextInfo != null && Object.hasOwnProperty.call(e, "contextInfo") && N.ContextInfo.encode(e.contextInfo, t.uint32(66).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ClientState(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.queryString = s : delete o.queryString;
					continue;
				case 2:
					if (a !== 2) break;
					o.widgetStates = N.WidgetStates.decode(e, e.uint32(), void 0, r + 1, o.widgetStates);
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.pageScriptHash = s : delete o.pageScriptHash;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.pageName = s : delete o.pageName;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.fragmentId = s : delete o.fragmentId;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.isAutoRerun = s : delete o.isAutoRerun;
					continue;
				case 7:
					if (a !== 2) break;
					o.cachedMessageHashes && o.cachedMessageHashes.length || (o.cachedMessageHashes = []), o.cachedMessageHashes.push(e.string());
					continue;
				case 8:
					if (a !== 2) break;
					o.contextInfo = N.ContextInfo.decode(e, e.uint32(), void 0, r + 1, o.contextInfo);
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ClientState) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ClientState();
		if (e.queryString != null && (typeof e.queryString != "string" || e.queryString.length) && (n.queryString = String(e.queryString)), e.widgetStates != null) {
			if (typeof e.widgetStates != "object") throw TypeError(".ClientState.widgetStates: object expected");
			n.widgetStates = N.WidgetStates.fromObject(e.widgetStates, t + 1);
		}
		if (e.pageScriptHash != null && (typeof e.pageScriptHash != "string" || e.pageScriptHash.length) && (n.pageScriptHash = String(e.pageScriptHash)), e.pageName != null && (typeof e.pageName != "string" || e.pageName.length) && (n.pageName = String(e.pageName)), e.fragmentId != null && (typeof e.fragmentId != "string" || e.fragmentId.length) && (n.fragmentId = String(e.fragmentId)), e.isAutoRerun != null && e.isAutoRerun && (n.isAutoRerun = !!e.isAutoRerun), e.cachedMessageHashes) {
			if (!Array.isArray(e.cachedMessageHashes)) throw TypeError(".ClientState.cachedMessageHashes: array expected");
			n.cachedMessageHashes = Array(e.cachedMessageHashes.length);
			for (let t = 0; t < e.cachedMessageHashes.length; ++t) n.cachedMessageHashes[t] = String(e.cachedMessageHashes[t]);
		}
		if (e.contextInfo != null) {
			if (typeof e.contextInfo != "object") throw TypeError(".ClientState.contextInfo: object expected");
			n.contextInfo = N.ContextInfo.fromObject(e.contextInfo, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.cachedMessageHashes = []), t.defaults && (r.queryString = "", r.widgetStates = null, r.pageScriptHash = "", r.pageName = "", r.fragmentId = "", r.isAutoRerun = !1, r.contextInfo = null), e.queryString != null && e.hasOwnProperty("queryString") && (r.queryString = e.queryString), e.widgetStates != null && e.hasOwnProperty("widgetStates") && (r.widgetStates = N.WidgetStates.toObject(e.widgetStates, t, n + 1)), e.pageScriptHash != null && e.hasOwnProperty("pageScriptHash") && (r.pageScriptHash = e.pageScriptHash), e.pageName != null && e.hasOwnProperty("pageName") && (r.pageName = e.pageName), e.fragmentId != null && e.hasOwnProperty("fragmentId") && (r.fragmentId = e.fragmentId), e.isAutoRerun != null && e.hasOwnProperty("isAutoRerun") && (r.isAutoRerun = e.isAutoRerun), e.cachedMessageHashes && e.cachedMessageHashes.length) {
			r.cachedMessageHashes = Array(e.cachedMessageHashes.length);
			for (let t = 0; t < e.cachedMessageHashes.length; ++t) r.cachedMessageHashes[t] = e.cachedMessageHashes[t];
		}
		return e.contextInfo != null && e.hasOwnProperty("contextInfo") && (r.contextInfo = N.ContextInfo.toObject(e.contextInfo, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ClientState";
	}, e;
})(), N.WidgetStates = (() => {
	function e(e) {
		if (this.widgets = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.widgets = M.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.widgets != null && e.widgets.length) for (let r = 0; r < e.widgets.length; ++r) N.WidgetState.encode(e.widgets[r], t.uint32(10).fork(), n + 1).ldelim();
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.WidgetStates();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.widgets && o.widgets.length || (o.widgets = []), o.widgets.push(N.WidgetState.decode(e, e.uint32(), void 0, r + 1));
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.WidgetStates) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.WidgetStates();
		if (e.widgets) {
			if (!Array.isArray(e.widgets)) throw TypeError(".WidgetStates.widgets: array expected");
			n.widgets = Array(e.widgets.length);
			for (let r = 0; r < e.widgets.length; ++r) {
				if (typeof e.widgets[r] != "object") throw TypeError(".WidgetStates.widgets: object expected");
				n.widgets[r] = N.WidgetState.fromObject(e.widgets[r], t + 1);
			}
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.widgets = []), e.widgets && e.widgets.length) {
			r.widgets = Array(e.widgets.length);
			for (let i = 0; i < e.widgets.length; ++i) r.widgets[i] = N.WidgetState.toObject(e.widgets[i], t, n + 1);
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/WidgetStates";
	}, e;
})(), N.WidgetState = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.triggerValue = null, e.prototype.boolValue = null, e.prototype.doubleValue = null, e.prototype.intValue = null, e.prototype.stringValue = null, e.prototype.doubleArrayValue = null, e.prototype.intArrayValue = null, e.prototype.stringArrayValue = null, e.prototype.jsonValue = null, e.prototype.arrowValue = null, e.prototype.bytesValue = null, e.prototype.fileUploaderStateValue = null, e.prototype.stringTriggerValue = null, e.prototype.chatInputValue = null, e.prototype.jsonTriggerValue = null;
	let t;
	return Object.defineProperty(e.prototype, "value", {
		get: M.oneOfGetter(t = [
			"triggerValue",
			"boolValue",
			"doubleValue",
			"intValue",
			"stringValue",
			"doubleArrayValue",
			"intArrayValue",
			"stringArrayValue",
			"jsonValue",
			"arrowValue",
			"bytesValue",
			"fileUploaderStateValue",
			"stringTriggerValue",
			"chatInputValue",
			"jsonTriggerValue"
		]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.triggerValue != null && Object.hasOwnProperty.call(e, "triggerValue") && t.uint32(16).bool(e.triggerValue), e.boolValue != null && Object.hasOwnProperty.call(e, "boolValue") && t.uint32(24).bool(e.boolValue), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(33).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(40).sint64(e.intValue), e.stringValue != null && Object.hasOwnProperty.call(e, "stringValue") && t.uint32(50).string(e.stringValue), e.doubleArrayValue != null && Object.hasOwnProperty.call(e, "doubleArrayValue") && N.DoubleArray.encode(e.doubleArrayValue, t.uint32(58).fork(), n + 1).ldelim(), e.intArrayValue != null && Object.hasOwnProperty.call(e, "intArrayValue") && N.SInt64Array.encode(e.intArrayValue, t.uint32(66).fork(), n + 1).ldelim(), e.stringArrayValue != null && Object.hasOwnProperty.call(e, "stringArrayValue") && N.StringArray.encode(e.stringArrayValue, t.uint32(74).fork(), n + 1).ldelim(), e.jsonValue != null && Object.hasOwnProperty.call(e, "jsonValue") && t.uint32(82).string(e.jsonValue), e.arrowValue != null && Object.hasOwnProperty.call(e, "arrowValue") && N.ArrowTable.encode(e.arrowValue, t.uint32(90).fork(), n + 1).ldelim(), e.bytesValue != null && Object.hasOwnProperty.call(e, "bytesValue") && t.uint32(98).bytes(e.bytesValue), e.fileUploaderStateValue != null && Object.hasOwnProperty.call(e, "fileUploaderStateValue") && N.FileUploaderState.encode(e.fileUploaderStateValue, t.uint32(106).fork(), n + 1).ldelim(), e.stringTriggerValue != null && Object.hasOwnProperty.call(e, "stringTriggerValue") && N.StringTriggerValue.encode(e.stringTriggerValue, t.uint32(114).fork(), n + 1).ldelim(), e.chatInputValue != null && Object.hasOwnProperty.call(e, "chatInputValue") && N.ChatInputValue.encode(e.chatInputValue, t.uint32(122).fork(), n + 1).ldelim(), e.jsonTriggerValue != null && Object.hasOwnProperty.call(e, "jsonTriggerValue") && t.uint32(130).string(e.jsonTriggerValue), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.WidgetState(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 0) break;
					o.triggerValue = e.bool(), o.value = "triggerValue";
					continue;
				case 3:
					if (a !== 0) break;
					o.boolValue = e.bool(), o.value = "boolValue";
					continue;
				case 4:
					if (a !== 1) break;
					o.doubleValue = e.double(), o.value = "doubleValue";
					continue;
				case 5:
					if (a !== 0) break;
					o.intValue = e.sint64(), o.value = "intValue";
					continue;
				case 6:
					if (a !== 2) break;
					o.stringValue = e.string(), o.value = "stringValue";
					continue;
				case 7:
					if (a !== 2) break;
					o.doubleArrayValue = N.DoubleArray.decode(e, e.uint32(), void 0, r + 1, o.doubleArrayValue), o.value = "doubleArrayValue";
					continue;
				case 8:
					if (a !== 2) break;
					o.intArrayValue = N.SInt64Array.decode(e, e.uint32(), void 0, r + 1, o.intArrayValue), o.value = "intArrayValue";
					continue;
				case 9:
					if (a !== 2) break;
					o.stringArrayValue = N.StringArray.decode(e, e.uint32(), void 0, r + 1, o.stringArrayValue), o.value = "stringArrayValue";
					continue;
				case 10:
					if (a !== 2) break;
					o.jsonValue = e.string(), o.value = "jsonValue";
					continue;
				case 11:
					if (a !== 2) break;
					o.arrowValue = N.ArrowTable.decode(e, e.uint32(), void 0, r + 1, o.arrowValue), o.value = "arrowValue";
					continue;
				case 12:
					if (a !== 2) break;
					o.bytesValue = e.bytes(), o.value = "bytesValue";
					continue;
				case 13:
					if (a !== 2) break;
					o.fileUploaderStateValue = N.FileUploaderState.decode(e, e.uint32(), void 0, r + 1, o.fileUploaderStateValue), o.value = "fileUploaderStateValue";
					continue;
				case 14:
					if (a !== 2) break;
					o.stringTriggerValue = N.StringTriggerValue.decode(e, e.uint32(), void 0, r + 1, o.stringTriggerValue), o.value = "stringTriggerValue";
					continue;
				case 15:
					if (a !== 2) break;
					o.chatInputValue = N.ChatInputValue.decode(e, e.uint32(), void 0, r + 1, o.chatInputValue), o.value = "chatInputValue";
					continue;
				case 16:
					if (a !== 2) break;
					o.jsonTriggerValue = e.string(), o.value = "jsonTriggerValue";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.WidgetState) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.WidgetState();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.triggerValue != null && (n.triggerValue = !!e.triggerValue), e.boolValue != null && (n.boolValue = !!e.boolValue), e.doubleValue != null && (n.doubleValue = Number(e.doubleValue)), e.intValue != null && (M.Long ? n.intValue = M.Long.fromValue(e.intValue, !1) : typeof e.intValue == "string" ? n.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? n.intValue = e.intValue : typeof e.intValue == "object" && (n.intValue = new M.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), e.stringValue != null && (n.stringValue = String(e.stringValue)), e.doubleArrayValue != null) {
			if (typeof e.doubleArrayValue != "object") throw TypeError(".WidgetState.doubleArrayValue: object expected");
			n.doubleArrayValue = N.DoubleArray.fromObject(e.doubleArrayValue, t + 1);
		}
		if (e.intArrayValue != null) {
			if (typeof e.intArrayValue != "object") throw TypeError(".WidgetState.intArrayValue: object expected");
			n.intArrayValue = N.SInt64Array.fromObject(e.intArrayValue, t + 1);
		}
		if (e.stringArrayValue != null) {
			if (typeof e.stringArrayValue != "object") throw TypeError(".WidgetState.stringArrayValue: object expected");
			n.stringArrayValue = N.StringArray.fromObject(e.stringArrayValue, t + 1);
		}
		if (e.jsonValue != null && (n.jsonValue = String(e.jsonValue)), e.arrowValue != null) {
			if (typeof e.arrowValue != "object") throw TypeError(".WidgetState.arrowValue: object expected");
			n.arrowValue = N.ArrowTable.fromObject(e.arrowValue, t + 1);
		}
		if (e.bytesValue != null && (typeof e.bytesValue == "string" ? M.base64.decode(e.bytesValue, n.bytesValue = M.newBuffer(M.base64.length(e.bytesValue)), 0) : e.bytesValue.length >= 0 && (n.bytesValue = e.bytesValue)), e.fileUploaderStateValue != null) {
			if (typeof e.fileUploaderStateValue != "object") throw TypeError(".WidgetState.fileUploaderStateValue: object expected");
			n.fileUploaderStateValue = N.FileUploaderState.fromObject(e.fileUploaderStateValue, t + 1);
		}
		if (e.stringTriggerValue != null) {
			if (typeof e.stringTriggerValue != "object") throw TypeError(".WidgetState.stringTriggerValue: object expected");
			n.stringTriggerValue = N.StringTriggerValue.fromObject(e.stringTriggerValue, t + 1);
		}
		if (e.chatInputValue != null) {
			if (typeof e.chatInputValue != "object") throw TypeError(".WidgetState.chatInputValue: object expected");
			n.chatInputValue = N.ChatInputValue.fromObject(e.chatInputValue, t + 1);
		}
		return e.jsonTriggerValue != null && (n.jsonTriggerValue = String(e.jsonTriggerValue)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = ""), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.triggerValue != null && e.hasOwnProperty("triggerValue") && (r.triggerValue = e.triggerValue, t.oneofs && (r.value = "triggerValue")), e.boolValue != null && e.hasOwnProperty("boolValue") && (r.boolValue = e.boolValue, t.oneofs && (r.value = "boolValue")), e.doubleValue != null && e.hasOwnProperty("doubleValue") && (r.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (r.value = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof BigInt < "u" && t.longs === BigInt ? r.intValue = typeof e.intValue == "number" ? BigInt(e.intValue) : M.Long.fromBits(e.intValue.low >>> 0, e.intValue.high >>> 0, !1).toBigInt() : typeof e.intValue == "number" ? r.intValue = t.longs === String ? String(e.intValue) : e.intValue : r.intValue = t.longs === String ? M.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new M.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (r.value = "intValue")), e.stringValue != null && e.hasOwnProperty("stringValue") && (r.stringValue = e.stringValue, t.oneofs && (r.value = "stringValue")), e.doubleArrayValue != null && e.hasOwnProperty("doubleArrayValue") && (r.doubleArrayValue = N.DoubleArray.toObject(e.doubleArrayValue, t, n + 1), t.oneofs && (r.value = "doubleArrayValue")), e.intArrayValue != null && e.hasOwnProperty("intArrayValue") && (r.intArrayValue = N.SInt64Array.toObject(e.intArrayValue, t, n + 1), t.oneofs && (r.value = "intArrayValue")), e.stringArrayValue != null && e.hasOwnProperty("stringArrayValue") && (r.stringArrayValue = N.StringArray.toObject(e.stringArrayValue, t, n + 1), t.oneofs && (r.value = "stringArrayValue")), e.jsonValue != null && e.hasOwnProperty("jsonValue") && (r.jsonValue = e.jsonValue, t.oneofs && (r.value = "jsonValue")), e.arrowValue != null && e.hasOwnProperty("arrowValue") && (r.arrowValue = N.ArrowTable.toObject(e.arrowValue, t, n + 1), t.oneofs && (r.value = "arrowValue")), e.bytesValue != null && e.hasOwnProperty("bytesValue") && (r.bytesValue = t.bytes === String ? M.base64.encode(e.bytesValue, 0, e.bytesValue.length) : t.bytes === Array ? Array.prototype.slice.call(e.bytesValue) : e.bytesValue, t.oneofs && (r.value = "bytesValue")), e.fileUploaderStateValue != null && e.hasOwnProperty("fileUploaderStateValue") && (r.fileUploaderStateValue = N.FileUploaderState.toObject(e.fileUploaderStateValue, t, n + 1), t.oneofs && (r.value = "fileUploaderStateValue")), e.stringTriggerValue != null && e.hasOwnProperty("stringTriggerValue") && (r.stringTriggerValue = N.StringTriggerValue.toObject(e.stringTriggerValue, t, n + 1), t.oneofs && (r.value = "stringTriggerValue")), e.chatInputValue != null && e.hasOwnProperty("chatInputValue") && (r.chatInputValue = N.ChatInputValue.toObject(e.chatInputValue, t, n + 1), t.oneofs && (r.value = "chatInputValue")), e.jsonTriggerValue != null && e.hasOwnProperty("jsonTriggerValue") && (r.jsonTriggerValue = e.jsonTriggerValue, t.oneofs && (r.value = "jsonTriggerValue")), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/WidgetState";
	}, e;
})(), N.StringArray = (() => {
	function e(e) {
		if (this.data = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.data = M.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.data != null && e.data.length) for (let n = 0; n < e.data.length; ++n) t.uint32(10).string(e.data[n]);
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.StringArray();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.data && o.data.length || (o.data = []), o.data.push(e.string());
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.StringArray) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.StringArray();
		if (e.data) {
			if (!Array.isArray(e.data)) throw TypeError(".StringArray.data: array expected");
			n.data = Array(e.data.length);
			for (let t = 0; t < e.data.length; ++t) n.data[t] = String(e.data[t]);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.data = []), e.data && e.data.length) {
			r.data = Array(e.data.length);
			for (let t = 0; t < e.data.length; ++t) r.data[t] = e.data[t];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/StringArray";
	}, e;
})(), N.DoubleArray = (() => {
	function e(e) {
		if (this.data = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.data = M.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.data != null && e.data.length) {
			t.uint32(10).fork();
			for (let n = 0; n < e.data.length; ++n) t.double(e.data[n]);
			t.ldelim();
		}
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.DoubleArray();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a === 2) {
						o.data && o.data.length || (o.data = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.data.push(e.double());
						continue;
					}
					if (a !== 1) break;
					o.data && o.data.length || (o.data = []), o.data.push(e.double());
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.DoubleArray) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.DoubleArray();
		if (e.data) {
			if (!Array.isArray(e.data)) throw TypeError(".DoubleArray.data: array expected");
			n.data = Array(e.data.length);
			for (let t = 0; t < e.data.length; ++t) n.data[t] = Number(e.data[t]);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.data = []), e.data && e.data.length) {
			r.data = Array(e.data.length);
			for (let n = 0; n < e.data.length; ++n) r.data[n] = t.json && !isFinite(e.data[n]) ? String(e.data[n]) : e.data[n];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/DoubleArray";
	}, e;
})(), N.Int32Array = (() => {
	function e(e) {
		if (this.data = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.data = M.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.data != null && e.data.length) {
			t.uint32(10).fork();
			for (let n = 0; n < e.data.length; ++n) t.int32(e.data[n]);
			t.ldelim();
		}
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Int32Array();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a === 2) {
						o.data && o.data.length || (o.data = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.data.push(e.int32());
						continue;
					}
					if (a !== 0) break;
					o.data && o.data.length || (o.data = []), o.data.push(e.int32());
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Int32Array) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Int32Array();
		if (e.data) {
			if (!Array.isArray(e.data)) throw TypeError(".Int32Array.data: array expected");
			n.data = Array(e.data.length);
			for (let t = 0; t < e.data.length; ++t) n.data[t] = e.data[t] | 0;
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.data = []), e.data && e.data.length) {
			r.data = Array(e.data.length);
			for (let t = 0; t < e.data.length; ++t) r.data[t] = e.data[t];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Int32Array";
	}, e;
})(), N.Int64Array = (() => {
	function e(e) {
		if (this.data = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.data = M.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.data != null && e.data.length) {
			t.uint32(10).fork();
			for (let n = 0; n < e.data.length; ++n) t.int64(e.data[n]);
			t.ldelim();
		}
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Int64Array();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a === 2) {
						o.data && o.data.length || (o.data = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.data.push(e.int64());
						continue;
					}
					if (a !== 0) break;
					o.data && o.data.length || (o.data = []), o.data.push(e.int64());
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Int64Array) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Int64Array();
		if (e.data) {
			if (!Array.isArray(e.data)) throw TypeError(".Int64Array.data: array expected");
			n.data = Array(e.data.length);
			for (let t = 0; t < e.data.length; ++t) M.Long ? n.data[t] = M.Long.fromValue(e.data[t], !1) : typeof e.data[t] == "string" ? n.data[t] = parseInt(e.data[t], 10) : typeof e.data[t] == "number" ? n.data[t] = e.data[t] : typeof e.data[t] == "object" && (n.data[t] = new M.LongBits(e.data[t].low >>> 0, e.data[t].high >>> 0).toNumber());
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.data = []), e.data && e.data.length) {
			r.data = Array(e.data.length);
			for (let n = 0; n < e.data.length; ++n) typeof BigInt < "u" && t.longs === BigInt ? r.data[n] = typeof e.data[n] == "number" ? BigInt(e.data[n]) : M.Long.fromBits(e.data[n].low >>> 0, e.data[n].high >>> 0, !1).toBigInt() : typeof e.data[n] == "number" ? r.data[n] = t.longs === String ? String(e.data[n]) : e.data[n] : r.data[n] = t.longs === String ? M.Long.prototype.toString.call(e.data[n]) : t.longs === Number ? new M.LongBits(e.data[n].low >>> 0, e.data[n].high >>> 0).toNumber() : e.data[n];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Int64Array";
	}, e;
})(), N.SInt64Array = (() => {
	function e(e) {
		if (this.data = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.data = M.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.data != null && e.data.length) {
			t.uint32(10).fork();
			for (let n = 0; n < e.data.length; ++n) t.sint64(e.data[n]);
			t.ldelim();
		}
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.SInt64Array();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a === 2) {
						o.data && o.data.length || (o.data = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.data.push(e.sint64());
						continue;
					}
					if (a !== 0) break;
					o.data && o.data.length || (o.data = []), o.data.push(e.sint64());
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.SInt64Array) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.SInt64Array();
		if (e.data) {
			if (!Array.isArray(e.data)) throw TypeError(".SInt64Array.data: array expected");
			n.data = Array(e.data.length);
			for (let t = 0; t < e.data.length; ++t) M.Long ? n.data[t] = M.Long.fromValue(e.data[t], !1) : typeof e.data[t] == "string" ? n.data[t] = parseInt(e.data[t], 10) : typeof e.data[t] == "number" ? n.data[t] = e.data[t] : typeof e.data[t] == "object" && (n.data[t] = new M.LongBits(e.data[t].low >>> 0, e.data[t].high >>> 0).toNumber());
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.data = []), e.data && e.data.length) {
			r.data = Array(e.data.length);
			for (let n = 0; n < e.data.length; ++n) typeof BigInt < "u" && t.longs === BigInt ? r.data[n] = typeof e.data[n] == "number" ? BigInt(e.data[n]) : M.Long.fromBits(e.data[n].low >>> 0, e.data[n].high >>> 0, !1).toBigInt() : typeof e.data[n] == "number" ? r.data[n] = t.longs === String ? String(e.data[n]) : e.data[n] : r.data[n] = t.longs === String ? M.Long.prototype.toString.call(e.data[n]) : t.longs === Number ? new M.LongBits(e.data[n].low >>> 0, e.data[n].high >>> 0).toNumber() : e.data[n];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/SInt64Array";
	}, e;
})(), N.UInt32Array = (() => {
	function e(e) {
		if (this.data = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.data = M.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.data != null && e.data.length) {
			t.uint32(10).fork();
			for (let n = 0; n < e.data.length; ++n) t.uint32(e.data[n]);
			t.ldelim();
		}
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.UInt32Array();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a === 2) {
						o.data && o.data.length || (o.data = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.data.push(e.uint32());
						continue;
					}
					if (a !== 0) break;
					o.data && o.data.length || (o.data = []), o.data.push(e.uint32());
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.UInt32Array) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.UInt32Array();
		if (e.data) {
			if (!Array.isArray(e.data)) throw TypeError(".UInt32Array.data: array expected");
			n.data = Array(e.data.length);
			for (let t = 0; t < e.data.length; ++t) n.data[t] = e.data[t] >>> 0;
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.data = []), e.data && e.data.length) {
			r.data = Array(e.data.length);
			for (let t = 0; t < e.data.length; ++t) r.data[t] = e.data[t];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/UInt32Array";
	}, e;
})(), N.StringTriggerValue = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.data = null;
	let t;
	return Object.defineProperty(e.prototype, "_data", {
		get: M.oneOfGetter(t = ["data"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.data != null && Object.hasOwnProperty.call(e, "data") && t.uint32(10).string(e.data), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.StringTriggerValue();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.data = e.string(), o._data = "data";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.StringTriggerValue) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.StringTriggerValue();
		return e.data != null && (n.data = String(e.data)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return e.data != null && e.hasOwnProperty("data") && (r.data = e.data), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/StringTriggerValue";
	}, e;
})(), N.FileURLsRequest = (() => {
	function e(e) {
		if (this.fileNames = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.requestId = "", e.prototype.fileNames = M.emptyArray, e.prototype.sessionId = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.requestId != null && Object.hasOwnProperty.call(e, "requestId") && t.uint32(10).string(e.requestId), e.fileNames != null && e.fileNames.length) for (let n = 0; n < e.fileNames.length; ++n) t.uint32(18).string(e.fileNames[n]);
		if (e.sessionId != null && Object.hasOwnProperty.call(e, "sessionId") && t.uint32(26).string(e.sessionId), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.FileURLsRequest(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.requestId = s : delete o.requestId;
					continue;
				case 2:
					if (a !== 2) break;
					o.fileNames && o.fileNames.length || (o.fileNames = []), o.fileNames.push(e.string());
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.sessionId = s : delete o.sessionId;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.FileURLsRequest) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.FileURLsRequest();
		if (e.requestId != null && (typeof e.requestId != "string" || e.requestId.length) && (n.requestId = String(e.requestId)), e.fileNames) {
			if (!Array.isArray(e.fileNames)) throw TypeError(".FileURLsRequest.fileNames: array expected");
			n.fileNames = Array(e.fileNames.length);
			for (let t = 0; t < e.fileNames.length; ++t) n.fileNames[t] = String(e.fileNames[t]);
		}
		return e.sessionId != null && (typeof e.sessionId != "string" || e.sessionId.length) && (n.sessionId = String(e.sessionId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.fileNames = []), t.defaults && (r.requestId = "", r.sessionId = ""), e.requestId != null && e.hasOwnProperty("requestId") && (r.requestId = e.requestId), e.fileNames && e.fileNames.length) {
			r.fileNames = Array(e.fileNames.length);
			for (let t = 0; t < e.fileNames.length; ++t) r.fileNames[t] = e.fileNames[t];
		}
		return e.sessionId != null && e.hasOwnProperty("sessionId") && (r.sessionId = e.sessionId), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/FileURLsRequest";
	}, e;
})(), N.FileURLs = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.fileId = "", e.prototype.uploadUrl = "", e.prototype.deleteUrl = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.fileId != null && Object.hasOwnProperty.call(e, "fileId") && t.uint32(10).string(e.fileId), e.uploadUrl != null && Object.hasOwnProperty.call(e, "uploadUrl") && t.uint32(18).string(e.uploadUrl), e.deleteUrl != null && Object.hasOwnProperty.call(e, "deleteUrl") && t.uint32(26).string(e.deleteUrl), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.FileURLs(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.fileId = s : delete o.fileId;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.uploadUrl = s : delete o.uploadUrl;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.deleteUrl = s : delete o.deleteUrl;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.FileURLs) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.FileURLs();
		return e.fileId != null && (typeof e.fileId != "string" || e.fileId.length) && (n.fileId = String(e.fileId)), e.uploadUrl != null && (typeof e.uploadUrl != "string" || e.uploadUrl.length) && (n.uploadUrl = String(e.uploadUrl)), e.deleteUrl != null && (typeof e.deleteUrl != "string" || e.deleteUrl.length) && (n.deleteUrl = String(e.deleteUrl)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.fileId = "", r.uploadUrl = "", r.deleteUrl = ""), e.fileId != null && e.hasOwnProperty("fileId") && (r.fileId = e.fileId), e.uploadUrl != null && e.hasOwnProperty("uploadUrl") && (r.uploadUrl = e.uploadUrl), e.deleteUrl != null && e.hasOwnProperty("deleteUrl") && (r.deleteUrl = e.deleteUrl), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/FileURLs";
	}, e;
})(), N.FileURLsResponse = (() => {
	function e(e) {
		if (this.fileUrls = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.responseId = "", e.prototype.fileUrls = M.emptyArray, e.prototype.errorMsg = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.responseId != null && Object.hasOwnProperty.call(e, "responseId") && t.uint32(10).string(e.responseId), e.fileUrls != null && e.fileUrls.length) for (let r = 0; r < e.fileUrls.length; ++r) N.FileURLs.encode(e.fileUrls[r], t.uint32(18).fork(), n + 1).ldelim();
		if (e.errorMsg != null && Object.hasOwnProperty.call(e, "errorMsg") && t.uint32(26).string(e.errorMsg), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.FileURLsResponse(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.responseId = s : delete o.responseId;
					continue;
				case 2:
					if (a !== 2) break;
					o.fileUrls && o.fileUrls.length || (o.fileUrls = []), o.fileUrls.push(N.FileURLs.decode(e, e.uint32(), void 0, r + 1));
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.errorMsg = s : delete o.errorMsg;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.FileURLsResponse) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.FileURLsResponse();
		if (e.responseId != null && (typeof e.responseId != "string" || e.responseId.length) && (n.responseId = String(e.responseId)), e.fileUrls) {
			if (!Array.isArray(e.fileUrls)) throw TypeError(".FileURLsResponse.fileUrls: array expected");
			n.fileUrls = Array(e.fileUrls.length);
			for (let r = 0; r < e.fileUrls.length; ++r) {
				if (typeof e.fileUrls[r] != "object") throw TypeError(".FileURLsResponse.fileUrls: object expected");
				n.fileUrls[r] = N.FileURLs.fromObject(e.fileUrls[r], t + 1);
			}
		}
		return e.errorMsg != null && (typeof e.errorMsg != "string" || e.errorMsg.length) && (n.errorMsg = String(e.errorMsg)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.fileUrls = []), t.defaults && (r.responseId = "", r.errorMsg = ""), e.responseId != null && e.hasOwnProperty("responseId") && (r.responseId = e.responseId), e.fileUrls && e.fileUrls.length) {
			r.fileUrls = Array(e.fileUrls.length);
			for (let i = 0; i < e.fileUrls.length; ++i) r.fileUrls[i] = N.FileURLs.toObject(e.fileUrls[i], t, n + 1);
		}
		return e.errorMsg != null && e.hasOwnProperty("errorMsg") && (r.errorMsg = e.errorMsg), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/FileURLsResponse";
	}, e;
})(), N.UploadedFileInfo = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.name = "", e.prototype.size = M.Long ? M.Long.fromBits(0, 0, !0) : 0, e.prototype.fileId = "", e.prototype.fileUrls = null, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(18).string(e.name), e.size != null && Object.hasOwnProperty.call(e, "size") && t.uint32(24).uint64(e.size), e.fileId != null && Object.hasOwnProperty.call(e, "fileId") && t.uint32(34).string(e.fileId), e.fileUrls != null && Object.hasOwnProperty.call(e, "fileUrls") && N.FileURLs.encode(e.fileUrls, t.uint32(42).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.UploadedFileInfo(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.name = s : delete o.name;
					continue;
				case 3:
					if (a !== 0) break;
					(typeof (s = e.uint64()) == "object" ? s.low || s.high : s !== 0) ? o.size = s : delete o.size;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.fileId = s : delete o.fileId;
					continue;
				case 5:
					if (a !== 2) break;
					o.fileUrls = N.FileURLs.decode(e, e.uint32(), void 0, r + 1, o.fileUrls);
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.UploadedFileInfo) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.UploadedFileInfo();
		if (e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = String(e.name)), e.size != null && (typeof e.size == "object" ? e.size.low || e.size.high : Number(e.size) !== 0) && (M.Long ? n.size = M.Long.fromValue(e.size, !0) : typeof e.size == "string" ? n.size = parseInt(e.size, 10) : typeof e.size == "number" ? n.size = e.size : typeof e.size == "object" && (n.size = new M.LongBits(e.size.low >>> 0, e.size.high >>> 0).toNumber(!0))), e.fileId != null && (typeof e.fileId != "string" || e.fileId.length) && (n.fileId = String(e.fileId)), e.fileUrls != null) {
			if (typeof e.fileUrls != "object") throw TypeError(".UploadedFileInfo.fileUrls: object expected");
			n.fileUrls = N.FileURLs.fromObject(e.fileUrls, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if (t.defaults) {
			if (r.name = "", M.Long) {
				let e = new M.Long(0, 0, !0);
				r.size = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
			} else r.size = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
			r.fileId = "", r.fileUrls = null;
		}
		return e.name != null && e.hasOwnProperty("name") && (r.name = e.name), e.size != null && e.hasOwnProperty("size") && (typeof BigInt < "u" && t.longs === BigInt ? r.size = typeof e.size == "number" ? BigInt(e.size) : M.Long.fromBits(e.size.low >>> 0, e.size.high >>> 0, !0).toBigInt() : typeof e.size == "number" ? r.size = t.longs === String ? String(e.size) : e.size : r.size = t.longs === String ? M.Long.prototype.toString.call(e.size) : t.longs === Number ? new M.LongBits(e.size.low >>> 0, e.size.high >>> 0).toNumber(!0) : e.size), e.fileId != null && e.hasOwnProperty("fileId") && (r.fileId = e.fileId), e.fileUrls != null && e.hasOwnProperty("fileUrls") && (r.fileUrls = N.FileURLs.toObject(e.fileUrls, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/UploadedFileInfo";
	}, e;
})(), N.FileUploaderState = (() => {
	function e(e) {
		if (this.uploadedFileInfo = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.uploadedFileInfo = M.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.uploadedFileInfo != null && e.uploadedFileInfo.length) for (let r = 0; r < e.uploadedFileInfo.length; ++r) N.UploadedFileInfo.encode(e.uploadedFileInfo[r], t.uint32(18).fork(), n + 1).ldelim();
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.FileUploaderState();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 2:
					if (a !== 2) break;
					o.uploadedFileInfo && o.uploadedFileInfo.length || (o.uploadedFileInfo = []), o.uploadedFileInfo.push(N.UploadedFileInfo.decode(e, e.uint32(), void 0, r + 1));
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.FileUploaderState) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.FileUploaderState();
		if (e.uploadedFileInfo) {
			if (!Array.isArray(e.uploadedFileInfo)) throw TypeError(".FileUploaderState.uploadedFileInfo: array expected");
			n.uploadedFileInfo = Array(e.uploadedFileInfo.length);
			for (let r = 0; r < e.uploadedFileInfo.length; ++r) {
				if (typeof e.uploadedFileInfo[r] != "object") throw TypeError(".FileUploaderState.uploadedFileInfo: object expected");
				n.uploadedFileInfo[r] = N.UploadedFileInfo.fromObject(e.uploadedFileInfo[r], t + 1);
			}
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.uploadedFileInfo = []), e.uploadedFileInfo && e.uploadedFileInfo.length) {
			r.uploadedFileInfo = Array(e.uploadedFileInfo.length);
			for (let i = 0; i < e.uploadedFileInfo.length; ++i) r.uploadedFileInfo[i] = N.UploadedFileInfo.toObject(e.uploadedFileInfo[i], t, n + 1);
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/FileUploaderState";
	}, e;
})(), N.ChatInputValue = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.data = null, e.prototype.fileUploaderState = null, e.prototype.audioFileInfo = null;
	let t;
	return Object.defineProperty(e.prototype, "_data", {
		get: M.oneOfGetter(t = ["data"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_fileUploaderState", {
		get: M.oneOfGetter(t = ["fileUploaderState"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_audioFileInfo", {
		get: M.oneOfGetter(t = ["audioFileInfo"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.data != null && Object.hasOwnProperty.call(e, "data") && t.uint32(10).string(e.data), e.fileUploaderState != null && Object.hasOwnProperty.call(e, "fileUploaderState") && N.FileUploaderState.encode(e.fileUploaderState, t.uint32(18).fork(), n + 1).ldelim(), e.audioFileInfo != null && Object.hasOwnProperty.call(e, "audioFileInfo") && N.UploadedFileInfo.encode(e.audioFileInfo, t.uint32(26).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ChatInputValue();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.data = e.string(), o._data = "data";
					continue;
				case 2:
					if (a !== 2) break;
					o.fileUploaderState = N.FileUploaderState.decode(e, e.uint32(), void 0, r + 1, o.fileUploaderState), o._fileUploaderState = "fileUploaderState";
					continue;
				case 3:
					if (a !== 2) break;
					o.audioFileInfo = N.UploadedFileInfo.decode(e, e.uint32(), void 0, r + 1, o.audioFileInfo), o._audioFileInfo = "audioFileInfo";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ChatInputValue) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ChatInputValue();
		if (e.data != null && (n.data = String(e.data)), e.fileUploaderState != null) {
			if (typeof e.fileUploaderState != "object") throw TypeError(".ChatInputValue.fileUploaderState: object expected");
			n.fileUploaderState = N.FileUploaderState.fromObject(e.fileUploaderState, t + 1);
		}
		if (e.audioFileInfo != null) {
			if (typeof e.audioFileInfo != "object") throw TypeError(".ChatInputValue.audioFileInfo: object expected");
			n.audioFileInfo = N.UploadedFileInfo.fromObject(e.audioFileInfo, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return e.data != null && e.hasOwnProperty("data") && (r.data = e.data), e.fileUploaderState != null && e.hasOwnProperty("fileUploaderState") && (r.fileUploaderState = N.FileUploaderState.toObject(e.fileUploaderState, t, n + 1)), e.audioFileInfo != null && e.hasOwnProperty("audioFileInfo") && (r.audioFileInfo = N.UploadedFileInfo.toObject(e.audioFileInfo, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ChatInputValue";
	}, e;
})(), N.ComponentInstance = (() => {
	function e(e) {
		if (this.specialArgs = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.jsonArgs = "", e.prototype.specialArgs = M.emptyArray, e.prototype.componentName = "", e.prototype.url = "", e.prototype.formId = "", e.prototype.tabIndex = null;
	let t;
	return Object.defineProperty(e.prototype, "_tabIndex", {
		get: M.oneOfGetter(t = ["tabIndex"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.jsonArgs != null && Object.hasOwnProperty.call(e, "jsonArgs") && t.uint32(18).string(e.jsonArgs), e.specialArgs != null && e.specialArgs.length) for (let r = 0; r < e.specialArgs.length; ++r) N.SpecialArg.encode(e.specialArgs[r], t.uint32(26).fork(), n + 1).ldelim();
		if (e.componentName != null && Object.hasOwnProperty.call(e, "componentName") && t.uint32(34).string(e.componentName), e.url != null && Object.hasOwnProperty.call(e, "url") && t.uint32(42).string(e.url), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(50).string(e.formId), e.tabIndex != null && Object.hasOwnProperty.call(e, "tabIndex") && t.uint32(56).int32(e.tabIndex), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ComponentInstance(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.jsonArgs = s : delete o.jsonArgs;
					continue;
				case 3:
					if (a !== 2) break;
					o.specialArgs && o.specialArgs.length || (o.specialArgs = []), o.specialArgs.push(N.SpecialArg.decode(e, e.uint32(), void 0, r + 1));
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.componentName = s : delete o.componentName;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.url = s : delete o.url;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 7:
					if (a !== 0) break;
					o.tabIndex = e.int32(), o._tabIndex = "tabIndex";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ComponentInstance) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ComponentInstance();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.jsonArgs != null && (typeof e.jsonArgs != "string" || e.jsonArgs.length) && (n.jsonArgs = String(e.jsonArgs)), e.specialArgs) {
			if (!Array.isArray(e.specialArgs)) throw TypeError(".ComponentInstance.specialArgs: array expected");
			n.specialArgs = Array(e.specialArgs.length);
			for (let r = 0; r < e.specialArgs.length; ++r) {
				if (typeof e.specialArgs[r] != "object") throw TypeError(".ComponentInstance.specialArgs: object expected");
				n.specialArgs[r] = N.SpecialArg.fromObject(e.specialArgs[r], t + 1);
			}
		}
		return e.componentName != null && (typeof e.componentName != "string" || e.componentName.length) && (n.componentName = String(e.componentName)), e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = String(e.url)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.tabIndex != null && (n.tabIndex = e.tabIndex | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.specialArgs = []), t.defaults && (r.id = "", r.jsonArgs = "", r.componentName = "", r.url = "", r.formId = ""), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.jsonArgs != null && e.hasOwnProperty("jsonArgs") && (r.jsonArgs = e.jsonArgs), e.specialArgs && e.specialArgs.length) {
			r.specialArgs = Array(e.specialArgs.length);
			for (let i = 0; i < e.specialArgs.length; ++i) r.specialArgs[i] = N.SpecialArg.toObject(e.specialArgs[i], t, n + 1);
		}
		return e.componentName != null && e.hasOwnProperty("componentName") && (r.componentName = e.componentName), e.url != null && e.hasOwnProperty("url") && (r.url = e.url), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.tabIndex != null && e.hasOwnProperty("tabIndex") && (r.tabIndex = e.tabIndex), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ComponentInstance";
	}, e;
})(), N.SpecialArg = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.key = "", e.prototype.arrowDataframe = null, e.prototype.bytes = null;
	let t;
	return Object.defineProperty(e.prototype, "value", {
		get: M.oneOfGetter(t = ["arrowDataframe", "bytes"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.key != null && Object.hasOwnProperty.call(e, "key") && t.uint32(10).string(e.key), e.arrowDataframe != null && Object.hasOwnProperty.call(e, "arrowDataframe") && N.ArrowDataframe.encode(e.arrowDataframe, t.uint32(18).fork(), n + 1).ldelim(), e.bytes != null && Object.hasOwnProperty.call(e, "bytes") && t.uint32(26).bytes(e.bytes), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.SpecialArg(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.key = s : delete o.key;
					continue;
				case 2:
					if (a !== 2) break;
					o.arrowDataframe = N.ArrowDataframe.decode(e, e.uint32(), void 0, r + 1, o.arrowDataframe), o.value = "arrowDataframe";
					continue;
				case 3:
					if (a !== 2) break;
					o.bytes = e.bytes(), o.value = "bytes";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.SpecialArg) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.SpecialArg();
		if (e.key != null && (typeof e.key != "string" || e.key.length) && (n.key = String(e.key)), e.arrowDataframe != null) {
			if (typeof e.arrowDataframe != "object") throw TypeError(".SpecialArg.arrowDataframe: object expected");
			n.arrowDataframe = N.ArrowDataframe.fromObject(e.arrowDataframe, t + 1);
		}
		return e.bytes != null && (typeof e.bytes == "string" ? M.base64.decode(e.bytes, n.bytes = M.newBuffer(M.base64.length(e.bytes)), 0) : e.bytes.length >= 0 && (n.bytes = e.bytes)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.key = ""), e.key != null && e.hasOwnProperty("key") && (r.key = e.key), e.arrowDataframe != null && e.hasOwnProperty("arrowDataframe") && (r.arrowDataframe = N.ArrowDataframe.toObject(e.arrowDataframe, t, n + 1), t.oneofs && (r.value = "arrowDataframe")), e.bytes != null && e.hasOwnProperty("bytes") && (r.bytes = t.bytes === String ? M.base64.encode(e.bytes, 0, e.bytes.length) : t.bytes === Array ? Array.prototype.slice.call(e.bytes) : e.bytes, t.oneofs && (r.value = "bytes")), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/SpecialArg";
	}, e;
})(), N.ArrowDataframe = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.data = null, e.prototype.height = 0, e.prototype.width = 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.data != null && Object.hasOwnProperty.call(e, "data") && N.ArrowTable.encode(e.data, t.uint32(10).fork(), n + 1).ldelim(), e.height != null && Object.hasOwnProperty.call(e, "height") && t.uint32(16).uint32(e.height), e.width != null && Object.hasOwnProperty.call(e, "width") && t.uint32(24).uint32(e.width), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ArrowDataframe(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.data = N.ArrowTable.decode(e, e.uint32(), void 0, r + 1, o.data);
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.uint32()) ? o.height = s : delete o.height;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.uint32()) ? o.width = s : delete o.width;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ArrowDataframe) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ArrowDataframe();
		if (e.data != null) {
			if (typeof e.data != "object") throw TypeError(".ArrowDataframe.data: object expected");
			n.data = N.ArrowTable.fromObject(e.data, t + 1);
		}
		return e.height != null && Number(e.height) !== 0 && (n.height = e.height >>> 0), e.width != null && Number(e.width) !== 0 && (n.width = e.width >>> 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.data = null, r.height = 0, r.width = 0), e.data != null && e.hasOwnProperty("data") && (r.data = N.ArrowTable.toObject(e.data, t, n + 1)), e.height != null && e.hasOwnProperty("height") && (r.height = e.height), e.width != null && e.hasOwnProperty("width") && (r.width = e.width), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ArrowDataframe";
	}, e;
})(), N.ArrowTable = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.data = M.newBuffer([]), e.prototype.index = M.newBuffer([]), e.prototype.columns = M.newBuffer([]), e.prototype.styler = null, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.data != null && Object.hasOwnProperty.call(e, "data") && t.uint32(10).bytes(e.data), e.index != null && Object.hasOwnProperty.call(e, "index") && t.uint32(18).bytes(e.index), e.columns != null && Object.hasOwnProperty.call(e, "columns") && t.uint32(26).bytes(e.columns), e.styler != null && Object.hasOwnProperty.call(e, "styler") && N.ArrowTableStyler.encode(e.styler, t.uint32(42).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ArrowTable(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.bytes()).length ? o.data = s : delete o.data;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.bytes()).length ? o.index = s : delete o.index;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.bytes()).length ? o.columns = s : delete o.columns;
					continue;
				case 5:
					if (a !== 2) break;
					o.styler = N.ArrowTableStyler.decode(e, e.uint32(), void 0, r + 1, o.styler);
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ArrowTable) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ArrowTable();
		if (e.data != null && e.data.length && (typeof e.data == "string" ? M.base64.decode(e.data, n.data = M.newBuffer(M.base64.length(e.data)), 0) : e.data.length >= 0 && (n.data = e.data)), e.index != null && e.index.length && (typeof e.index == "string" ? M.base64.decode(e.index, n.index = M.newBuffer(M.base64.length(e.index)), 0) : e.index.length >= 0 && (n.index = e.index)), e.columns != null && e.columns.length && (typeof e.columns == "string" ? M.base64.decode(e.columns, n.columns = M.newBuffer(M.base64.length(e.columns)), 0) : e.columns.length >= 0 && (n.columns = e.columns)), e.styler != null) {
			if (typeof e.styler != "object") throw TypeError(".ArrowTable.styler: object expected");
			n.styler = N.ArrowTableStyler.fromObject(e.styler, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (t.bytes === String ? r.data = "" : (r.data = [], t.bytes !== Array && (r.data = M.newBuffer(r.data))), t.bytes === String ? r.index = "" : (r.index = [], t.bytes !== Array && (r.index = M.newBuffer(r.index))), t.bytes === String ? r.columns = "" : (r.columns = [], t.bytes !== Array && (r.columns = M.newBuffer(r.columns))), r.styler = null), e.data != null && e.hasOwnProperty("data") && (r.data = t.bytes === String ? M.base64.encode(e.data, 0, e.data.length) : t.bytes === Array ? Array.prototype.slice.call(e.data) : e.data), e.index != null && e.hasOwnProperty("index") && (r.index = t.bytes === String ? M.base64.encode(e.index, 0, e.index.length) : t.bytes === Array ? Array.prototype.slice.call(e.index) : e.index), e.columns != null && e.hasOwnProperty("columns") && (r.columns = t.bytes === String ? M.base64.encode(e.columns, 0, e.columns.length) : t.bytes === Array ? Array.prototype.slice.call(e.columns) : e.columns), e.styler != null && e.hasOwnProperty("styler") && (r.styler = N.ArrowTableStyler.toObject(e.styler, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ArrowTable";
	}, e;
})(), N.ArrowTableStyler = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.uuid = "", e.prototype.caption = "", e.prototype.styles = "", e.prototype.displayValues = M.newBuffer([]), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.uuid != null && Object.hasOwnProperty.call(e, "uuid") && t.uint32(10).string(e.uuid), e.caption != null && Object.hasOwnProperty.call(e, "caption") && t.uint32(18).string(e.caption), e.styles != null && Object.hasOwnProperty.call(e, "styles") && t.uint32(26).string(e.styles), e.displayValues != null && Object.hasOwnProperty.call(e, "displayValues") && t.uint32(34).bytes(e.displayValues), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ArrowTableStyler(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.uuid = s : delete o.uuid;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.caption = s : delete o.caption;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.styles = s : delete o.styles;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.bytes()).length ? o.displayValues = s : delete o.displayValues;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ArrowTableStyler) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ArrowTableStyler();
		return e.uuid != null && (typeof e.uuid != "string" || e.uuid.length) && (n.uuid = String(e.uuid)), e.caption != null && (typeof e.caption != "string" || e.caption.length) && (n.caption = String(e.caption)), e.styles != null && (typeof e.styles != "string" || e.styles.length) && (n.styles = String(e.styles)), e.displayValues != null && e.displayValues.length && (typeof e.displayValues == "string" ? M.base64.decode(e.displayValues, n.displayValues = M.newBuffer(M.base64.length(e.displayValues)), 0) : e.displayValues.length >= 0 && (n.displayValues = e.displayValues)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.uuid = "", r.caption = "", r.styles = "", t.bytes === String ? r.displayValues = "" : (r.displayValues = [], t.bytes !== Array && (r.displayValues = M.newBuffer(r.displayValues)))), e.uuid != null && e.hasOwnProperty("uuid") && (r.uuid = e.uuid), e.caption != null && e.hasOwnProperty("caption") && (r.caption = e.caption), e.styles != null && e.hasOwnProperty("styles") && (r.styles = e.styles), e.displayValues != null && e.hasOwnProperty("displayValues") && (r.displayValues = t.bytes === String ? M.base64.encode(e.displayValues, 0, e.displayValues.length) : t.bytes === Array ? Array.prototype.slice.call(e.displayValues) : e.displayValues), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ArrowTableStyler";
	}, e;
})(), N.Balloons = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.show = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.show != null && Object.hasOwnProperty.call(e, "show") && t.uint32(24).bool(e.show), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Balloons(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.show = s : delete o.show;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Balloons) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Balloons();
		return e.show != null && e.show && (n.show = !!e.show), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.show = !1), e.show != null && e.hasOwnProperty("show") && (r.show = e.show), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Balloons";
	}, e;
})(), N.MixedData = (() => {
	function e(e) {
		if (this.arrowBlobs = {}, e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.json = "", e.prototype.arrowBlobs = M.emptyObject, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.json != null && Object.hasOwnProperty.call(e, "json") && t.uint32(10).string(e.json), e.arrowBlobs != null && Object.hasOwnProperty.call(e, "arrowBlobs")) for (let r = Object.keys(e.arrowBlobs), i = 0; i < r.length; ++i) t.uint32(18).fork().uint32(10).string(r[i]), N.ArrowData.encode(e.arrowBlobs[r[i]], t.uint32(18).fork(), n + 1).ldelim().ldelim();
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.MixedData(), s, c;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(c = e.string()).length ? o.json = c : delete o.json;
					continue;
				case 2: {
					if (a !== 2) break;
					o.arrowBlobs === M.emptyObject && (o.arrowBlobs = {});
					let t = e.uint32() + e.pos;
					for (s = "", c = null; e.pos < t;) {
						let t = e.tag();
						switch (a = t & 7, t >>>= 3) {
							case 1:
								if (a !== 2) break;
								s = e.string();
								continue;
							case 2:
								if (a !== 2) break;
								c = N.ArrowData.decode(e, e.uint32(), void 0, r + 1);
								continue;
						}
						e.skipType(a, r, t);
					}
					s === "__proto__" && M.makeProp(o.arrowBlobs, s), o.arrowBlobs[s] = c || new N.ArrowData();
					continue;
				}
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.MixedData) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.MixedData();
		if (e.json != null && (typeof e.json != "string" || e.json.length) && (n.json = String(e.json)), e.arrowBlobs) {
			if (typeof e.arrowBlobs != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
			n.arrowBlobs = {};
			for (let r = Object.keys(e.arrowBlobs), i = 0; i < r.length; ++i) {
				if (r[i] === "__proto__" && M.makeProp(n.arrowBlobs, r[i]), typeof e.arrowBlobs[r[i]] != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
				n.arrowBlobs[r[i]] = N.ArrowData.fromObject(e.arrowBlobs[r[i]], t + 1);
			}
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		(t.objects || t.defaults) && (r.arrowBlobs = {}), t.defaults && (r.json = ""), e.json != null && e.hasOwnProperty("json") && (r.json = e.json);
		let i;
		if (e.arrowBlobs && (i = Object.keys(e.arrowBlobs)).length) {
			r.arrowBlobs = {};
			for (let a = 0; a < i.length; ++a) i[a] === "__proto__" && M.makeProp(r.arrowBlobs, i[a]), r.arrowBlobs[i[a]] = N.ArrowData.toObject(e.arrowBlobs[i[a]], t, n + 1);
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/MixedData";
	}, e;
})(), N.BidiComponent = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.componentName = "", e.prototype.jsContent = null, e.prototype.jsSourcePath = null, e.prototype.formId = "", e.prototype.htmlContent = null, e.prototype.cssContent = null, e.prototype.cssSourcePath = null, e.prototype.isolateStyles = !1, e.prototype.json = null, e.prototype.arrowData = null, e.prototype.bytes = null, e.prototype.mixed = null;
	let t;
	return Object.defineProperty(e.prototype, "_jsContent", {
		get: M.oneOfGetter(t = ["jsContent"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_jsSourcePath", {
		get: M.oneOfGetter(t = ["jsSourcePath"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_htmlContent", {
		get: M.oneOfGetter(t = ["htmlContent"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_cssContent", {
		get: M.oneOfGetter(t = ["cssContent"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_cssSourcePath", {
		get: M.oneOfGetter(t = ["cssSourcePath"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "data", {
		get: M.oneOfGetter(t = [
			"json",
			"arrowData",
			"bytes",
			"mixed"
		]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.componentName != null && Object.hasOwnProperty.call(e, "componentName") && t.uint32(18).string(e.componentName), e.jsContent != null && Object.hasOwnProperty.call(e, "jsContent") && t.uint32(26).string(e.jsContent), e.jsSourcePath != null && Object.hasOwnProperty.call(e, "jsSourcePath") && t.uint32(34).string(e.jsSourcePath), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(42).string(e.formId), e.htmlContent != null && Object.hasOwnProperty.call(e, "htmlContent") && t.uint32(50).string(e.htmlContent), e.cssContent != null && Object.hasOwnProperty.call(e, "cssContent") && t.uint32(58).string(e.cssContent), e.cssSourcePath != null && Object.hasOwnProperty.call(e, "cssSourcePath") && t.uint32(66).string(e.cssSourcePath), e.isolateStyles != null && Object.hasOwnProperty.call(e, "isolateStyles") && t.uint32(72).bool(e.isolateStyles), e.json != null && Object.hasOwnProperty.call(e, "json") && t.uint32(82).string(e.json), e.arrowData != null && Object.hasOwnProperty.call(e, "arrowData") && N.ArrowData.encode(e.arrowData, t.uint32(90).fork(), n + 1).ldelim(), e.bytes != null && Object.hasOwnProperty.call(e, "bytes") && t.uint32(98).bytes(e.bytes), e.mixed != null && Object.hasOwnProperty.call(e, "mixed") && N.MixedData.encode(e.mixed, t.uint32(106).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.BidiComponent(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.componentName = s : delete o.componentName;
					continue;
				case 3:
					if (a !== 2) break;
					o.jsContent = e.string(), o._jsContent = "jsContent";
					continue;
				case 4:
					if (a !== 2) break;
					o.jsSourcePath = e.string(), o._jsSourcePath = "jsSourcePath";
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 2) break;
					o.htmlContent = e.string(), o._htmlContent = "htmlContent";
					continue;
				case 7:
					if (a !== 2) break;
					o.cssContent = e.string(), o._cssContent = "cssContent";
					continue;
				case 8:
					if (a !== 2) break;
					o.cssSourcePath = e.string(), o._cssSourcePath = "cssSourcePath";
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.isolateStyles = s : delete o.isolateStyles;
					continue;
				case 10:
					if (a !== 2) break;
					o.json = e.string(), o.data = "json";
					continue;
				case 11:
					if (a !== 2) break;
					o.arrowData = N.ArrowData.decode(e, e.uint32(), void 0, r + 1, o.arrowData), o.data = "arrowData";
					continue;
				case 12:
					if (a !== 2) break;
					o.bytes = e.bytes(), o.data = "bytes";
					continue;
				case 13:
					if (a !== 2) break;
					o.mixed = N.MixedData.decode(e, e.uint32(), void 0, r + 1, o.mixed), o.data = "mixed";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.BidiComponent) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.BidiComponent();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.componentName != null && (typeof e.componentName != "string" || e.componentName.length) && (n.componentName = String(e.componentName)), e.jsContent != null && (n.jsContent = String(e.jsContent)), e.jsSourcePath != null && (n.jsSourcePath = String(e.jsSourcePath)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.htmlContent != null && (n.htmlContent = String(e.htmlContent)), e.cssContent != null && (n.cssContent = String(e.cssContent)), e.cssSourcePath != null && (n.cssSourcePath = String(e.cssSourcePath)), e.isolateStyles != null && e.isolateStyles && (n.isolateStyles = !!e.isolateStyles), e.json != null && (n.json = String(e.json)), e.arrowData != null) {
			if (typeof e.arrowData != "object") throw TypeError(".BidiComponent.arrowData: object expected");
			n.arrowData = N.ArrowData.fromObject(e.arrowData, t + 1);
		}
		if (e.bytes != null && (typeof e.bytes == "string" ? M.base64.decode(e.bytes, n.bytes = M.newBuffer(M.base64.length(e.bytes)), 0) : e.bytes.length >= 0 && (n.bytes = e.bytes)), e.mixed != null) {
			if (typeof e.mixed != "object") throw TypeError(".BidiComponent.mixed: object expected");
			n.mixed = N.MixedData.fromObject(e.mixed, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.componentName = "", r.formId = "", r.isolateStyles = !1), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.componentName != null && e.hasOwnProperty("componentName") && (r.componentName = e.componentName), e.jsContent != null && e.hasOwnProperty("jsContent") && (r.jsContent = e.jsContent), e.jsSourcePath != null && e.hasOwnProperty("jsSourcePath") && (r.jsSourcePath = e.jsSourcePath), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.htmlContent != null && e.hasOwnProperty("htmlContent") && (r.htmlContent = e.htmlContent), e.cssContent != null && e.hasOwnProperty("cssContent") && (r.cssContent = e.cssContent), e.cssSourcePath != null && e.hasOwnProperty("cssSourcePath") && (r.cssSourcePath = e.cssSourcePath), e.isolateStyles != null && e.hasOwnProperty("isolateStyles") && (r.isolateStyles = e.isolateStyles), e.json != null && e.hasOwnProperty("json") && (r.json = e.json, t.oneofs && (r.data = "json")), e.arrowData != null && e.hasOwnProperty("arrowData") && (r.arrowData = N.ArrowData.toObject(e.arrowData, t, n + 1), t.oneofs && (r.data = "arrowData")), e.bytes != null && e.hasOwnProperty("bytes") && (r.bytes = t.bytes === String ? M.base64.encode(e.bytes, 0, e.bytes.length) : t.bytes === Array ? Array.prototype.slice.call(e.bytes) : e.bytes, t.oneofs && (r.data = "bytes")), e.mixed != null && e.hasOwnProperty("mixed") && (r.mixed = N.MixedData.toObject(e.mixed, t, n + 1), t.oneofs && (r.data = "mixed")), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/BidiComponent";
	}, e;
})(), N.Block = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.vertical = null, e.prototype.horizontal = null, e.prototype.column = null, e.prototype.expandable = null, e.prototype.form = null, e.prototype.tabContainer = null, e.prototype.tab = null, e.prototype.chatMessage = null, e.prototype.popover = null, e.prototype.dialog = null, e.prototype.flexContainer = null, e.prototype.allowEmpty = !1, e.prototype.id = null, e.prototype.heightConfig = null, e.prototype.widthConfig = null, e.prototype.autoscroll = null;
	let t;
	return Object.defineProperty(e.prototype, "type", {
		get: M.oneOfGetter(t = [
			"vertical",
			"horizontal",
			"column",
			"expandable",
			"form",
			"tabContainer",
			"tab",
			"chatMessage",
			"popover",
			"dialog",
			"flexContainer"
		]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_id", {
		get: M.oneOfGetter(t = ["id"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_heightConfig", {
		get: M.oneOfGetter(t = ["heightConfig"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_widthConfig", {
		get: M.oneOfGetter(t = ["widthConfig"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_autoscroll", {
		get: M.oneOfGetter(t = ["autoscroll"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.vertical != null && Object.hasOwnProperty.call(e, "vertical") && N.Block.Vertical.encode(e.vertical, t.uint32(10).fork(), n + 1).ldelim(), e.horizontal != null && Object.hasOwnProperty.call(e, "horizontal") && N.Block.Horizontal.encode(e.horizontal, t.uint32(18).fork(), n + 1).ldelim(), e.column != null && Object.hasOwnProperty.call(e, "column") && N.Block.Column.encode(e.column, t.uint32(26).fork(), n + 1).ldelim(), e.expandable != null && Object.hasOwnProperty.call(e, "expandable") && N.Block.Expandable.encode(e.expandable, t.uint32(34).fork(), n + 1).ldelim(), e.form != null && Object.hasOwnProperty.call(e, "form") && N.Block.Form.encode(e.form, t.uint32(42).fork(), n + 1).ldelim(), e.tabContainer != null && Object.hasOwnProperty.call(e, "tabContainer") && N.Block.TabContainer.encode(e.tabContainer, t.uint32(50).fork(), n + 1).ldelim(), e.tab != null && Object.hasOwnProperty.call(e, "tab") && N.Block.Tab.encode(e.tab, t.uint32(58).fork(), n + 1).ldelim(), e.allowEmpty != null && Object.hasOwnProperty.call(e, "allowEmpty") && t.uint32(64).bool(e.allowEmpty), e.chatMessage != null && Object.hasOwnProperty.call(e, "chatMessage") && N.Block.ChatMessage.encode(e.chatMessage, t.uint32(74).fork(), n + 1).ldelim(), e.popover != null && Object.hasOwnProperty.call(e, "popover") && N.Block.Popover.encode(e.popover, t.uint32(82).fork(), n + 1).ldelim(), e.dialog != null && Object.hasOwnProperty.call(e, "dialog") && N.Block.Dialog.encode(e.dialog, t.uint32(90).fork(), n + 1).ldelim(), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(98).string(e.id), e.flexContainer != null && Object.hasOwnProperty.call(e, "flexContainer") && N.Block.FlexContainer.encode(e.flexContainer, t.uint32(106).fork(), n + 1).ldelim(), e.heightConfig != null && Object.hasOwnProperty.call(e, "heightConfig") && N.streamlit.HeightConfig.encode(e.heightConfig, t.uint32(114).fork(), n + 1).ldelim(), e.widthConfig != null && Object.hasOwnProperty.call(e, "widthConfig") && N.streamlit.WidthConfig.encode(e.widthConfig, t.uint32(122).fork(), n + 1).ldelim(), e.autoscroll != null && Object.hasOwnProperty.call(e, "autoscroll") && t.uint32(128).bool(e.autoscroll), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Block(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.vertical = N.Block.Vertical.decode(e, e.uint32(), void 0, r + 1, o.vertical), o.type = "vertical";
					continue;
				case 2:
					if (a !== 2) break;
					o.horizontal = N.Block.Horizontal.decode(e, e.uint32(), void 0, r + 1, o.horizontal), o.type = "horizontal";
					continue;
				case 3:
					if (a !== 2) break;
					o.column = N.Block.Column.decode(e, e.uint32(), void 0, r + 1, o.column), o.type = "column";
					continue;
				case 4:
					if (a !== 2) break;
					o.expandable = N.Block.Expandable.decode(e, e.uint32(), void 0, r + 1, o.expandable), o.type = "expandable";
					continue;
				case 5:
					if (a !== 2) break;
					o.form = N.Block.Form.decode(e, e.uint32(), void 0, r + 1, o.form), o.type = "form";
					continue;
				case 6:
					if (a !== 2) break;
					o.tabContainer = N.Block.TabContainer.decode(e, e.uint32(), void 0, r + 1, o.tabContainer), o.type = "tabContainer";
					continue;
				case 7:
					if (a !== 2) break;
					o.tab = N.Block.Tab.decode(e, e.uint32(), void 0, r + 1, o.tab), o.type = "tab";
					continue;
				case 9:
					if (a !== 2) break;
					o.chatMessage = N.Block.ChatMessage.decode(e, e.uint32(), void 0, r + 1, o.chatMessage), o.type = "chatMessage";
					continue;
				case 10:
					if (a !== 2) break;
					o.popover = N.Block.Popover.decode(e, e.uint32(), void 0, r + 1, o.popover), o.type = "popover";
					continue;
				case 11:
					if (a !== 2) break;
					o.dialog = N.Block.Dialog.decode(e, e.uint32(), void 0, r + 1, o.dialog), o.type = "dialog";
					continue;
				case 13:
					if (a !== 2) break;
					o.flexContainer = N.Block.FlexContainer.decode(e, e.uint32(), void 0, r + 1, o.flexContainer), o.type = "flexContainer";
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.allowEmpty = s : delete o.allowEmpty;
					continue;
				case 12:
					if (a !== 2) break;
					o.id = e.string(), o._id = "id";
					continue;
				case 14:
					if (a !== 2) break;
					o.heightConfig = N.streamlit.HeightConfig.decode(e, e.uint32(), void 0, r + 1, o.heightConfig), o._heightConfig = "heightConfig";
					continue;
				case 15:
					if (a !== 2) break;
					o.widthConfig = N.streamlit.WidthConfig.decode(e, e.uint32(), void 0, r + 1, o.widthConfig), o._widthConfig = "widthConfig";
					continue;
				case 16:
					if (a !== 0) break;
					o.autoscroll = e.bool(), o._autoscroll = "autoscroll";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Block) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Block();
		if (e.vertical != null) {
			if (typeof e.vertical != "object") throw TypeError(".Block.vertical: object expected");
			n.vertical = N.Block.Vertical.fromObject(e.vertical, t + 1);
		}
		if (e.horizontal != null) {
			if (typeof e.horizontal != "object") throw TypeError(".Block.horizontal: object expected");
			n.horizontal = N.Block.Horizontal.fromObject(e.horizontal, t + 1);
		}
		if (e.column != null) {
			if (typeof e.column != "object") throw TypeError(".Block.column: object expected");
			n.column = N.Block.Column.fromObject(e.column, t + 1);
		}
		if (e.expandable != null) {
			if (typeof e.expandable != "object") throw TypeError(".Block.expandable: object expected");
			n.expandable = N.Block.Expandable.fromObject(e.expandable, t + 1);
		}
		if (e.form != null) {
			if (typeof e.form != "object") throw TypeError(".Block.form: object expected");
			n.form = N.Block.Form.fromObject(e.form, t + 1);
		}
		if (e.tabContainer != null) {
			if (typeof e.tabContainer != "object") throw TypeError(".Block.tabContainer: object expected");
			n.tabContainer = N.Block.TabContainer.fromObject(e.tabContainer, t + 1);
		}
		if (e.tab != null) {
			if (typeof e.tab != "object") throw TypeError(".Block.tab: object expected");
			n.tab = N.Block.Tab.fromObject(e.tab, t + 1);
		}
		if (e.chatMessage != null) {
			if (typeof e.chatMessage != "object") throw TypeError(".Block.chatMessage: object expected");
			n.chatMessage = N.Block.ChatMessage.fromObject(e.chatMessage, t + 1);
		}
		if (e.popover != null) {
			if (typeof e.popover != "object") throw TypeError(".Block.popover: object expected");
			n.popover = N.Block.Popover.fromObject(e.popover, t + 1);
		}
		if (e.dialog != null) {
			if (typeof e.dialog != "object") throw TypeError(".Block.dialog: object expected");
			n.dialog = N.Block.Dialog.fromObject(e.dialog, t + 1);
		}
		if (e.flexContainer != null) {
			if (typeof e.flexContainer != "object") throw TypeError(".Block.flexContainer: object expected");
			n.flexContainer = N.Block.FlexContainer.fromObject(e.flexContainer, t + 1);
		}
		if (e.allowEmpty != null && e.allowEmpty && (n.allowEmpty = !!e.allowEmpty), e.id != null && (n.id = String(e.id)), e.heightConfig != null) {
			if (typeof e.heightConfig != "object") throw TypeError(".Block.heightConfig: object expected");
			n.heightConfig = N.streamlit.HeightConfig.fromObject(e.heightConfig, t + 1);
		}
		if (e.widthConfig != null) {
			if (typeof e.widthConfig != "object") throw TypeError(".Block.widthConfig: object expected");
			n.widthConfig = N.streamlit.WidthConfig.fromObject(e.widthConfig, t + 1);
		}
		return e.autoscroll != null && (n.autoscroll = !!e.autoscroll), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.allowEmpty = !1), e.vertical != null && e.hasOwnProperty("vertical") && (r.vertical = N.Block.Vertical.toObject(e.vertical, t, n + 1), t.oneofs && (r.type = "vertical")), e.horizontal != null && e.hasOwnProperty("horizontal") && (r.horizontal = N.Block.Horizontal.toObject(e.horizontal, t, n + 1), t.oneofs && (r.type = "horizontal")), e.column != null && e.hasOwnProperty("column") && (r.column = N.Block.Column.toObject(e.column, t, n + 1), t.oneofs && (r.type = "column")), e.expandable != null && e.hasOwnProperty("expandable") && (r.expandable = N.Block.Expandable.toObject(e.expandable, t, n + 1), t.oneofs && (r.type = "expandable")), e.form != null && e.hasOwnProperty("form") && (r.form = N.Block.Form.toObject(e.form, t, n + 1), t.oneofs && (r.type = "form")), e.tabContainer != null && e.hasOwnProperty("tabContainer") && (r.tabContainer = N.Block.TabContainer.toObject(e.tabContainer, t, n + 1), t.oneofs && (r.type = "tabContainer")), e.tab != null && e.hasOwnProperty("tab") && (r.tab = N.Block.Tab.toObject(e.tab, t, n + 1), t.oneofs && (r.type = "tab")), e.allowEmpty != null && e.hasOwnProperty("allowEmpty") && (r.allowEmpty = e.allowEmpty), e.chatMessage != null && e.hasOwnProperty("chatMessage") && (r.chatMessage = N.Block.ChatMessage.toObject(e.chatMessage, t, n + 1), t.oneofs && (r.type = "chatMessage")), e.popover != null && e.hasOwnProperty("popover") && (r.popover = N.Block.Popover.toObject(e.popover, t, n + 1), t.oneofs && (r.type = "popover")), e.dialog != null && e.hasOwnProperty("dialog") && (r.dialog = N.Block.Dialog.toObject(e.dialog, t, n + 1), t.oneofs && (r.type = "dialog")), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.flexContainer != null && e.hasOwnProperty("flexContainer") && (r.flexContainer = N.Block.FlexContainer.toObject(e.flexContainer, t, n + 1), t.oneofs && (r.type = "flexContainer")), e.heightConfig != null && e.hasOwnProperty("heightConfig") && (r.heightConfig = N.streamlit.HeightConfig.toObject(e.heightConfig, t, n + 1)), e.widthConfig != null && e.hasOwnProperty("widthConfig") && (r.widthConfig = N.streamlit.WidthConfig.toObject(e.widthConfig, t, n + 1)), e.autoscroll != null && e.hasOwnProperty("autoscroll") && (r.autoscroll = e.autoscroll), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Block";
	}, e.Vertical = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.border = !1, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.border != null && Object.hasOwnProperty.call(e, "border") && t.uint32(8).bool(e.border), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Block.Vertical(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						(s = e.bool()) ? o.border = s : delete o.border;
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.Block.Vertical) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.Block.Vertical();
			return e.border != null && e.border && (n.border = !!e.border), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.border = !1), e.border != null && e.hasOwnProperty("border") && (r.border = e.border), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Vertical";
		}, e;
	})(), e.Horizontal = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.gap = "", e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.gap != null && Object.hasOwnProperty.call(e, "gap") && t.uint32(10).string(e.gap), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Block.Horizontal(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.string()).length ? o.gap = s : delete o.gap;
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.Block.Horizontal) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.Block.Horizontal();
			return e.gap != null && (typeof e.gap != "string" || e.gap.length) && (n.gap = String(e.gap)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.gap = ""), e.gap != null && e.hasOwnProperty("gap") && (r.gap = e.gap), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Horizontal";
		}, e;
	})(), e.FlexContainer = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.border = !1, e.prototype.gapConfig = null, e.prototype.scale = 0, e.prototype.direction = 0, e.prototype.wrap = !1, e.prototype.justify = 0, e.prototype.align = 0, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.border != null && Object.hasOwnProperty.call(e, "border") && t.uint32(8).bool(e.border), e.gapConfig != null && Object.hasOwnProperty.call(e, "gapConfig") && N.streamlit.GapConfig.encode(e.gapConfig, t.uint32(18).fork(), n + 1).ldelim(), e.scale != null && Object.hasOwnProperty.call(e, "scale") && t.uint32(29).float(e.scale), e.direction != null && Object.hasOwnProperty.call(e, "direction") && t.uint32(32).int32(e.direction), e.wrap != null && Object.hasOwnProperty.call(e, "wrap") && t.uint32(40).bool(e.wrap), e.justify != null && Object.hasOwnProperty.call(e, "justify") && t.uint32(56).int32(e.justify), e.align != null && Object.hasOwnProperty.call(e, "align") && t.uint32(64).int32(e.align), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Block.FlexContainer(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						(s = e.bool()) ? o.border = s : delete o.border;
						continue;
					case 2:
						if (a !== 2) break;
						o.gapConfig = N.streamlit.GapConfig.decode(e, e.uint32(), void 0, r + 1, o.gapConfig);
						continue;
					case 3:
						if (a !== 5) break;
						(s = e.float()) === 0 ? delete o.scale : o.scale = s;
						continue;
					case 4:
						if (a !== 0) break;
						(s = e.int32()) ? o.direction = s : delete o.direction;
						continue;
					case 5:
						if (a !== 0) break;
						(s = e.bool()) ? o.wrap = s : delete o.wrap;
						continue;
					case 7:
						if (a !== 0) break;
						(s = e.int32()) ? o.justify = s : delete o.justify;
						continue;
					case 8:
						if (a !== 0) break;
						(s = e.int32()) ? o.align = s : delete o.align;
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.Block.FlexContainer) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.Block.FlexContainer();
			if (e.border != null && e.border && (n.border = !!e.border), e.gapConfig != null) {
				if (typeof e.gapConfig != "object") throw TypeError(".Block.FlexContainer.gapConfig: object expected");
				n.gapConfig = N.streamlit.GapConfig.fromObject(e.gapConfig, t + 1);
			}
			if (e.scale != null && Number(e.scale) !== 0 && (n.scale = Number(e.scale)), e.direction !== 0 && (typeof e.direction != "string" || N.Block.FlexContainer.Direction[e.direction] !== 0)) switch (e.direction) {
				default:
					if (typeof e.direction == "number") {
						n.direction = e.direction;
						break;
					}
					break;
				case "DIRECTION_UNDEFINED":
				case 0:
					n.direction = 0;
					break;
				case "VERTICAL":
				case 1:
					n.direction = 1;
					break;
				case "HORIZONTAL":
				case 2:
					n.direction = 2;
					break;
			}
			if (e.wrap != null && e.wrap && (n.wrap = !!e.wrap), e.justify !== 0 && (typeof e.justify != "string" || N.Block.FlexContainer.Justify[e.justify] !== 0)) switch (e.justify) {
				default:
					if (typeof e.justify == "number") {
						n.justify = e.justify;
						break;
					}
					break;
				case "JUSTIFY_UNDEFINED":
				case 0:
					n.justify = 0;
					break;
				case "JUSTIFY_START":
				case 1:
					n.justify = 1;
					break;
				case "JUSTIFY_END":
				case 2:
					n.justify = 2;
					break;
				case "JUSTIFY_CENTER":
				case 3:
					n.justify = 3;
					break;
				case "SPACE_BETWEEN":
				case 4:
					n.justify = 4;
					break;
			}
			if (e.align !== 0 && (typeof e.align != "string" || N.Block.FlexContainer.Align[e.align] !== 0)) switch (e.align) {
				default:
					if (typeof e.align == "number") {
						n.align = e.align;
						break;
					}
					break;
				case "ALIGN_UNDEFINED":
				case 0:
					n.align = 0;
					break;
				case "ALIGN_START":
				case 1:
					n.align = 1;
					break;
				case "ALIGN_END":
				case 2:
					n.align = 2;
					break;
				case "ALIGN_CENTER":
				case 3:
					n.align = 3;
					break;
				case "STRETCH":
				case 4:
					n.align = 4;
					break;
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.border = !1, r.gapConfig = null, r.scale = 0, r.direction = t.enums === String ? "DIRECTION_UNDEFINED" : 0, r.wrap = !1, r.justify = t.enums === String ? "JUSTIFY_UNDEFINED" : 0, r.align = t.enums === String ? "ALIGN_UNDEFINED" : 0), e.border != null && e.hasOwnProperty("border") && (r.border = e.border), e.gapConfig != null && e.hasOwnProperty("gapConfig") && (r.gapConfig = N.streamlit.GapConfig.toObject(e.gapConfig, t, n + 1)), e.scale != null && e.hasOwnProperty("scale") && (r.scale = t.json && !isFinite(e.scale) ? String(e.scale) : e.scale), e.direction != null && e.hasOwnProperty("direction") && (r.direction = t.enums === String ? N.Block.FlexContainer.Direction[e.direction] === void 0 ? e.direction : N.Block.FlexContainer.Direction[e.direction] : e.direction), e.wrap != null && e.hasOwnProperty("wrap") && (r.wrap = e.wrap), e.justify != null && e.hasOwnProperty("justify") && (r.justify = t.enums === String ? N.Block.FlexContainer.Justify[e.justify] === void 0 ? e.justify : N.Block.FlexContainer.Justify[e.justify] : e.justify), e.align != null && e.hasOwnProperty("align") && (r.align = t.enums === String ? N.Block.FlexContainer.Align[e.align] === void 0 ? e.align : N.Block.FlexContainer.Align[e.align] : e.align), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/Block.FlexContainer";
		}, e.Direction = (function() {
			let e = {}, t = Object.create(e);
			return t[e[0] = "DIRECTION_UNDEFINED"] = 0, t[e[1] = "VERTICAL"] = 1, t[e[2] = "HORIZONTAL"] = 2, t;
		})(), e.Justify = (function() {
			let e = {}, t = Object.create(e);
			return t[e[0] = "JUSTIFY_UNDEFINED"] = 0, t[e[1] = "JUSTIFY_START"] = 1, t[e[2] = "JUSTIFY_END"] = 2, t[e[3] = "JUSTIFY_CENTER"] = 3, t[e[4] = "SPACE_BETWEEN"] = 4, t;
		})(), e.Align = (function() {
			let e = {}, t = Object.create(e);
			return t[e[0] = "ALIGN_UNDEFINED"] = 0, t[e[1] = "ALIGN_START"] = 1, t[e[2] = "ALIGN_END"] = 2, t[e[3] = "ALIGN_CENTER"] = 3, t[e[4] = "STRETCH"] = 4, t;
		})(), e;
	})(), e.Column = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.weight = 0, e.prototype.verticalAlignment = 0, e.prototype.showBorder = !1, e.prototype.gapConfig = null;
		let t;
		return Object.defineProperty(e.prototype, "_gapConfig", {
			get: M.oneOfGetter(t = ["gapConfig"]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.weight != null && Object.hasOwnProperty.call(e, "weight") && t.uint32(9).double(e.weight), e.verticalAlignment != null && Object.hasOwnProperty.call(e, "verticalAlignment") && t.uint32(24).int32(e.verticalAlignment), e.showBorder != null && Object.hasOwnProperty.call(e, "showBorder") && t.uint32(32).bool(e.showBorder), e.gapConfig != null && Object.hasOwnProperty.call(e, "gapConfig") && N.streamlit.GapConfig.encode(e.gapConfig, t.uint32(42).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Block.Column(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						(s = e.double()) === 0 ? delete o.weight : o.weight = s;
						continue;
					case 3:
						if (a !== 0) break;
						(s = e.int32()) ? o.verticalAlignment = s : delete o.verticalAlignment;
						continue;
					case 4:
						if (a !== 0) break;
						(s = e.bool()) ? o.showBorder = s : delete o.showBorder;
						continue;
					case 5:
						if (a !== 2) break;
						o.gapConfig = N.streamlit.GapConfig.decode(e, e.uint32(), void 0, r + 1, o.gapConfig), o._gapConfig = "gapConfig";
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.Block.Column) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.Block.Column();
			if (e.weight != null && Number(e.weight) !== 0 && (n.weight = Number(e.weight)), e.verticalAlignment !== 0 && (typeof e.verticalAlignment != "string" || N.Block.Column.VerticalAlignment[e.verticalAlignment] !== 0)) switch (e.verticalAlignment) {
				default:
					if (typeof e.verticalAlignment == "number") {
						n.verticalAlignment = e.verticalAlignment;
						break;
					}
					break;
				case "TOP":
				case 0:
					n.verticalAlignment = 0;
					break;
				case "CENTER":
				case 1:
					n.verticalAlignment = 1;
					break;
				case "BOTTOM":
				case 2:
					n.verticalAlignment = 2;
					break;
			}
			if (e.showBorder != null && e.showBorder && (n.showBorder = !!e.showBorder), e.gapConfig != null) {
				if (typeof e.gapConfig != "object") throw TypeError(".Block.Column.gapConfig: object expected");
				n.gapConfig = N.streamlit.GapConfig.fromObject(e.gapConfig, t + 1);
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.weight = 0, r.verticalAlignment = t.enums === String ? "TOP" : 0, r.showBorder = !1), e.weight != null && e.hasOwnProperty("weight") && (r.weight = t.json && !isFinite(e.weight) ? String(e.weight) : e.weight), e.verticalAlignment != null && e.hasOwnProperty("verticalAlignment") && (r.verticalAlignment = t.enums === String ? N.Block.Column.VerticalAlignment[e.verticalAlignment] === void 0 ? e.verticalAlignment : N.Block.Column.VerticalAlignment[e.verticalAlignment] : e.verticalAlignment), e.showBorder != null && e.hasOwnProperty("showBorder") && (r.showBorder = e.showBorder), e.gapConfig != null && e.hasOwnProperty("gapConfig") && (r.gapConfig = N.streamlit.GapConfig.toObject(e.gapConfig, t, n + 1)), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Column";
		}, e.VerticalAlignment = (function() {
			let e = {}, t = Object.create(e);
			return t[e[0] = "TOP"] = 0, t[e[1] = "CENTER"] = 1, t[e[2] = "BOTTOM"] = 2, t;
		})(), e;
	})(), e.Expandable = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.label = "", e.prototype.expanded = null, e.prototype.icon = "", e.prototype.id = null;
		let t;
		return Object.defineProperty(e.prototype, "_expanded", {
			get: M.oneOfGetter(t = ["expanded"]),
			set: M.oneOfSetter(t)
		}), Object.defineProperty(e.prototype, "_id", {
			get: M.oneOfGetter(t = ["id"]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(10).string(e.label), e.expanded != null && Object.hasOwnProperty.call(e, "expanded") && t.uint32(16).bool(e.expanded), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(26).string(e.icon), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(34).string(e.id), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Block.Expandable(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.string()).length ? o.label = s : delete o.label;
						continue;
					case 2:
						if (a !== 0) break;
						o.expanded = e.bool(), o._expanded = "expanded";
						continue;
					case 3:
						if (a !== 2) break;
						(s = e.string()).length ? o.icon = s : delete o.icon;
						continue;
					case 4:
						if (a !== 2) break;
						o.id = e.string(), o._id = "id";
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.Block.Expandable) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.Block.Expandable();
			return e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.expanded != null && (n.expanded = !!e.expanded), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = String(e.icon)), e.id != null && (n.id = String(e.id)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.label = "", r.icon = ""), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.expanded != null && e.hasOwnProperty("expanded") && (r.expanded = e.expanded), e.icon != null && e.hasOwnProperty("icon") && (r.icon = e.icon), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Expandable";
		}, e;
	})(), e.Dialog = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.title = "", e.prototype.dismissible = !1, e.prototype.width = 0, e.prototype.isOpen = null, e.prototype.id = "", e.prototype.icon = "";
		let t;
		return Object.defineProperty(e.prototype, "_isOpen", {
			get: M.oneOfGetter(t = ["isOpen"]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.title != null && Object.hasOwnProperty.call(e, "title") && t.uint32(10).string(e.title), e.dismissible != null && Object.hasOwnProperty.call(e, "dismissible") && t.uint32(16).bool(e.dismissible), e.width != null && Object.hasOwnProperty.call(e, "width") && t.uint32(24).int32(e.width), e.isOpen != null && Object.hasOwnProperty.call(e, "isOpen") && t.uint32(32).bool(e.isOpen), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(42).string(e.id), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(50).string(e.icon), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Block.Dialog(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.string()).length ? o.title = s : delete o.title;
						continue;
					case 2:
						if (a !== 0) break;
						(s = e.bool()) ? o.dismissible = s : delete o.dismissible;
						continue;
					case 3:
						if (a !== 0) break;
						(s = e.int32()) ? o.width = s : delete o.width;
						continue;
					case 4:
						if (a !== 0) break;
						o.isOpen = e.bool(), o._isOpen = "isOpen";
						continue;
					case 5:
						if (a !== 2) break;
						(s = e.string()).length ? o.id = s : delete o.id;
						continue;
					case 6:
						if (a !== 2) break;
						(s = e.string()).length ? o.icon = s : delete o.icon;
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.Block.Dialog) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.Block.Dialog();
			if (e.title != null && (typeof e.title != "string" || e.title.length) && (n.title = String(e.title)), e.dismissible != null && e.dismissible && (n.dismissible = !!e.dismissible), e.width !== 0 && (typeof e.width != "string" || N.Block.Dialog.DialogWidth[e.width] !== 0)) switch (e.width) {
				default:
					if (typeof e.width == "number") {
						n.width = e.width;
						break;
					}
					break;
				case "SMALL":
				case 0:
					n.width = 0;
					break;
				case "LARGE":
				case 1:
					n.width = 1;
					break;
				case "MEDIUM":
				case 2:
					n.width = 2;
					break;
			}
			return e.isOpen != null && (n.isOpen = !!e.isOpen), e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = String(e.icon)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.title = "", r.dismissible = !1, r.width = t.enums === String ? "SMALL" : 0, r.id = "", r.icon = ""), e.title != null && e.hasOwnProperty("title") && (r.title = e.title), e.dismissible != null && e.hasOwnProperty("dismissible") && (r.dismissible = e.dismissible), e.width != null && e.hasOwnProperty("width") && (r.width = t.enums === String ? N.Block.Dialog.DialogWidth[e.width] === void 0 ? e.width : N.Block.Dialog.DialogWidth[e.width] : e.width), e.isOpen != null && e.hasOwnProperty("isOpen") && (r.isOpen = e.isOpen), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.icon != null && e.hasOwnProperty("icon") && (r.icon = e.icon), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Dialog";
		}, e.DialogWidth = (function() {
			let e = {}, t = Object.create(e);
			return t[e[0] = "SMALL"] = 0, t[e[1] = "LARGE"] = 1, t[e[2] = "MEDIUM"] = 2, t;
		})(), e;
	})(), e.Form = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.formId = "", e.prototype.clearOnSubmit = !1, e.prototype.border = !1, e.prototype.enterToSubmit = !1, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(10).string(e.formId), e.clearOnSubmit != null && Object.hasOwnProperty.call(e, "clearOnSubmit") && t.uint32(16).bool(e.clearOnSubmit), e.border != null && Object.hasOwnProperty.call(e, "border") && t.uint32(24).bool(e.border), e.enterToSubmit != null && Object.hasOwnProperty.call(e, "enterToSubmit") && t.uint32(32).bool(e.enterToSubmit), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Block.Form(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.string()).length ? o.formId = s : delete o.formId;
						continue;
					case 2:
						if (a !== 0) break;
						(s = e.bool()) ? o.clearOnSubmit = s : delete o.clearOnSubmit;
						continue;
					case 3:
						if (a !== 0) break;
						(s = e.bool()) ? o.border = s : delete o.border;
						continue;
					case 4:
						if (a !== 0) break;
						(s = e.bool()) ? o.enterToSubmit = s : delete o.enterToSubmit;
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.Block.Form) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.Block.Form();
			return e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.clearOnSubmit != null && e.clearOnSubmit && (n.clearOnSubmit = !!e.clearOnSubmit), e.border != null && e.border && (n.border = !!e.border), e.enterToSubmit != null && e.enterToSubmit && (n.enterToSubmit = !!e.enterToSubmit), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.formId = "", r.clearOnSubmit = !1, r.border = !1, r.enterToSubmit = !1), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.clearOnSubmit != null && e.hasOwnProperty("clearOnSubmit") && (r.clearOnSubmit = e.clearOnSubmit), e.border != null && e.hasOwnProperty("border") && (r.border = e.border), e.enterToSubmit != null && e.hasOwnProperty("enterToSubmit") && (r.enterToSubmit = e.enterToSubmit), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Form";
		}, e;
	})(), e.TabContainer = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.defaultTabIndex = 0, e.prototype.id = null;
		let t;
		return Object.defineProperty(e.prototype, "_id", {
			get: M.oneOfGetter(t = ["id"]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.defaultTabIndex != null && Object.hasOwnProperty.call(e, "defaultTabIndex") && t.uint32(8).int32(e.defaultTabIndex), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(18).string(e.id), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Block.TabContainer(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						(s = e.int32()) ? o.defaultTabIndex = s : delete o.defaultTabIndex;
						continue;
					case 2:
						if (a !== 2) break;
						o.id = e.string(), o._id = "id";
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.Block.TabContainer) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.Block.TabContainer();
			return e.defaultTabIndex != null && Number(e.defaultTabIndex) !== 0 && (n.defaultTabIndex = e.defaultTabIndex | 0), e.id != null && (n.id = String(e.id)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.defaultTabIndex = 0), e.defaultTabIndex != null && e.hasOwnProperty("defaultTabIndex") && (r.defaultTabIndex = e.defaultTabIndex), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/Block.TabContainer";
		}, e;
	})(), e.Tab = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.label = "", e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(10).string(e.label), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Block.Tab(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.string()).length ? o.label = s : delete o.label;
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.Block.Tab) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.Block.Tab();
			return e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.label = ""), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Tab";
		}, e;
	})(), e.Popover = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.label = "", e.prototype.help = "", e.prototype.disabled = !1, e.prototype.icon = "", e.prototype.type = "", e.prototype.open = null, e.prototype.id = null;
		let t;
		return Object.defineProperty(e.prototype, "_open", {
			get: M.oneOfGetter(t = ["open"]),
			set: M.oneOfSetter(t)
		}), Object.defineProperty(e.prototype, "_id", {
			get: M.oneOfGetter(t = ["id"]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(10).string(e.label), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(26).string(e.help), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(32).bool(e.disabled), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(42).string(e.icon), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(50).string(e.type), e.open != null && Object.hasOwnProperty.call(e, "open") && t.uint32(56).bool(e.open), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(66).string(e.id), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Block.Popover(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.string()).length ? o.label = s : delete o.label;
						continue;
					case 3:
						if (a !== 2) break;
						(s = e.string()).length ? o.help = s : delete o.help;
						continue;
					case 4:
						if (a !== 0) break;
						(s = e.bool()) ? o.disabled = s : delete o.disabled;
						continue;
					case 5:
						if (a !== 2) break;
						(s = e.string()).length ? o.icon = s : delete o.icon;
						continue;
					case 6:
						if (a !== 2) break;
						(s = e.string()).length ? o.type = s : delete o.type;
						continue;
					case 7:
						if (a !== 0) break;
						o.open = e.bool(), o._open = "open";
						continue;
					case 8:
						if (a !== 2) break;
						o.id = e.string(), o._id = "id";
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.Block.Popover) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.Block.Popover();
			return e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = String(e.icon)), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = String(e.type)), e.open != null && (n.open = !!e.open), e.id != null && (n.id = String(e.id)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.label = "", r.help = "", r.disabled = !1, r.icon = "", r.type = ""), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.icon != null && e.hasOwnProperty("icon") && (r.icon = e.icon), e.type != null && e.hasOwnProperty("type") && (r.type = e.type), e.open != null && e.hasOwnProperty("open") && (r.open = e.open), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Popover";
		}, e;
	})(), e.ChatMessage = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.name = "", e.prototype.avatar = "", e.prototype.avatarType = 0, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(10).string(e.name), e.avatar != null && Object.hasOwnProperty.call(e, "avatar") && t.uint32(18).string(e.avatar), e.avatarType != null && Object.hasOwnProperty.call(e, "avatarType") && t.uint32(24).int32(e.avatarType), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Block.ChatMessage(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.string()).length ? o.name = s : delete o.name;
						continue;
					case 2:
						if (a !== 2) break;
						(s = e.string()).length ? o.avatar = s : delete o.avatar;
						continue;
					case 3:
						if (a !== 0) break;
						(s = e.int32()) ? o.avatarType = s : delete o.avatarType;
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.Block.ChatMessage) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.Block.ChatMessage();
			if (e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = String(e.name)), e.avatar != null && (typeof e.avatar != "string" || e.avatar.length) && (n.avatar = String(e.avatar)), e.avatarType !== 0 && (typeof e.avatarType != "string" || N.Block.ChatMessage.AvatarType[e.avatarType] !== 0)) switch (e.avatarType) {
				default:
					if (typeof e.avatarType == "number") {
						n.avatarType = e.avatarType;
						break;
					}
					break;
				case "IMAGE":
				case 0:
					n.avatarType = 0;
					break;
				case "EMOJI":
				case 1:
					n.avatarType = 1;
					break;
				case "ICON":
				case 2:
					n.avatarType = 2;
					break;
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.name = "", r.avatar = "", r.avatarType = t.enums === String ? "IMAGE" : 0), e.name != null && e.hasOwnProperty("name") && (r.name = e.name), e.avatar != null && e.hasOwnProperty("avatar") && (r.avatar = e.avatar), e.avatarType != null && e.hasOwnProperty("avatarType") && (r.avatarType = t.enums === String ? N.Block.ChatMessage.AvatarType[e.avatarType] === void 0 ? e.avatarType : N.Block.ChatMessage.AvatarType[e.avatarType] : e.avatarType), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/Block.ChatMessage";
		}, e.AvatarType = (function() {
			let e = {}, t = Object.create(e);
			return t[e[0] = "IMAGE"] = 0, t[e[1] = "EMOJI"] = 1, t[e[2] = "ICON"] = 2, t;
		})(), e;
	})(), e;
})(), N.Button = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.id = "", e.prototype.label = "", e.prototype.default = !1, e.prototype.help = "", e.prototype.formId = "", e.prototype.isFormSubmitter = !1, e.prototype.type = "", e.prototype.disabled = !1, e.prototype.icon = "", e.prototype.shortcut = "", e.prototype.iconPosition = 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.default != null && Object.hasOwnProperty.call(e, "default") && t.uint32(24).bool(e.default), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(34).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(42).string(e.formId), e.isFormSubmitter != null && Object.hasOwnProperty.call(e, "isFormSubmitter") && t.uint32(48).bool(e.isFormSubmitter), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(58).string(e.type), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(64).bool(e.disabled), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(82).string(e.icon), e.shortcut != null && Object.hasOwnProperty.call(e, "shortcut") && t.uint32(90).string(e.shortcut), e.iconPosition != null && Object.hasOwnProperty.call(e, "iconPosition") && t.uint32(96).int32(e.iconPosition), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Button(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.default = s : delete o.default;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.isFormSubmitter = s : delete o.isFormSubmitter;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.string()).length ? o.type = s : delete o.type;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.string()).length ? o.icon = s : delete o.icon;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.string()).length ? o.shortcut = s : delete o.shortcut;
					continue;
				case 12:
					if (a !== 0) break;
					(s = e.int32()) ? o.iconPosition = s : delete o.iconPosition;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Button) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Button();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.default != null && e.default && (n.default = !!e.default), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.isFormSubmitter != null && e.isFormSubmitter && (n.isFormSubmitter = !!e.isFormSubmitter), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = String(e.type)), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = String(e.icon)), e.shortcut != null && (typeof e.shortcut != "string" || e.shortcut.length) && (n.shortcut = String(e.shortcut)), e.iconPosition !== 0 && (typeof e.iconPosition != "string" || N.streamlit.ButtonLikeIconPosition[e.iconPosition] !== 0)) switch (e.iconPosition) {
			default:
				if (typeof e.iconPosition == "number") {
					n.iconPosition = e.iconPosition;
					break;
				}
				break;
			case "LEFT":
			case 0:
				n.iconPosition = 0;
				break;
			case "RIGHT":
			case 1:
				n.iconPosition = 1;
				break;
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.default = !1, r.help = "", r.formId = "", r.isFormSubmitter = !1, r.type = "", r.disabled = !1, r.icon = "", r.shortcut = "", r.iconPosition = t.enums === String ? "LEFT" : 0), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.default != null && e.hasOwnProperty("default") && (r.default = e.default), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.isFormSubmitter != null && e.hasOwnProperty("isFormSubmitter") && (r.isFormSubmitter = e.isFormSubmitter), e.type != null && e.hasOwnProperty("type") && (r.type = e.type), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.icon != null && e.hasOwnProperty("icon") && (r.icon = e.icon), e.shortcut != null && e.hasOwnProperty("shortcut") && (r.shortcut = e.shortcut), e.iconPosition != null && e.hasOwnProperty("iconPosition") && (r.iconPosition = t.enums === String ? N.streamlit.ButtonLikeIconPosition[e.iconPosition] === void 0 ? e.iconPosition : N.streamlit.ButtonLikeIconPosition[e.iconPosition] : e.iconPosition), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Button";
	}, e;
})(), N.ButtonGroup = (() => {
	function e(e) {
		if (this.options = [], this.default = [], this.rawValues = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.options = M.emptyArray, e.prototype.default = M.emptyArray, e.prototype.disabled = !1, e.prototype.clickMode = 0, e.prototype.formId = "", e.prototype.setValue = !1, e.prototype.style = 0, e.prototype.label = "", e.prototype.labelVisibility = null, e.prototype.help = null, e.prototype.rawValues = M.emptyArray, e.prototype.queryParamKey = null, e.prototype.required = !1;
	let t;
	return Object.defineProperty(e.prototype, "_help", {
		get: M.oneOfGetter(t = ["help"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_queryParamKey", {
		get: M.oneOfGetter(t = ["queryParamKey"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.options != null && e.options.length) for (let r = 0; r < e.options.length; ++r) N.ButtonGroup.Option.encode(e.options[r], t.uint32(18).fork(), n + 1).ldelim();
		if (e.default != null && e.default.length) {
			t.uint32(26).fork();
			for (let n = 0; n < e.default.length; ++n) t.uint32(e.default[n]);
			t.ldelim();
		}
		if (e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(32).bool(e.disabled), e.clickMode != null && Object.hasOwnProperty.call(e, "clickMode") && t.uint32(40).int32(e.clickMode), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(50).string(e.formId), e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(64).bool(e.setValue), e.style != null && Object.hasOwnProperty.call(e, "style") && t.uint32(80).int32(e.style), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(90).string(e.label), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(98).fork(), n + 1).ldelim(), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(106).string(e.help), e.rawValues != null && e.rawValues.length) for (let n = 0; n < e.rawValues.length; ++n) t.uint32(114).string(e.rawValues[n]);
		if (e.queryParamKey != null && Object.hasOwnProperty.call(e, "queryParamKey") && t.uint32(122).string(e.queryParamKey), e.required != null && Object.hasOwnProperty.call(e, "required") && t.uint32(128).bool(e.required), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ButtonGroup(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					o.options && o.options.length || (o.options = []), o.options.push(N.ButtonGroup.Option.decode(e, e.uint32(), void 0, r + 1));
					continue;
				case 3:
					if (a === 2) {
						o.default && o.default.length || (o.default = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.default.push(e.uint32());
						continue;
					}
					if (a !== 0) break;
					o.default && o.default.length || (o.default = []), o.default.push(e.uint32());
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.int32()) ? o.clickMode = s : delete o.clickMode;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.int32()) ? o.style = s : delete o.style;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 12:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 13:
					if (a !== 2) break;
					o.help = e.string(), o._help = "help";
					continue;
				case 14:
					if (a !== 2) break;
					o.rawValues && o.rawValues.length || (o.rawValues = []), o.rawValues.push(e.string());
					continue;
				case 15:
					if (a !== 2) break;
					o.queryParamKey = e.string(), o._queryParamKey = "queryParamKey";
					continue;
				case 16:
					if (a !== 0) break;
					(s = e.bool()) ? o.required = s : delete o.required;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ButtonGroup) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ButtonGroup();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.options) {
			if (!Array.isArray(e.options)) throw TypeError(".ButtonGroup.options: array expected");
			n.options = Array(e.options.length);
			for (let r = 0; r < e.options.length; ++r) {
				if (typeof e.options[r] != "object") throw TypeError(".ButtonGroup.options: object expected");
				n.options[r] = N.ButtonGroup.Option.fromObject(e.options[r], t + 1);
			}
		}
		if (e.default) {
			if (!Array.isArray(e.default)) throw TypeError(".ButtonGroup.default: array expected");
			n.default = Array(e.default.length);
			for (let t = 0; t < e.default.length; ++t) n.default[t] = e.default[t] >>> 0;
		}
		if (e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.clickMode !== 0 && (typeof e.clickMode != "string" || N.ButtonGroup.ClickMode[e.clickMode] !== 0)) switch (e.clickMode) {
			default:
				if (typeof e.clickMode == "number") {
					n.clickMode = e.clickMode;
					break;
				}
				break;
			case "SINGLE_SELECT":
			case 0:
				n.clickMode = 0;
				break;
			case "MULTI_SELECT":
			case 1:
				n.clickMode = 1;
				break;
		}
		if (e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.style !== 0 && (typeof e.style != "string" || N.ButtonGroup.Style[e.style] !== 0)) switch (e.style) {
			default:
				if (typeof e.style == "number") {
					n.style = e.style;
					break;
				}
				break;
			case "SEGMENTED_CONTROL":
			case 0:
				n.style = 0;
				break;
			case "PILLS":
			case 1:
				n.style = 1;
				break;
		}
		if (e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".ButtonGroup.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.help != null && (n.help = String(e.help)), e.rawValues) {
			if (!Array.isArray(e.rawValues)) throw TypeError(".ButtonGroup.rawValues: array expected");
			n.rawValues = Array(e.rawValues.length);
			for (let t = 0; t < e.rawValues.length; ++t) n.rawValues[t] = String(e.rawValues[t]);
		}
		return e.queryParamKey != null && (n.queryParamKey = String(e.queryParamKey)), e.required != null && e.required && (n.required = !!e.required), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.options = [], r.default = [], r.rawValues = []), t.defaults && (r.id = "", r.disabled = !1, r.clickMode = t.enums === String ? "SINGLE_SELECT" : 0, r.formId = "", r.setValue = !1, r.style = t.enums === String ? "SEGMENTED_CONTROL" : 0, r.label = "", r.labelVisibility = null, r.required = !1), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.options && e.options.length) {
			r.options = Array(e.options.length);
			for (let i = 0; i < e.options.length; ++i) r.options[i] = N.ButtonGroup.Option.toObject(e.options[i], t, n + 1);
		}
		if (e.default && e.default.length) {
			r.default = Array(e.default.length);
			for (let t = 0; t < e.default.length; ++t) r.default[t] = e.default[t];
		}
		if (e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.clickMode != null && e.hasOwnProperty("clickMode") && (r.clickMode = t.enums === String ? N.ButtonGroup.ClickMode[e.clickMode] === void 0 ? e.clickMode : N.ButtonGroup.ClickMode[e.clickMode] : e.clickMode), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.style != null && e.hasOwnProperty("style") && (r.style = t.enums === String ? N.ButtonGroup.Style[e.style] === void 0 ? e.style : N.ButtonGroup.Style[e.style] : e.style), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.rawValues && e.rawValues.length) {
			r.rawValues = Array(e.rawValues.length);
			for (let t = 0; t < e.rawValues.length; ++t) r.rawValues[t] = e.rawValues[t];
		}
		return e.queryParamKey != null && e.hasOwnProperty("queryParamKey") && (r.queryParamKey = e.queryParamKey), e.required != null && e.hasOwnProperty("required") && (r.required = e.required), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ButtonGroup";
	}, e.ClickMode = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "SINGLE_SELECT"] = 0, t[e[1] = "MULTI_SELECT"] = 1, t;
	})(), e.Option = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.content = "", e.prototype.contentIcon = null;
		let t;
		return Object.defineProperty(e.prototype, "_contentIcon", {
			get: M.oneOfGetter(t = ["contentIcon"]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.content != null && Object.hasOwnProperty.call(e, "content") && t.uint32(10).string(e.content), e.contentIcon != null && Object.hasOwnProperty.call(e, "contentIcon") && t.uint32(26).string(e.contentIcon), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ButtonGroup.Option(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.string()).length ? o.content = s : delete o.content;
						continue;
					case 3:
						if (a !== 2) break;
						o.contentIcon = e.string(), o._contentIcon = "contentIcon";
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.ButtonGroup.Option) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.ButtonGroup.Option();
			return e.content != null && (typeof e.content != "string" || e.content.length) && (n.content = String(e.content)), e.contentIcon != null && (n.contentIcon = String(e.contentIcon)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.content = ""), e.content != null && e.hasOwnProperty("content") && (r.content = e.content), e.contentIcon != null && e.hasOwnProperty("contentIcon") && (r.contentIcon = e.contentIcon), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/ButtonGroup.Option";
		}, e;
	})(), e.Style = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "SEGMENTED_CONTROL"] = 0, t[e[1] = "PILLS"] = 1, t;
	})(), e;
})(), N.CameraInput = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.id = "", e.prototype.label = "", e.prototype.help = "", e.prototype.formId = "", e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(26).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(34).string(e.formId), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(40).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(50).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.CameraInput(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 6:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.CameraInput) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.CameraInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".CameraInput.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.help = "", r.formId = "", r.disabled = !1, r.labelVisibility = null), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/CameraInput";
	}, e;
})(), N.ChatInput = (() => {
	function e(e) {
		if (this.fileType = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.placeholder = "", e.prototype.maxChars = 0, e.prototype.disabled = !1, e.prototype.value = "", e.prototype.setValue = !1, e.prototype.default = "", e.prototype.acceptFile = 0, e.prototype.fileType = M.emptyArray, e.prototype.maxUploadSizeMb = 0, e.prototype.acceptAudio = !1, e.prototype.audioSampleRate = null;
	let t;
	return Object.defineProperty(e.prototype, "_audioSampleRate", {
		get: M.oneOfGetter(t = ["audioSampleRate"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.placeholder != null && Object.hasOwnProperty.call(e, "placeholder") && t.uint32(18).string(e.placeholder), e.maxChars != null && Object.hasOwnProperty.call(e, "maxChars") && t.uint32(24).uint32(e.maxChars), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(32).bool(e.disabled), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(42).string(e.value), e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(48).bool(e.setValue), e.default != null && Object.hasOwnProperty.call(e, "default") && t.uint32(58).string(e.default), e.acceptFile != null && Object.hasOwnProperty.call(e, "acceptFile") && t.uint32(72).int32(e.acceptFile), e.fileType != null && e.fileType.length) for (let n = 0; n < e.fileType.length; ++n) t.uint32(82).string(e.fileType[n]);
		if (e.maxUploadSizeMb != null && Object.hasOwnProperty.call(e, "maxUploadSizeMb") && t.uint32(88).int32(e.maxUploadSizeMb), e.acceptAudio != null && Object.hasOwnProperty.call(e, "acceptAudio") && t.uint32(96).bool(e.acceptAudio), e.audioSampleRate != null && Object.hasOwnProperty.call(e, "audioSampleRate") && t.uint32(104).int32(e.audioSampleRate), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ChatInput(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.placeholder = s : delete o.placeholder;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.uint32()) ? o.maxChars = s : delete o.maxChars;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.value = s : delete o.value;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.string()).length ? o.default = s : delete o.default;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.int32()) ? o.acceptFile = s : delete o.acceptFile;
					continue;
				case 10:
					if (a !== 2) break;
					o.fileType && o.fileType.length || (o.fileType = []), o.fileType.push(e.string());
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.int32()) ? o.maxUploadSizeMb = s : delete o.maxUploadSizeMb;
					continue;
				case 12:
					if (a !== 0) break;
					(s = e.bool()) ? o.acceptAudio = s : delete o.acceptAudio;
					continue;
				case 13:
					if (a !== 0) break;
					o.audioSampleRate = e.int32(), o._audioSampleRate = "audioSampleRate";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ChatInput) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ChatInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.placeholder != null && (typeof e.placeholder != "string" || e.placeholder.length) && (n.placeholder = String(e.placeholder)), e.maxChars != null && Number(e.maxChars) !== 0 && (n.maxChars = e.maxChars >>> 0), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.value != null && (typeof e.value != "string" || e.value.length) && (n.value = String(e.value)), e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.default != null && (typeof e.default != "string" || e.default.length) && (n.default = String(e.default)), e.acceptFile !== 0 && (typeof e.acceptFile != "string" || N.ChatInput.AcceptFile[e.acceptFile] !== 0)) switch (e.acceptFile) {
			default:
				if (typeof e.acceptFile == "number") {
					n.acceptFile = e.acceptFile;
					break;
				}
				break;
			case "NONE":
			case 0:
				n.acceptFile = 0;
				break;
			case "SINGLE":
			case 1:
				n.acceptFile = 1;
				break;
			case "MULTIPLE":
			case 2:
				n.acceptFile = 2;
				break;
			case "DIRECTORY":
			case 3:
				n.acceptFile = 3;
				break;
		}
		if (e.fileType) {
			if (!Array.isArray(e.fileType)) throw TypeError(".ChatInput.fileType: array expected");
			n.fileType = Array(e.fileType.length);
			for (let t = 0; t < e.fileType.length; ++t) n.fileType[t] = String(e.fileType[t]);
		}
		return e.maxUploadSizeMb != null && Number(e.maxUploadSizeMb) !== 0 && (n.maxUploadSizeMb = e.maxUploadSizeMb | 0), e.acceptAudio != null && e.acceptAudio && (n.acceptAudio = !!e.acceptAudio), e.audioSampleRate != null && (n.audioSampleRate = e.audioSampleRate | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.fileType = []), t.defaults && (r.id = "", r.placeholder = "", r.maxChars = 0, r.disabled = !1, r.value = "", r.setValue = !1, r.default = "", r.acceptFile = t.enums === String ? "NONE" : 0, r.maxUploadSizeMb = 0, r.acceptAudio = !1), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.placeholder != null && e.hasOwnProperty("placeholder") && (r.placeholder = e.placeholder), e.maxChars != null && e.hasOwnProperty("maxChars") && (r.maxChars = e.maxChars), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.value != null && e.hasOwnProperty("value") && (r.value = e.value), e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.default != null && e.hasOwnProperty("default") && (r.default = e.default), e.acceptFile != null && e.hasOwnProperty("acceptFile") && (r.acceptFile = t.enums === String ? N.ChatInput.AcceptFile[e.acceptFile] === void 0 ? e.acceptFile : N.ChatInput.AcceptFile[e.acceptFile] : e.acceptFile), e.fileType && e.fileType.length) {
			r.fileType = Array(e.fileType.length);
			for (let t = 0; t < e.fileType.length; ++t) r.fileType[t] = e.fileType[t];
		}
		return e.maxUploadSizeMb != null && e.hasOwnProperty("maxUploadSizeMb") && (r.maxUploadSizeMb = e.maxUploadSizeMb), e.acceptAudio != null && e.hasOwnProperty("acceptAudio") && (r.acceptAudio = e.acceptAudio), e.audioSampleRate != null && e.hasOwnProperty("audioSampleRate") && (r.audioSampleRate = e.audioSampleRate), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ChatInput";
	}, e.AcceptFile = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "NONE"] = 0, t[e[1] = "SINGLE"] = 1, t[e[2] = "MULTIPLE"] = 2, t[e[3] = "DIRECTORY"] = 3, t;
	})(), e;
})(), N.Checkbox = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = !1, e.prototype.help = "", e.prototype.formId = "", e.prototype.value = !1, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.type = 0, e.prototype.queryParamKey = null;
	let t;
	return Object.defineProperty(e.prototype, "_queryParamKey", {
		get: M.oneOfGetter(t = ["queryParamKey"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.default != null && Object.hasOwnProperty.call(e, "default") && t.uint32(24).bool(e.default), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(34).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(42).string(e.formId), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(48).bool(e.value), e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(56).bool(e.setValue), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(64).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(74).fork(), n + 1).ldelim(), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(80).int32(e.type), e.queryParamKey != null && Object.hasOwnProperty.call(e, "queryParamKey") && t.uint32(90).string(e.queryParamKey), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Checkbox(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.default = s : delete o.default;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.value = s : delete o.value;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 9:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.int32()) ? o.type = s : delete o.type;
					continue;
				case 11:
					if (a !== 2) break;
					o.queryParamKey = e.string(), o._queryParamKey = "queryParamKey";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Checkbox) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Checkbox();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.default != null && e.default && (n.default = !!e.default), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.value != null && e.value && (n.value = !!e.value), e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".Checkbox.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.type !== 0 && (typeof e.type != "string" || N.Checkbox.StyleType[e.type] !== 0)) switch (e.type) {
			default:
				if (typeof e.type == "number") {
					n.type = e.type;
					break;
				}
				break;
			case "DEFAULT":
			case 0:
				n.type = 0;
				break;
			case "TOGGLE":
			case 1:
				n.type = 1;
				break;
		}
		return e.queryParamKey != null && (n.queryParamKey = String(e.queryParamKey)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.default = !1, r.help = "", r.formId = "", r.value = !1, r.setValue = !1, r.disabled = !1, r.labelVisibility = null, r.type = t.enums === String ? "DEFAULT" : 0), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.default != null && e.hasOwnProperty("default") && (r.default = e.default), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.value != null && e.hasOwnProperty("value") && (r.value = e.value), e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.type != null && e.hasOwnProperty("type") && (r.type = t.enums === String ? N.Checkbox.StyleType[e.type] === void 0 ? e.type : N.Checkbox.StyleType[e.type] : e.type), e.queryParamKey != null && e.hasOwnProperty("queryParamKey") && (r.queryParamKey = e.queryParamKey), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Checkbox";
	}, e.StyleType = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "DEFAULT"] = 0, t[e[1] = "TOGGLE"] = 1, t;
	})(), e;
})(), N.Code = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.codeText = "", e.prototype.language = "", e.prototype.showLineNumbers = !1, e.prototype.wrapLines = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.codeText != null && Object.hasOwnProperty.call(e, "codeText") && t.uint32(10).string(e.codeText), e.language != null && Object.hasOwnProperty.call(e, "language") && t.uint32(18).string(e.language), e.showLineNumbers != null && Object.hasOwnProperty.call(e, "showLineNumbers") && t.uint32(24).bool(e.showLineNumbers), e.wrapLines != null && Object.hasOwnProperty.call(e, "wrapLines") && t.uint32(32).bool(e.wrapLines), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Code(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.codeText = s : delete o.codeText;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.language = s : delete o.language;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.showLineNumbers = s : delete o.showLineNumbers;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.wrapLines = s : delete o.wrapLines;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Code) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Code();
		return e.codeText != null && (typeof e.codeText != "string" || e.codeText.length) && (n.codeText = String(e.codeText)), e.language != null && (typeof e.language != "string" || e.language.length) && (n.language = String(e.language)), e.showLineNumbers != null && e.showLineNumbers && (n.showLineNumbers = !!e.showLineNumbers), e.wrapLines != null && e.wrapLines && (n.wrapLines = !!e.wrapLines), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.codeText = "", r.language = "", r.showLineNumbers = !1, r.wrapLines = !1), e.codeText != null && e.hasOwnProperty("codeText") && (r.codeText = e.codeText), e.language != null && e.hasOwnProperty("language") && (r.language = e.language), e.showLineNumbers != null && e.hasOwnProperty("showLineNumbers") && (r.showLineNumbers = e.showLineNumbers), e.wrapLines != null && e.hasOwnProperty("wrapLines") && (r.wrapLines = e.wrapLines), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Code";
	}, e;
})(), N.ColorPicker = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = "", e.prototype.help = "", e.prototype.formId = "", e.prototype.value = "", e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.queryParamKey = null;
	let t;
	return Object.defineProperty(e.prototype, "_queryParamKey", {
		get: M.oneOfGetter(t = ["queryParamKey"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.default != null && Object.hasOwnProperty.call(e, "default") && t.uint32(26).string(e.default), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(34).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(42).string(e.formId), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(50).string(e.value), e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(56).bool(e.setValue), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(64).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(74).fork(), n + 1).ldelim(), e.queryParamKey != null && Object.hasOwnProperty.call(e, "queryParamKey") && t.uint32(82).string(e.queryParamKey), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ColorPicker(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.default = s : delete o.default;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.value = s : delete o.value;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 9:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 10:
					if (a !== 2) break;
					o.queryParamKey = e.string(), o._queryParamKey = "queryParamKey";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ColorPicker) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ColorPicker();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.default != null && (typeof e.default != "string" || e.default.length) && (n.default = String(e.default)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.value != null && (typeof e.value != "string" || e.value.length) && (n.value = String(e.value)), e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".ColorPicker.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.queryParamKey != null && (n.queryParamKey = String(e.queryParamKey)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.default = "", r.help = "", r.formId = "", r.value = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.default != null && e.hasOwnProperty("default") && (r.default = e.default), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.value != null && e.hasOwnProperty("value") && (r.value = e.value), e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.queryParamKey != null && e.hasOwnProperty("queryParamKey") && (r.queryParamKey = e.queryParamKey), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ColorPicker";
	}, e;
})(), N.Dataframe = (() => {
	function e(e) {
		if (this.columnOrder = [], this.selectionMode = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.arrowData = null, e.prototype.id = "", e.prototype.columns = "", e.prototype.editingMode = 0, e.prototype.disabled = !1, e.prototype.formId = "", e.prototype.columnOrder = M.emptyArray, e.prototype.selectionMode = M.emptyArray, e.prototype.rowHeight = null, e.prototype.placeholder = null, e.prototype.selectionState = null, e.prototype.selectionDefault = null;
	let t;
	return Object.defineProperty(e.prototype, "_rowHeight", {
		get: M.oneOfGetter(t = ["rowHeight"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_placeholder", {
		get: M.oneOfGetter(t = ["placeholder"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_selectionState", {
		get: M.oneOfGetter(t = ["selectionState"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_selectionDefault", {
		get: M.oneOfGetter(t = ["selectionDefault"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.arrowData != null && Object.hasOwnProperty.call(e, "arrowData") && N.ArrowData.encode(e.arrowData, t.uint32(10).fork(), n + 1).ldelim(), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(18).string(e.id), e.columns != null && Object.hasOwnProperty.call(e, "columns") && t.uint32(26).string(e.columns), e.editingMode != null && Object.hasOwnProperty.call(e, "editingMode") && t.uint32(32).int32(e.editingMode), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(40).bool(e.disabled), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(50).string(e.formId), e.columnOrder != null && e.columnOrder.length) for (let n = 0; n < e.columnOrder.length; ++n) t.uint32(58).string(e.columnOrder[n]);
		if (e.selectionMode != null && e.selectionMode.length) {
			t.uint32(66).fork();
			for (let n = 0; n < e.selectionMode.length; ++n) t.int32(e.selectionMode[n]);
			t.ldelim();
		}
		if (e.rowHeight != null && Object.hasOwnProperty.call(e, "rowHeight") && t.uint32(72).uint32(e.rowHeight), e.placeholder != null && Object.hasOwnProperty.call(e, "placeholder") && t.uint32(82).string(e.placeholder), e.selectionState != null && Object.hasOwnProperty.call(e, "selectionState") && t.uint32(90).string(e.selectionState), e.selectionDefault != null && Object.hasOwnProperty.call(e, "selectionDefault") && t.uint32(98).string(e.selectionDefault), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Dataframe(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.arrowData = N.ArrowData.decode(e, e.uint32(), void 0, r + 1, o.arrowData);
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.columns = s : delete o.columns;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.int32()) ? o.editingMode = s : delete o.editingMode;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 7:
					if (a !== 2) break;
					o.columnOrder && o.columnOrder.length || (o.columnOrder = []), o.columnOrder.push(e.string());
					continue;
				case 8:
					if (a === 2) {
						o.selectionMode && o.selectionMode.length || (o.selectionMode = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.selectionMode.push(e.int32());
						continue;
					}
					if (a !== 0) break;
					o.selectionMode && o.selectionMode.length || (o.selectionMode = []), o.selectionMode.push(e.int32());
					continue;
				case 9:
					if (a !== 0) break;
					o.rowHeight = e.uint32(), o._rowHeight = "rowHeight";
					continue;
				case 10:
					if (a !== 2) break;
					o.placeholder = e.string(), o._placeholder = "placeholder";
					continue;
				case 11:
					if (a !== 2) break;
					o.selectionState = e.string(), o._selectionState = "selectionState";
					continue;
				case 12:
					if (a !== 2) break;
					o.selectionDefault = e.string(), o._selectionDefault = "selectionDefault";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Dataframe) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Dataframe();
		if (e.arrowData != null) {
			if (typeof e.arrowData != "object") throw TypeError(".Dataframe.arrowData: object expected");
			n.arrowData = N.ArrowData.fromObject(e.arrowData, t + 1);
		}
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.columns != null && (typeof e.columns != "string" || e.columns.length) && (n.columns = String(e.columns)), e.editingMode !== 0 && (typeof e.editingMode != "string" || N.Dataframe.EditingMode[e.editingMode] !== 0)) switch (e.editingMode) {
			default:
				if (typeof e.editingMode == "number") {
					n.editingMode = e.editingMode;
					break;
				}
				break;
			case "READ_ONLY":
			case 0:
				n.editingMode = 0;
				break;
			case "FIXED":
			case 1:
				n.editingMode = 1;
				break;
			case "DYNAMIC":
			case 2:
				n.editingMode = 2;
				break;
			case "ADD_ONLY":
			case 3:
				n.editingMode = 3;
				break;
			case "DELETE_ONLY":
			case 4:
				n.editingMode = 4;
				break;
		}
		if (e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.columnOrder) {
			if (!Array.isArray(e.columnOrder)) throw TypeError(".Dataframe.columnOrder: array expected");
			n.columnOrder = Array(e.columnOrder.length);
			for (let t = 0; t < e.columnOrder.length; ++t) n.columnOrder[t] = String(e.columnOrder[t]);
		}
		if (e.selectionMode) {
			if (!Array.isArray(e.selectionMode)) throw TypeError(".Dataframe.selectionMode: array expected");
			n.selectionMode = Array(e.selectionMode.length);
			for (let t = 0; t < e.selectionMode.length; ++t) switch (e.selectionMode[t]) {
				default: if (typeof e.selectionMode[t] == "number") {
					n.selectionMode[t] = e.selectionMode[t];
					break;
				}
				case "SINGLE_ROW":
				case 0:
					n.selectionMode[t] = 0;
					break;
				case "MULTI_ROW":
				case 1:
					n.selectionMode[t] = 1;
					break;
				case "SINGLE_COLUMN":
				case 2:
					n.selectionMode[t] = 2;
					break;
				case "MULTI_COLUMN":
				case 3:
					n.selectionMode[t] = 3;
					break;
				case "SINGLE_CELL":
				case 4:
					n.selectionMode[t] = 4;
					break;
				case "MULTI_CELL":
				case 5:
					n.selectionMode[t] = 5;
					break;
				case "SINGLE_ROW_REQUIRED":
				case 6:
					n.selectionMode[t] = 6;
					break;
			}
		}
		return e.rowHeight != null && (n.rowHeight = e.rowHeight >>> 0), e.placeholder != null && (n.placeholder = String(e.placeholder)), e.selectionState != null && (n.selectionState = String(e.selectionState)), e.selectionDefault != null && (n.selectionDefault = String(e.selectionDefault)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.columnOrder = [], r.selectionMode = []), t.defaults && (r.arrowData = null, r.id = "", r.columns = "", r.editingMode = t.enums === String ? "READ_ONLY" : 0, r.disabled = !1, r.formId = ""), e.arrowData != null && e.hasOwnProperty("arrowData") && (r.arrowData = N.ArrowData.toObject(e.arrowData, t, n + 1)), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.columns != null && e.hasOwnProperty("columns") && (r.columns = e.columns), e.editingMode != null && e.hasOwnProperty("editingMode") && (r.editingMode = t.enums === String ? N.Dataframe.EditingMode[e.editingMode] === void 0 ? e.editingMode : N.Dataframe.EditingMode[e.editingMode] : e.editingMode), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.columnOrder && e.columnOrder.length) {
			r.columnOrder = Array(e.columnOrder.length);
			for (let t = 0; t < e.columnOrder.length; ++t) r.columnOrder[t] = e.columnOrder[t];
		}
		if (e.selectionMode && e.selectionMode.length) {
			r.selectionMode = Array(e.selectionMode.length);
			for (let n = 0; n < e.selectionMode.length; ++n) r.selectionMode[n] = t.enums === String ? N.Dataframe.SelectionMode[e.selectionMode[n]] === void 0 ? e.selectionMode[n] : N.Dataframe.SelectionMode[e.selectionMode[n]] : e.selectionMode[n];
		}
		return e.rowHeight != null && e.hasOwnProperty("rowHeight") && (r.rowHeight = e.rowHeight), e.placeholder != null && e.hasOwnProperty("placeholder") && (r.placeholder = e.placeholder), e.selectionState != null && e.hasOwnProperty("selectionState") && (r.selectionState = e.selectionState), e.selectionDefault != null && e.hasOwnProperty("selectionDefault") && (r.selectionDefault = e.selectionDefault), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Dataframe";
	}, e.EditingMode = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "READ_ONLY"] = 0, t[e[1] = "FIXED"] = 1, t[e[2] = "DYNAMIC"] = 2, t[e[3] = "ADD_ONLY"] = 3, t[e[4] = "DELETE_ONLY"] = 4, t;
	})(), e.SelectionMode = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "SINGLE_ROW"] = 0, t[e[1] = "MULTI_ROW"] = 1, t[e[2] = "SINGLE_COLUMN"] = 2, t[e[3] = "MULTI_COLUMN"] = 3, t[e[4] = "SINGLE_CELL"] = 4, t[e[5] = "MULTI_CELL"] = 5, t[e[6] = "SINGLE_ROW_REQUIRED"] = 6, t;
	})(), e;
})(), N.DateInput = (() => {
	function e(e) {
		if (this.default = [], this.value = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = M.emptyArray, e.prototype.min = "", e.prototype.max = "", e.prototype.isRange = !1, e.prototype.help = "", e.prototype.formId = "", e.prototype.value = M.emptyArray, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.format = "", e.prototype.queryParamKey = null;
	let t;
	return Object.defineProperty(e.prototype, "_queryParamKey", {
		get: M.oneOfGetter(t = ["queryParamKey"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.default != null && e.default.length) for (let n = 0; n < e.default.length; ++n) t.uint32(26).string(e.default[n]);
		if (e.min != null && Object.hasOwnProperty.call(e, "min") && t.uint32(34).string(e.min), e.max != null && Object.hasOwnProperty.call(e, "max") && t.uint32(42).string(e.max), e.isRange != null && Object.hasOwnProperty.call(e, "isRange") && t.uint32(48).bool(e.isRange), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(58).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(66).string(e.formId), e.value != null && e.value.length) for (let n = 0; n < e.value.length; ++n) t.uint32(74).string(e.value[n]);
		if (e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(80).bool(e.setValue), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(88).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(98).fork(), n + 1).ldelim(), e.format != null && Object.hasOwnProperty.call(e, "format") && t.uint32(106).string(e.format), e.queryParamKey != null && Object.hasOwnProperty.call(e, "queryParamKey") && t.uint32(114).string(e.queryParamKey), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.DateInput(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.default && o.default.length || (o.default = []), o.default.push(e.string());
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.min = s : delete o.min;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.max = s : delete o.max;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.isRange = s : delete o.isRange;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 8:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 9:
					if (a !== 2) break;
					o.value && o.value.length || (o.value = []), o.value.push(e.string());
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 12:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 13:
					if (a !== 2) break;
					(s = e.string()).length ? o.format = s : delete o.format;
					continue;
				case 14:
					if (a !== 2) break;
					o.queryParamKey = e.string(), o._queryParamKey = "queryParamKey";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.DateInput) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.DateInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.default) {
			if (!Array.isArray(e.default)) throw TypeError(".DateInput.default: array expected");
			n.default = Array(e.default.length);
			for (let t = 0; t < e.default.length; ++t) n.default[t] = String(e.default[t]);
		}
		if (e.min != null && (typeof e.min != "string" || e.min.length) && (n.min = String(e.min)), e.max != null && (typeof e.max != "string" || e.max.length) && (n.max = String(e.max)), e.isRange != null && e.isRange && (n.isRange = !!e.isRange), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.value) {
			if (!Array.isArray(e.value)) throw TypeError(".DateInput.value: array expected");
			n.value = Array(e.value.length);
			for (let t = 0; t < e.value.length; ++t) n.value[t] = String(e.value[t]);
		}
		if (e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".DateInput.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.format != null && (typeof e.format != "string" || e.format.length) && (n.format = String(e.format)), e.queryParamKey != null && (n.queryParamKey = String(e.queryParamKey)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.default = [], r.value = []), t.defaults && (r.id = "", r.label = "", r.min = "", r.max = "", r.isRange = !1, r.help = "", r.formId = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null, r.format = ""), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.default && e.default.length) {
			r.default = Array(e.default.length);
			for (let t = 0; t < e.default.length; ++t) r.default[t] = e.default[t];
		}
		if (e.min != null && e.hasOwnProperty("min") && (r.min = e.min), e.max != null && e.hasOwnProperty("max") && (r.max = e.max), e.isRange != null && e.hasOwnProperty("isRange") && (r.isRange = e.isRange), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.value && e.value.length) {
			r.value = Array(e.value.length);
			for (let t = 0; t < e.value.length; ++t) r.value[t] = e.value[t];
		}
		return e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.format != null && e.hasOwnProperty("format") && (r.format = e.format), e.queryParamKey != null && e.hasOwnProperty("queryParamKey") && (r.queryParamKey = e.queryParamKey), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/DateInput";
	}, e;
})(), N.DateTimeInput = (() => {
	function e(e) {
		if (this.default = [], this.value = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = M.emptyArray, e.prototype.min = "", e.prototype.max = "", e.prototype.help = "", e.prototype.formId = "", e.prototype.value = M.emptyArray, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.format = "", e.prototype.step = M.Long ? M.Long.fromBits(0, 0, !1) : 0, e.prototype.isRange = !1, e.prototype.queryParamKey = null;
	let t;
	return Object.defineProperty(e.prototype, "_queryParamKey", {
		get: M.oneOfGetter(t = ["queryParamKey"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.default != null && e.default.length) for (let n = 0; n < e.default.length; ++n) t.uint32(26).string(e.default[n]);
		if (e.min != null && Object.hasOwnProperty.call(e, "min") && t.uint32(34).string(e.min), e.max != null && Object.hasOwnProperty.call(e, "max") && t.uint32(42).string(e.max), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(50).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(58).string(e.formId), e.value != null && e.value.length) for (let n = 0; n < e.value.length; ++n) t.uint32(66).string(e.value[n]);
		if (e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(72).bool(e.setValue), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(80).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(90).fork(), n + 1).ldelim(), e.format != null && Object.hasOwnProperty.call(e, "format") && t.uint32(98).string(e.format), e.step != null && Object.hasOwnProperty.call(e, "step") && t.uint32(104).int64(e.step), e.isRange != null && Object.hasOwnProperty.call(e, "isRange") && t.uint32(112).bool(e.isRange), e.queryParamKey != null && Object.hasOwnProperty.call(e, "queryParamKey") && t.uint32(122).string(e.queryParamKey), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.DateTimeInput(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.default && o.default.length || (o.default = []), o.default.push(e.string());
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.min = s : delete o.min;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.max = s : delete o.max;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 8:
					if (a !== 2) break;
					o.value && o.value.length || (o.value = []), o.value.push(e.string());
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 11:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.string()).length ? o.format = s : delete o.format;
					continue;
				case 13:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.step = s : delete o.step;
					continue;
				case 14:
					if (a !== 0) break;
					(s = e.bool()) ? o.isRange = s : delete o.isRange;
					continue;
				case 15:
					if (a !== 2) break;
					o.queryParamKey = e.string(), o._queryParamKey = "queryParamKey";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.DateTimeInput) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.DateTimeInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.default) {
			if (!Array.isArray(e.default)) throw TypeError(".DateTimeInput.default: array expected");
			n.default = Array(e.default.length);
			for (let t = 0; t < e.default.length; ++t) n.default[t] = String(e.default[t]);
		}
		if (e.min != null && (typeof e.min != "string" || e.min.length) && (n.min = String(e.min)), e.max != null && (typeof e.max != "string" || e.max.length) && (n.max = String(e.max)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.value) {
			if (!Array.isArray(e.value)) throw TypeError(".DateTimeInput.value: array expected");
			n.value = Array(e.value.length);
			for (let t = 0; t < e.value.length; ++t) n.value[t] = String(e.value[t]);
		}
		if (e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".DateTimeInput.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.format != null && (typeof e.format != "string" || e.format.length) && (n.format = String(e.format)), e.step != null && (typeof e.step == "object" ? e.step.low || e.step.high : Number(e.step) !== 0) && (M.Long ? n.step = M.Long.fromValue(e.step, !1) : typeof e.step == "string" ? n.step = parseInt(e.step, 10) : typeof e.step == "number" ? n.step = e.step : typeof e.step == "object" && (n.step = new M.LongBits(e.step.low >>> 0, e.step.high >>> 0).toNumber())), e.isRange != null && e.isRange && (n.isRange = !!e.isRange), e.queryParamKey != null && (n.queryParamKey = String(e.queryParamKey)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.default = [], r.value = []), t.defaults) {
			if (r.id = "", r.label = "", r.min = "", r.max = "", r.help = "", r.formId = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null, r.format = "", M.Long) {
				let e = new M.Long(0, 0, !1);
				r.step = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
			} else r.step = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
			r.isRange = !1;
		}
		if (e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.default && e.default.length) {
			r.default = Array(e.default.length);
			for (let t = 0; t < e.default.length; ++t) r.default[t] = e.default[t];
		}
		if (e.min != null && e.hasOwnProperty("min") && (r.min = e.min), e.max != null && e.hasOwnProperty("max") && (r.max = e.max), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.value && e.value.length) {
			r.value = Array(e.value.length);
			for (let t = 0; t < e.value.length; ++t) r.value[t] = e.value[t];
		}
		return e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.format != null && e.hasOwnProperty("format") && (r.format = e.format), e.step != null && e.hasOwnProperty("step") && (typeof BigInt < "u" && t.longs === BigInt ? r.step = typeof e.step == "number" ? BigInt(e.step) : M.Long.fromBits(e.step.low >>> 0, e.step.high >>> 0, !1).toBigInt() : typeof e.step == "number" ? r.step = t.longs === String ? String(e.step) : e.step : r.step = t.longs === String ? M.Long.prototype.toString.call(e.step) : t.longs === Number ? new M.LongBits(e.step.low >>> 0, e.step.high >>> 0).toNumber() : e.step), e.isRange != null && e.hasOwnProperty("isRange") && (r.isRange = e.isRange), e.queryParamKey != null && e.hasOwnProperty("queryParamKey") && (r.queryParamKey = e.queryParamKey), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/DateTimeInput";
	}, e;
})(), N.DeckGlJsonChart = (() => {
	function e(e) {
		if (this.selectionMode = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.json = "", e.prototype.tooltip = "", e.prototype.id = "", e.prototype.mapboxToken = "", e.prototype.selectionMode = M.emptyArray, e.prototype.formId = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.json != null && Object.hasOwnProperty.call(e, "json") && t.uint32(10).string(e.json), e.tooltip != null && Object.hasOwnProperty.call(e, "tooltip") && t.uint32(18).string(e.tooltip), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(42).string(e.id), e.mapboxToken != null && Object.hasOwnProperty.call(e, "mapboxToken") && t.uint32(50).string(e.mapboxToken), e.selectionMode != null && e.selectionMode.length) {
			t.uint32(74).fork();
			for (let n = 0; n < e.selectionMode.length; ++n) t.int32(e.selectionMode[n]);
			t.ldelim();
		}
		if (e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(82).string(e.formId), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.DeckGlJsonChart(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.json = s : delete o.json;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.tooltip = s : delete o.tooltip;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.mapboxToken = s : delete o.mapboxToken;
					continue;
				case 9:
					if (a === 2) {
						o.selectionMode && o.selectionMode.length || (o.selectionMode = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.selectionMode.push(e.int32());
						continue;
					}
					if (a !== 0) break;
					o.selectionMode && o.selectionMode.length || (o.selectionMode = []), o.selectionMode.push(e.int32());
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.DeckGlJsonChart) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.DeckGlJsonChart();
		if (e.json != null && (typeof e.json != "string" || e.json.length) && (n.json = String(e.json)), e.tooltip != null && (typeof e.tooltip != "string" || e.tooltip.length) && (n.tooltip = String(e.tooltip)), e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.mapboxToken != null && (typeof e.mapboxToken != "string" || e.mapboxToken.length) && (n.mapboxToken = String(e.mapboxToken)), e.selectionMode) {
			if (!Array.isArray(e.selectionMode)) throw TypeError(".DeckGlJsonChart.selectionMode: array expected");
			n.selectionMode = Array(e.selectionMode.length);
			for (let t = 0; t < e.selectionMode.length; ++t) switch (e.selectionMode[t]) {
				default: if (typeof e.selectionMode[t] == "number") {
					n.selectionMode[t] = e.selectionMode[t];
					break;
				}
				case "SINGLE_OBJECT":
				case 0:
					n.selectionMode[t] = 0;
					break;
				case "MULTI_OBJECT":
				case 1:
					n.selectionMode[t] = 1;
					break;
			}
		}
		return e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.selectionMode = []), t.defaults && (r.json = "", r.tooltip = "", r.id = "", r.mapboxToken = "", r.formId = ""), e.json != null && e.hasOwnProperty("json") && (r.json = e.json), e.tooltip != null && e.hasOwnProperty("tooltip") && (r.tooltip = e.tooltip), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.mapboxToken != null && e.hasOwnProperty("mapboxToken") && (r.mapboxToken = e.mapboxToken), e.selectionMode && e.selectionMode.length) {
			r.selectionMode = Array(e.selectionMode.length);
			for (let n = 0; n < e.selectionMode.length; ++n) r.selectionMode[n] = t.enums === String ? N.DeckGlJsonChart.SelectionMode[e.selectionMode[n]] === void 0 ? e.selectionMode[n] : N.DeckGlJsonChart.SelectionMode[e.selectionMode[n]] : e.selectionMode[n];
		}
		return e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/DeckGlJsonChart";
	}, e.SelectionMode = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "SINGLE_OBJECT"] = 0, t[e[1] = "MULTI_OBJECT"] = 1, t;
	})(), e;
})(), N.Delta = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.newElement = null, e.prototype.addBlock = null, e.prototype.newTransient = null, e.prototype.arrowAddRows = null, e.prototype.fragmentId = "";
	let t;
	return Object.defineProperty(e.prototype, "type", {
		get: M.oneOfGetter(t = [
			"newElement",
			"addBlock",
			"newTransient",
			"arrowAddRows"
		]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.newElement != null && Object.hasOwnProperty.call(e, "newElement") && N.Element.encode(e.newElement, t.uint32(26).fork(), n + 1).ldelim(), e.addBlock != null && Object.hasOwnProperty.call(e, "addBlock") && N.Block.encode(e.addBlock, t.uint32(50).fork(), n + 1).ldelim(), e.arrowAddRows != null && Object.hasOwnProperty.call(e, "arrowAddRows") && N.ArrowNamedDataSet.encode(e.arrowAddRows, t.uint32(58).fork(), n + 1).ldelim(), e.fragmentId != null && Object.hasOwnProperty.call(e, "fragmentId") && t.uint32(66).string(e.fragmentId), e.newTransient != null && Object.hasOwnProperty.call(e, "newTransient") && N.Transient.encode(e.newTransient, t.uint32(74).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Delta(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 3:
					if (a !== 2) break;
					o.newElement = N.Element.decode(e, e.uint32(), void 0, r + 1, o.newElement), o.type = "newElement";
					continue;
				case 6:
					if (a !== 2) break;
					o.addBlock = N.Block.decode(e, e.uint32(), void 0, r + 1, o.addBlock), o.type = "addBlock";
					continue;
				case 9:
					if (a !== 2) break;
					o.newTransient = N.Transient.decode(e, e.uint32(), void 0, r + 1, o.newTransient), o.type = "newTransient";
					continue;
				case 7:
					if (a !== 2) break;
					o.arrowAddRows = N.ArrowNamedDataSet.decode(e, e.uint32(), void 0, r + 1, o.arrowAddRows), o.type = "arrowAddRows";
					continue;
				case 8:
					if (a !== 2) break;
					(s = e.string()).length ? o.fragmentId = s : delete o.fragmentId;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Delta) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Delta();
		if (e.newElement != null) {
			if (typeof e.newElement != "object") throw TypeError(".Delta.newElement: object expected");
			n.newElement = N.Element.fromObject(e.newElement, t + 1);
		}
		if (e.addBlock != null) {
			if (typeof e.addBlock != "object") throw TypeError(".Delta.addBlock: object expected");
			n.addBlock = N.Block.fromObject(e.addBlock, t + 1);
		}
		if (e.newTransient != null) {
			if (typeof e.newTransient != "object") throw TypeError(".Delta.newTransient: object expected");
			n.newTransient = N.Transient.fromObject(e.newTransient, t + 1);
		}
		if (e.arrowAddRows != null) {
			if (typeof e.arrowAddRows != "object") throw TypeError(".Delta.arrowAddRows: object expected");
			n.arrowAddRows = N.ArrowNamedDataSet.fromObject(e.arrowAddRows, t + 1);
		}
		return e.fragmentId != null && (typeof e.fragmentId != "string" || e.fragmentId.length) && (n.fragmentId = String(e.fragmentId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.fragmentId = ""), e.newElement != null && e.hasOwnProperty("newElement") && (r.newElement = N.Element.toObject(e.newElement, t, n + 1), t.oneofs && (r.type = "newElement")), e.addBlock != null && e.hasOwnProperty("addBlock") && (r.addBlock = N.Block.toObject(e.addBlock, t, n + 1), t.oneofs && (r.type = "addBlock")), e.arrowAddRows != null && e.hasOwnProperty("arrowAddRows") && (r.arrowAddRows = N.ArrowNamedDataSet.toObject(e.arrowAddRows, t, n + 1), t.oneofs && (r.type = "arrowAddRows")), e.fragmentId != null && e.hasOwnProperty("fragmentId") && (r.fragmentId = e.fragmentId), e.newTransient != null && e.hasOwnProperty("newTransient") && (r.newTransient = N.Transient.toObject(e.newTransient, t, n + 1), t.oneofs && (r.type = "newTransient")), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Delta";
	}, e;
})(), N.Element = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.heightConfig = null, e.prototype.widthConfig = null, e.prototype.textAlignmentConfig = null, e.prototype.alert = null, e.prototype.dataframe = null, e.prototype.table = null, e.prototype.vegaLiteChart = null, e.prototype.audio = null, e.prototype.audioInput = null, e.prototype.balloons = null, e.prototype.bidiComponent = null, e.prototype.button = null, e.prototype.buttonGroup = null, e.prototype.downloadButton = null, e.prototype.cameraInput = null, e.prototype.chatInput = null, e.prototype.checkbox = null, e.prototype.colorPicker = null, e.prototype.componentInstance = null, e.prototype.dateInput = null, e.prototype.deckGlJsonChart = null, e.prototype.helpInfo = null, e.prototype.empty = null, e.prototype.exception = null, e.prototype.favicon = null, e.prototype.feedback = null, e.prototype.fileUploader = null, e.prototype.graphvizChart = null, e.prototype.html = null, e.prototype.iframe = null, e.prototype.imgs = null, e.prototype.json = null, e.prototype.linkButton = null, e.prototype.markdown = null, e.prototype.metric = null, e.prototype.multiselect = null, e.prototype.numberInput = null, e.prototype.pageLink = null, e.prototype.plotlyChart = null, e.prototype.progress = null, e.prototype.radio = null, e.prototype.selectbox = null, e.prototype.skeleton = null, e.prototype.slider = null, e.prototype.snow = null, e.prototype.space = null, e.prototype.spinner = null, e.prototype.text = null, e.prototype.textArea = null, e.prototype.textInput = null, e.prototype.timeInput = null, e.prototype.dateTimeInput = null, e.prototype.toast = null, e.prototype.video = null, e.prototype.heading = null, e.prototype.code = null, e.prototype.menuButton = null;
	let t;
	return Object.defineProperty(e.prototype, "_heightConfig", {
		get: M.oneOfGetter(t = ["heightConfig"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_widthConfig", {
		get: M.oneOfGetter(t = ["widthConfig"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_textAlignmentConfig", {
		get: M.oneOfGetter(t = ["textAlignmentConfig"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "type", {
		get: M.oneOfGetter(t = /* @__PURE__ */ "alert.dataframe.table.vegaLiteChart.audio.audioInput.balloons.bidiComponent.button.buttonGroup.downloadButton.cameraInput.chatInput.checkbox.colorPicker.componentInstance.dateInput.deckGlJsonChart.helpInfo.empty.exception.favicon.feedback.fileUploader.graphvizChart.html.iframe.imgs.json.linkButton.markdown.metric.multiselect.numberInput.pageLink.plotlyChart.progress.radio.selectbox.skeleton.slider.snow.space.spinner.text.textArea.textInput.timeInput.dateTimeInput.toast.video.heading.code.menuButton".split(".")),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.text != null && Object.hasOwnProperty.call(e, "text") && N.Text.encode(e.text, t.uint32(10).fork(), n + 1).ldelim(), e.empty != null && Object.hasOwnProperty.call(e, "empty") && N.Empty.encode(e.empty, t.uint32(18).fork(), n + 1).ldelim(), e.progress != null && Object.hasOwnProperty.call(e, "progress") && N.Progress.encode(e.progress, t.uint32(42).fork(), n + 1).ldelim(), e.imgs != null && Object.hasOwnProperty.call(e, "imgs") && N.ImageList.encode(e.imgs, t.uint32(50).fork(), n + 1).ldelim(), e.helpInfo != null && Object.hasOwnProperty.call(e, "helpInfo") && N.Help.encode(e.helpInfo, t.uint32(58).fork(), n + 1).ldelim(), e.exception != null && Object.hasOwnProperty.call(e, "exception") && N.Exception.encode(e.exception, t.uint32(66).fork(), n + 1).ldelim(), e.balloons != null && Object.hasOwnProperty.call(e, "balloons") && N.Balloons.encode(e.balloons, t.uint32(98).fork(), n + 1).ldelim(), e.audio != null && Object.hasOwnProperty.call(e, "audio") && N.Audio.encode(e.audio, t.uint32(106).fork(), n + 1).ldelim(), e.video != null && Object.hasOwnProperty.call(e, "video") && N.Video.encode(e.video, t.uint32(114).fork(), n + 1).ldelim(), e.plotlyChart != null && Object.hasOwnProperty.call(e, "plotlyChart") && N.PlotlyChart.encode(e.plotlyChart, t.uint32(130).fork(), n + 1).ldelim(), e.graphvizChart != null && Object.hasOwnProperty.call(e, "graphvizChart") && N.GraphVizChart.encode(e.graphvizChart, t.uint32(146).fork(), n + 1).ldelim(), e.button != null && Object.hasOwnProperty.call(e, "button") && N.Button.encode(e.button, t.uint32(154).fork(), n + 1).ldelim(), e.checkbox != null && Object.hasOwnProperty.call(e, "checkbox") && N.Checkbox.encode(e.checkbox, t.uint32(162).fork(), n + 1).ldelim(), e.slider != null && Object.hasOwnProperty.call(e, "slider") && N.Slider.encode(e.slider, t.uint32(170).fork(), n + 1).ldelim(), e.textArea != null && Object.hasOwnProperty.call(e, "textArea") && N.TextArea.encode(e.textArea, t.uint32(178).fork(), n + 1).ldelim(), e.radio != null && Object.hasOwnProperty.call(e, "radio") && N.Radio.encode(e.radio, t.uint32(186).fork(), n + 1).ldelim(), e.textInput != null && Object.hasOwnProperty.call(e, "textInput") && N.TextInput.encode(e.textInput, t.uint32(194).fork(), n + 1).ldelim(), e.selectbox != null && Object.hasOwnProperty.call(e, "selectbox") && N.Selectbox.encode(e.selectbox, t.uint32(202).fork(), n + 1).ldelim(), e.timeInput != null && Object.hasOwnProperty.call(e, "timeInput") && N.TimeInput.encode(e.timeInput, t.uint32(210).fork(), n + 1).ldelim(), e.dateInput != null && Object.hasOwnProperty.call(e, "dateInput") && N.DateInput.encode(e.dateInput, t.uint32(218).fork(), n + 1).ldelim(), e.multiselect != null && Object.hasOwnProperty.call(e, "multiselect") && N.MultiSelect.encode(e.multiselect, t.uint32(226).fork(), n + 1).ldelim(), e.markdown != null && Object.hasOwnProperty.call(e, "markdown") && N.Markdown.encode(e.markdown, t.uint32(234).fork(), n + 1).ldelim(), e.alert != null && Object.hasOwnProperty.call(e, "alert") && N.Alert.encode(e.alert, t.uint32(242).fork(), n + 1).ldelim(), e.json != null && Object.hasOwnProperty.call(e, "json") && N.Json.encode(e.json, t.uint32(250).fork(), n + 1).ldelim(), e.numberInput != null && Object.hasOwnProperty.call(e, "numberInput") && N.NumberInput.encode(e.numberInput, t.uint32(258).fork(), n + 1).ldelim(), e.fileUploader != null && Object.hasOwnProperty.call(e, "fileUploader") && N.FileUploader.encode(e.fileUploader, t.uint32(266).fork(), n + 1).ldelim(), e.deckGlJsonChart != null && Object.hasOwnProperty.call(e, "deckGlJsonChart") && N.DeckGlJsonChart.encode(e.deckGlJsonChart, t.uint32(274).fork(), n + 1).ldelim(), e.colorPicker != null && Object.hasOwnProperty.call(e, "colorPicker") && N.ColorPicker.encode(e.colorPicker, t.uint32(282).fork(), n + 1).ldelim(), e.favicon != null && Object.hasOwnProperty.call(e, "favicon") && N.Favicon.encode(e.favicon, t.uint32(290).fork(), n + 1).ldelim(), e.componentInstance != null && Object.hasOwnProperty.call(e, "componentInstance") && N.ComponentInstance.encode(e.componentInstance, t.uint32(298).fork(), n + 1).ldelim(), e.iframe != null && Object.hasOwnProperty.call(e, "iframe") && N.IFrame.encode(e.iframe, t.uint32(306).fork(), n + 1).ldelim(), e.table != null && Object.hasOwnProperty.call(e, "table") && N.Table.encode(e.table, t.uint32(314).fork(), n + 1).ldelim(), e.dataframe != null && Object.hasOwnProperty.call(e, "dataframe") && N.Dataframe.encode(e.dataframe, t.uint32(322).fork(), n + 1).ldelim(), e.vegaLiteChart != null && Object.hasOwnProperty.call(e, "vegaLiteChart") && N.VegaLiteChart.encode(e.vegaLiteChart, t.uint32(330).fork(), n + 1).ldelim(), e.metric != null && Object.hasOwnProperty.call(e, "metric") && N.Metric.encode(e.metric, t.uint32(338).fork(), n + 1).ldelim(), e.downloadButton != null && Object.hasOwnProperty.call(e, "downloadButton") && N.DownloadButton.encode(e.downloadButton, t.uint32(346).fork(), n + 1).ldelim(), e.spinner != null && Object.hasOwnProperty.call(e, "spinner") && N.Spinner.encode(e.spinner, t.uint32(354).fork(), n + 1).ldelim(), e.cameraInput != null && Object.hasOwnProperty.call(e, "cameraInput") && N.CameraInput.encode(e.cameraInput, t.uint32(362).fork(), n + 1).ldelim(), e.snow != null && Object.hasOwnProperty.call(e, "snow") && N.Snow.encode(e.snow, t.uint32(370).fork(), n + 1).ldelim(), e.heading != null && Object.hasOwnProperty.call(e, "heading") && N.Heading.encode(e.heading, t.uint32(378).fork(), n + 1).ldelim(), e.code != null && Object.hasOwnProperty.call(e, "code") && N.Code.encode(e.code, t.uint32(386).fork(), n + 1).ldelim(), e.chatInput != null && Object.hasOwnProperty.call(e, "chatInput") && N.ChatInput.encode(e.chatInput, t.uint32(394).fork(), n + 1).ldelim(), e.toast != null && Object.hasOwnProperty.call(e, "toast") && N.Toast.encode(e.toast, t.uint32(402).fork(), n + 1).ldelim(), e.linkButton != null && Object.hasOwnProperty.call(e, "linkButton") && N.LinkButton.encode(e.linkButton, t.uint32(410).fork(), n + 1).ldelim(), e.skeleton != null && Object.hasOwnProperty.call(e, "skeleton") && N.Skeleton.encode(e.skeleton, t.uint32(418).fork(), n + 1).ldelim(), e.pageLink != null && Object.hasOwnProperty.call(e, "pageLink") && N.PageLink.encode(e.pageLink, t.uint32(426).fork(), n + 1).ldelim(), e.html != null && Object.hasOwnProperty.call(e, "html") && N.Html.encode(e.html, t.uint32(434).fork(), n + 1).ldelim(), e.buttonGroup != null && Object.hasOwnProperty.call(e, "buttonGroup") && N.ButtonGroup.encode(e.buttonGroup, t.uint32(442).fork(), n + 1).ldelim(), e.audioInput != null && Object.hasOwnProperty.call(e, "audioInput") && N.AudioInput.encode(e.audioInput, t.uint32(450).fork(), n + 1).ldelim(), e.heightConfig != null && Object.hasOwnProperty.call(e, "heightConfig") && N.streamlit.HeightConfig.encode(e.heightConfig, t.uint32(458).fork(), n + 1).ldelim(), e.widthConfig != null && Object.hasOwnProperty.call(e, "widthConfig") && N.streamlit.WidthConfig.encode(e.widthConfig, t.uint32(466).fork(), n + 1).ldelim(), e.bidiComponent != null && Object.hasOwnProperty.call(e, "bidiComponent") && N.BidiComponent.encode(e.bidiComponent, t.uint32(474).fork(), n + 1).ldelim(), e.space != null && Object.hasOwnProperty.call(e, "space") && N.Space.encode(e.space, t.uint32(482).fork(), n + 1).ldelim(), e.textAlignmentConfig != null && Object.hasOwnProperty.call(e, "textAlignmentConfig") && N.streamlit.TextAlignmentConfig.encode(e.textAlignmentConfig, t.uint32(490).fork(), n + 1).ldelim(), e.dateTimeInput != null && Object.hasOwnProperty.call(e, "dateTimeInput") && N.DateTimeInput.encode(e.dateTimeInput, t.uint32(498).fork(), n + 1).ldelim(), e.feedback != null && Object.hasOwnProperty.call(e, "feedback") && N.Feedback.encode(e.feedback, t.uint32(506).fork(), n + 1).ldelim(), e.menuButton != null && Object.hasOwnProperty.call(e, "menuButton") && N.MenuButton.encode(e.menuButton, t.uint32(514).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Element();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 57:
					if (a !== 2) break;
					o.heightConfig = N.streamlit.HeightConfig.decode(e, e.uint32(), void 0, r + 1, o.heightConfig), o._heightConfig = "heightConfig";
					continue;
				case 58:
					if (a !== 2) break;
					o.widthConfig = N.streamlit.WidthConfig.decode(e, e.uint32(), void 0, r + 1, o.widthConfig), o._widthConfig = "widthConfig";
					continue;
				case 61:
					if (a !== 2) break;
					o.textAlignmentConfig = N.streamlit.TextAlignmentConfig.decode(e, e.uint32(), void 0, r + 1, o.textAlignmentConfig), o._textAlignmentConfig = "textAlignmentConfig";
					continue;
				case 30:
					if (a !== 2) break;
					o.alert = N.Alert.decode(e, e.uint32(), void 0, r + 1, o.alert), o.type = "alert";
					continue;
				case 40:
					if (a !== 2) break;
					o.dataframe = N.Dataframe.decode(e, e.uint32(), void 0, r + 1, o.dataframe), o.type = "dataframe";
					continue;
				case 39:
					if (a !== 2) break;
					o.table = N.Table.decode(e, e.uint32(), void 0, r + 1, o.table), o.type = "table";
					continue;
				case 41:
					if (a !== 2) break;
					o.vegaLiteChart = N.VegaLiteChart.decode(e, e.uint32(), void 0, r + 1, o.vegaLiteChart), o.type = "vegaLiteChart";
					continue;
				case 13:
					if (a !== 2) break;
					o.audio = N.Audio.decode(e, e.uint32(), void 0, r + 1, o.audio), o.type = "audio";
					continue;
				case 56:
					if (a !== 2) break;
					o.audioInput = N.AudioInput.decode(e, e.uint32(), void 0, r + 1, o.audioInput), o.type = "audioInput";
					continue;
				case 12:
					if (a !== 2) break;
					o.balloons = N.Balloons.decode(e, e.uint32(), void 0, r + 1, o.balloons), o.type = "balloons";
					continue;
				case 59:
					if (a !== 2) break;
					o.bidiComponent = N.BidiComponent.decode(e, e.uint32(), void 0, r + 1, o.bidiComponent), o.type = "bidiComponent";
					continue;
				case 19:
					if (a !== 2) break;
					o.button = N.Button.decode(e, e.uint32(), void 0, r + 1, o.button), o.type = "button";
					continue;
				case 55:
					if (a !== 2) break;
					o.buttonGroup = N.ButtonGroup.decode(e, e.uint32(), void 0, r + 1, o.buttonGroup), o.type = "buttonGroup";
					continue;
				case 43:
					if (a !== 2) break;
					o.downloadButton = N.DownloadButton.decode(e, e.uint32(), void 0, r + 1, o.downloadButton), o.type = "downloadButton";
					continue;
				case 45:
					if (a !== 2) break;
					o.cameraInput = N.CameraInput.decode(e, e.uint32(), void 0, r + 1, o.cameraInput), o.type = "cameraInput";
					continue;
				case 49:
					if (a !== 2) break;
					o.chatInput = N.ChatInput.decode(e, e.uint32(), void 0, r + 1, o.chatInput), o.type = "chatInput";
					continue;
				case 20:
					if (a !== 2) break;
					o.checkbox = N.Checkbox.decode(e, e.uint32(), void 0, r + 1, o.checkbox), o.type = "checkbox";
					continue;
				case 35:
					if (a !== 2) break;
					o.colorPicker = N.ColorPicker.decode(e, e.uint32(), void 0, r + 1, o.colorPicker), o.type = "colorPicker";
					continue;
				case 37:
					if (a !== 2) break;
					o.componentInstance = N.ComponentInstance.decode(e, e.uint32(), void 0, r + 1, o.componentInstance), o.type = "componentInstance";
					continue;
				case 27:
					if (a !== 2) break;
					o.dateInput = N.DateInput.decode(e, e.uint32(), void 0, r + 1, o.dateInput), o.type = "dateInput";
					continue;
				case 34:
					if (a !== 2) break;
					o.deckGlJsonChart = N.DeckGlJsonChart.decode(e, e.uint32(), void 0, r + 1, o.deckGlJsonChart), o.type = "deckGlJsonChart";
					continue;
				case 7:
					if (a !== 2) break;
					o.helpInfo = N.Help.decode(e, e.uint32(), void 0, r + 1, o.helpInfo), o.type = "helpInfo";
					continue;
				case 2:
					if (a !== 2) break;
					o.empty = N.Empty.decode(e, e.uint32(), void 0, r + 1, o.empty), o.type = "empty";
					continue;
				case 8:
					if (a !== 2) break;
					o.exception = N.Exception.decode(e, e.uint32(), void 0, r + 1, o.exception), o.type = "exception";
					continue;
				case 36:
					if (a !== 2) break;
					o.favicon = N.Favicon.decode(e, e.uint32(), void 0, r + 1, o.favicon), o.type = "favicon";
					continue;
				case 63:
					if (a !== 2) break;
					o.feedback = N.Feedback.decode(e, e.uint32(), void 0, r + 1, o.feedback), o.type = "feedback";
					continue;
				case 33:
					if (a !== 2) break;
					o.fileUploader = N.FileUploader.decode(e, e.uint32(), void 0, r + 1, o.fileUploader), o.type = "fileUploader";
					continue;
				case 18:
					if (a !== 2) break;
					o.graphvizChart = N.GraphVizChart.decode(e, e.uint32(), void 0, r + 1, o.graphvizChart), o.type = "graphvizChart";
					continue;
				case 54:
					if (a !== 2) break;
					o.html = N.Html.decode(e, e.uint32(), void 0, r + 1, o.html), o.type = "html";
					continue;
				case 38:
					if (a !== 2) break;
					o.iframe = N.IFrame.decode(e, e.uint32(), void 0, r + 1, o.iframe), o.type = "iframe";
					continue;
				case 6:
					if (a !== 2) break;
					o.imgs = N.ImageList.decode(e, e.uint32(), void 0, r + 1, o.imgs), o.type = "imgs";
					continue;
				case 31:
					if (a !== 2) break;
					o.json = N.Json.decode(e, e.uint32(), void 0, r + 1, o.json), o.type = "json";
					continue;
				case 51:
					if (a !== 2) break;
					o.linkButton = N.LinkButton.decode(e, e.uint32(), void 0, r + 1, o.linkButton), o.type = "linkButton";
					continue;
				case 29:
					if (a !== 2) break;
					o.markdown = N.Markdown.decode(e, e.uint32(), void 0, r + 1, o.markdown), o.type = "markdown";
					continue;
				case 42:
					if (a !== 2) break;
					o.metric = N.Metric.decode(e, e.uint32(), void 0, r + 1, o.metric), o.type = "metric";
					continue;
				case 28:
					if (a !== 2) break;
					o.multiselect = N.MultiSelect.decode(e, e.uint32(), void 0, r + 1, o.multiselect), o.type = "multiselect";
					continue;
				case 32:
					if (a !== 2) break;
					o.numberInput = N.NumberInput.decode(e, e.uint32(), void 0, r + 1, o.numberInput), o.type = "numberInput";
					continue;
				case 53:
					if (a !== 2) break;
					o.pageLink = N.PageLink.decode(e, e.uint32(), void 0, r + 1, o.pageLink), o.type = "pageLink";
					continue;
				case 16:
					if (a !== 2) break;
					o.plotlyChart = N.PlotlyChart.decode(e, e.uint32(), void 0, r + 1, o.plotlyChart), o.type = "plotlyChart";
					continue;
				case 5:
					if (a !== 2) break;
					o.progress = N.Progress.decode(e, e.uint32(), void 0, r + 1, o.progress), o.type = "progress";
					continue;
				case 23:
					if (a !== 2) break;
					o.radio = N.Radio.decode(e, e.uint32(), void 0, r + 1, o.radio), o.type = "radio";
					continue;
				case 25:
					if (a !== 2) break;
					o.selectbox = N.Selectbox.decode(e, e.uint32(), void 0, r + 1, o.selectbox), o.type = "selectbox";
					continue;
				case 52:
					if (a !== 2) break;
					o.skeleton = N.Skeleton.decode(e, e.uint32(), void 0, r + 1, o.skeleton), o.type = "skeleton";
					continue;
				case 21:
					if (a !== 2) break;
					o.slider = N.Slider.decode(e, e.uint32(), void 0, r + 1, o.slider), o.type = "slider";
					continue;
				case 46:
					if (a !== 2) break;
					o.snow = N.Snow.decode(e, e.uint32(), void 0, r + 1, o.snow), o.type = "snow";
					continue;
				case 60:
					if (a !== 2) break;
					o.space = N.Space.decode(e, e.uint32(), void 0, r + 1, o.space), o.type = "space";
					continue;
				case 44:
					if (a !== 2) break;
					o.spinner = N.Spinner.decode(e, e.uint32(), void 0, r + 1, o.spinner), o.type = "spinner";
					continue;
				case 1:
					if (a !== 2) break;
					o.text = N.Text.decode(e, e.uint32(), void 0, r + 1, o.text), o.type = "text";
					continue;
				case 22:
					if (a !== 2) break;
					o.textArea = N.TextArea.decode(e, e.uint32(), void 0, r + 1, o.textArea), o.type = "textArea";
					continue;
				case 24:
					if (a !== 2) break;
					o.textInput = N.TextInput.decode(e, e.uint32(), void 0, r + 1, o.textInput), o.type = "textInput";
					continue;
				case 26:
					if (a !== 2) break;
					o.timeInput = N.TimeInput.decode(e, e.uint32(), void 0, r + 1, o.timeInput), o.type = "timeInput";
					continue;
				case 62:
					if (a !== 2) break;
					o.dateTimeInput = N.DateTimeInput.decode(e, e.uint32(), void 0, r + 1, o.dateTimeInput), o.type = "dateTimeInput";
					continue;
				case 50:
					if (a !== 2) break;
					o.toast = N.Toast.decode(e, e.uint32(), void 0, r + 1, o.toast), o.type = "toast";
					continue;
				case 14:
					if (a !== 2) break;
					o.video = N.Video.decode(e, e.uint32(), void 0, r + 1, o.video), o.type = "video";
					continue;
				case 47:
					if (a !== 2) break;
					o.heading = N.Heading.decode(e, e.uint32(), void 0, r + 1, o.heading), o.type = "heading";
					continue;
				case 48:
					if (a !== 2) break;
					o.code = N.Code.decode(e, e.uint32(), void 0, r + 1, o.code), o.type = "code";
					continue;
				case 64:
					if (a !== 2) break;
					o.menuButton = N.MenuButton.decode(e, e.uint32(), void 0, r + 1, o.menuButton), o.type = "menuButton";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Element) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Element();
		if (e.heightConfig != null) {
			if (typeof e.heightConfig != "object") throw TypeError(".Element.heightConfig: object expected");
			n.heightConfig = N.streamlit.HeightConfig.fromObject(e.heightConfig, t + 1);
		}
		if (e.widthConfig != null) {
			if (typeof e.widthConfig != "object") throw TypeError(".Element.widthConfig: object expected");
			n.widthConfig = N.streamlit.WidthConfig.fromObject(e.widthConfig, t + 1);
		}
		if (e.textAlignmentConfig != null) {
			if (typeof e.textAlignmentConfig != "object") throw TypeError(".Element.textAlignmentConfig: object expected");
			n.textAlignmentConfig = N.streamlit.TextAlignmentConfig.fromObject(e.textAlignmentConfig, t + 1);
		}
		if (e.alert != null) {
			if (typeof e.alert != "object") throw TypeError(".Element.alert: object expected");
			n.alert = N.Alert.fromObject(e.alert, t + 1);
		}
		if (e.dataframe != null) {
			if (typeof e.dataframe != "object") throw TypeError(".Element.dataframe: object expected");
			n.dataframe = N.Dataframe.fromObject(e.dataframe, t + 1);
		}
		if (e.table != null) {
			if (typeof e.table != "object") throw TypeError(".Element.table: object expected");
			n.table = N.Table.fromObject(e.table, t + 1);
		}
		if (e.vegaLiteChart != null) {
			if (typeof e.vegaLiteChart != "object") throw TypeError(".Element.vegaLiteChart: object expected");
			n.vegaLiteChart = N.VegaLiteChart.fromObject(e.vegaLiteChart, t + 1);
		}
		if (e.audio != null) {
			if (typeof e.audio != "object") throw TypeError(".Element.audio: object expected");
			n.audio = N.Audio.fromObject(e.audio, t + 1);
		}
		if (e.audioInput != null) {
			if (typeof e.audioInput != "object") throw TypeError(".Element.audioInput: object expected");
			n.audioInput = N.AudioInput.fromObject(e.audioInput, t + 1);
		}
		if (e.balloons != null) {
			if (typeof e.balloons != "object") throw TypeError(".Element.balloons: object expected");
			n.balloons = N.Balloons.fromObject(e.balloons, t + 1);
		}
		if (e.bidiComponent != null) {
			if (typeof e.bidiComponent != "object") throw TypeError(".Element.bidiComponent: object expected");
			n.bidiComponent = N.BidiComponent.fromObject(e.bidiComponent, t + 1);
		}
		if (e.button != null) {
			if (typeof e.button != "object") throw TypeError(".Element.button: object expected");
			n.button = N.Button.fromObject(e.button, t + 1);
		}
		if (e.buttonGroup != null) {
			if (typeof e.buttonGroup != "object") throw TypeError(".Element.buttonGroup: object expected");
			n.buttonGroup = N.ButtonGroup.fromObject(e.buttonGroup, t + 1);
		}
		if (e.downloadButton != null) {
			if (typeof e.downloadButton != "object") throw TypeError(".Element.downloadButton: object expected");
			n.downloadButton = N.DownloadButton.fromObject(e.downloadButton, t + 1);
		}
		if (e.cameraInput != null) {
			if (typeof e.cameraInput != "object") throw TypeError(".Element.cameraInput: object expected");
			n.cameraInput = N.CameraInput.fromObject(e.cameraInput, t + 1);
		}
		if (e.chatInput != null) {
			if (typeof e.chatInput != "object") throw TypeError(".Element.chatInput: object expected");
			n.chatInput = N.ChatInput.fromObject(e.chatInput, t + 1);
		}
		if (e.checkbox != null) {
			if (typeof e.checkbox != "object") throw TypeError(".Element.checkbox: object expected");
			n.checkbox = N.Checkbox.fromObject(e.checkbox, t + 1);
		}
		if (e.colorPicker != null) {
			if (typeof e.colorPicker != "object") throw TypeError(".Element.colorPicker: object expected");
			n.colorPicker = N.ColorPicker.fromObject(e.colorPicker, t + 1);
		}
		if (e.componentInstance != null) {
			if (typeof e.componentInstance != "object") throw TypeError(".Element.componentInstance: object expected");
			n.componentInstance = N.ComponentInstance.fromObject(e.componentInstance, t + 1);
		}
		if (e.dateInput != null) {
			if (typeof e.dateInput != "object") throw TypeError(".Element.dateInput: object expected");
			n.dateInput = N.DateInput.fromObject(e.dateInput, t + 1);
		}
		if (e.deckGlJsonChart != null) {
			if (typeof e.deckGlJsonChart != "object") throw TypeError(".Element.deckGlJsonChart: object expected");
			n.deckGlJsonChart = N.DeckGlJsonChart.fromObject(e.deckGlJsonChart, t + 1);
		}
		if (e.helpInfo != null) {
			if (typeof e.helpInfo != "object") throw TypeError(".Element.helpInfo: object expected");
			n.helpInfo = N.Help.fromObject(e.helpInfo, t + 1);
		}
		if (e.empty != null) {
			if (typeof e.empty != "object") throw TypeError(".Element.empty: object expected");
			n.empty = N.Empty.fromObject(e.empty, t + 1);
		}
		if (e.exception != null) {
			if (typeof e.exception != "object") throw TypeError(".Element.exception: object expected");
			n.exception = N.Exception.fromObject(e.exception, t + 1);
		}
		if (e.favicon != null) {
			if (typeof e.favicon != "object") throw TypeError(".Element.favicon: object expected");
			n.favicon = N.Favicon.fromObject(e.favicon, t + 1);
		}
		if (e.feedback != null) {
			if (typeof e.feedback != "object") throw TypeError(".Element.feedback: object expected");
			n.feedback = N.Feedback.fromObject(e.feedback, t + 1);
		}
		if (e.fileUploader != null) {
			if (typeof e.fileUploader != "object") throw TypeError(".Element.fileUploader: object expected");
			n.fileUploader = N.FileUploader.fromObject(e.fileUploader, t + 1);
		}
		if (e.graphvizChart != null) {
			if (typeof e.graphvizChart != "object") throw TypeError(".Element.graphvizChart: object expected");
			n.graphvizChart = N.GraphVizChart.fromObject(e.graphvizChart, t + 1);
		}
		if (e.html != null) {
			if (typeof e.html != "object") throw TypeError(".Element.html: object expected");
			n.html = N.Html.fromObject(e.html, t + 1);
		}
		if (e.iframe != null) {
			if (typeof e.iframe != "object") throw TypeError(".Element.iframe: object expected");
			n.iframe = N.IFrame.fromObject(e.iframe, t + 1);
		}
		if (e.imgs != null) {
			if (typeof e.imgs != "object") throw TypeError(".Element.imgs: object expected");
			n.imgs = N.ImageList.fromObject(e.imgs, t + 1);
		}
		if (e.json != null) {
			if (typeof e.json != "object") throw TypeError(".Element.json: object expected");
			n.json = N.Json.fromObject(e.json, t + 1);
		}
		if (e.linkButton != null) {
			if (typeof e.linkButton != "object") throw TypeError(".Element.linkButton: object expected");
			n.linkButton = N.LinkButton.fromObject(e.linkButton, t + 1);
		}
		if (e.markdown != null) {
			if (typeof e.markdown != "object") throw TypeError(".Element.markdown: object expected");
			n.markdown = N.Markdown.fromObject(e.markdown, t + 1);
		}
		if (e.metric != null) {
			if (typeof e.metric != "object") throw TypeError(".Element.metric: object expected");
			n.metric = N.Metric.fromObject(e.metric, t + 1);
		}
		if (e.multiselect != null) {
			if (typeof e.multiselect != "object") throw TypeError(".Element.multiselect: object expected");
			n.multiselect = N.MultiSelect.fromObject(e.multiselect, t + 1);
		}
		if (e.numberInput != null) {
			if (typeof e.numberInput != "object") throw TypeError(".Element.numberInput: object expected");
			n.numberInput = N.NumberInput.fromObject(e.numberInput, t + 1);
		}
		if (e.pageLink != null) {
			if (typeof e.pageLink != "object") throw TypeError(".Element.pageLink: object expected");
			n.pageLink = N.PageLink.fromObject(e.pageLink, t + 1);
		}
		if (e.plotlyChart != null) {
			if (typeof e.plotlyChart != "object") throw TypeError(".Element.plotlyChart: object expected");
			n.plotlyChart = N.PlotlyChart.fromObject(e.plotlyChart, t + 1);
		}
		if (e.progress != null) {
			if (typeof e.progress != "object") throw TypeError(".Element.progress: object expected");
			n.progress = N.Progress.fromObject(e.progress, t + 1);
		}
		if (e.radio != null) {
			if (typeof e.radio != "object") throw TypeError(".Element.radio: object expected");
			n.radio = N.Radio.fromObject(e.radio, t + 1);
		}
		if (e.selectbox != null) {
			if (typeof e.selectbox != "object") throw TypeError(".Element.selectbox: object expected");
			n.selectbox = N.Selectbox.fromObject(e.selectbox, t + 1);
		}
		if (e.skeleton != null) {
			if (typeof e.skeleton != "object") throw TypeError(".Element.skeleton: object expected");
			n.skeleton = N.Skeleton.fromObject(e.skeleton, t + 1);
		}
		if (e.slider != null) {
			if (typeof e.slider != "object") throw TypeError(".Element.slider: object expected");
			n.slider = N.Slider.fromObject(e.slider, t + 1);
		}
		if (e.snow != null) {
			if (typeof e.snow != "object") throw TypeError(".Element.snow: object expected");
			n.snow = N.Snow.fromObject(e.snow, t + 1);
		}
		if (e.space != null) {
			if (typeof e.space != "object") throw TypeError(".Element.space: object expected");
			n.space = N.Space.fromObject(e.space, t + 1);
		}
		if (e.spinner != null) {
			if (typeof e.spinner != "object") throw TypeError(".Element.spinner: object expected");
			n.spinner = N.Spinner.fromObject(e.spinner, t + 1);
		}
		if (e.text != null) {
			if (typeof e.text != "object") throw TypeError(".Element.text: object expected");
			n.text = N.Text.fromObject(e.text, t + 1);
		}
		if (e.textArea != null) {
			if (typeof e.textArea != "object") throw TypeError(".Element.textArea: object expected");
			n.textArea = N.TextArea.fromObject(e.textArea, t + 1);
		}
		if (e.textInput != null) {
			if (typeof e.textInput != "object") throw TypeError(".Element.textInput: object expected");
			n.textInput = N.TextInput.fromObject(e.textInput, t + 1);
		}
		if (e.timeInput != null) {
			if (typeof e.timeInput != "object") throw TypeError(".Element.timeInput: object expected");
			n.timeInput = N.TimeInput.fromObject(e.timeInput, t + 1);
		}
		if (e.dateTimeInput != null) {
			if (typeof e.dateTimeInput != "object") throw TypeError(".Element.dateTimeInput: object expected");
			n.dateTimeInput = N.DateTimeInput.fromObject(e.dateTimeInput, t + 1);
		}
		if (e.toast != null) {
			if (typeof e.toast != "object") throw TypeError(".Element.toast: object expected");
			n.toast = N.Toast.fromObject(e.toast, t + 1);
		}
		if (e.video != null) {
			if (typeof e.video != "object") throw TypeError(".Element.video: object expected");
			n.video = N.Video.fromObject(e.video, t + 1);
		}
		if (e.heading != null) {
			if (typeof e.heading != "object") throw TypeError(".Element.heading: object expected");
			n.heading = N.Heading.fromObject(e.heading, t + 1);
		}
		if (e.code != null) {
			if (typeof e.code != "object") throw TypeError(".Element.code: object expected");
			n.code = N.Code.fromObject(e.code, t + 1);
		}
		if (e.menuButton != null) {
			if (typeof e.menuButton != "object") throw TypeError(".Element.menuButton: object expected");
			n.menuButton = N.MenuButton.fromObject(e.menuButton, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return e.text != null && e.hasOwnProperty("text") && (r.text = N.Text.toObject(e.text, t, n + 1), t.oneofs && (r.type = "text")), e.empty != null && e.hasOwnProperty("empty") && (r.empty = N.Empty.toObject(e.empty, t, n + 1), t.oneofs && (r.type = "empty")), e.progress != null && e.hasOwnProperty("progress") && (r.progress = N.Progress.toObject(e.progress, t, n + 1), t.oneofs && (r.type = "progress")), e.imgs != null && e.hasOwnProperty("imgs") && (r.imgs = N.ImageList.toObject(e.imgs, t, n + 1), t.oneofs && (r.type = "imgs")), e.helpInfo != null && e.hasOwnProperty("helpInfo") && (r.helpInfo = N.Help.toObject(e.helpInfo, t, n + 1), t.oneofs && (r.type = "helpInfo")), e.exception != null && e.hasOwnProperty("exception") && (r.exception = N.Exception.toObject(e.exception, t, n + 1), t.oneofs && (r.type = "exception")), e.balloons != null && e.hasOwnProperty("balloons") && (r.balloons = N.Balloons.toObject(e.balloons, t, n + 1), t.oneofs && (r.type = "balloons")), e.audio != null && e.hasOwnProperty("audio") && (r.audio = N.Audio.toObject(e.audio, t, n + 1), t.oneofs && (r.type = "audio")), e.video != null && e.hasOwnProperty("video") && (r.video = N.Video.toObject(e.video, t, n + 1), t.oneofs && (r.type = "video")), e.plotlyChart != null && e.hasOwnProperty("plotlyChart") && (r.plotlyChart = N.PlotlyChart.toObject(e.plotlyChart, t, n + 1), t.oneofs && (r.type = "plotlyChart")), e.graphvizChart != null && e.hasOwnProperty("graphvizChart") && (r.graphvizChart = N.GraphVizChart.toObject(e.graphvizChart, t, n + 1), t.oneofs && (r.type = "graphvizChart")), e.button != null && e.hasOwnProperty("button") && (r.button = N.Button.toObject(e.button, t, n + 1), t.oneofs && (r.type = "button")), e.checkbox != null && e.hasOwnProperty("checkbox") && (r.checkbox = N.Checkbox.toObject(e.checkbox, t, n + 1), t.oneofs && (r.type = "checkbox")), e.slider != null && e.hasOwnProperty("slider") && (r.slider = N.Slider.toObject(e.slider, t, n + 1), t.oneofs && (r.type = "slider")), e.textArea != null && e.hasOwnProperty("textArea") && (r.textArea = N.TextArea.toObject(e.textArea, t, n + 1), t.oneofs && (r.type = "textArea")), e.radio != null && e.hasOwnProperty("radio") && (r.radio = N.Radio.toObject(e.radio, t, n + 1), t.oneofs && (r.type = "radio")), e.textInput != null && e.hasOwnProperty("textInput") && (r.textInput = N.TextInput.toObject(e.textInput, t, n + 1), t.oneofs && (r.type = "textInput")), e.selectbox != null && e.hasOwnProperty("selectbox") && (r.selectbox = N.Selectbox.toObject(e.selectbox, t, n + 1), t.oneofs && (r.type = "selectbox")), e.timeInput != null && e.hasOwnProperty("timeInput") && (r.timeInput = N.TimeInput.toObject(e.timeInput, t, n + 1), t.oneofs && (r.type = "timeInput")), e.dateInput != null && e.hasOwnProperty("dateInput") && (r.dateInput = N.DateInput.toObject(e.dateInput, t, n + 1), t.oneofs && (r.type = "dateInput")), e.multiselect != null && e.hasOwnProperty("multiselect") && (r.multiselect = N.MultiSelect.toObject(e.multiselect, t, n + 1), t.oneofs && (r.type = "multiselect")), e.markdown != null && e.hasOwnProperty("markdown") && (r.markdown = N.Markdown.toObject(e.markdown, t, n + 1), t.oneofs && (r.type = "markdown")), e.alert != null && e.hasOwnProperty("alert") && (r.alert = N.Alert.toObject(e.alert, t, n + 1), t.oneofs && (r.type = "alert")), e.json != null && e.hasOwnProperty("json") && (r.json = N.Json.toObject(e.json, t, n + 1), t.oneofs && (r.type = "json")), e.numberInput != null && e.hasOwnProperty("numberInput") && (r.numberInput = N.NumberInput.toObject(e.numberInput, t, n + 1), t.oneofs && (r.type = "numberInput")), e.fileUploader != null && e.hasOwnProperty("fileUploader") && (r.fileUploader = N.FileUploader.toObject(e.fileUploader, t, n + 1), t.oneofs && (r.type = "fileUploader")), e.deckGlJsonChart != null && e.hasOwnProperty("deckGlJsonChart") && (r.deckGlJsonChart = N.DeckGlJsonChart.toObject(e.deckGlJsonChart, t, n + 1), t.oneofs && (r.type = "deckGlJsonChart")), e.colorPicker != null && e.hasOwnProperty("colorPicker") && (r.colorPicker = N.ColorPicker.toObject(e.colorPicker, t, n + 1), t.oneofs && (r.type = "colorPicker")), e.favicon != null && e.hasOwnProperty("favicon") && (r.favicon = N.Favicon.toObject(e.favicon, t, n + 1), t.oneofs && (r.type = "favicon")), e.componentInstance != null && e.hasOwnProperty("componentInstance") && (r.componentInstance = N.ComponentInstance.toObject(e.componentInstance, t, n + 1), t.oneofs && (r.type = "componentInstance")), e.iframe != null && e.hasOwnProperty("iframe") && (r.iframe = N.IFrame.toObject(e.iframe, t, n + 1), t.oneofs && (r.type = "iframe")), e.table != null && e.hasOwnProperty("table") && (r.table = N.Table.toObject(e.table, t, n + 1), t.oneofs && (r.type = "table")), e.dataframe != null && e.hasOwnProperty("dataframe") && (r.dataframe = N.Dataframe.toObject(e.dataframe, t, n + 1), t.oneofs && (r.type = "dataframe")), e.vegaLiteChart != null && e.hasOwnProperty("vegaLiteChart") && (r.vegaLiteChart = N.VegaLiteChart.toObject(e.vegaLiteChart, t, n + 1), t.oneofs && (r.type = "vegaLiteChart")), e.metric != null && e.hasOwnProperty("metric") && (r.metric = N.Metric.toObject(e.metric, t, n + 1), t.oneofs && (r.type = "metric")), e.downloadButton != null && e.hasOwnProperty("downloadButton") && (r.downloadButton = N.DownloadButton.toObject(e.downloadButton, t, n + 1), t.oneofs && (r.type = "downloadButton")), e.spinner != null && e.hasOwnProperty("spinner") && (r.spinner = N.Spinner.toObject(e.spinner, t, n + 1), t.oneofs && (r.type = "spinner")), e.cameraInput != null && e.hasOwnProperty("cameraInput") && (r.cameraInput = N.CameraInput.toObject(e.cameraInput, t, n + 1), t.oneofs && (r.type = "cameraInput")), e.snow != null && e.hasOwnProperty("snow") && (r.snow = N.Snow.toObject(e.snow, t, n + 1), t.oneofs && (r.type = "snow")), e.heading != null && e.hasOwnProperty("heading") && (r.heading = N.Heading.toObject(e.heading, t, n + 1), t.oneofs && (r.type = "heading")), e.code != null && e.hasOwnProperty("code") && (r.code = N.Code.toObject(e.code, t, n + 1), t.oneofs && (r.type = "code")), e.chatInput != null && e.hasOwnProperty("chatInput") && (r.chatInput = N.ChatInput.toObject(e.chatInput, t, n + 1), t.oneofs && (r.type = "chatInput")), e.toast != null && e.hasOwnProperty("toast") && (r.toast = N.Toast.toObject(e.toast, t, n + 1), t.oneofs && (r.type = "toast")), e.linkButton != null && e.hasOwnProperty("linkButton") && (r.linkButton = N.LinkButton.toObject(e.linkButton, t, n + 1), t.oneofs && (r.type = "linkButton")), e.skeleton != null && e.hasOwnProperty("skeleton") && (r.skeleton = N.Skeleton.toObject(e.skeleton, t, n + 1), t.oneofs && (r.type = "skeleton")), e.pageLink != null && e.hasOwnProperty("pageLink") && (r.pageLink = N.PageLink.toObject(e.pageLink, t, n + 1), t.oneofs && (r.type = "pageLink")), e.html != null && e.hasOwnProperty("html") && (r.html = N.Html.toObject(e.html, t, n + 1), t.oneofs && (r.type = "html")), e.buttonGroup != null && e.hasOwnProperty("buttonGroup") && (r.buttonGroup = N.ButtonGroup.toObject(e.buttonGroup, t, n + 1), t.oneofs && (r.type = "buttonGroup")), e.audioInput != null && e.hasOwnProperty("audioInput") && (r.audioInput = N.AudioInput.toObject(e.audioInput, t, n + 1), t.oneofs && (r.type = "audioInput")), e.heightConfig != null && e.hasOwnProperty("heightConfig") && (r.heightConfig = N.streamlit.HeightConfig.toObject(e.heightConfig, t, n + 1)), e.widthConfig != null && e.hasOwnProperty("widthConfig") && (r.widthConfig = N.streamlit.WidthConfig.toObject(e.widthConfig, t, n + 1)), e.bidiComponent != null && e.hasOwnProperty("bidiComponent") && (r.bidiComponent = N.BidiComponent.toObject(e.bidiComponent, t, n + 1), t.oneofs && (r.type = "bidiComponent")), e.space != null && e.hasOwnProperty("space") && (r.space = N.Space.toObject(e.space, t, n + 1), t.oneofs && (r.type = "space")), e.textAlignmentConfig != null && e.hasOwnProperty("textAlignmentConfig") && (r.textAlignmentConfig = N.streamlit.TextAlignmentConfig.toObject(e.textAlignmentConfig, t, n + 1)), e.dateTimeInput != null && e.hasOwnProperty("dateTimeInput") && (r.dateTimeInput = N.DateTimeInput.toObject(e.dateTimeInput, t, n + 1), t.oneofs && (r.type = "dateTimeInput")), e.feedback != null && e.hasOwnProperty("feedback") && (r.feedback = N.Feedback.toObject(e.feedback, t, n + 1), t.oneofs && (r.type = "feedback")), e.menuButton != null && e.hasOwnProperty("menuButton") && (r.menuButton = N.MenuButton.toObject(e.menuButton, t, n + 1), t.oneofs && (r.type = "menuButton")), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Element";
	}, e;
})(), N.DownloadButton = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = !1, e.prototype.help = "", e.prototype.formId = "", e.prototype.url = "", e.prototype.disabled = !1, e.prototype.useContainerWidth = !1, e.prototype.type = "", e.prototype.icon = "", e.prototype.ignoreRerun = !1, e.prototype.deferredFileId = null, e.prototype.shortcut = "", e.prototype.iconPosition = 0;
	let t;
	return Object.defineProperty(e.prototype, "_deferredFileId", {
		get: M.oneOfGetter(t = ["deferredFileId"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.default != null && Object.hasOwnProperty.call(e, "default") && t.uint32(24).bool(e.default), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(34).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(42).string(e.formId), e.url != null && Object.hasOwnProperty.call(e, "url") && t.uint32(50).string(e.url), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(56).bool(e.disabled), e.useContainerWidth != null && Object.hasOwnProperty.call(e, "useContainerWidth") && t.uint32(64).bool(e.useContainerWidth), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(74).string(e.type), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(82).string(e.icon), e.ignoreRerun != null && Object.hasOwnProperty.call(e, "ignoreRerun") && t.uint32(88).bool(e.ignoreRerun), e.deferredFileId != null && Object.hasOwnProperty.call(e, "deferredFileId") && t.uint32(98).string(e.deferredFileId), e.shortcut != null && Object.hasOwnProperty.call(e, "shortcut") && t.uint32(106).string(e.shortcut), e.iconPosition != null && Object.hasOwnProperty.call(e, "iconPosition") && t.uint32(112).int32(e.iconPosition), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.DownloadButton(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.default = s : delete o.default;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.url = s : delete o.url;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.useContainerWidth = s : delete o.useContainerWidth;
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.string()).length ? o.type = s : delete o.type;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.string()).length ? o.icon = s : delete o.icon;
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
				case 12:
					if (a !== 2) break;
					o.deferredFileId = e.string(), o._deferredFileId = "deferredFileId";
					continue;
				case 13:
					if (a !== 2) break;
					(s = e.string()).length ? o.shortcut = s : delete o.shortcut;
					continue;
				case 14:
					if (a !== 0) break;
					(s = e.int32()) ? o.iconPosition = s : delete o.iconPosition;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.DownloadButton) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.DownloadButton();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.default != null && e.default && (n.default = !!e.default), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = String(e.url)), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.useContainerWidth != null && e.useContainerWidth && (n.useContainerWidth = !!e.useContainerWidth), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = String(e.type)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = String(e.icon)), e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = !!e.ignoreRerun), e.deferredFileId != null && (n.deferredFileId = String(e.deferredFileId)), e.shortcut != null && (typeof e.shortcut != "string" || e.shortcut.length) && (n.shortcut = String(e.shortcut)), e.iconPosition !== 0 && (typeof e.iconPosition != "string" || N.streamlit.ButtonLikeIconPosition[e.iconPosition] !== 0)) switch (e.iconPosition) {
			default:
				if (typeof e.iconPosition == "number") {
					n.iconPosition = e.iconPosition;
					break;
				}
				break;
			case "LEFT":
			case 0:
				n.iconPosition = 0;
				break;
			case "RIGHT":
			case 1:
				n.iconPosition = 1;
				break;
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.default = !1, r.help = "", r.formId = "", r.url = "", r.disabled = !1, r.useContainerWidth = !1, r.type = "", r.icon = "", r.ignoreRerun = !1, r.shortcut = "", r.iconPosition = t.enums === String ? "LEFT" : 0), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.default != null && e.hasOwnProperty("default") && (r.default = e.default), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.url != null && e.hasOwnProperty("url") && (r.url = e.url), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.useContainerWidth != null && e.hasOwnProperty("useContainerWidth") && (r.useContainerWidth = e.useContainerWidth), e.type != null && e.hasOwnProperty("type") && (r.type = e.type), e.icon != null && e.hasOwnProperty("icon") && (r.icon = e.icon), e.ignoreRerun != null && e.hasOwnProperty("ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), e.deferredFileId != null && e.hasOwnProperty("deferredFileId") && (r.deferredFileId = e.deferredFileId), e.shortcut != null && e.hasOwnProperty("shortcut") && (r.shortcut = e.shortcut), e.iconPosition != null && e.hasOwnProperty("iconPosition") && (r.iconPosition = t.enums === String ? N.streamlit.ButtonLikeIconPosition[e.iconPosition] === void 0 ? e.iconPosition : N.streamlit.ButtonLikeIconPosition[e.iconPosition] : e.iconPosition), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/DownloadButton";
	}, e;
})(), N.Empty = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Empty();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			e.skipType(i & 7, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Empty) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		return new N.Empty();
	}, e.toObject = function() {
		return {};
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Empty";
	}, e;
})(), N.Exception = (() => {
	function e(e) {
		if (this.stackTrace = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.type = "", e.prototype.message = "", e.prototype.messageIsMarkdown = !1, e.prototype.stackTrace = M.emptyArray, e.prototype.isWarning = !1, e.prototype.widthConfig = null, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(10).string(e.type), e.message != null && Object.hasOwnProperty.call(e, "message") && t.uint32(18).string(e.message), e.stackTrace != null && e.stackTrace.length) for (let n = 0; n < e.stackTrace.length; ++n) t.uint32(26).string(e.stackTrace[n]);
		if (e.messageIsMarkdown != null && Object.hasOwnProperty.call(e, "messageIsMarkdown") && t.uint32(32).bool(e.messageIsMarkdown), e.isWarning != null && Object.hasOwnProperty.call(e, "isWarning") && t.uint32(40).bool(e.isWarning), e.widthConfig != null && Object.hasOwnProperty.call(e, "widthConfig") && N.streamlit.WidthConfig.encode(e.widthConfig, t.uint32(50).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Exception(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.type = s : delete o.type;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.message = s : delete o.message;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.messageIsMarkdown = s : delete o.messageIsMarkdown;
					continue;
				case 3:
					if (a !== 2) break;
					o.stackTrace && o.stackTrace.length || (o.stackTrace = []), o.stackTrace.push(e.string());
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.isWarning = s : delete o.isWarning;
					continue;
				case 6:
					if (a !== 2) break;
					o.widthConfig = N.streamlit.WidthConfig.decode(e, e.uint32(), void 0, r + 1, o.widthConfig);
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Exception) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Exception();
		if (e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = String(e.type)), e.message != null && (typeof e.message != "string" || e.message.length) && (n.message = String(e.message)), e.messageIsMarkdown != null && e.messageIsMarkdown && (n.messageIsMarkdown = !!e.messageIsMarkdown), e.stackTrace) {
			if (!Array.isArray(e.stackTrace)) throw TypeError(".Exception.stackTrace: array expected");
			n.stackTrace = Array(e.stackTrace.length);
			for (let t = 0; t < e.stackTrace.length; ++t) n.stackTrace[t] = String(e.stackTrace[t]);
		}
		if (e.isWarning != null && e.isWarning && (n.isWarning = !!e.isWarning), e.widthConfig != null) {
			if (typeof e.widthConfig != "object") throw TypeError(".Exception.widthConfig: object expected");
			n.widthConfig = N.streamlit.WidthConfig.fromObject(e.widthConfig, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.stackTrace = []), t.defaults && (r.type = "", r.message = "", r.messageIsMarkdown = !1, r.isWarning = !1, r.widthConfig = null), e.type != null && e.hasOwnProperty("type") && (r.type = e.type), e.message != null && e.hasOwnProperty("message") && (r.message = e.message), e.stackTrace && e.stackTrace.length) {
			r.stackTrace = Array(e.stackTrace.length);
			for (let t = 0; t < e.stackTrace.length; ++t) r.stackTrace[t] = e.stackTrace[t];
		}
		return e.messageIsMarkdown != null && e.hasOwnProperty("messageIsMarkdown") && (r.messageIsMarkdown = e.messageIsMarkdown), e.isWarning != null && e.hasOwnProperty("isWarning") && (r.isWarning = e.isWarning), e.widthConfig != null && e.hasOwnProperty("widthConfig") && (r.widthConfig = N.streamlit.WidthConfig.toObject(e.widthConfig, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Exception";
	}, e;
})(), N.Favicon = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.url = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.url != null && Object.hasOwnProperty.call(e, "url") && t.uint32(10).string(e.url), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Favicon(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.url = s : delete o.url;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Favicon) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Favicon();
		return e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = String(e.url)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.url = ""), e.url != null && e.hasOwnProperty("url") && (r.url = e.url), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Favicon";
	}, e;
})(), N.Feedback = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.type = 0, e.prototype.default = null, e.prototype.disabled = !1, e.prototype.formId = "", e.prototype.value = null, e.prototype.setValue = !1;
	let t;
	return Object.defineProperty(e.prototype, "_default", {
		get: M.oneOfGetter(t = ["default"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_value", {
		get: M.oneOfGetter(t = ["value"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(16).int32(e.type), e.default != null && Object.hasOwnProperty.call(e, "default") && t.uint32(24).uint32(e.default), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(32).bool(e.disabled), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(42).string(e.formId), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(48).uint32(e.value), e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(56).bool(e.setValue), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Feedback(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.int32()) ? o.type = s : delete o.type;
					continue;
				case 3:
					if (a !== 0) break;
					o.default = e.uint32(), o._default = "default";
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 0) break;
					o.value = e.uint32(), o._value = "value";
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Feedback) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Feedback();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.type !== 0 && (typeof e.type != "string" || N.Feedback.FeedbackType[e.type] !== 0)) switch (e.type) {
			default:
				if (typeof e.type == "number") {
					n.type = e.type;
					break;
				}
				break;
			case "THUMBS":
			case 0:
				n.type = 0;
				break;
			case "FACES":
			case 1:
				n.type = 1;
				break;
			case "STARS":
			case 2:
				n.type = 2;
				break;
		}
		return e.default != null && (n.default = e.default >>> 0), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.value != null && (n.value = e.value >>> 0), e.setValue != null && e.setValue && (n.setValue = !!e.setValue), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.type = t.enums === String ? "THUMBS" : 0, r.disabled = !1, r.formId = "", r.setValue = !1), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.type != null && e.hasOwnProperty("type") && (r.type = t.enums === String ? N.Feedback.FeedbackType[e.type] === void 0 ? e.type : N.Feedback.FeedbackType[e.type] : e.type), e.default != null && e.hasOwnProperty("default") && (r.default = e.default), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.value != null && e.hasOwnProperty("value") && (r.value = e.value), e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Feedback";
	}, e.FeedbackType = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "THUMBS"] = 0, t[e[1] = "FACES"] = 1, t[e[2] = "STARS"] = 2, t;
	})(), e;
})(), N.FileUploader = (() => {
	function e(e) {
		if (this.type = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.id = "", e.prototype.label = "", e.prototype.type = M.emptyArray, e.prototype.maxUploadSizeMb = 0, e.prototype.multipleFiles = !1, e.prototype.help = "", e.prototype.formId = "", e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.acceptDirectory = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.type != null && e.type.length) for (let n = 0; n < e.type.length; ++n) t.uint32(26).string(e.type[n]);
		if (e.maxUploadSizeMb != null && Object.hasOwnProperty.call(e, "maxUploadSizeMb") && t.uint32(32).int32(e.maxUploadSizeMb), e.multipleFiles != null && Object.hasOwnProperty.call(e, "multipleFiles") && t.uint32(48).bool(e.multipleFiles), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(58).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(66).string(e.formId), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(72).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(82).fork(), n + 1).ldelim(), e.acceptDirectory != null && Object.hasOwnProperty.call(e, "acceptDirectory") && t.uint32(88).bool(e.acceptDirectory), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.FileUploader(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.type && o.type.length || (o.type = []), o.type.push(e.string());
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.int32()) ? o.maxUploadSizeMb = s : delete o.maxUploadSizeMb;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.multipleFiles = s : delete o.multipleFiles;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 8:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 10:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.acceptDirectory = s : delete o.acceptDirectory;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.FileUploader) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.FileUploader();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.type) {
			if (!Array.isArray(e.type)) throw TypeError(".FileUploader.type: array expected");
			n.type = Array(e.type.length);
			for (let t = 0; t < e.type.length; ++t) n.type[t] = String(e.type[t]);
		}
		if (e.maxUploadSizeMb != null && Number(e.maxUploadSizeMb) !== 0 && (n.maxUploadSizeMb = e.maxUploadSizeMb | 0), e.multipleFiles != null && e.multipleFiles && (n.multipleFiles = !!e.multipleFiles), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".FileUploader.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.acceptDirectory != null && e.acceptDirectory && (n.acceptDirectory = !!e.acceptDirectory), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.type = []), t.defaults && (r.id = "", r.label = "", r.maxUploadSizeMb = 0, r.multipleFiles = !1, r.help = "", r.formId = "", r.disabled = !1, r.labelVisibility = null, r.acceptDirectory = !1), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.type && e.type.length) {
			r.type = Array(e.type.length);
			for (let t = 0; t < e.type.length; ++t) r.type[t] = e.type[t];
		}
		return e.maxUploadSizeMb != null && e.hasOwnProperty("maxUploadSizeMb") && (r.maxUploadSizeMb = e.maxUploadSizeMb), e.multipleFiles != null && e.hasOwnProperty("multipleFiles") && (r.multipleFiles = e.multipleFiles), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.acceptDirectory != null && e.hasOwnProperty("acceptDirectory") && (r.acceptDirectory = e.acceptDirectory), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/FileUploader";
	}, e;
})(), N.GraphVizChart = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.spec = "", e.prototype.elementId = "", e.prototype.engine = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.spec != null && Object.hasOwnProperty.call(e, "spec") && t.uint32(10).string(e.spec), e.elementId != null && Object.hasOwnProperty.call(e, "elementId") && t.uint32(42).string(e.elementId), e.engine != null && Object.hasOwnProperty.call(e, "engine") && t.uint32(50).string(e.engine), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.GraphVizChart(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.spec = s : delete o.spec;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.elementId = s : delete o.elementId;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.engine = s : delete o.engine;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.GraphVizChart) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.GraphVizChart();
		return e.spec != null && (typeof e.spec != "string" || e.spec.length) && (n.spec = String(e.spec)), e.elementId != null && (typeof e.elementId != "string" || e.elementId.length) && (n.elementId = String(e.elementId)), e.engine != null && (typeof e.engine != "string" || e.engine.length) && (n.engine = String(e.engine)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.spec = "", r.elementId = "", r.engine = ""), e.spec != null && e.hasOwnProperty("spec") && (r.spec = e.spec), e.elementId != null && e.hasOwnProperty("elementId") && (r.elementId = e.elementId), e.engine != null && e.hasOwnProperty("engine") && (r.engine = e.engine), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/GraphVizChart";
	}, e;
})(), N.Heading = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.tag = "", e.prototype.anchor = "", e.prototype.body = "", e.prototype.help = "", e.prototype.hideAnchor = !1, e.prototype.divider = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.tag != null && Object.hasOwnProperty.call(e, "tag") && t.uint32(10).string(e.tag), e.anchor != null && Object.hasOwnProperty.call(e, "anchor") && t.uint32(18).string(e.anchor), e.body != null && Object.hasOwnProperty.call(e, "body") && t.uint32(26).string(e.body), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(34).string(e.help), e.hideAnchor != null && Object.hasOwnProperty.call(e, "hideAnchor") && t.uint32(40).bool(e.hideAnchor), e.divider != null && Object.hasOwnProperty.call(e, "divider") && t.uint32(50).string(e.divider), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Heading(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.tag = s : delete o.tag;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.anchor = s : delete o.anchor;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.body = s : delete o.body;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.hideAnchor = s : delete o.hideAnchor;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.divider = s : delete o.divider;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Heading) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Heading();
		return e.tag != null && (typeof e.tag != "string" || e.tag.length) && (n.tag = String(e.tag)), e.anchor != null && (typeof e.anchor != "string" || e.anchor.length) && (n.anchor = String(e.anchor)), e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = String(e.body)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.hideAnchor != null && e.hideAnchor && (n.hideAnchor = !!e.hideAnchor), e.divider != null && (typeof e.divider != "string" || e.divider.length) && (n.divider = String(e.divider)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.tag = "", r.anchor = "", r.body = "", r.help = "", r.hideAnchor = !1, r.divider = ""), e.tag != null && e.hasOwnProperty("tag") && (r.tag = e.tag), e.anchor != null && e.hasOwnProperty("anchor") && (r.anchor = e.anchor), e.body != null && e.hasOwnProperty("body") && (r.body = e.body), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.hideAnchor != null && e.hasOwnProperty("hideAnchor") && (r.hideAnchor = e.hideAnchor), e.divider != null && e.hasOwnProperty("divider") && (r.divider = e.divider), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Heading";
	}, e;
})(), N.Help = (() => {
	function e(e) {
		if (this.members = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.docString = "", e.prototype.type = "", e.prototype.name = "", e.prototype.value = "", e.prototype.members = M.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.docString != null && Object.hasOwnProperty.call(e, "docString") && t.uint32(26).string(e.docString), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(34).string(e.type), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(50).string(e.name), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(58).string(e.value), e.members != null && e.members.length) for (let r = 0; r < e.members.length; ++r) N.Member.encode(e.members[r], t.uint32(66).fork(), n + 1).ldelim();
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Help(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.docString = s : delete o.docString;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.type = s : delete o.type;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.name = s : delete o.name;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.string()).length ? o.value = s : delete o.value;
					continue;
				case 8:
					if (a !== 2) break;
					o.members && o.members.length || (o.members = []), o.members.push(N.Member.decode(e, e.uint32(), void 0, r + 1));
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Help) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Help();
		if (e.docString != null && (typeof e.docString != "string" || e.docString.length) && (n.docString = String(e.docString)), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = String(e.type)), e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = String(e.name)), e.value != null && (typeof e.value != "string" || e.value.length) && (n.value = String(e.value)), e.members) {
			if (!Array.isArray(e.members)) throw TypeError(".Help.members: array expected");
			n.members = Array(e.members.length);
			for (let r = 0; r < e.members.length; ++r) {
				if (typeof e.members[r] != "object") throw TypeError(".Help.members: object expected");
				n.members[r] = N.Member.fromObject(e.members[r], t + 1);
			}
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.members = []), t.defaults && (r.docString = "", r.type = "", r.name = "", r.value = ""), e.docString != null && e.hasOwnProperty("docString") && (r.docString = e.docString), e.type != null && e.hasOwnProperty("type") && (r.type = e.type), e.name != null && e.hasOwnProperty("name") && (r.name = e.name), e.value != null && e.hasOwnProperty("value") && (r.value = e.value), e.members && e.members.length) {
			r.members = Array(e.members.length);
			for (let i = 0; i < e.members.length; ++i) r.members[i] = N.Member.toObject(e.members[i], t, n + 1);
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Help";
	}, e;
})(), N.Member = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.name = "", e.prototype.type = "", e.prototype.value = null, e.prototype.docString = null;
	let t;
	return Object.defineProperty(e.prototype, "contents", {
		get: M.oneOfGetter(t = ["value", "docString"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(10).string(e.name), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(18).string(e.type), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(26).string(e.value), e.docString != null && Object.hasOwnProperty.call(e, "docString") && t.uint32(34).string(e.docString), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Member(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.name = s : delete o.name;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.type = s : delete o.type;
					continue;
				case 3:
					if (a !== 2) break;
					o.value = e.string(), o.contents = "value";
					continue;
				case 4:
					if (a !== 2) break;
					o.docString = e.string(), o.contents = "docString";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Member) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Member();
		return e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = String(e.name)), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = String(e.type)), e.value != null && (n.value = String(e.value)), e.docString != null && (n.docString = String(e.docString)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.name = "", r.type = ""), e.name != null && e.hasOwnProperty("name") && (r.name = e.name), e.type != null && e.hasOwnProperty("type") && (r.type = e.type), e.value != null && e.hasOwnProperty("value") && (r.value = e.value, t.oneofs && (r.contents = "value")), e.docString != null && e.hasOwnProperty("docString") && (r.docString = e.docString, t.oneofs && (r.contents = "docString")), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Member";
	}, e;
})(), N.Html = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.body = "", e.prototype.unsafeAllowJavascript = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.body != null && Object.hasOwnProperty.call(e, "body") && t.uint32(10).string(e.body), e.unsafeAllowJavascript != null && Object.hasOwnProperty.call(e, "unsafeAllowJavascript") && t.uint32(16).bool(e.unsafeAllowJavascript), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Html(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.body = s : delete o.body;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.bool()) ? o.unsafeAllowJavascript = s : delete o.unsafeAllowJavascript;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Html) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Html();
		return e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = String(e.body)), e.unsafeAllowJavascript != null && e.unsafeAllowJavascript && (n.unsafeAllowJavascript = !!e.unsafeAllowJavascript), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.body = "", r.unsafeAllowJavascript = !1), e.body != null && e.hasOwnProperty("body") && (r.body = e.body), e.unsafeAllowJavascript != null && e.hasOwnProperty("unsafeAllowJavascript") && (r.unsafeAllowJavascript = e.unsafeAllowJavascript), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Html";
	}, e;
})(), N.IFrame = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.src = null, e.prototype.srcdoc = null, e.prototype.scrolling = !1, e.prototype.tabIndex = null;
	let t;
	return Object.defineProperty(e.prototype, "type", {
		get: M.oneOfGetter(t = ["src", "srcdoc"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_tabIndex", {
		get: M.oneOfGetter(t = ["tabIndex"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.src != null && Object.hasOwnProperty.call(e, "src") && t.uint32(10).string(e.src), e.srcdoc != null && Object.hasOwnProperty.call(e, "srcdoc") && t.uint32(18).string(e.srcdoc), e.scrolling != null && Object.hasOwnProperty.call(e, "scrolling") && t.uint32(56).bool(e.scrolling), e.tabIndex != null && Object.hasOwnProperty.call(e, "tabIndex") && t.uint32(64).int32(e.tabIndex), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.IFrame(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.src = e.string(), o.type = "src";
					continue;
				case 2:
					if (a !== 2) break;
					o.srcdoc = e.string(), o.type = "srcdoc";
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.scrolling = s : delete o.scrolling;
					continue;
				case 8:
					if (a !== 0) break;
					o.tabIndex = e.int32(), o._tabIndex = "tabIndex";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.IFrame) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.IFrame();
		return e.src != null && (n.src = String(e.src)), e.srcdoc != null && (n.srcdoc = String(e.srcdoc)), e.scrolling != null && e.scrolling && (n.scrolling = !!e.scrolling), e.tabIndex != null && (n.tabIndex = e.tabIndex | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.scrolling = !1), e.src != null && e.hasOwnProperty("src") && (r.src = e.src, t.oneofs && (r.type = "src")), e.srcdoc != null && e.hasOwnProperty("srcdoc") && (r.srcdoc = e.srcdoc, t.oneofs && (r.type = "srcdoc")), e.scrolling != null && e.hasOwnProperty("scrolling") && (r.scrolling = e.scrolling), e.tabIndex != null && e.hasOwnProperty("tabIndex") && (r.tabIndex = e.tabIndex), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/IFrame";
	}, e;
})(), N.Image = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.url = "", e.prototype.caption = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.caption != null && Object.hasOwnProperty.call(e, "caption") && t.uint32(18).string(e.caption), e.url != null && Object.hasOwnProperty.call(e, "url") && t.uint32(26).string(e.url), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Image(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.url = s : delete o.url;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.caption = s : delete o.caption;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Image) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Image();
		return e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = String(e.url)), e.caption != null && (typeof e.caption != "string" || e.caption.length) && (n.caption = String(e.caption)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.caption = "", r.url = ""), e.caption != null && e.hasOwnProperty("caption") && (r.caption = e.caption), e.url != null && e.hasOwnProperty("url") && (r.url = e.url), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Image";
	}, e;
})(), N.ImageList = (() => {
	function e(e) {
		if (this.imgs = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.imgs = M.emptyArray, e.prototype.link = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.imgs != null && e.imgs.length) for (let r = 0; r < e.imgs.length; ++r) N.Image.encode(e.imgs[r], t.uint32(10).fork(), n + 1).ldelim();
		if (e.link != null && Object.hasOwnProperty.call(e, "link") && t.uint32(26).string(e.link), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ImageList(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.imgs && o.imgs.length || (o.imgs = []), o.imgs.push(N.Image.decode(e, e.uint32(), void 0, r + 1));
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.link = s : delete o.link;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ImageList) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ImageList();
		if (e.imgs) {
			if (!Array.isArray(e.imgs)) throw TypeError(".ImageList.imgs: array expected");
			n.imgs = Array(e.imgs.length);
			for (let r = 0; r < e.imgs.length; ++r) {
				if (typeof e.imgs[r] != "object") throw TypeError(".ImageList.imgs: object expected");
				n.imgs[r] = N.Image.fromObject(e.imgs[r], t + 1);
			}
		}
		return e.link != null && (typeof e.link != "string" || e.link.length) && (n.link = String(e.link)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.imgs = []), t.defaults && (r.link = ""), e.imgs && e.imgs.length) {
			r.imgs = Array(e.imgs.length);
			for (let i = 0; i < e.imgs.length; ++i) r.imgs[i] = N.Image.toObject(e.imgs[i], t, n + 1);
		}
		return e.link != null && e.hasOwnProperty("link") && (r.link = e.link), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ImageList";
	}, e;
})(), N.Json = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.body = "", e.prototype.expanded = !1, e.prototype.maxExpandDepth = null;
	let t;
	return Object.defineProperty(e.prototype, "_maxExpandDepth", {
		get: M.oneOfGetter(t = ["maxExpandDepth"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.body != null && Object.hasOwnProperty.call(e, "body") && t.uint32(10).string(e.body), e.expanded != null && Object.hasOwnProperty.call(e, "expanded") && t.uint32(16).bool(e.expanded), e.maxExpandDepth != null && Object.hasOwnProperty.call(e, "maxExpandDepth") && t.uint32(24).int32(e.maxExpandDepth), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Json(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.body = s : delete o.body;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.bool()) ? o.expanded = s : delete o.expanded;
					continue;
				case 3:
					if (a !== 0) break;
					o.maxExpandDepth = e.int32(), o._maxExpandDepth = "maxExpandDepth";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Json) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Json();
		return e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = String(e.body)), e.expanded != null && e.expanded && (n.expanded = !!e.expanded), e.maxExpandDepth != null && (n.maxExpandDepth = e.maxExpandDepth | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.body = "", r.expanded = !1), e.body != null && e.hasOwnProperty("body") && (r.body = e.body), e.expanded != null && e.hasOwnProperty("expanded") && (r.expanded = e.expanded), e.maxExpandDepth != null && e.hasOwnProperty("maxExpandDepth") && (r.maxExpandDepth = e.maxExpandDepth), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Json";
	}, e;
})(), N.LinkButton = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.id = "", e.prototype.label = "", e.prototype.help = "", e.prototype.url = "", e.prototype.disabled = !1, e.prototype.useContainerWidth = !1, e.prototype.type = "", e.prototype.icon = "", e.prototype.shortcut = "", e.prototype.iconPosition = 0, e.prototype.ignoreRerun = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(34).string(e.help), e.url != null && Object.hasOwnProperty.call(e, "url") && t.uint32(50).string(e.url), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(56).bool(e.disabled), e.useContainerWidth != null && Object.hasOwnProperty.call(e, "useContainerWidth") && t.uint32(64).bool(e.useContainerWidth), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(74).string(e.type), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(82).string(e.icon), e.shortcut != null && Object.hasOwnProperty.call(e, "shortcut") && t.uint32(90).string(e.shortcut), e.iconPosition != null && Object.hasOwnProperty.call(e, "iconPosition") && t.uint32(96).int32(e.iconPosition), e.ignoreRerun != null && Object.hasOwnProperty.call(e, "ignoreRerun") && t.uint32(104).bool(e.ignoreRerun), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.LinkButton(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.url = s : delete o.url;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.useContainerWidth = s : delete o.useContainerWidth;
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.string()).length ? o.type = s : delete o.type;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.string()).length ? o.icon = s : delete o.icon;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.string()).length ? o.shortcut = s : delete o.shortcut;
					continue;
				case 12:
					if (a !== 0) break;
					(s = e.int32()) ? o.iconPosition = s : delete o.iconPosition;
					continue;
				case 13:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.LinkButton) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.LinkButton();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = String(e.url)), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.useContainerWidth != null && e.useContainerWidth && (n.useContainerWidth = !!e.useContainerWidth), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = String(e.type)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = String(e.icon)), e.shortcut != null && (typeof e.shortcut != "string" || e.shortcut.length) && (n.shortcut = String(e.shortcut)), e.iconPosition !== 0 && (typeof e.iconPosition != "string" || N.streamlit.ButtonLikeIconPosition[e.iconPosition] !== 0)) switch (e.iconPosition) {
			default:
				if (typeof e.iconPosition == "number") {
					n.iconPosition = e.iconPosition;
					break;
				}
				break;
			case "LEFT":
			case 0:
				n.iconPosition = 0;
				break;
			case "RIGHT":
			case 1:
				n.iconPosition = 1;
				break;
		}
		return e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = !!e.ignoreRerun), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.help = "", r.url = "", r.disabled = !1, r.useContainerWidth = !1, r.type = "", r.icon = "", r.shortcut = "", r.iconPosition = t.enums === String ? "LEFT" : 0, r.ignoreRerun = !1), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.url != null && e.hasOwnProperty("url") && (r.url = e.url), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.useContainerWidth != null && e.hasOwnProperty("useContainerWidth") && (r.useContainerWidth = e.useContainerWidth), e.type != null && e.hasOwnProperty("type") && (r.type = e.type), e.icon != null && e.hasOwnProperty("icon") && (r.icon = e.icon), e.shortcut != null && e.hasOwnProperty("shortcut") && (r.shortcut = e.shortcut), e.iconPosition != null && e.hasOwnProperty("iconPosition") && (r.iconPosition = t.enums === String ? N.streamlit.ButtonLikeIconPosition[e.iconPosition] === void 0 ? e.iconPosition : N.streamlit.ButtonLikeIconPosition[e.iconPosition] : e.iconPosition), e.ignoreRerun != null && e.hasOwnProperty("ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/LinkButton";
	}, e;
})(), N.Markdown = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.body = "", e.prototype.allowHtml = !1, e.prototype.elementType = 0, e.prototype.help = "", e.prototype.unterminatedParsing = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.body != null && Object.hasOwnProperty.call(e, "body") && t.uint32(10).string(e.body), e.allowHtml != null && Object.hasOwnProperty.call(e, "allowHtml") && t.uint32(16).bool(e.allowHtml), e.elementType != null && Object.hasOwnProperty.call(e, "elementType") && t.uint32(32).int32(e.elementType), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(42).string(e.help), e.unterminatedParsing != null && Object.hasOwnProperty.call(e, "unterminatedParsing") && t.uint32(48).bool(e.unterminatedParsing), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Markdown(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.body = s : delete o.body;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.bool()) ? o.allowHtml = s : delete o.allowHtml;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.int32()) ? o.elementType = s : delete o.elementType;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.unterminatedParsing = s : delete o.unterminatedParsing;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Markdown) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Markdown();
		if (e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = String(e.body)), e.allowHtml != null && e.allowHtml && (n.allowHtml = !!e.allowHtml), e.elementType !== 0 && (typeof e.elementType != "string" || N.Markdown.Type[e.elementType] !== 0)) switch (e.elementType) {
			default:
				if (typeof e.elementType == "number") {
					n.elementType = e.elementType;
					break;
				}
				break;
			case "UNSPECIFIED":
			case 0:
				n.elementType = 0;
				break;
			case "NATIVE":
			case 1:
				n.elementType = 1;
				break;
			case "CAPTION":
			case 2:
				n.elementType = 2;
				break;
			case "CODE":
			case 3:
				n.elementType = 3;
				break;
			case "LATEX":
			case 4:
				n.elementType = 4;
				break;
			case "DIVIDER":
			case 5:
				n.elementType = 5;
				break;
		}
		return e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.unterminatedParsing != null && e.unterminatedParsing && (n.unterminatedParsing = !!e.unterminatedParsing), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.body = "", r.allowHtml = !1, r.elementType = t.enums === String ? "UNSPECIFIED" : 0, r.help = "", r.unterminatedParsing = !1), e.body != null && e.hasOwnProperty("body") && (r.body = e.body), e.allowHtml != null && e.hasOwnProperty("allowHtml") && (r.allowHtml = e.allowHtml), e.elementType != null && e.hasOwnProperty("elementType") && (r.elementType = t.enums === String ? N.Markdown.Type[e.elementType] === void 0 ? e.elementType : N.Markdown.Type[e.elementType] : e.elementType), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.unterminatedParsing != null && e.hasOwnProperty("unterminatedParsing") && (r.unterminatedParsing = e.unterminatedParsing), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Markdown";
	}, e.Type = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "UNSPECIFIED"] = 0, t[e[1] = "NATIVE"] = 1, t[e[2] = "CAPTION"] = 2, t[e[3] = "CODE"] = 3, t[e[4] = "LATEX"] = 4, t[e[5] = "DIVIDER"] = 5, t;
	})(), e;
})(), N.MenuButton = (() => {
	function e(e) {
		if (this.options = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.id = "", e.prototype.label = "", e.prototype.options = M.emptyArray, e.prototype.help = "", e.prototype.type = "", e.prototype.disabled = !1, e.prototype.icon = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.options != null && e.options.length) for (let n = 0; n < e.options.length; ++n) t.uint32(26).string(e.options[n]);
		if (e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(34).string(e.help), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(42).string(e.type), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(48).bool(e.disabled), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(58).string(e.icon), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.MenuButton(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.options && o.options.length || (o.options = []), o.options.push(e.string());
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.type = s : delete o.type;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.string()).length ? o.icon = s : delete o.icon;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.MenuButton) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.MenuButton();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.options) {
			if (!Array.isArray(e.options)) throw TypeError(".MenuButton.options: array expected");
			n.options = Array(e.options.length);
			for (let t = 0; t < e.options.length; ++t) n.options[t] = String(e.options[t]);
		}
		return e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = String(e.type)), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = String(e.icon)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.options = []), t.defaults && (r.id = "", r.label = "", r.help = "", r.type = "", r.disabled = !1, r.icon = ""), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.options && e.options.length) {
			r.options = Array(e.options.length);
			for (let t = 0; t < e.options.length; ++t) r.options[t] = e.options[t];
		}
		return e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.type != null && e.hasOwnProperty("type") && (r.type = e.type), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.icon != null && e.hasOwnProperty("icon") && (r.icon = e.icon), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/MenuButton";
	}, e;
})(), N.Metric = (() => {
	function e(e) {
		if (this.chartData = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.label = "", e.prototype.body = "", e.prototype.delta = "", e.prototype.direction = 0, e.prototype.color = 0, e.prototype.help = "", e.prototype.labelVisibility = null, e.prototype.showBorder = !1, e.prototype.chartData = M.emptyArray, e.prototype.chartType = 0, e.prototype.format = "", e.prototype.deltaDescription = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(10).string(e.label), e.body != null && Object.hasOwnProperty.call(e, "body") && t.uint32(18).string(e.body), e.delta != null && Object.hasOwnProperty.call(e, "delta") && t.uint32(26).string(e.delta), e.direction != null && Object.hasOwnProperty.call(e, "direction") && t.uint32(32).int32(e.direction), e.color != null && Object.hasOwnProperty.call(e, "color") && t.uint32(40).int32(e.color), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(50).string(e.help), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(58).fork(), n + 1).ldelim(), e.showBorder != null && Object.hasOwnProperty.call(e, "showBorder") && t.uint32(64).bool(e.showBorder), e.chartData != null && e.chartData.length) {
			t.uint32(74).fork();
			for (let n = 0; n < e.chartData.length; ++n) t.double(e.chartData[n]);
			t.ldelim();
		}
		if (e.chartType != null && Object.hasOwnProperty.call(e, "chartType") && t.uint32(80).int32(e.chartType), e.format != null && Object.hasOwnProperty.call(e, "format") && t.uint32(90).string(e.format), e.deltaDescription != null && Object.hasOwnProperty.call(e, "deltaDescription") && t.uint32(98).string(e.deltaDescription), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Metric(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.body = s : delete o.body;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.delta = s : delete o.delta;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.int32()) ? o.direction = s : delete o.direction;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.int32()) ? o.color = s : delete o.color;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 7:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.showBorder = s : delete o.showBorder;
					continue;
				case 9:
					if (a === 2) {
						o.chartData && o.chartData.length || (o.chartData = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.chartData.push(e.double());
						continue;
					}
					if (a !== 1) break;
					o.chartData && o.chartData.length || (o.chartData = []), o.chartData.push(e.double());
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.int32()) ? o.chartType = s : delete o.chartType;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.string()).length ? o.format = s : delete o.format;
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.string()).length ? o.deltaDescription = s : delete o.deltaDescription;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Metric) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Metric();
		if (e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = String(e.body)), e.delta != null && (typeof e.delta != "string" || e.delta.length) && (n.delta = String(e.delta)), e.direction !== 0 && (typeof e.direction != "string" || N.Metric.MetricDirection[e.direction] !== 0)) switch (e.direction) {
			default:
				if (typeof e.direction == "number") {
					n.direction = e.direction;
					break;
				}
				break;
			case "DOWN":
			case 0:
				n.direction = 0;
				break;
			case "UP":
			case 1:
				n.direction = 1;
				break;
			case "NONE":
			case 2:
				n.direction = 2;
				break;
		}
		if (e.color !== 0 && (typeof e.color != "string" || N.Metric.MetricColor[e.color] !== 0)) switch (e.color) {
			default:
				if (typeof e.color == "number") {
					n.color = e.color;
					break;
				}
				break;
			case "RED":
			case 0:
				n.color = 0;
				break;
			case "GREEN":
			case 1:
				n.color = 1;
				break;
			case "GRAY":
			case 2:
				n.color = 2;
				break;
			case "ORANGE":
			case 3:
				n.color = 3;
				break;
			case "YELLOW":
			case 4:
				n.color = 4;
				break;
			case "BLUE":
			case 5:
				n.color = 5;
				break;
			case "VIOLET":
			case 6:
				n.color = 6;
				break;
			case "PRIMARY":
			case 7:
				n.color = 7;
				break;
		}
		if (e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".Metric.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.showBorder != null && e.showBorder && (n.showBorder = !!e.showBorder), e.chartData) {
			if (!Array.isArray(e.chartData)) throw TypeError(".Metric.chartData: array expected");
			n.chartData = Array(e.chartData.length);
			for (let t = 0; t < e.chartData.length; ++t) n.chartData[t] = Number(e.chartData[t]);
		}
		if (e.chartType !== 0 && (typeof e.chartType != "string" || N.Metric.ChartType[e.chartType] !== 0)) switch (e.chartType) {
			default:
				if (typeof e.chartType == "number") {
					n.chartType = e.chartType;
					break;
				}
				break;
			case "LINE":
			case 0:
				n.chartType = 0;
				break;
			case "BAR":
			case 1:
				n.chartType = 1;
				break;
			case "AREA":
			case 2:
				n.chartType = 2;
				break;
		}
		return e.format != null && (typeof e.format != "string" || e.format.length) && (n.format = String(e.format)), e.deltaDescription != null && (typeof e.deltaDescription != "string" || e.deltaDescription.length) && (n.deltaDescription = String(e.deltaDescription)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.chartData = []), t.defaults && (r.label = "", r.body = "", r.delta = "", r.direction = t.enums === String ? "DOWN" : 0, r.color = t.enums === String ? "RED" : 0, r.help = "", r.labelVisibility = null, r.showBorder = !1, r.chartType = t.enums === String ? "LINE" : 0, r.format = "", r.deltaDescription = ""), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.body != null && e.hasOwnProperty("body") && (r.body = e.body), e.delta != null && e.hasOwnProperty("delta") && (r.delta = e.delta), e.direction != null && e.hasOwnProperty("direction") && (r.direction = t.enums === String ? N.Metric.MetricDirection[e.direction] === void 0 ? e.direction : N.Metric.MetricDirection[e.direction] : e.direction), e.color != null && e.hasOwnProperty("color") && (r.color = t.enums === String ? N.Metric.MetricColor[e.color] === void 0 ? e.color : N.Metric.MetricColor[e.color] : e.color), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.showBorder != null && e.hasOwnProperty("showBorder") && (r.showBorder = e.showBorder), e.chartData && e.chartData.length) {
			r.chartData = Array(e.chartData.length);
			for (let n = 0; n < e.chartData.length; ++n) r.chartData[n] = t.json && !isFinite(e.chartData[n]) ? String(e.chartData[n]) : e.chartData[n];
		}
		return e.chartType != null && e.hasOwnProperty("chartType") && (r.chartType = t.enums === String ? N.Metric.ChartType[e.chartType] === void 0 ? e.chartType : N.Metric.ChartType[e.chartType] : e.chartType), e.format != null && e.hasOwnProperty("format") && (r.format = e.format), e.deltaDescription != null && e.hasOwnProperty("deltaDescription") && (r.deltaDescription = e.deltaDescription), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Metric";
	}, e.MetricDirection = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "DOWN"] = 0, t[e[1] = "UP"] = 1, t[e[2] = "NONE"] = 2, t;
	})(), e.MetricColor = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "RED"] = 0, t[e[1] = "GREEN"] = 1, t[e[2] = "GRAY"] = 2, t[e[3] = "ORANGE"] = 3, t[e[4] = "YELLOW"] = 4, t[e[5] = "BLUE"] = 5, t[e[6] = "VIOLET"] = 6, t[e[7] = "PRIMARY"] = 7, t;
	})(), e.ChartType = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "LINE"] = 0, t[e[1] = "BAR"] = 1, t[e[2] = "AREA"] = 2, t;
	})(), e;
})(), N.MultiSelect = (() => {
	function e(e) {
		if (this.default = [], this.options = [], this.rawValues = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = M.emptyArray, e.prototype.options = M.emptyArray, e.prototype.help = "", e.prototype.formId = "", e.prototype.rawValues = M.emptyArray, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.maxSelections = 0, e.prototype.placeholder = "", e.prototype.acceptNewOptions = null, e.prototype.queryParamKey = null, e.prototype.filterMode = 0;
	let t;
	return Object.defineProperty(e.prototype, "_acceptNewOptions", {
		get: M.oneOfGetter(t = ["acceptNewOptions"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_queryParamKey", {
		get: M.oneOfGetter(t = ["queryParamKey"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.default != null && e.default.length) {
			t.uint32(26).fork();
			for (let n = 0; n < e.default.length; ++n) t.int32(e.default[n]);
			t.ldelim();
		}
		if (e.options != null && e.options.length) for (let n = 0; n < e.options.length; ++n) t.uint32(34).string(e.options[n]);
		if (e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(42).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(50).string(e.formId), e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(64).bool(e.setValue), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(72).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(82).fork(), n + 1).ldelim(), e.maxSelections != null && Object.hasOwnProperty.call(e, "maxSelections") && t.uint32(88).int32(e.maxSelections), e.placeholder != null && Object.hasOwnProperty.call(e, "placeholder") && t.uint32(98).string(e.placeholder), e.acceptNewOptions != null && Object.hasOwnProperty.call(e, "acceptNewOptions") && t.uint32(104).bool(e.acceptNewOptions), e.rawValues != null && e.rawValues.length) for (let n = 0; n < e.rawValues.length; ++n) t.uint32(114).string(e.rawValues[n]);
		if (e.queryParamKey != null && Object.hasOwnProperty.call(e, "queryParamKey") && t.uint32(122).string(e.queryParamKey), e.filterMode != null && Object.hasOwnProperty.call(e, "filterMode") && t.uint32(128).int32(e.filterMode), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.MultiSelect(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a === 2) {
						o.default && o.default.length || (o.default = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.default.push(e.int32());
						continue;
					}
					if (a !== 0) break;
					o.default && o.default.length || (o.default = []), o.default.push(e.int32());
					continue;
				case 4:
					if (a !== 2) break;
					o.options && o.options.length || (o.options = []), o.options.push(e.string());
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 14:
					if (a !== 2) break;
					o.rawValues && o.rawValues.length || (o.rawValues = []), o.rawValues.push(e.string());
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 10:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.int32()) ? o.maxSelections = s : delete o.maxSelections;
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.string()).length ? o.placeholder = s : delete o.placeholder;
					continue;
				case 13:
					if (a !== 0) break;
					o.acceptNewOptions = e.bool(), o._acceptNewOptions = "acceptNewOptions";
					continue;
				case 15:
					if (a !== 2) break;
					o.queryParamKey = e.string(), o._queryParamKey = "queryParamKey";
					continue;
				case 16:
					if (a !== 0) break;
					(s = e.int32()) ? o.filterMode = s : delete o.filterMode;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.MultiSelect) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.MultiSelect();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.default) {
			if (!Array.isArray(e.default)) throw TypeError(".MultiSelect.default: array expected");
			n.default = Array(e.default.length);
			for (let t = 0; t < e.default.length; ++t) n.default[t] = e.default[t] | 0;
		}
		if (e.options) {
			if (!Array.isArray(e.options)) throw TypeError(".MultiSelect.options: array expected");
			n.options = Array(e.options.length);
			for (let t = 0; t < e.options.length; ++t) n.options[t] = String(e.options[t]);
		}
		if (e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.rawValues) {
			if (!Array.isArray(e.rawValues)) throw TypeError(".MultiSelect.rawValues: array expected");
			n.rawValues = Array(e.rawValues.length);
			for (let t = 0; t < e.rawValues.length; ++t) n.rawValues[t] = String(e.rawValues[t]);
		}
		if (e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".MultiSelect.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.maxSelections != null && Number(e.maxSelections) !== 0 && (n.maxSelections = e.maxSelections | 0), e.placeholder != null && (typeof e.placeholder != "string" || e.placeholder.length) && (n.placeholder = String(e.placeholder)), e.acceptNewOptions != null && (n.acceptNewOptions = !!e.acceptNewOptions), e.queryParamKey != null && (n.queryParamKey = String(e.queryParamKey)), e.filterMode !== 0 && (typeof e.filterMode != "string" || N.streamlit.SelectWidgetFilterMode[e.filterMode] !== 0)) switch (e.filterMode) {
			default:
				if (typeof e.filterMode == "number") {
					n.filterMode = e.filterMode;
					break;
				}
				break;
			case "FILTER_MODE_FUZZY":
			case 0:
				n.filterMode = 0;
				break;
			case "FILTER_MODE_CONTAINS":
			case 1:
				n.filterMode = 1;
				break;
			case "FILTER_MODE_PREFIX":
			case 2:
				n.filterMode = 2;
				break;
			case "FILTER_MODE_NONE":
			case 3:
				n.filterMode = 3;
				break;
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.default = [], r.options = [], r.rawValues = []), t.defaults && (r.id = "", r.label = "", r.help = "", r.formId = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null, r.maxSelections = 0, r.placeholder = "", r.filterMode = t.enums === String ? "FILTER_MODE_FUZZY" : 0), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.default && e.default.length) {
			r.default = Array(e.default.length);
			for (let t = 0; t < e.default.length; ++t) r.default[t] = e.default[t];
		}
		if (e.options && e.options.length) {
			r.options = Array(e.options.length);
			for (let t = 0; t < e.options.length; ++t) r.options[t] = e.options[t];
		}
		if (e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.maxSelections != null && e.hasOwnProperty("maxSelections") && (r.maxSelections = e.maxSelections), e.placeholder != null && e.hasOwnProperty("placeholder") && (r.placeholder = e.placeholder), e.acceptNewOptions != null && e.hasOwnProperty("acceptNewOptions") && (r.acceptNewOptions = e.acceptNewOptions), e.rawValues && e.rawValues.length) {
			r.rawValues = Array(e.rawValues.length);
			for (let t = 0; t < e.rawValues.length; ++t) r.rawValues[t] = e.rawValues[t];
		}
		return e.queryParamKey != null && e.hasOwnProperty("queryParamKey") && (r.queryParamKey = e.queryParamKey), e.filterMode != null && e.hasOwnProperty("filterMode") && (r.filterMode = t.enums === String ? N.streamlit.SelectWidgetFilterMode[e.filterMode] === void 0 ? e.filterMode : N.streamlit.SelectWidgetFilterMode[e.filterMode] : e.filterMode), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/MultiSelect";
	}, e;
})(), N.NumberInput = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.label = "", e.prototype.formId = "", e.prototype.format = "", e.prototype.hasMin = !1, e.prototype.hasMax = !1, e.prototype.dataType = 0, e.prototype.default = null, e.prototype.step = 0, e.prototype.min = 0, e.prototype.max = 0, e.prototype.help = "", e.prototype.value = null, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.placeholder = "", e.prototype.icon = "", e.prototype.queryParamKey = null;
	let t;
	return Object.defineProperty(e.prototype, "_default", {
		get: M.oneOfGetter(t = ["default"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_value", {
		get: M.oneOfGetter(t = ["value"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_queryParamKey", {
		get: M.oneOfGetter(t = ["queryParamKey"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(26).string(e.formId), e.format != null && Object.hasOwnProperty.call(e, "format") && t.uint32(66).string(e.format), e.hasMin != null && Object.hasOwnProperty.call(e, "hasMin") && t.uint32(88).bool(e.hasMin), e.hasMax != null && Object.hasOwnProperty.call(e, "hasMax") && t.uint32(96).bool(e.hasMax), e.dataType != null && Object.hasOwnProperty.call(e, "dataType") && t.uint32(104).int32(e.dataType), e.default != null && Object.hasOwnProperty.call(e, "default") && t.uint32(113).double(e.default), e.step != null && Object.hasOwnProperty.call(e, "step") && t.uint32(121).double(e.step), e.min != null && Object.hasOwnProperty.call(e, "min") && t.uint32(129).double(e.min), e.max != null && Object.hasOwnProperty.call(e, "max") && t.uint32(137).double(e.max), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(146).string(e.help), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(153).double(e.value), e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(160).bool(e.setValue), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(168).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(178).fork(), n + 1).ldelim(), e.placeholder != null && Object.hasOwnProperty.call(e, "placeholder") && t.uint32(186).string(e.placeholder), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(194).string(e.icon), e.queryParamKey != null && Object.hasOwnProperty.call(e, "queryParamKey") && t.uint32(202).string(e.queryParamKey), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.NumberInput(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 8:
					if (a !== 2) break;
					(s = e.string()).length ? o.format = s : delete o.format;
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.hasMin = s : delete o.hasMin;
					continue;
				case 12:
					if (a !== 0) break;
					(s = e.bool()) ? o.hasMax = s : delete o.hasMax;
					continue;
				case 13:
					if (a !== 0) break;
					(s = e.int32()) ? o.dataType = s : delete o.dataType;
					continue;
				case 14:
					if (a !== 1) break;
					o.default = e.double(), o._default = "default";
					continue;
				case 15:
					if (a !== 1) break;
					(s = e.double()) === 0 ? delete o.step : o.step = s;
					continue;
				case 16:
					if (a !== 1) break;
					(s = e.double()) === 0 ? delete o.min : o.min = s;
					continue;
				case 17:
					if (a !== 1) break;
					(s = e.double()) === 0 ? delete o.max : o.max = s;
					continue;
				case 18:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 19:
					if (a !== 1) break;
					o.value = e.double(), o._value = "value";
					continue;
				case 20:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 21:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 22:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 23:
					if (a !== 2) break;
					(s = e.string()).length ? o.placeholder = s : delete o.placeholder;
					continue;
				case 24:
					if (a !== 2) break;
					(s = e.string()).length ? o.icon = s : delete o.icon;
					continue;
				case 25:
					if (a !== 2) break;
					o.queryParamKey = e.string(), o._queryParamKey = "queryParamKey";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.NumberInput) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.NumberInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.format != null && (typeof e.format != "string" || e.format.length) && (n.format = String(e.format)), e.hasMin != null && e.hasMin && (n.hasMin = !!e.hasMin), e.hasMax != null && e.hasMax && (n.hasMax = !!e.hasMax), e.dataType !== 0 && (typeof e.dataType != "string" || N.NumberInput.DataType[e.dataType] !== 0)) switch (e.dataType) {
			default:
				if (typeof e.dataType == "number") {
					n.dataType = e.dataType;
					break;
				}
				break;
			case "INT":
			case 0:
				n.dataType = 0;
				break;
			case "FLOAT":
			case 1:
				n.dataType = 1;
				break;
		}
		if (e.default != null && (n.default = Number(e.default)), e.step != null && Number(e.step) !== 0 && (n.step = Number(e.step)), e.min != null && Number(e.min) !== 0 && (n.min = Number(e.min)), e.max != null && Number(e.max) !== 0 && (n.max = Number(e.max)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.value != null && (n.value = Number(e.value)), e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".NumberInput.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.placeholder != null && (typeof e.placeholder != "string" || e.placeholder.length) && (n.placeholder = String(e.placeholder)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = String(e.icon)), e.queryParamKey != null && (n.queryParamKey = String(e.queryParamKey)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.formId = "", r.format = "", r.hasMin = !1, r.hasMax = !1, r.dataType = t.enums === String ? "INT" : 0, r.step = 0, r.min = 0, r.max = 0, r.help = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null, r.placeholder = "", r.icon = ""), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.format != null && e.hasOwnProperty("format") && (r.format = e.format), e.hasMin != null && e.hasOwnProperty("hasMin") && (r.hasMin = e.hasMin), e.hasMax != null && e.hasOwnProperty("hasMax") && (r.hasMax = e.hasMax), e.dataType != null && e.hasOwnProperty("dataType") && (r.dataType = t.enums === String ? N.NumberInput.DataType[e.dataType] === void 0 ? e.dataType : N.NumberInput.DataType[e.dataType] : e.dataType), e.default != null && e.hasOwnProperty("default") && (r.default = t.json && !isFinite(e.default) ? String(e.default) : e.default), e.step != null && e.hasOwnProperty("step") && (r.step = t.json && !isFinite(e.step) ? String(e.step) : e.step), e.min != null && e.hasOwnProperty("min") && (r.min = t.json && !isFinite(e.min) ? String(e.min) : e.min), e.max != null && e.hasOwnProperty("max") && (r.max = t.json && !isFinite(e.max) ? String(e.max) : e.max), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.value != null && e.hasOwnProperty("value") && (r.value = t.json && !isFinite(e.value) ? String(e.value) : e.value), e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.placeholder != null && e.hasOwnProperty("placeholder") && (r.placeholder = e.placeholder), e.icon != null && e.hasOwnProperty("icon") && (r.icon = e.icon), e.queryParamKey != null && e.hasOwnProperty("queryParamKey") && (r.queryParamKey = e.queryParamKey), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/NumberInput";
	}, e.DataType = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "INT"] = 0, t[e[1] = "FLOAT"] = 1, t;
	})(), e;
})(), N.PageLink = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.page = "", e.prototype.label = "", e.prototype.icon = "", e.prototype.pageScriptHash = "", e.prototype.help = "", e.prototype.useContainerWidth = null, e.prototype.disabled = !1, e.prototype.external = !1, e.prototype.queryString = "", e.prototype.iconPosition = 0;
	let t;
	return Object.defineProperty(e.prototype, "_useContainerWidth", {
		get: M.oneOfGetter(t = ["useContainerWidth"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.page != null && Object.hasOwnProperty.call(e, "page") && t.uint32(10).string(e.page), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(26).string(e.icon), e.pageScriptHash != null && Object.hasOwnProperty.call(e, "pageScriptHash") && t.uint32(34).string(e.pageScriptHash), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(42).string(e.help), e.useContainerWidth != null && Object.hasOwnProperty.call(e, "useContainerWidth") && t.uint32(48).bool(e.useContainerWidth), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(56).bool(e.disabled), e.external != null && Object.hasOwnProperty.call(e, "external") && t.uint32(64).bool(e.external), e.queryString != null && Object.hasOwnProperty.call(e, "queryString") && t.uint32(74).string(e.queryString), e.iconPosition != null && Object.hasOwnProperty.call(e, "iconPosition") && t.uint32(80).int32(e.iconPosition), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.PageLink(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.page = s : delete o.page;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.icon = s : delete o.icon;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.pageScriptHash = s : delete o.pageScriptHash;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 6:
					if (a !== 0) break;
					o.useContainerWidth = e.bool(), o._useContainerWidth = "useContainerWidth";
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.external = s : delete o.external;
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.string()).length ? o.queryString = s : delete o.queryString;
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.int32()) ? o.iconPosition = s : delete o.iconPosition;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.PageLink) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.PageLink();
		if (e.page != null && (typeof e.page != "string" || e.page.length) && (n.page = String(e.page)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = String(e.icon)), e.pageScriptHash != null && (typeof e.pageScriptHash != "string" || e.pageScriptHash.length) && (n.pageScriptHash = String(e.pageScriptHash)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.useContainerWidth != null && (n.useContainerWidth = !!e.useContainerWidth), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.external != null && e.external && (n.external = !!e.external), e.queryString != null && (typeof e.queryString != "string" || e.queryString.length) && (n.queryString = String(e.queryString)), e.iconPosition !== 0 && (typeof e.iconPosition != "string" || N.streamlit.ButtonLikeIconPosition[e.iconPosition] !== 0)) switch (e.iconPosition) {
			default:
				if (typeof e.iconPosition == "number") {
					n.iconPosition = e.iconPosition;
					break;
				}
				break;
			case "LEFT":
			case 0:
				n.iconPosition = 0;
				break;
			case "RIGHT":
			case 1:
				n.iconPosition = 1;
				break;
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.page = "", r.label = "", r.icon = "", r.pageScriptHash = "", r.help = "", r.disabled = !1, r.external = !1, r.queryString = "", r.iconPosition = t.enums === String ? "LEFT" : 0), e.page != null && e.hasOwnProperty("page") && (r.page = e.page), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.icon != null && e.hasOwnProperty("icon") && (r.icon = e.icon), e.pageScriptHash != null && e.hasOwnProperty("pageScriptHash") && (r.pageScriptHash = e.pageScriptHash), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.useContainerWidth != null && e.hasOwnProperty("useContainerWidth") && (r.useContainerWidth = e.useContainerWidth), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.external != null && e.hasOwnProperty("external") && (r.external = e.external), e.queryString != null && e.hasOwnProperty("queryString") && (r.queryString = e.queryString), e.iconPosition != null && e.hasOwnProperty("iconPosition") && (r.iconPosition = t.enums === String ? N.streamlit.ButtonLikeIconPosition[e.iconPosition] === void 0 ? e.iconPosition : N.streamlit.ButtonLikeIconPosition[e.iconPosition] : e.iconPosition), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/PageLink";
	}, e;
})(), N.PlotlyChart = (() => {
	function e(e) {
		if (this.selectionMode = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.theme = "", e.prototype.id = "", e.prototype.selectionMode = M.emptyArray, e.prototype.formId = "", e.prototype.spec = "", e.prototype.config = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.theme != null && Object.hasOwnProperty.call(e, "theme") && t.uint32(50).string(e.theme), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(58).string(e.id), e.selectionMode != null && e.selectionMode.length) {
			t.uint32(66).fork();
			for (let n = 0; n < e.selectionMode.length; ++n) t.int32(e.selectionMode[n]);
			t.ldelim();
		}
		if (e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(74).string(e.formId), e.spec != null && Object.hasOwnProperty.call(e, "spec") && t.uint32(82).string(e.spec), e.config != null && Object.hasOwnProperty.call(e, "config") && t.uint32(90).string(e.config), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.PlotlyChart(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.theme = s : delete o.theme;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 8:
					if (a === 2) {
						o.selectionMode && o.selectionMode.length || (o.selectionMode = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.selectionMode.push(e.int32());
						continue;
					}
					if (a !== 0) break;
					o.selectionMode && o.selectionMode.length || (o.selectionMode = []), o.selectionMode.push(e.int32());
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.string()).length ? o.spec = s : delete o.spec;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.string()).length ? o.config = s : delete o.config;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.PlotlyChart) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.PlotlyChart();
		if (e.theme != null && (typeof e.theme != "string" || e.theme.length) && (n.theme = String(e.theme)), e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.selectionMode) {
			if (!Array.isArray(e.selectionMode)) throw TypeError(".PlotlyChart.selectionMode: array expected");
			n.selectionMode = Array(e.selectionMode.length);
			for (let t = 0; t < e.selectionMode.length; ++t) switch (e.selectionMode[t]) {
				default: if (typeof e.selectionMode[t] == "number") {
					n.selectionMode[t] = e.selectionMode[t];
					break;
				}
				case "POINTS":
				case 0:
					n.selectionMode[t] = 0;
					break;
				case "BOX":
				case 1:
					n.selectionMode[t] = 1;
					break;
				case "LASSO":
				case 2:
					n.selectionMode[t] = 2;
					break;
			}
		}
		return e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.spec != null && (typeof e.spec != "string" || e.spec.length) && (n.spec = String(e.spec)), e.config != null && (typeof e.config != "string" || e.config.length) && (n.config = String(e.config)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.selectionMode = []), t.defaults && (r.theme = "", r.id = "", r.formId = "", r.spec = "", r.config = ""), e.theme != null && e.hasOwnProperty("theme") && (r.theme = e.theme), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.selectionMode && e.selectionMode.length) {
			r.selectionMode = Array(e.selectionMode.length);
			for (let n = 0; n < e.selectionMode.length; ++n) r.selectionMode[n] = t.enums === String ? N.PlotlyChart.SelectionMode[e.selectionMode[n]] === void 0 ? e.selectionMode[n] : N.PlotlyChart.SelectionMode[e.selectionMode[n]] : e.selectionMode[n];
		}
		return e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.spec != null && e.hasOwnProperty("spec") && (r.spec = e.spec), e.config != null && e.hasOwnProperty("config") && (r.config = e.config), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/PlotlyChart";
	}, e.SelectionMode = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "POINTS"] = 0, t[e[1] = "BOX"] = 1, t[e[2] = "LASSO"] = 2, t;
	})(), e;
})(), N.Progress = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.value = 0, e.prototype.text = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(8).uint32(e.value), e.text != null && Object.hasOwnProperty.call(e, "text") && t.uint32(18).string(e.text), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Progress(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					(s = e.uint32()) ? o.value = s : delete o.value;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.text = s : delete o.text;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Progress) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Progress();
		return e.value != null && Number(e.value) !== 0 && (n.value = e.value >>> 0), e.text != null && (typeof e.text != "string" || e.text.length) && (n.text = String(e.text)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.value = 0, r.text = ""), e.value != null && e.hasOwnProperty("value") && (r.value = e.value), e.text != null && e.hasOwnProperty("text") && (r.text = e.text), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Progress";
	}, e;
})(), N.Radio = (() => {
	function e(e) {
		if (this.options = [], this.captions = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = null, e.prototype.options = M.emptyArray, e.prototype.help = "", e.prototype.formId = "", e.prototype.rawValue = null, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.horizontal = !1, e.prototype.labelVisibility = null, e.prototype.captions = M.emptyArray, e.prototype.queryParamKey = null;
	let t;
	return Object.defineProperty(e.prototype, "_default", {
		get: M.oneOfGetter(t = ["default"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_rawValue", {
		get: M.oneOfGetter(t = ["rawValue"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_queryParamKey", {
		get: M.oneOfGetter(t = ["queryParamKey"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.default != null && Object.hasOwnProperty.call(e, "default") && t.uint32(24).int32(e.default), e.options != null && e.options.length) for (let n = 0; n < e.options.length; ++n) t.uint32(34).string(e.options[n]);
		if (e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(42).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(50).string(e.formId), e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(64).bool(e.setValue), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(72).bool(e.disabled), e.horizontal != null && Object.hasOwnProperty.call(e, "horizontal") && t.uint32(80).bool(e.horizontal), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(90).fork(), n + 1).ldelim(), e.captions != null && e.captions.length) for (let n = 0; n < e.captions.length; ++n) t.uint32(98).string(e.captions[n]);
		if (e.rawValue != null && Object.hasOwnProperty.call(e, "rawValue") && t.uint32(106).string(e.rawValue), e.queryParamKey != null && Object.hasOwnProperty.call(e, "queryParamKey") && t.uint32(114).string(e.queryParamKey), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Radio(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 0) break;
					o.default = e.int32(), o._default = "default";
					continue;
				case 4:
					if (a !== 2) break;
					o.options && o.options.length || (o.options = []), o.options.push(e.string());
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 13:
					if (a !== 2) break;
					o.rawValue = e.string(), o._rawValue = "rawValue";
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.bool()) ? o.horizontal = s : delete o.horizontal;
					continue;
				case 11:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 12:
					if (a !== 2) break;
					o.captions && o.captions.length || (o.captions = []), o.captions.push(e.string());
					continue;
				case 14:
					if (a !== 2) break;
					o.queryParamKey = e.string(), o._queryParamKey = "queryParamKey";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Radio) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Radio();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.default != null && (n.default = e.default | 0), e.options) {
			if (!Array.isArray(e.options)) throw TypeError(".Radio.options: array expected");
			n.options = Array(e.options.length);
			for (let t = 0; t < e.options.length; ++t) n.options[t] = String(e.options[t]);
		}
		if (e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.rawValue != null && (n.rawValue = String(e.rawValue)), e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.horizontal != null && e.horizontal && (n.horizontal = !!e.horizontal), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".Radio.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.captions) {
			if (!Array.isArray(e.captions)) throw TypeError(".Radio.captions: array expected");
			n.captions = Array(e.captions.length);
			for (let t = 0; t < e.captions.length; ++t) n.captions[t] = String(e.captions[t]);
		}
		return e.queryParamKey != null && (n.queryParamKey = String(e.queryParamKey)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.options = [], r.captions = []), t.defaults && (r.id = "", r.label = "", r.help = "", r.formId = "", r.setValue = !1, r.disabled = !1, r.horizontal = !1, r.labelVisibility = null), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.default != null && e.hasOwnProperty("default") && (r.default = e.default), e.options && e.options.length) {
			r.options = Array(e.options.length);
			for (let t = 0; t < e.options.length; ++t) r.options[t] = e.options[t];
		}
		if (e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.horizontal != null && e.hasOwnProperty("horizontal") && (r.horizontal = e.horizontal), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.captions && e.captions.length) {
			r.captions = Array(e.captions.length);
			for (let t = 0; t < e.captions.length; ++t) r.captions[t] = e.captions[t];
		}
		return e.rawValue != null && e.hasOwnProperty("rawValue") && (r.rawValue = e.rawValue), e.queryParamKey != null && e.hasOwnProperty("queryParamKey") && (r.queryParamKey = e.queryParamKey), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Radio";
	}, e;
})(), N.Selectbox = (() => {
	function e(e) {
		if (this.options = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = null, e.prototype.options = M.emptyArray, e.prototype.help = "", e.prototype.formId = "", e.prototype.rawValue = null, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.placeholder = "", e.prototype.acceptNewOptions = null, e.prototype.queryParamKey = null, e.prototype.filterMode = 0;
	let t;
	return Object.defineProperty(e.prototype, "_default", {
		get: M.oneOfGetter(t = ["default"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_rawValue", {
		get: M.oneOfGetter(t = ["rawValue"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_acceptNewOptions", {
		get: M.oneOfGetter(t = ["acceptNewOptions"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_queryParamKey", {
		get: M.oneOfGetter(t = ["queryParamKey"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.default != null && Object.hasOwnProperty.call(e, "default") && t.uint32(24).int32(e.default), e.options != null && e.options.length) for (let n = 0; n < e.options.length; ++n) t.uint32(34).string(e.options[n]);
		if (e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(42).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(50).string(e.formId), e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(64).bool(e.setValue), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(72).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(82).fork(), n + 1).ldelim(), e.placeholder != null && Object.hasOwnProperty.call(e, "placeholder") && t.uint32(90).string(e.placeholder), e.acceptNewOptions != null && Object.hasOwnProperty.call(e, "acceptNewOptions") && t.uint32(96).bool(e.acceptNewOptions), e.rawValue != null && Object.hasOwnProperty.call(e, "rawValue") && t.uint32(106).string(e.rawValue), e.queryParamKey != null && Object.hasOwnProperty.call(e, "queryParamKey") && t.uint32(114).string(e.queryParamKey), e.filterMode != null && Object.hasOwnProperty.call(e, "filterMode") && t.uint32(120).int32(e.filterMode), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Selectbox(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 0) break;
					o.default = e.int32(), o._default = "default";
					continue;
				case 4:
					if (a !== 2) break;
					o.options && o.options.length || (o.options = []), o.options.push(e.string());
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 13:
					if (a !== 2) break;
					o.rawValue = e.string(), o._rawValue = "rawValue";
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 10:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.string()).length ? o.placeholder = s : delete o.placeholder;
					continue;
				case 12:
					if (a !== 0) break;
					o.acceptNewOptions = e.bool(), o._acceptNewOptions = "acceptNewOptions";
					continue;
				case 14:
					if (a !== 2) break;
					o.queryParamKey = e.string(), o._queryParamKey = "queryParamKey";
					continue;
				case 15:
					if (a !== 0) break;
					(s = e.int32()) ? o.filterMode = s : delete o.filterMode;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Selectbox) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Selectbox();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.default != null && (n.default = e.default | 0), e.options) {
			if (!Array.isArray(e.options)) throw TypeError(".Selectbox.options: array expected");
			n.options = Array(e.options.length);
			for (let t = 0; t < e.options.length; ++t) n.options[t] = String(e.options[t]);
		}
		if (e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.rawValue != null && (n.rawValue = String(e.rawValue)), e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".Selectbox.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.placeholder != null && (typeof e.placeholder != "string" || e.placeholder.length) && (n.placeholder = String(e.placeholder)), e.acceptNewOptions != null && (n.acceptNewOptions = !!e.acceptNewOptions), e.queryParamKey != null && (n.queryParamKey = String(e.queryParamKey)), e.filterMode !== 0 && (typeof e.filterMode != "string" || N.streamlit.SelectWidgetFilterMode[e.filterMode] !== 0)) switch (e.filterMode) {
			default:
				if (typeof e.filterMode == "number") {
					n.filterMode = e.filterMode;
					break;
				}
				break;
			case "FILTER_MODE_FUZZY":
			case 0:
				n.filterMode = 0;
				break;
			case "FILTER_MODE_CONTAINS":
			case 1:
				n.filterMode = 1;
				break;
			case "FILTER_MODE_PREFIX":
			case 2:
				n.filterMode = 2;
				break;
			case "FILTER_MODE_NONE":
			case 3:
				n.filterMode = 3;
				break;
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.options = []), t.defaults && (r.id = "", r.label = "", r.help = "", r.formId = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null, r.placeholder = "", r.filterMode = t.enums === String ? "FILTER_MODE_FUZZY" : 0), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.default != null && e.hasOwnProperty("default") && (r.default = e.default), e.options && e.options.length) {
			r.options = Array(e.options.length);
			for (let t = 0; t < e.options.length; ++t) r.options[t] = e.options[t];
		}
		return e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.placeholder != null && e.hasOwnProperty("placeholder") && (r.placeholder = e.placeholder), e.acceptNewOptions != null && e.hasOwnProperty("acceptNewOptions") && (r.acceptNewOptions = e.acceptNewOptions), e.rawValue != null && e.hasOwnProperty("rawValue") && (r.rawValue = e.rawValue), e.queryParamKey != null && e.hasOwnProperty("queryParamKey") && (r.queryParamKey = e.queryParamKey), e.filterMode != null && e.hasOwnProperty("filterMode") && (r.filterMode = t.enums === String ? N.streamlit.SelectWidgetFilterMode[e.filterMode] === void 0 ? e.filterMode : N.streamlit.SelectWidgetFilterMode[e.filterMode] : e.filterMode), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Selectbox";
	}, e;
})(), N.Skeleton = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.style = 0, e.prototype.height = null;
	let t;
	return Object.defineProperty(e.prototype, "_height", {
		get: M.oneOfGetter(t = ["height"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.style != null && Object.hasOwnProperty.call(e, "style") && t.uint32(8).int32(e.style), e.height != null && Object.hasOwnProperty.call(e, "height") && t.uint32(16).int32(e.height), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Skeleton(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					(s = e.int32()) ? o.style = s : delete o.style;
					continue;
				case 2:
					if (a !== 0) break;
					o.height = e.int32(), o._height = "height";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Skeleton) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Skeleton();
		if (e.style !== 0 && (typeof e.style != "string" || N.Skeleton.SkeletonStyle[e.style] !== 0)) switch (e.style) {
			default:
				if (typeof e.style == "number") {
					n.style = e.style;
					break;
				}
				break;
			case "ELEMENT":
			case 0:
				n.style = 0;
				break;
			case "APP":
			case 1:
				n.style = 1;
				break;
		}
		return e.height != null && (n.height = e.height | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.style = t.enums === String ? "ELEMENT" : 0), e.style != null && e.hasOwnProperty("style") && (r.style = t.enums === String ? N.Skeleton.SkeletonStyle[e.style] === void 0 ? e.style : N.Skeleton.SkeletonStyle[e.style] : e.style), e.height != null && e.hasOwnProperty("height") && (r.height = e.height), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Skeleton";
	}, e.SkeletonStyle = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "ELEMENT"] = 0, t[e[1] = "APP"] = 1, t;
	})(), e;
})(), N.Slider = (() => {
	function e(e) {
		if (this.default = [], this.value = [], this.options = [], this.rawValue = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.formId = "", e.prototype.label = "", e.prototype.format = "", e.prototype.dataType = 0, e.prototype.default = M.emptyArray, e.prototype.min = 0, e.prototype.max = 0, e.prototype.step = 0, e.prototype.value = M.emptyArray, e.prototype.setValue = !1, e.prototype.options = M.emptyArray, e.prototype.help = "", e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.type = 0, e.prototype.rawValue = M.emptyArray, e.prototype.queryParamKey = null;
	let t;
	return Object.defineProperty(e.prototype, "_queryParamKey", {
		get: M.oneOfGetter(t = ["queryParamKey"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(18).string(e.formId), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(26).string(e.label), e.format != null && Object.hasOwnProperty.call(e, "format") && t.uint32(34).string(e.format), e.dataType != null && Object.hasOwnProperty.call(e, "dataType") && t.uint32(40).int32(e.dataType), e.default != null && e.default.length) {
			t.uint32(50).fork();
			for (let n = 0; n < e.default.length; ++n) t.double(e.default[n]);
			t.ldelim();
		}
		if (e.min != null && Object.hasOwnProperty.call(e, "min") && t.uint32(57).double(e.min), e.max != null && Object.hasOwnProperty.call(e, "max") && t.uint32(65).double(e.max), e.step != null && Object.hasOwnProperty.call(e, "step") && t.uint32(73).double(e.step), e.value != null && e.value.length) {
			t.uint32(82).fork();
			for (let n = 0; n < e.value.length; ++n) t.double(e.value[n]);
			t.ldelim();
		}
		if (e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(88).bool(e.setValue), e.options != null && e.options.length) for (let n = 0; n < e.options.length; ++n) t.uint32(106).string(e.options[n]);
		if (e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(114).string(e.help), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(120).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(130).fork(), n + 1).ldelim(), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(136).int32(e.type), e.rawValue != null && e.rawValue.length) for (let n = 0; n < e.rawValue.length; ++n) t.uint32(146).string(e.rawValue[n]);
		if (e.queryParamKey != null && Object.hasOwnProperty.call(e, "queryParamKey") && t.uint32(154).string(e.queryParamKey), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Slider(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.format = s : delete o.format;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.int32()) ? o.dataType = s : delete o.dataType;
					continue;
				case 6:
					if (a === 2) {
						o.default && o.default.length || (o.default = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.default.push(e.double());
						continue;
					}
					if (a !== 1) break;
					o.default && o.default.length || (o.default = []), o.default.push(e.double());
					continue;
				case 7:
					if (a !== 1) break;
					(s = e.double()) === 0 ? delete o.min : o.min = s;
					continue;
				case 8:
					if (a !== 1) break;
					(s = e.double()) === 0 ? delete o.max : o.max = s;
					continue;
				case 9:
					if (a !== 1) break;
					(s = e.double()) === 0 ? delete o.step : o.step = s;
					continue;
				case 10:
					if (a === 2) {
						o.value && o.value.length || (o.value = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.value.push(e.double());
						continue;
					}
					if (a !== 1) break;
					o.value && o.value.length || (o.value = []), o.value.push(e.double());
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 13:
					if (a !== 2) break;
					o.options && o.options.length || (o.options = []), o.options.push(e.string());
					continue;
				case 14:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 15:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 16:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 17:
					if (a !== 0) break;
					(s = e.int32()) ? o.type = s : delete o.type;
					continue;
				case 18:
					if (a !== 2) break;
					o.rawValue && o.rawValue.length || (o.rawValue = []), o.rawValue.push(e.string());
					continue;
				case 19:
					if (a !== 2) break;
					o.queryParamKey = e.string(), o._queryParamKey = "queryParamKey";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Slider) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Slider();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.format != null && (typeof e.format != "string" || e.format.length) && (n.format = String(e.format)), e.dataType !== 0 && (typeof e.dataType != "string" || N.Slider.DataType[e.dataType] !== 0)) switch (e.dataType) {
			default:
				if (typeof e.dataType == "number") {
					n.dataType = e.dataType;
					break;
				}
				break;
			case "INT":
			case 0:
				n.dataType = 0;
				break;
			case "FLOAT":
			case 1:
				n.dataType = 1;
				break;
			case "DATETIME":
			case 2:
				n.dataType = 2;
				break;
			case "DATE":
			case 3:
				n.dataType = 3;
				break;
			case "TIME":
			case 4:
				n.dataType = 4;
				break;
		}
		if (e.default) {
			if (!Array.isArray(e.default)) throw TypeError(".Slider.default: array expected");
			n.default = Array(e.default.length);
			for (let t = 0; t < e.default.length; ++t) n.default[t] = Number(e.default[t]);
		}
		if (e.min != null && Number(e.min) !== 0 && (n.min = Number(e.min)), e.max != null && Number(e.max) !== 0 && (n.max = Number(e.max)), e.step != null && Number(e.step) !== 0 && (n.step = Number(e.step)), e.value) {
			if (!Array.isArray(e.value)) throw TypeError(".Slider.value: array expected");
			n.value = Array(e.value.length);
			for (let t = 0; t < e.value.length; ++t) n.value[t] = Number(e.value[t]);
		}
		if (e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.options) {
			if (!Array.isArray(e.options)) throw TypeError(".Slider.options: array expected");
			n.options = Array(e.options.length);
			for (let t = 0; t < e.options.length; ++t) n.options[t] = String(e.options[t]);
		}
		if (e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".Slider.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.type !== 0 && (typeof e.type != "string" || N.Slider.Type[e.type] !== 0)) switch (e.type) {
			default:
				if (typeof e.type == "number") {
					n.type = e.type;
					break;
				}
				break;
			case "UNSPECIFIED":
			case 0:
				n.type = 0;
				break;
			case "SLIDER":
			case 1:
				n.type = 1;
				break;
			case "SELECT_SLIDER":
			case 2:
				n.type = 2;
				break;
		}
		if (e.rawValue) {
			if (!Array.isArray(e.rawValue)) throw TypeError(".Slider.rawValue: array expected");
			n.rawValue = Array(e.rawValue.length);
			for (let t = 0; t < e.rawValue.length; ++t) n.rawValue[t] = String(e.rawValue[t]);
		}
		return e.queryParamKey != null && (n.queryParamKey = String(e.queryParamKey)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.default = [], r.value = [], r.options = [], r.rawValue = []), t.defaults && (r.id = "", r.formId = "", r.label = "", r.format = "", r.dataType = t.enums === String ? "INT" : 0, r.min = 0, r.max = 0, r.step = 0, r.setValue = !1, r.help = "", r.disabled = !1, r.labelVisibility = null, r.type = t.enums === String ? "UNSPECIFIED" : 0), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.format != null && e.hasOwnProperty("format") && (r.format = e.format), e.dataType != null && e.hasOwnProperty("dataType") && (r.dataType = t.enums === String ? N.Slider.DataType[e.dataType] === void 0 ? e.dataType : N.Slider.DataType[e.dataType] : e.dataType), e.default && e.default.length) {
			r.default = Array(e.default.length);
			for (let n = 0; n < e.default.length; ++n) r.default[n] = t.json && !isFinite(e.default[n]) ? String(e.default[n]) : e.default[n];
		}
		if (e.min != null && e.hasOwnProperty("min") && (r.min = t.json && !isFinite(e.min) ? String(e.min) : e.min), e.max != null && e.hasOwnProperty("max") && (r.max = t.json && !isFinite(e.max) ? String(e.max) : e.max), e.step != null && e.hasOwnProperty("step") && (r.step = t.json && !isFinite(e.step) ? String(e.step) : e.step), e.value && e.value.length) {
			r.value = Array(e.value.length);
			for (let n = 0; n < e.value.length; ++n) r.value[n] = t.json && !isFinite(e.value[n]) ? String(e.value[n]) : e.value[n];
		}
		if (e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.options && e.options.length) {
			r.options = Array(e.options.length);
			for (let t = 0; t < e.options.length; ++t) r.options[t] = e.options[t];
		}
		if (e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.type != null && e.hasOwnProperty("type") && (r.type = t.enums === String ? N.Slider.Type[e.type] === void 0 ? e.type : N.Slider.Type[e.type] : e.type), e.rawValue && e.rawValue.length) {
			r.rawValue = Array(e.rawValue.length);
			for (let t = 0; t < e.rawValue.length; ++t) r.rawValue[t] = e.rawValue[t];
		}
		return e.queryParamKey != null && e.hasOwnProperty("queryParamKey") && (r.queryParamKey = e.queryParamKey), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Slider";
	}, e.DataType = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "INT"] = 0, t[e[1] = "FLOAT"] = 1, t[e[2] = "DATETIME"] = 2, t[e[3] = "DATE"] = 3, t[e[4] = "TIME"] = 4, t;
	})(), e.Type = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "UNSPECIFIED"] = 0, t[e[1] = "SLIDER"] = 1, t[e[2] = "SELECT_SLIDER"] = 2, t;
	})(), e;
})(), N.Snow = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.show = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.show != null && Object.hasOwnProperty.call(e, "show") && t.uint32(8).bool(e.show), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Snow(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					(s = e.bool()) ? o.show = s : delete o.show;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Snow) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Snow();
		return e.show != null && e.show && (n.show = !!e.show), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.show = !1), e.show != null && e.hasOwnProperty("show") && (r.show = e.show), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Snow";
	}, e;
})(), N.Space = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Space();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			e.skipType(i & 7, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Space) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		return new N.Space();
	}, e.toObject = function() {
		return {};
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Space";
	}, e;
})(), N.Spinner = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.text = "", e.prototype.cache = !1, e.prototype.showTime = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.text != null && Object.hasOwnProperty.call(e, "text") && t.uint32(10).string(e.text), e.cache != null && Object.hasOwnProperty.call(e, "cache") && t.uint32(16).bool(e.cache), e.showTime != null && Object.hasOwnProperty.call(e, "showTime") && t.uint32(24).bool(e.showTime), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Spinner(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.text = s : delete o.text;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.bool()) ? o.cache = s : delete o.cache;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.showTime = s : delete o.showTime;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Spinner) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Spinner();
		return e.text != null && (typeof e.text != "string" || e.text.length) && (n.text = String(e.text)), e.cache != null && e.cache && (n.cache = !!e.cache), e.showTime != null && e.showTime && (n.showTime = !!e.showTime), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.text = "", r.cache = !1, r.showTime = !1), e.text != null && e.hasOwnProperty("text") && (r.text = e.text), e.cache != null && e.hasOwnProperty("cache") && (r.cache = e.cache), e.showTime != null && e.hasOwnProperty("showTime") && (r.showTime = e.showTime), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Spinner";
	}, e;
})(), N.Table = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.arrowData = null, e.prototype.borderMode = 0, e.prototype.hideIndex = !1, e.prototype.hideHeader = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.arrowData != null && Object.hasOwnProperty.call(e, "arrowData") && N.ArrowData.encode(e.arrowData, t.uint32(10).fork(), n + 1).ldelim(), e.borderMode != null && Object.hasOwnProperty.call(e, "borderMode") && t.uint32(16).int32(e.borderMode), e.hideIndex != null && Object.hasOwnProperty.call(e, "hideIndex") && t.uint32(24).bool(e.hideIndex), e.hideHeader != null && Object.hasOwnProperty.call(e, "hideHeader") && t.uint32(32).bool(e.hideHeader), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Table(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.arrowData = N.ArrowData.decode(e, e.uint32(), void 0, r + 1, o.arrowData);
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.int32()) ? o.borderMode = s : delete o.borderMode;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.hideIndex = s : delete o.hideIndex;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.hideHeader = s : delete o.hideHeader;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Table) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Table();
		if (e.arrowData != null) {
			if (typeof e.arrowData != "object") throw TypeError(".Table.arrowData: object expected");
			n.arrowData = N.ArrowData.fromObject(e.arrowData, t + 1);
		}
		if (e.borderMode !== 0 && (typeof e.borderMode != "string" || N.Table.BorderMode[e.borderMode] !== 0)) switch (e.borderMode) {
			default:
				if (typeof e.borderMode == "number") {
					n.borderMode = e.borderMode;
					break;
				}
				break;
			case "ALL":
			case 0:
				n.borderMode = 0;
				break;
			case "NONE":
			case 1:
				n.borderMode = 1;
				break;
			case "HORIZONTAL":
			case 2:
				n.borderMode = 2;
				break;
		}
		return e.hideIndex != null && e.hideIndex && (n.hideIndex = !!e.hideIndex), e.hideHeader != null && e.hideHeader && (n.hideHeader = !!e.hideHeader), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.arrowData = null, r.borderMode = t.enums === String ? "ALL" : 0, r.hideIndex = !1, r.hideHeader = !1), e.arrowData != null && e.hasOwnProperty("arrowData") && (r.arrowData = N.ArrowData.toObject(e.arrowData, t, n + 1)), e.borderMode != null && e.hasOwnProperty("borderMode") && (r.borderMode = t.enums === String ? N.Table.BorderMode[e.borderMode] === void 0 ? e.borderMode : N.Table.BorderMode[e.borderMode] : e.borderMode), e.hideIndex != null && e.hasOwnProperty("hideIndex") && (r.hideIndex = e.hideIndex), e.hideHeader != null && e.hasOwnProperty("hideHeader") && (r.hideHeader = e.hideHeader), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Table";
	}, e.BorderMode = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "ALL"] = 0, t[e[1] = "NONE"] = 1, t[e[2] = "HORIZONTAL"] = 2, t;
	})(), e;
})(), N.Text = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.body = "", e.prototype.help = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.body != null && Object.hasOwnProperty.call(e, "body") && t.uint32(10).string(e.body), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(18).string(e.help), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Text(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.body = s : delete o.body;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Text) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Text();
		return e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = String(e.body)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.body = "", r.help = ""), e.body != null && e.hasOwnProperty("body") && (r.body = e.body), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Text";
	}, e;
})(), N.TextArea = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = null, e.prototype.maxChars = 0, e.prototype.help = "", e.prototype.formId = "", e.prototype.value = null, e.prototype.setValue = !1, e.prototype.placeholder = "", e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.queryParamKey = null;
	let t;
	return Object.defineProperty(e.prototype, "_default", {
		get: M.oneOfGetter(t = ["default"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_value", {
		get: M.oneOfGetter(t = ["value"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_queryParamKey", {
		get: M.oneOfGetter(t = ["queryParamKey"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.default != null && Object.hasOwnProperty.call(e, "default") && t.uint32(26).string(e.default), e.maxChars != null && Object.hasOwnProperty.call(e, "maxChars") && t.uint32(40).uint32(e.maxChars), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(50).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(58).string(e.formId), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(66).string(e.value), e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(72).bool(e.setValue), e.placeholder != null && Object.hasOwnProperty.call(e, "placeholder") && t.uint32(82).string(e.placeholder), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(88).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(98).fork(), n + 1).ldelim(), e.queryParamKey != null && Object.hasOwnProperty.call(e, "queryParamKey") && t.uint32(106).string(e.queryParamKey), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.TextArea(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.default = e.string(), o._default = "default";
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.uint32()) ? o.maxChars = s : delete o.maxChars;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 8:
					if (a !== 2) break;
					o.value = e.string(), o._value = "value";
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.string()).length ? o.placeholder = s : delete o.placeholder;
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 12:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 13:
					if (a !== 2) break;
					o.queryParamKey = e.string(), o._queryParamKey = "queryParamKey";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.TextArea) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.TextArea();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.default != null && (n.default = String(e.default)), e.maxChars != null && Number(e.maxChars) !== 0 && (n.maxChars = e.maxChars >>> 0), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.value != null && (n.value = String(e.value)), e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.placeholder != null && (typeof e.placeholder != "string" || e.placeholder.length) && (n.placeholder = String(e.placeholder)), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".TextArea.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.queryParamKey != null && (n.queryParamKey = String(e.queryParamKey)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.maxChars = 0, r.help = "", r.formId = "", r.setValue = !1, r.placeholder = "", r.disabled = !1, r.labelVisibility = null), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.default != null && e.hasOwnProperty("default") && (r.default = e.default), e.maxChars != null && e.hasOwnProperty("maxChars") && (r.maxChars = e.maxChars), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.value != null && e.hasOwnProperty("value") && (r.value = e.value), e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.placeholder != null && e.hasOwnProperty("placeholder") && (r.placeholder = e.placeholder), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.queryParamKey != null && e.hasOwnProperty("queryParamKey") && (r.queryParamKey = e.queryParamKey), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/TextArea";
	}, e;
})(), N.TextInput = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = null, e.prototype.type = 0, e.prototype.maxChars = 0, e.prototype.help = "", e.prototype.formId = "", e.prototype.value = null, e.prototype.setValue = !1, e.prototype.autocomplete = "", e.prototype.placeholder = "", e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.icon = "", e.prototype.queryParamKey = null;
	let t;
	return Object.defineProperty(e.prototype, "_default", {
		get: M.oneOfGetter(t = ["default"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_value", {
		get: M.oneOfGetter(t = ["value"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_queryParamKey", {
		get: M.oneOfGetter(t = ["queryParamKey"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.default != null && Object.hasOwnProperty.call(e, "default") && t.uint32(26).string(e.default), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(32).int32(e.type), e.maxChars != null && Object.hasOwnProperty.call(e, "maxChars") && t.uint32(40).uint32(e.maxChars), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(50).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(58).string(e.formId), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(66).string(e.value), e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(72).bool(e.setValue), e.autocomplete != null && Object.hasOwnProperty.call(e, "autocomplete") && t.uint32(82).string(e.autocomplete), e.placeholder != null && Object.hasOwnProperty.call(e, "placeholder") && t.uint32(90).string(e.placeholder), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(96).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(106).fork(), n + 1).ldelim(), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(114).string(e.icon), e.queryParamKey != null && Object.hasOwnProperty.call(e, "queryParamKey") && t.uint32(122).string(e.queryParamKey), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.TextInput(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.default = e.string(), o._default = "default";
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.int32()) ? o.type = s : delete o.type;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.uint32()) ? o.maxChars = s : delete o.maxChars;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 8:
					if (a !== 2) break;
					o.value = e.string(), o._value = "value";
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.string()).length ? o.autocomplete = s : delete o.autocomplete;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.string()).length ? o.placeholder = s : delete o.placeholder;
					continue;
				case 12:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 13:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 14:
					if (a !== 2) break;
					(s = e.string()).length ? o.icon = s : delete o.icon;
					continue;
				case 15:
					if (a !== 2) break;
					o.queryParamKey = e.string(), o._queryParamKey = "queryParamKey";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.TextInput) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.TextInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.default != null && (n.default = String(e.default)), e.type !== 0 && (typeof e.type != "string" || N.TextInput.Type[e.type] !== 0)) switch (e.type) {
			default:
				if (typeof e.type == "number") {
					n.type = e.type;
					break;
				}
				break;
			case "DEFAULT":
			case 0:
				n.type = 0;
				break;
			case "PASSWORD":
			case 1:
				n.type = 1;
				break;
		}
		if (e.maxChars != null && Number(e.maxChars) !== 0 && (n.maxChars = e.maxChars >>> 0), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.value != null && (n.value = String(e.value)), e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.autocomplete != null && (typeof e.autocomplete != "string" || e.autocomplete.length) && (n.autocomplete = String(e.autocomplete)), e.placeholder != null && (typeof e.placeholder != "string" || e.placeholder.length) && (n.placeholder = String(e.placeholder)), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".TextInput.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = String(e.icon)), e.queryParamKey != null && (n.queryParamKey = String(e.queryParamKey)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.type = t.enums === String ? "DEFAULT" : 0, r.maxChars = 0, r.help = "", r.formId = "", r.setValue = !1, r.autocomplete = "", r.placeholder = "", r.disabled = !1, r.labelVisibility = null, r.icon = ""), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.default != null && e.hasOwnProperty("default") && (r.default = e.default), e.type != null && e.hasOwnProperty("type") && (r.type = t.enums === String ? N.TextInput.Type[e.type] === void 0 ? e.type : N.TextInput.Type[e.type] : e.type), e.maxChars != null && e.hasOwnProperty("maxChars") && (r.maxChars = e.maxChars), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.value != null && e.hasOwnProperty("value") && (r.value = e.value), e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.autocomplete != null && e.hasOwnProperty("autocomplete") && (r.autocomplete = e.autocomplete), e.placeholder != null && e.hasOwnProperty("placeholder") && (r.placeholder = e.placeholder), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.icon != null && e.hasOwnProperty("icon") && (r.icon = e.icon), e.queryParamKey != null && e.hasOwnProperty("queryParamKey") && (r.queryParamKey = e.queryParamKey), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/TextInput";
	}, e.Type = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "DEFAULT"] = 0, t[e[1] = "PASSWORD"] = 1, t;
	})(), e;
})(), N.TimeInput = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = null, e.prototype.help = "", e.prototype.formId = "", e.prototype.value = null, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.step = M.Long ? M.Long.fromBits(0, 0, !1) : 0, e.prototype.queryParamKey = null;
	let t;
	return Object.defineProperty(e.prototype, "_default", {
		get: M.oneOfGetter(t = ["default"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_value", {
		get: M.oneOfGetter(t = ["value"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_queryParamKey", {
		get: M.oneOfGetter(t = ["queryParamKey"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(10).string(e.id), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(18).string(e.label), e.default != null && Object.hasOwnProperty.call(e, "default") && t.uint32(26).string(e.default), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(34).string(e.help), e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(42).string(e.formId), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(50).string(e.value), e.setValue != null && Object.hasOwnProperty.call(e, "setValue") && t.uint32(56).bool(e.setValue), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && t.uint32(64).bool(e.disabled), e.labelVisibility != null && Object.hasOwnProperty.call(e, "labelVisibility") && N.LabelVisibility.encode(e.labelVisibility, t.uint32(74).fork(), n + 1).ldelim(), e.step != null && Object.hasOwnProperty.call(e, "step") && t.uint32(80).int64(e.step), e.queryParamKey != null && Object.hasOwnProperty.call(e, "queryParamKey") && t.uint32(90).string(e.queryParamKey), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.TimeInput(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.default = e.string(), o._default = "default";
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 2) break;
					o.value = e.string(), o._value = "value";
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 9:
					if (a !== 2) break;
					o.labelVisibility = N.LabelVisibility.decode(e, e.uint32(), void 0, r + 1, o.labelVisibility);
					continue;
				case 10:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.step = s : delete o.step;
					continue;
				case 11:
					if (a !== 2) break;
					o.queryParamKey = e.string(), o._queryParamKey = "queryParamKey";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.TimeInput) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.TimeInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.default != null && (n.default = String(e.default)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), e.value != null && (n.value = String(e.value)), e.setValue != null && e.setValue && (n.setValue = !!e.setValue), e.disabled != null && e.disabled && (n.disabled = !!e.disabled), e.labelVisibility != null) {
			if (typeof e.labelVisibility != "object") throw TypeError(".TimeInput.labelVisibility: object expected");
			n.labelVisibility = N.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.step != null && (typeof e.step == "object" ? e.step.low || e.step.high : Number(e.step) !== 0) && (M.Long ? n.step = M.Long.fromValue(e.step, !1) : typeof e.step == "string" ? n.step = parseInt(e.step, 10) : typeof e.step == "number" ? n.step = e.step : typeof e.step == "object" && (n.step = new M.LongBits(e.step.low >>> 0, e.step.high >>> 0).toNumber())), e.queryParamKey != null && (n.queryParamKey = String(e.queryParamKey)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if (t.defaults) if (r.id = "", r.label = "", r.help = "", r.formId = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null, M.Long) {
			let e = new M.Long(0, 0, !1);
			r.step = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
		} else r.step = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
		return e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.default != null && e.hasOwnProperty("default") && (r.default = e.default), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), e.value != null && e.hasOwnProperty("value") && (r.value = e.value), e.setValue != null && e.hasOwnProperty("setValue") && (r.setValue = e.setValue), e.disabled != null && e.hasOwnProperty("disabled") && (r.disabled = e.disabled), e.labelVisibility != null && e.hasOwnProperty("labelVisibility") && (r.labelVisibility = N.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.step != null && e.hasOwnProperty("step") && (typeof BigInt < "u" && t.longs === BigInt ? r.step = typeof e.step == "number" ? BigInt(e.step) : M.Long.fromBits(e.step.low >>> 0, e.step.high >>> 0, !1).toBigInt() : typeof e.step == "number" ? r.step = t.longs === String ? String(e.step) : e.step : r.step = t.longs === String ? M.Long.prototype.toString.call(e.step) : t.longs === Number ? new M.LongBits(e.step.low >>> 0, e.step.high >>> 0).toNumber() : e.step), e.queryParamKey != null && e.hasOwnProperty("queryParamKey") && (r.queryParamKey = e.queryParamKey), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/TimeInput";
	}, e;
})(), N.Toast = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.body = "", e.prototype.icon = "", e.prototype.duration = null;
	let t;
	return Object.defineProperty(e.prototype, "_duration", {
		get: M.oneOfGetter(t = ["duration"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.body != null && Object.hasOwnProperty.call(e, "body") && t.uint32(10).string(e.body), e.icon != null && Object.hasOwnProperty.call(e, "icon") && t.uint32(18).string(e.icon), e.duration != null && Object.hasOwnProperty.call(e, "duration") && t.uint32(24).int32(e.duration), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Toast(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.body = s : delete o.body;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.icon = s : delete o.icon;
					continue;
				case 3:
					if (a !== 0) break;
					o.duration = e.int32(), o._duration = "duration";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Toast) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Toast();
		return e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = String(e.body)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = String(e.icon)), e.duration != null && (n.duration = e.duration | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.body = "", r.icon = ""), e.body != null && e.hasOwnProperty("body") && (r.body = e.body), e.icon != null && e.hasOwnProperty("icon") && (r.icon = e.icon), e.duration != null && e.hasOwnProperty("duration") && (r.duration = e.duration), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Toast";
	}, e;
})(), N.VegaLiteChart = (() => {
	function e(e) {
		if (this.datasets = [], this.selectionMode = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.spec = "", e.prototype.data = null, e.prototype.datasets = M.emptyArray, e.prototype.useContainerWidth = !1, e.prototype.theme = "", e.prototype.id = "", e.prototype.selectionMode = M.emptyArray, e.prototype.formId = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.spec != null && Object.hasOwnProperty.call(e, "spec") && t.uint32(10).string(e.spec), e.data != null && Object.hasOwnProperty.call(e, "data") && N.ArrowData.encode(e.data, t.uint32(18).fork(), n + 1).ldelim(), e.datasets != null && e.datasets.length) for (let r = 0; r < e.datasets.length; ++r) N.ArrowNamedDataSet.encode(e.datasets[r], t.uint32(34).fork(), n + 1).ldelim();
		if (e.useContainerWidth != null && Object.hasOwnProperty.call(e, "useContainerWidth") && t.uint32(40).bool(e.useContainerWidth), e.theme != null && Object.hasOwnProperty.call(e, "theme") && t.uint32(50).string(e.theme), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(58).string(e.id), e.selectionMode != null && e.selectionMode.length) for (let n = 0; n < e.selectionMode.length; ++n) t.uint32(66).string(e.selectionMode[n]);
		if (e.formId != null && Object.hasOwnProperty.call(e, "formId") && t.uint32(74).string(e.formId), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.VegaLiteChart(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.spec = s : delete o.spec;
					continue;
				case 2:
					if (a !== 2) break;
					o.data = N.ArrowData.decode(e, e.uint32(), void 0, r + 1, o.data);
					continue;
				case 4:
					if (a !== 2) break;
					o.datasets && o.datasets.length || (o.datasets = []), o.datasets.push(N.ArrowNamedDataSet.decode(e, e.uint32(), void 0, r + 1));
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.useContainerWidth = s : delete o.useContainerWidth;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.theme = s : delete o.theme;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 8:
					if (a !== 2) break;
					o.selectionMode && o.selectionMode.length || (o.selectionMode = []), o.selectionMode.push(e.string());
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.string()).length ? o.formId = s : delete o.formId;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.VegaLiteChart) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.VegaLiteChart();
		if (e.spec != null && (typeof e.spec != "string" || e.spec.length) && (n.spec = String(e.spec)), e.data != null) {
			if (typeof e.data != "object") throw TypeError(".VegaLiteChart.data: object expected");
			n.data = N.ArrowData.fromObject(e.data, t + 1);
		}
		if (e.datasets) {
			if (!Array.isArray(e.datasets)) throw TypeError(".VegaLiteChart.datasets: array expected");
			n.datasets = Array(e.datasets.length);
			for (let r = 0; r < e.datasets.length; ++r) {
				if (typeof e.datasets[r] != "object") throw TypeError(".VegaLiteChart.datasets: object expected");
				n.datasets[r] = N.ArrowNamedDataSet.fromObject(e.datasets[r], t + 1);
			}
		}
		if (e.useContainerWidth != null && e.useContainerWidth && (n.useContainerWidth = !!e.useContainerWidth), e.theme != null && (typeof e.theme != "string" || e.theme.length) && (n.theme = String(e.theme)), e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.selectionMode) {
			if (!Array.isArray(e.selectionMode)) throw TypeError(".VegaLiteChart.selectionMode: array expected");
			n.selectionMode = Array(e.selectionMode.length);
			for (let t = 0; t < e.selectionMode.length; ++t) n.selectionMode[t] = String(e.selectionMode[t]);
		}
		return e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = String(e.formId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.datasets = [], r.selectionMode = []), t.defaults && (r.spec = "", r.data = null, r.useContainerWidth = !1, r.theme = "", r.id = "", r.formId = ""), e.spec != null && e.hasOwnProperty("spec") && (r.spec = e.spec), e.data != null && e.hasOwnProperty("data") && (r.data = N.ArrowData.toObject(e.data, t, n + 1)), e.datasets && e.datasets.length) {
			r.datasets = Array(e.datasets.length);
			for (let i = 0; i < e.datasets.length; ++i) r.datasets[i] = N.ArrowNamedDataSet.toObject(e.datasets[i], t, n + 1);
		}
		if (e.useContainerWidth != null && e.hasOwnProperty("useContainerWidth") && (r.useContainerWidth = e.useContainerWidth), e.theme != null && e.hasOwnProperty("theme") && (r.theme = e.theme), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.selectionMode && e.selectionMode.length) {
			r.selectionMode = Array(e.selectionMode.length);
			for (let t = 0; t < e.selectionMode.length; ++t) r.selectionMode[t] = e.selectionMode[t];
		}
		return e.formId != null && e.hasOwnProperty("formId") && (r.formId = e.formId), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/VegaLiteChart";
	}, e;
})(), N.SubtitleTrack = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.label = "", e.prototype.url = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(10).string(e.label), e.url != null && Object.hasOwnProperty.call(e, "url") && t.uint32(18).string(e.url), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.SubtitleTrack(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.url = s : delete o.url;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.SubtitleTrack) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.SubtitleTrack();
		return e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = String(e.url)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.label = "", r.url = ""), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.url != null && e.hasOwnProperty("url") && (r.url = e.url), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/SubtitleTrack";
	}, e;
})(), N.Video = (() => {
	function e(e) {
		if (this.subtitles = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.url = "", e.prototype.startTime = 0, e.prototype.type = 0, e.prototype.subtitles = M.emptyArray, e.prototype.endTime = 0, e.prototype.loop = !1, e.prototype.autoplay = !1, e.prototype.muted = !1, e.prototype.id = "", e.prototype.widthConfig = null;
	let t;
	return Object.defineProperty(e.prototype, "_widthConfig", {
		get: M.oneOfGetter(t = ["widthConfig"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.startTime != null && Object.hasOwnProperty.call(e, "startTime") && t.uint32(24).int32(e.startTime), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(40).int32(e.type), e.url != null && Object.hasOwnProperty.call(e, "url") && t.uint32(50).string(e.url), e.subtitles != null && e.subtitles.length) for (let r = 0; r < e.subtitles.length; ++r) N.SubtitleTrack.encode(e.subtitles[r], t.uint32(58).fork(), n + 1).ldelim();
		if (e.endTime != null && Object.hasOwnProperty.call(e, "endTime") && t.uint32(64).int32(e.endTime), e.loop != null && Object.hasOwnProperty.call(e, "loop") && t.uint32(72).bool(e.loop), e.autoplay != null && Object.hasOwnProperty.call(e, "autoplay") && t.uint32(80).bool(e.autoplay), e.muted != null && Object.hasOwnProperty.call(e, "muted") && t.uint32(88).bool(e.muted), e.id != null && Object.hasOwnProperty.call(e, "id") && t.uint32(98).string(e.id), e.widthConfig != null && Object.hasOwnProperty.call(e, "widthConfig") && N.streamlit.WidthConfig.encode(e.widthConfig, t.uint32(106).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Video(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.url = s : delete o.url;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.int32()) ? o.startTime = s : delete o.startTime;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.int32()) ? o.type = s : delete o.type;
					continue;
				case 7:
					if (a !== 2) break;
					o.subtitles && o.subtitles.length || (o.subtitles = []), o.subtitles.push(N.SubtitleTrack.decode(e, e.uint32(), void 0, r + 1));
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.int32()) ? o.endTime = s : delete o.endTime;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.loop = s : delete o.loop;
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.bool()) ? o.autoplay = s : delete o.autoplay;
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.muted = s : delete o.muted;
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.string()).length ? o.id = s : delete o.id;
					continue;
				case 13:
					if (a !== 2) break;
					o.widthConfig = N.streamlit.WidthConfig.decode(e, e.uint32(), void 0, r + 1, o.widthConfig), o._widthConfig = "widthConfig";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Video) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Video();
		if (e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = String(e.url)), e.startTime != null && Number(e.startTime) !== 0 && (n.startTime = e.startTime | 0), e.type !== 0 && (typeof e.type != "string" || N.Video.Type[e.type] !== 0)) switch (e.type) {
			default:
				if (typeof e.type == "number") {
					n.type = e.type;
					break;
				}
				break;
			case "UNUSED":
			case 0:
				n.type = 0;
				break;
			case "NATIVE":
			case 1:
				n.type = 1;
				break;
			case "YOUTUBE_IFRAME":
			case 2:
				n.type = 2;
				break;
		}
		if (e.subtitles) {
			if (!Array.isArray(e.subtitles)) throw TypeError(".Video.subtitles: array expected");
			n.subtitles = Array(e.subtitles.length);
			for (let r = 0; r < e.subtitles.length; ++r) {
				if (typeof e.subtitles[r] != "object") throw TypeError(".Video.subtitles: object expected");
				n.subtitles[r] = N.SubtitleTrack.fromObject(e.subtitles[r], t + 1);
			}
		}
		if (e.endTime != null && Number(e.endTime) !== 0 && (n.endTime = e.endTime | 0), e.loop != null && e.loop && (n.loop = !!e.loop), e.autoplay != null && e.autoplay && (n.autoplay = !!e.autoplay), e.muted != null && e.muted && (n.muted = !!e.muted), e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = String(e.id)), e.widthConfig != null) {
			if (typeof e.widthConfig != "object") throw TypeError(".Video.widthConfig: object expected");
			n.widthConfig = N.streamlit.WidthConfig.fromObject(e.widthConfig, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.subtitles = []), t.defaults && (r.startTime = 0, r.type = t.enums === String ? "UNUSED" : 0, r.url = "", r.endTime = 0, r.loop = !1, r.autoplay = !1, r.muted = !1, r.id = ""), e.startTime != null && e.hasOwnProperty("startTime") && (r.startTime = e.startTime), e.type != null && e.hasOwnProperty("type") && (r.type = t.enums === String ? N.Video.Type[e.type] === void 0 ? e.type : N.Video.Type[e.type] : e.type), e.url != null && e.hasOwnProperty("url") && (r.url = e.url), e.subtitles && e.subtitles.length) {
			r.subtitles = Array(e.subtitles.length);
			for (let i = 0; i < e.subtitles.length; ++i) r.subtitles[i] = N.SubtitleTrack.toObject(e.subtitles[i], t, n + 1);
		}
		return e.endTime != null && e.hasOwnProperty("endTime") && (r.endTime = e.endTime), e.loop != null && e.hasOwnProperty("loop") && (r.loop = e.loop), e.autoplay != null && e.hasOwnProperty("autoplay") && (r.autoplay = e.autoplay), e.muted != null && e.hasOwnProperty("muted") && (r.muted = e.muted), e.id != null && e.hasOwnProperty("id") && (r.id = e.id), e.widthConfig != null && e.hasOwnProperty("widthConfig") && (r.widthConfig = N.streamlit.WidthConfig.toObject(e.widthConfig, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Video";
	}, e.Type = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "UNUSED"] = 0, t[e[1] = "NATIVE"] = 1, t[e[2] = "YOUTUBE_IFRAME"] = 2, t;
	})(), e;
})(), N.Transient = (() => {
	function e(e) {
		if (this.elements = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.elements = M.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.elements != null && e.elements.length) for (let r = 0; r < e.elements.length; ++r) N.Element.encode(e.elements[r], t.uint32(10).fork(), n + 1).ldelim();
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Transient();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.elements && o.elements.length || (o.elements = []), o.elements.push(N.Element.decode(e, e.uint32(), void 0, r + 1));
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Transient) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Transient();
		if (e.elements) {
			if (!Array.isArray(e.elements)) throw TypeError(".Transient.elements: array expected");
			n.elements = Array(e.elements.length);
			for (let r = 0; r < e.elements.length; ++r) {
				if (typeof e.elements[r] != "object") throw TypeError(".Transient.elements: object expected");
				n.elements[r] = N.Element.fromObject(e.elements[r], t + 1);
			}
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.elements = []), e.elements && e.elements.length) {
			r.elements = Array(e.elements.length);
			for (let i = 0; i < e.elements.length; ++i) r.elements[i] = N.Element.toObject(e.elements[i], t, n + 1);
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Transient";
	}, e;
})();
var P = N.ForwardMsg = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.hash = "", e.prototype.metadata = null, e.prototype.newSession = null, e.prototype.delta = null, e.prototype.pageInfoChanged = null, e.prototype.pageConfigChanged = null, e.prototype.scriptFinished = null, e.prototype.gitInfoChanged = null, e.prototype.pageProfile = null, e.prototype.sessionStatusChanged = null, e.prototype.sessionEvent = null, e.prototype.navigation = null, e.prototype.pageNotFound = null, e.prototype.fileUrlsResponse = null, e.prototype.autoRerun = null, e.prototype.logo = null, e.prototype.authRedirect = null, e.prototype.parentMessage = null, e.prototype.refHash = null, e.prototype.deferredFileResponse = null, e.prototype.heartbeatAck = null, e.prototype.debugLastBackmsgId = "";
	let t;
	return Object.defineProperty(e.prototype, "type", {
		get: M.oneOfGetter(t = [
			"newSession",
			"delta",
			"pageInfoChanged",
			"pageConfigChanged",
			"scriptFinished",
			"gitInfoChanged",
			"pageProfile",
			"sessionStatusChanged",
			"sessionEvent",
			"navigation",
			"pageNotFound",
			"fileUrlsResponse",
			"autoRerun",
			"logo",
			"authRedirect",
			"parentMessage",
			"refHash",
			"deferredFileResponse",
			"heartbeatAck"
		]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.hash != null && Object.hasOwnProperty.call(e, "hash") && t.uint32(10).string(e.hash), e.metadata != null && Object.hasOwnProperty.call(e, "metadata") && N.ForwardMsgMetadata.encode(e.metadata, t.uint32(18).fork(), n + 1).ldelim(), e.newSession != null && Object.hasOwnProperty.call(e, "newSession") && N.NewSession.encode(e.newSession, t.uint32(34).fork(), n + 1).ldelim(), e.delta != null && Object.hasOwnProperty.call(e, "delta") && N.Delta.encode(e.delta, t.uint32(42).fork(), n + 1).ldelim(), e.scriptFinished != null && Object.hasOwnProperty.call(e, "scriptFinished") && t.uint32(48).int32(e.scriptFinished), e.sessionStatusChanged != null && Object.hasOwnProperty.call(e, "sessionStatusChanged") && N.SessionStatus.encode(e.sessionStatusChanged, t.uint32(74).fork(), n + 1).ldelim(), e.sessionEvent != null && Object.hasOwnProperty.call(e, "sessionEvent") && N.SessionEvent.encode(e.sessionEvent, t.uint32(82).fork(), n + 1).ldelim(), e.refHash != null && Object.hasOwnProperty.call(e, "refHash") && t.uint32(90).string(e.refHash), e.pageInfoChanged != null && Object.hasOwnProperty.call(e, "pageInfoChanged") && N.PageInfo.encode(e.pageInfoChanged, t.uint32(98).fork(), n + 1).ldelim(), e.pageConfigChanged != null && Object.hasOwnProperty.call(e, "pageConfigChanged") && N.PageConfig.encode(e.pageConfigChanged, t.uint32(106).fork(), n + 1).ldelim(), e.gitInfoChanged != null && Object.hasOwnProperty.call(e, "gitInfoChanged") && N.GitInfo.encode(e.gitInfoChanged, t.uint32(114).fork(), n + 1).ldelim(), e.pageNotFound != null && Object.hasOwnProperty.call(e, "pageNotFound") && N.PageNotFound.encode(e.pageNotFound, t.uint32(122).fork(), n + 1).ldelim(), e.debugLastBackmsgId != null && Object.hasOwnProperty.call(e, "debugLastBackmsgId") && t.uint32(138).string(e.debugLastBackmsgId), e.pageProfile != null && Object.hasOwnProperty.call(e, "pageProfile") && N.PageProfile.encode(e.pageProfile, t.uint32(146).fork(), n + 1).ldelim(), e.fileUrlsResponse != null && Object.hasOwnProperty.call(e, "fileUrlsResponse") && N.FileURLsResponse.encode(e.fileUrlsResponse, t.uint32(154).fork(), n + 1).ldelim(), e.parentMessage != null && Object.hasOwnProperty.call(e, "parentMessage") && N.ParentMessage.encode(e.parentMessage, t.uint32(162).fork(), n + 1).ldelim(), e.autoRerun != null && Object.hasOwnProperty.call(e, "autoRerun") && N.AutoRerun.encode(e.autoRerun, t.uint32(170).fork(), n + 1).ldelim(), e.logo != null && Object.hasOwnProperty.call(e, "logo") && N.Logo.encode(e.logo, t.uint32(178).fork(), n + 1).ldelim(), e.navigation != null && Object.hasOwnProperty.call(e, "navigation") && N.Navigation.encode(e.navigation, t.uint32(186).fork(), n + 1).ldelim(), e.authRedirect != null && Object.hasOwnProperty.call(e, "authRedirect") && N.AuthRedirect.encode(e.authRedirect, t.uint32(194).fork(), n + 1).ldelim(), e.deferredFileResponse != null && Object.hasOwnProperty.call(e, "deferredFileResponse") && N.DeferredFileResponse.encode(e.deferredFileResponse, t.uint32(202).fork(), n + 1).ldelim(), e.heartbeatAck != null && Object.hasOwnProperty.call(e, "heartbeatAck") && t.uint32(208).bool(e.heartbeatAck), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ForwardMsg(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.hash = s : delete o.hash;
					continue;
				case 2:
					if (a !== 2) break;
					o.metadata = N.ForwardMsgMetadata.decode(e, e.uint32(), void 0, r + 1, o.metadata);
					continue;
				case 4:
					if (a !== 2) break;
					o.newSession = N.NewSession.decode(e, e.uint32(), void 0, r + 1, o.newSession), o.type = "newSession";
					continue;
				case 5:
					if (a !== 2) break;
					o.delta = N.Delta.decode(e, e.uint32(), void 0, r + 1, o.delta), o.type = "delta";
					continue;
				case 12:
					if (a !== 2) break;
					o.pageInfoChanged = N.PageInfo.decode(e, e.uint32(), void 0, r + 1, o.pageInfoChanged), o.type = "pageInfoChanged";
					continue;
				case 13:
					if (a !== 2) break;
					o.pageConfigChanged = N.PageConfig.decode(e, e.uint32(), void 0, r + 1, o.pageConfigChanged), o.type = "pageConfigChanged";
					continue;
				case 6:
					if (a !== 0) break;
					o.scriptFinished = e.int32(), o.type = "scriptFinished";
					continue;
				case 14:
					if (a !== 2) break;
					o.gitInfoChanged = N.GitInfo.decode(e, e.uint32(), void 0, r + 1, o.gitInfoChanged), o.type = "gitInfoChanged";
					continue;
				case 18:
					if (a !== 2) break;
					o.pageProfile = N.PageProfile.decode(e, e.uint32(), void 0, r + 1, o.pageProfile), o.type = "pageProfile";
					continue;
				case 9:
					if (a !== 2) break;
					o.sessionStatusChanged = N.SessionStatus.decode(e, e.uint32(), void 0, r + 1, o.sessionStatusChanged), o.type = "sessionStatusChanged";
					continue;
				case 10:
					if (a !== 2) break;
					o.sessionEvent = N.SessionEvent.decode(e, e.uint32(), void 0, r + 1, o.sessionEvent), o.type = "sessionEvent";
					continue;
				case 23:
					if (a !== 2) break;
					o.navigation = N.Navigation.decode(e, e.uint32(), void 0, r + 1, o.navigation), o.type = "navigation";
					continue;
				case 15:
					if (a !== 2) break;
					o.pageNotFound = N.PageNotFound.decode(e, e.uint32(), void 0, r + 1, o.pageNotFound), o.type = "pageNotFound";
					continue;
				case 19:
					if (a !== 2) break;
					o.fileUrlsResponse = N.FileURLsResponse.decode(e, e.uint32(), void 0, r + 1, o.fileUrlsResponse), o.type = "fileUrlsResponse";
					continue;
				case 21:
					if (a !== 2) break;
					o.autoRerun = N.AutoRerun.decode(e, e.uint32(), void 0, r + 1, o.autoRerun), o.type = "autoRerun";
					continue;
				case 22:
					if (a !== 2) break;
					o.logo = N.Logo.decode(e, e.uint32(), void 0, r + 1, o.logo), o.type = "logo";
					continue;
				case 24:
					if (a !== 2) break;
					o.authRedirect = N.AuthRedirect.decode(e, e.uint32(), void 0, r + 1, o.authRedirect), o.type = "authRedirect";
					continue;
				case 20:
					if (a !== 2) break;
					o.parentMessage = N.ParentMessage.decode(e, e.uint32(), void 0, r + 1, o.parentMessage), o.type = "parentMessage";
					continue;
				case 11:
					if (a !== 2) break;
					o.refHash = e.string(), o.type = "refHash";
					continue;
				case 25:
					if (a !== 2) break;
					o.deferredFileResponse = N.DeferredFileResponse.decode(e, e.uint32(), void 0, r + 1, o.deferredFileResponse), o.type = "deferredFileResponse";
					continue;
				case 26:
					if (a !== 0) break;
					o.heartbeatAck = e.bool(), o.type = "heartbeatAck";
					continue;
				case 17:
					if (a !== 2) break;
					(s = e.string()).length ? o.debugLastBackmsgId = s : delete o.debugLastBackmsgId;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ForwardMsg) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ForwardMsg();
		if (e.hash != null && (typeof e.hash != "string" || e.hash.length) && (n.hash = String(e.hash)), e.metadata != null) {
			if (typeof e.metadata != "object") throw TypeError(".ForwardMsg.metadata: object expected");
			n.metadata = N.ForwardMsgMetadata.fromObject(e.metadata, t + 1);
		}
		if (e.newSession != null) {
			if (typeof e.newSession != "object") throw TypeError(".ForwardMsg.newSession: object expected");
			n.newSession = N.NewSession.fromObject(e.newSession, t + 1);
		}
		if (e.delta != null) {
			if (typeof e.delta != "object") throw TypeError(".ForwardMsg.delta: object expected");
			n.delta = N.Delta.fromObject(e.delta, t + 1);
		}
		if (e.pageInfoChanged != null) {
			if (typeof e.pageInfoChanged != "object") throw TypeError(".ForwardMsg.pageInfoChanged: object expected");
			n.pageInfoChanged = N.PageInfo.fromObject(e.pageInfoChanged, t + 1);
		}
		if (e.pageConfigChanged != null) {
			if (typeof e.pageConfigChanged != "object") throw TypeError(".ForwardMsg.pageConfigChanged: object expected");
			n.pageConfigChanged = N.PageConfig.fromObject(e.pageConfigChanged, t + 1);
		}
		switch (e.scriptFinished) {
			default:
				if (typeof e.scriptFinished == "number") {
					n.scriptFinished = e.scriptFinished;
					break;
				}
				break;
			case "FINISHED_SUCCESSFULLY":
			case 0:
				n.scriptFinished = 0;
				break;
			case "FINISHED_WITH_COMPILE_ERROR":
			case 1:
				n.scriptFinished = 1;
				break;
			case "FINISHED_EARLY_FOR_RERUN":
			case 2:
				n.scriptFinished = 2;
				break;
			case "FINISHED_FRAGMENT_RUN_SUCCESSFULLY":
			case 3:
				n.scriptFinished = 3;
				break;
		}
		if (e.gitInfoChanged != null) {
			if (typeof e.gitInfoChanged != "object") throw TypeError(".ForwardMsg.gitInfoChanged: object expected");
			n.gitInfoChanged = N.GitInfo.fromObject(e.gitInfoChanged, t + 1);
		}
		if (e.pageProfile != null) {
			if (typeof e.pageProfile != "object") throw TypeError(".ForwardMsg.pageProfile: object expected");
			n.pageProfile = N.PageProfile.fromObject(e.pageProfile, t + 1);
		}
		if (e.sessionStatusChanged != null) {
			if (typeof e.sessionStatusChanged != "object") throw TypeError(".ForwardMsg.sessionStatusChanged: object expected");
			n.sessionStatusChanged = N.SessionStatus.fromObject(e.sessionStatusChanged, t + 1);
		}
		if (e.sessionEvent != null) {
			if (typeof e.sessionEvent != "object") throw TypeError(".ForwardMsg.sessionEvent: object expected");
			n.sessionEvent = N.SessionEvent.fromObject(e.sessionEvent, t + 1);
		}
		if (e.navigation != null) {
			if (typeof e.navigation != "object") throw TypeError(".ForwardMsg.navigation: object expected");
			n.navigation = N.Navigation.fromObject(e.navigation, t + 1);
		}
		if (e.pageNotFound != null) {
			if (typeof e.pageNotFound != "object") throw TypeError(".ForwardMsg.pageNotFound: object expected");
			n.pageNotFound = N.PageNotFound.fromObject(e.pageNotFound, t + 1);
		}
		if (e.fileUrlsResponse != null) {
			if (typeof e.fileUrlsResponse != "object") throw TypeError(".ForwardMsg.fileUrlsResponse: object expected");
			n.fileUrlsResponse = N.FileURLsResponse.fromObject(e.fileUrlsResponse, t + 1);
		}
		if (e.autoRerun != null) {
			if (typeof e.autoRerun != "object") throw TypeError(".ForwardMsg.autoRerun: object expected");
			n.autoRerun = N.AutoRerun.fromObject(e.autoRerun, t + 1);
		}
		if (e.logo != null) {
			if (typeof e.logo != "object") throw TypeError(".ForwardMsg.logo: object expected");
			n.logo = N.Logo.fromObject(e.logo, t + 1);
		}
		if (e.authRedirect != null) {
			if (typeof e.authRedirect != "object") throw TypeError(".ForwardMsg.authRedirect: object expected");
			n.authRedirect = N.AuthRedirect.fromObject(e.authRedirect, t + 1);
		}
		if (e.parentMessage != null) {
			if (typeof e.parentMessage != "object") throw TypeError(".ForwardMsg.parentMessage: object expected");
			n.parentMessage = N.ParentMessage.fromObject(e.parentMessage, t + 1);
		}
		if (e.refHash != null && (n.refHash = String(e.refHash)), e.deferredFileResponse != null) {
			if (typeof e.deferredFileResponse != "object") throw TypeError(".ForwardMsg.deferredFileResponse: object expected");
			n.deferredFileResponse = N.DeferredFileResponse.fromObject(e.deferredFileResponse, t + 1);
		}
		return e.heartbeatAck != null && (n.heartbeatAck = !!e.heartbeatAck), e.debugLastBackmsgId != null && (typeof e.debugLastBackmsgId != "string" || e.debugLastBackmsgId.length) && (n.debugLastBackmsgId = String(e.debugLastBackmsgId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.hash = "", r.metadata = null, r.debugLastBackmsgId = ""), e.hash != null && e.hasOwnProperty("hash") && (r.hash = e.hash), e.metadata != null && e.hasOwnProperty("metadata") && (r.metadata = N.ForwardMsgMetadata.toObject(e.metadata, t, n + 1)), e.newSession != null && e.hasOwnProperty("newSession") && (r.newSession = N.NewSession.toObject(e.newSession, t, n + 1), t.oneofs && (r.type = "newSession")), e.delta != null && e.hasOwnProperty("delta") && (r.delta = N.Delta.toObject(e.delta, t, n + 1), t.oneofs && (r.type = "delta")), e.scriptFinished != null && e.hasOwnProperty("scriptFinished") && (r.scriptFinished = t.enums === String ? N.ForwardMsg.ScriptFinishedStatus[e.scriptFinished] === void 0 ? e.scriptFinished : N.ForwardMsg.ScriptFinishedStatus[e.scriptFinished] : e.scriptFinished, t.oneofs && (r.type = "scriptFinished")), e.sessionStatusChanged != null && e.hasOwnProperty("sessionStatusChanged") && (r.sessionStatusChanged = N.SessionStatus.toObject(e.sessionStatusChanged, t, n + 1), t.oneofs && (r.type = "sessionStatusChanged")), e.sessionEvent != null && e.hasOwnProperty("sessionEvent") && (r.sessionEvent = N.SessionEvent.toObject(e.sessionEvent, t, n + 1), t.oneofs && (r.type = "sessionEvent")), e.refHash != null && e.hasOwnProperty("refHash") && (r.refHash = e.refHash, t.oneofs && (r.type = "refHash")), e.pageInfoChanged != null && e.hasOwnProperty("pageInfoChanged") && (r.pageInfoChanged = N.PageInfo.toObject(e.pageInfoChanged, t, n + 1), t.oneofs && (r.type = "pageInfoChanged")), e.pageConfigChanged != null && e.hasOwnProperty("pageConfigChanged") && (r.pageConfigChanged = N.PageConfig.toObject(e.pageConfigChanged, t, n + 1), t.oneofs && (r.type = "pageConfigChanged")), e.gitInfoChanged != null && e.hasOwnProperty("gitInfoChanged") && (r.gitInfoChanged = N.GitInfo.toObject(e.gitInfoChanged, t, n + 1), t.oneofs && (r.type = "gitInfoChanged")), e.pageNotFound != null && e.hasOwnProperty("pageNotFound") && (r.pageNotFound = N.PageNotFound.toObject(e.pageNotFound, t, n + 1), t.oneofs && (r.type = "pageNotFound")), e.debugLastBackmsgId != null && e.hasOwnProperty("debugLastBackmsgId") && (r.debugLastBackmsgId = e.debugLastBackmsgId), e.pageProfile != null && e.hasOwnProperty("pageProfile") && (r.pageProfile = N.PageProfile.toObject(e.pageProfile, t, n + 1), t.oneofs && (r.type = "pageProfile")), e.fileUrlsResponse != null && e.hasOwnProperty("fileUrlsResponse") && (r.fileUrlsResponse = N.FileURLsResponse.toObject(e.fileUrlsResponse, t, n + 1), t.oneofs && (r.type = "fileUrlsResponse")), e.parentMessage != null && e.hasOwnProperty("parentMessage") && (r.parentMessage = N.ParentMessage.toObject(e.parentMessage, t, n + 1), t.oneofs && (r.type = "parentMessage")), e.autoRerun != null && e.hasOwnProperty("autoRerun") && (r.autoRerun = N.AutoRerun.toObject(e.autoRerun, t, n + 1), t.oneofs && (r.type = "autoRerun")), e.logo != null && e.hasOwnProperty("logo") && (r.logo = N.Logo.toObject(e.logo, t, n + 1), t.oneofs && (r.type = "logo")), e.navigation != null && e.hasOwnProperty("navigation") && (r.navigation = N.Navigation.toObject(e.navigation, t, n + 1), t.oneofs && (r.type = "navigation")), e.authRedirect != null && e.hasOwnProperty("authRedirect") && (r.authRedirect = N.AuthRedirect.toObject(e.authRedirect, t, n + 1), t.oneofs && (r.type = "authRedirect")), e.deferredFileResponse != null && e.hasOwnProperty("deferredFileResponse") && (r.deferredFileResponse = N.DeferredFileResponse.toObject(e.deferredFileResponse, t, n + 1), t.oneofs && (r.type = "deferredFileResponse")), e.heartbeatAck != null && e.hasOwnProperty("heartbeatAck") && (r.heartbeatAck = e.heartbeatAck, t.oneofs && (r.type = "heartbeatAck")), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ForwardMsg";
	}, e.ScriptFinishedStatus = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "FINISHED_SUCCESSFULLY"] = 0, t[e[1] = "FINISHED_WITH_COMPILE_ERROR"] = 1, t[e[2] = "FINISHED_EARLY_FOR_RERUN"] = 2, t[e[3] = "FINISHED_FRAGMENT_RUN_SUCCESSFULLY"] = 3, t;
	})(), e;
})();
N.DeferredFileResponse = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.fileId = "", e.prototype.url = "", e.prototype.errorMsg = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.fileId != null && Object.hasOwnProperty.call(e, "fileId") && t.uint32(10).string(e.fileId), e.url != null && Object.hasOwnProperty.call(e, "url") && t.uint32(18).string(e.url), e.errorMsg != null && Object.hasOwnProperty.call(e, "errorMsg") && t.uint32(26).string(e.errorMsg), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.DeferredFileResponse(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.fileId = s : delete o.fileId;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.url = s : delete o.url;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.errorMsg = s : delete o.errorMsg;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.DeferredFileResponse) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.DeferredFileResponse();
		return e.fileId != null && (typeof e.fileId != "string" || e.fileId.length) && (n.fileId = String(e.fileId)), e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = String(e.url)), e.errorMsg != null && (typeof e.errorMsg != "string" || e.errorMsg.length) && (n.errorMsg = String(e.errorMsg)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.fileId = "", r.url = "", r.errorMsg = ""), e.fileId != null && e.hasOwnProperty("fileId") && (r.fileId = e.fileId), e.url != null && e.hasOwnProperty("url") && (r.url = e.url), e.errorMsg != null && e.hasOwnProperty("errorMsg") && (r.errorMsg = e.errorMsg), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/DeferredFileResponse";
	}, e;
})(), N.ForwardMsgMetadata = (() => {
	function e(e) {
		if (this.deltaPath = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.cacheable = !1, e.prototype.deltaPath = M.emptyArray, e.prototype.activeScriptHash = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.cacheable != null && Object.hasOwnProperty.call(e, "cacheable") && t.uint32(8).bool(e.cacheable), e.deltaPath != null && e.deltaPath.length) {
			t.uint32(18).fork();
			for (let n = 0; n < e.deltaPath.length; ++n) t.uint32(e.deltaPath[n]);
			t.ldelim();
		}
		if (e.activeScriptHash != null && Object.hasOwnProperty.call(e, "activeScriptHash") && t.uint32(34).string(e.activeScriptHash), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ForwardMsgMetadata(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					(s = e.bool()) ? o.cacheable = s : delete o.cacheable;
					continue;
				case 2:
					if (a === 2) {
						o.deltaPath && o.deltaPath.length || (o.deltaPath = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.deltaPath.push(e.uint32());
						continue;
					}
					if (a !== 0) break;
					o.deltaPath && o.deltaPath.length || (o.deltaPath = []), o.deltaPath.push(e.uint32());
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.activeScriptHash = s : delete o.activeScriptHash;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ForwardMsgMetadata) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ForwardMsgMetadata();
		if (e.cacheable != null && e.cacheable && (n.cacheable = !!e.cacheable), e.deltaPath) {
			if (!Array.isArray(e.deltaPath)) throw TypeError(".ForwardMsgMetadata.deltaPath: array expected");
			n.deltaPath = Array(e.deltaPath.length);
			for (let t = 0; t < e.deltaPath.length; ++t) n.deltaPath[t] = e.deltaPath[t] >>> 0;
		}
		return e.activeScriptHash != null && (typeof e.activeScriptHash != "string" || e.activeScriptHash.length) && (n.activeScriptHash = String(e.activeScriptHash)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.deltaPath = []), t.defaults && (r.cacheable = !1, r.activeScriptHash = ""), e.cacheable != null && e.hasOwnProperty("cacheable") && (r.cacheable = e.cacheable), e.deltaPath && e.deltaPath.length) {
			r.deltaPath = Array(e.deltaPath.length);
			for (let t = 0; t < e.deltaPath.length; ++t) r.deltaPath[t] = e.deltaPath[t];
		}
		return e.activeScriptHash != null && e.hasOwnProperty("activeScriptHash") && (r.activeScriptHash = e.activeScriptHash), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ForwardMsgMetadata";
	}, e;
})();
var de = N.ForwardMsgList = (() => {
	function e(e) {
		if (this.messages = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.messages = M.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.messages != null && e.messages.length) for (let r = 0; r < e.messages.length; ++r) N.ForwardMsg.encode(e.messages[r], t.uint32(10).fork(), n + 1).ldelim();
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ForwardMsgList();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.messages && o.messages.length || (o.messages = []), o.messages.push(N.ForwardMsg.decode(e, e.uint32(), void 0, r + 1));
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ForwardMsgList) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ForwardMsgList();
		if (e.messages) {
			if (!Array.isArray(e.messages)) throw TypeError(".ForwardMsgList.messages: array expected");
			n.messages = Array(e.messages.length);
			for (let r = 0; r < e.messages.length; ++r) {
				if (typeof e.messages[r] != "object") throw TypeError(".ForwardMsgList.messages: object expected");
				n.messages[r] = N.ForwardMsg.fromObject(e.messages[r], t + 1);
			}
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.messages = []), e.messages && e.messages.length) {
			r.messages = Array(e.messages.length);
			for (let i = 0; i < e.messages.length; ++i) r.messages[i] = N.ForwardMsg.toObject(e.messages[i], t, n + 1);
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ForwardMsgList";
	}, e;
})();
//#endregion
//#region ../utils/dist/streamlit-utils.es.js
N.GitInfo = (() => {
	function e(e) {
		if (this.untrackedFiles = [], this.uncommittedFiles = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.repository = "", e.prototype.branch = "", e.prototype.module = "", e.prototype.untrackedFiles = M.emptyArray, e.prototype.uncommittedFiles = M.emptyArray, e.prototype.state = 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.repository != null && Object.hasOwnProperty.call(e, "repository") && t.uint32(10).string(e.repository), e.branch != null && Object.hasOwnProperty.call(e, "branch") && t.uint32(18).string(e.branch), e.module != null && Object.hasOwnProperty.call(e, "module") && t.uint32(26).string(e.module), e.untrackedFiles != null && e.untrackedFiles.length) for (let n = 0; n < e.untrackedFiles.length; ++n) t.uint32(34).string(e.untrackedFiles[n]);
		if (e.uncommittedFiles != null && e.uncommittedFiles.length) for (let n = 0; n < e.uncommittedFiles.length; ++n) t.uint32(42).string(e.uncommittedFiles[n]);
		if (e.state != null && Object.hasOwnProperty.call(e, "state") && t.uint32(48).int32(e.state), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.GitInfo(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.repository = s : delete o.repository;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.branch = s : delete o.branch;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.module = s : delete o.module;
					continue;
				case 4:
					if (a !== 2) break;
					o.untrackedFiles && o.untrackedFiles.length || (o.untrackedFiles = []), o.untrackedFiles.push(e.string());
					continue;
				case 5:
					if (a !== 2) break;
					o.uncommittedFiles && o.uncommittedFiles.length || (o.uncommittedFiles = []), o.uncommittedFiles.push(e.string());
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.int32()) ? o.state = s : delete o.state;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.GitInfo) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.GitInfo();
		if (e.repository != null && (typeof e.repository != "string" || e.repository.length) && (n.repository = String(e.repository)), e.branch != null && (typeof e.branch != "string" || e.branch.length) && (n.branch = String(e.branch)), e.module != null && (typeof e.module != "string" || e.module.length) && (n.module = String(e.module)), e.untrackedFiles) {
			if (!Array.isArray(e.untrackedFiles)) throw TypeError(".GitInfo.untrackedFiles: array expected");
			n.untrackedFiles = Array(e.untrackedFiles.length);
			for (let t = 0; t < e.untrackedFiles.length; ++t) n.untrackedFiles[t] = String(e.untrackedFiles[t]);
		}
		if (e.uncommittedFiles) {
			if (!Array.isArray(e.uncommittedFiles)) throw TypeError(".GitInfo.uncommittedFiles: array expected");
			n.uncommittedFiles = Array(e.uncommittedFiles.length);
			for (let t = 0; t < e.uncommittedFiles.length; ++t) n.uncommittedFiles[t] = String(e.uncommittedFiles[t]);
		}
		if (e.state !== 0 && (typeof e.state != "string" || N.GitInfo.GitStates[e.state] !== 0)) switch (e.state) {
			default:
				if (typeof e.state == "number") {
					n.state = e.state;
					break;
				}
				break;
			case "DEFAULT":
			case 0:
				n.state = 0;
				break;
			case "HEAD_DETACHED":
			case 1:
				n.state = 1;
				break;
			case "AHEAD_OF_REMOTE":
			case 2:
				n.state = 2;
				break;
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.untrackedFiles = [], r.uncommittedFiles = []), t.defaults && (r.repository = "", r.branch = "", r.module = "", r.state = t.enums === String ? "DEFAULT" : 0), e.repository != null && e.hasOwnProperty("repository") && (r.repository = e.repository), e.branch != null && e.hasOwnProperty("branch") && (r.branch = e.branch), e.module != null && e.hasOwnProperty("module") && (r.module = e.module), e.untrackedFiles && e.untrackedFiles.length) {
			r.untrackedFiles = Array(e.untrackedFiles.length);
			for (let t = 0; t < e.untrackedFiles.length; ++t) r.untrackedFiles[t] = e.untrackedFiles[t];
		}
		if (e.uncommittedFiles && e.uncommittedFiles.length) {
			r.uncommittedFiles = Array(e.uncommittedFiles.length);
			for (let t = 0; t < e.uncommittedFiles.length; ++t) r.uncommittedFiles[t] = e.uncommittedFiles[t];
		}
		return e.state != null && e.hasOwnProperty("state") && (r.state = t.enums === String ? N.GitInfo.GitStates[e.state] === void 0 ? e.state : N.GitInfo.GitStates[e.state] : e.state), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/GitInfo";
	}, e.GitStates = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "DEFAULT"] = 0, t[e[1] = "HEAD_DETACHED"] = 1, t[e[2] = "AHEAD_OF_REMOTE"] = 2, t;
	})(), e;
})(), N.Logo = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.image = "", e.prototype.link = "", e.prototype.iconImage = "", e.prototype.size = "", e.prototype.imageType = 0, e.prototype.iconImageType = 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.image != null && Object.hasOwnProperty.call(e, "image") && t.uint32(10).string(e.image), e.link != null && Object.hasOwnProperty.call(e, "link") && t.uint32(18).string(e.link), e.iconImage != null && Object.hasOwnProperty.call(e, "iconImage") && t.uint32(26).string(e.iconImage), e.size != null && Object.hasOwnProperty.call(e, "size") && t.uint32(34).string(e.size), e.imageType != null && Object.hasOwnProperty.call(e, "imageType") && t.uint32(40).int32(e.imageType), e.iconImageType != null && Object.hasOwnProperty.call(e, "iconImageType") && t.uint32(48).int32(e.iconImageType), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Logo(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.image = s : delete o.image;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.link = s : delete o.link;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.iconImage = s : delete o.iconImage;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.size = s : delete o.size;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.int32()) ? o.imageType = s : delete o.imageType;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.int32()) ? o.iconImageType = s : delete o.iconImageType;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Logo) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Logo();
		if (e.image != null && (typeof e.image != "string" || e.image.length) && (n.image = String(e.image)), e.link != null && (typeof e.link != "string" || e.link.length) && (n.link = String(e.link)), e.iconImage != null && (typeof e.iconImage != "string" || e.iconImage.length) && (n.iconImage = String(e.iconImage)), e.size != null && (typeof e.size != "string" || e.size.length) && (n.size = String(e.size)), e.imageType !== 0 && (typeof e.imageType != "string" || N.Logo.ImageType[e.imageType] !== 0)) switch (e.imageType) {
			default:
				if (typeof e.imageType == "number") {
					n.imageType = e.imageType;
					break;
				}
				break;
			case "IMAGE":
			case 0:
				n.imageType = 0;
				break;
			case "EMOJI":
			case 1:
				n.imageType = 1;
				break;
			case "ICON":
			case 2:
				n.imageType = 2;
				break;
		}
		if (e.iconImageType !== 0 && (typeof e.iconImageType != "string" || N.Logo.ImageType[e.iconImageType] !== 0)) switch (e.iconImageType) {
			default:
				if (typeof e.iconImageType == "number") {
					n.iconImageType = e.iconImageType;
					break;
				}
				break;
			case "IMAGE":
			case 0:
				n.iconImageType = 0;
				break;
			case "EMOJI":
			case 1:
				n.iconImageType = 1;
				break;
			case "ICON":
			case 2:
				n.iconImageType = 2;
				break;
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.image = "", r.link = "", r.iconImage = "", r.size = "", r.imageType = t.enums === String ? "IMAGE" : 0, r.iconImageType = t.enums === String ? "IMAGE" : 0), e.image != null && e.hasOwnProperty("image") && (r.image = e.image), e.link != null && e.hasOwnProperty("link") && (r.link = e.link), e.iconImage != null && e.hasOwnProperty("iconImage") && (r.iconImage = e.iconImage), e.size != null && e.hasOwnProperty("size") && (r.size = e.size), e.imageType != null && e.hasOwnProperty("imageType") && (r.imageType = t.enums === String ? N.Logo.ImageType[e.imageType] === void 0 ? e.imageType : N.Logo.ImageType[e.imageType] : e.imageType), e.iconImageType != null && e.hasOwnProperty("iconImageType") && (r.iconImageType = t.enums === String ? N.Logo.ImageType[e.iconImageType] === void 0 ? e.iconImageType : N.Logo.ImageType[e.iconImageType] : e.iconImageType), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Logo";
	}, e.ImageType = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "IMAGE"] = 0, t[e[1] = "EMOJI"] = 1, t[e[2] = "ICON"] = 2, t;
	})(), e;
})(), N.Navigation = (() => {
	function e(e) {
		if (this.sections = [], this.appPages = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.sections = M.emptyArray, e.prototype.appPages = M.emptyArray, e.prototype.position = 0, e.prototype.pageScriptHash = "", e.prototype.expanded = !1, e.prototype.visibleItems = null;
	let t;
	return Object.defineProperty(e.prototype, "_visibleItems", {
		get: M.oneOfGetter(t = ["visibleItems"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.sections != null && e.sections.length) for (let n = 0; n < e.sections.length; ++n) t.uint32(10).string(e.sections[n]);
		if (e.appPages != null && e.appPages.length) for (let r = 0; r < e.appPages.length; ++r) N.AppPage.encode(e.appPages[r], t.uint32(18).fork(), n + 1).ldelim();
		if (e.position != null && Object.hasOwnProperty.call(e, "position") && t.uint32(24).int32(e.position), e.pageScriptHash != null && Object.hasOwnProperty.call(e, "pageScriptHash") && t.uint32(34).string(e.pageScriptHash), e.expanded != null && Object.hasOwnProperty.call(e, "expanded") && t.uint32(40).bool(e.expanded), e.visibleItems != null && Object.hasOwnProperty.call(e, "visibleItems") && t.uint32(48).uint32(e.visibleItems), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Navigation(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.sections && o.sections.length || (o.sections = []), o.sections.push(e.string());
					continue;
				case 2:
					if (a !== 2) break;
					o.appPages && o.appPages.length || (o.appPages = []), o.appPages.push(N.AppPage.decode(e, e.uint32(), void 0, r + 1));
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.int32()) ? o.position = s : delete o.position;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.pageScriptHash = s : delete o.pageScriptHash;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.expanded = s : delete o.expanded;
					continue;
				case 6:
					if (a !== 0) break;
					o.visibleItems = e.uint32(), o._visibleItems = "visibleItems";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Navigation) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Navigation();
		if (e.sections) {
			if (!Array.isArray(e.sections)) throw TypeError(".Navigation.sections: array expected");
			n.sections = Array(e.sections.length);
			for (let t = 0; t < e.sections.length; ++t) n.sections[t] = String(e.sections[t]);
		}
		if (e.appPages) {
			if (!Array.isArray(e.appPages)) throw TypeError(".Navigation.appPages: array expected");
			n.appPages = Array(e.appPages.length);
			for (let r = 0; r < e.appPages.length; ++r) {
				if (typeof e.appPages[r] != "object") throw TypeError(".Navigation.appPages: object expected");
				n.appPages[r] = N.AppPage.fromObject(e.appPages[r], t + 1);
			}
		}
		if (e.position !== 0 && (typeof e.position != "string" || N.Navigation.Position[e.position] !== 0)) switch (e.position) {
			default:
				if (typeof e.position == "number") {
					n.position = e.position;
					break;
				}
				break;
			case "HIDDEN":
			case 0:
				n.position = 0;
				break;
			case "SIDEBAR":
			case 1:
				n.position = 1;
				break;
			case "TOP":
			case 2:
				n.position = 2;
				break;
		}
		return e.pageScriptHash != null && (typeof e.pageScriptHash != "string" || e.pageScriptHash.length) && (n.pageScriptHash = String(e.pageScriptHash)), e.expanded != null && e.expanded && (n.expanded = !!e.expanded), e.visibleItems != null && (n.visibleItems = e.visibleItems >>> 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.sections = [], r.appPages = []), t.defaults && (r.position = t.enums === String ? "HIDDEN" : 0, r.pageScriptHash = "", r.expanded = !1), e.sections && e.sections.length) {
			r.sections = Array(e.sections.length);
			for (let t = 0; t < e.sections.length; ++t) r.sections[t] = e.sections[t];
		}
		if (e.appPages && e.appPages.length) {
			r.appPages = Array(e.appPages.length);
			for (let i = 0; i < e.appPages.length; ++i) r.appPages[i] = N.AppPage.toObject(e.appPages[i], t, n + 1);
		}
		return e.position != null && e.hasOwnProperty("position") && (r.position = t.enums === String ? N.Navigation.Position[e.position] === void 0 ? e.position : N.Navigation.Position[e.position] : e.position), e.pageScriptHash != null && e.hasOwnProperty("pageScriptHash") && (r.pageScriptHash = e.pageScriptHash), e.expanded != null && e.hasOwnProperty("expanded") && (r.expanded = e.expanded), e.visibleItems != null && e.hasOwnProperty("visibleItems") && (r.visibleItems = e.visibleItems), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Navigation";
	}, e.Position = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "HIDDEN"] = 0, t[e[1] = "SIDEBAR"] = 1, t[e[2] = "TOP"] = 2, t;
	})(), e;
})(), N.NewSession = (() => {
	function e(e) {
		if (this.appPages = [], this.fragmentIdsThisRun = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.initialize = null, e.prototype.scriptRunId = "", e.prototype.name = "", e.prototype.mainScriptPath = "", e.prototype.config = null, e.prototype.customTheme = null, e.prototype.appPages = M.emptyArray, e.prototype.pageScriptHash = "", e.prototype.fragmentIdsThisRun = M.emptyArray, e.prototype.mainScriptHash = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.initialize != null && Object.hasOwnProperty.call(e, "initialize") && N.Initialize.encode(e.initialize, t.uint32(10).fork(), n + 1).ldelim(), e.scriptRunId != null && Object.hasOwnProperty.call(e, "scriptRunId") && t.uint32(18).string(e.scriptRunId), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(26).string(e.name), e.mainScriptPath != null && Object.hasOwnProperty.call(e, "mainScriptPath") && t.uint32(34).string(e.mainScriptPath), e.config != null && Object.hasOwnProperty.call(e, "config") && N.Config.encode(e.config, t.uint32(50).fork(), n + 1).ldelim(), e.customTheme != null && Object.hasOwnProperty.call(e, "customTheme") && N.CustomThemeConfig.encode(e.customTheme, t.uint32(58).fork(), n + 1).ldelim(), e.appPages != null && e.appPages.length) for (let r = 0; r < e.appPages.length; ++r) N.AppPage.encode(e.appPages[r], t.uint32(66).fork(), n + 1).ldelim();
		if (e.pageScriptHash != null && Object.hasOwnProperty.call(e, "pageScriptHash") && t.uint32(74).string(e.pageScriptHash), e.fragmentIdsThisRun != null && e.fragmentIdsThisRun.length) for (let n = 0; n < e.fragmentIdsThisRun.length; ++n) t.uint32(82).string(e.fragmentIdsThisRun[n]);
		if (e.mainScriptHash != null && Object.hasOwnProperty.call(e, "mainScriptHash") && t.uint32(90).string(e.mainScriptHash), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.NewSession(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.initialize = N.Initialize.decode(e, e.uint32(), void 0, r + 1, o.initialize);
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.scriptRunId = s : delete o.scriptRunId;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.name = s : delete o.name;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.mainScriptPath = s : delete o.mainScriptPath;
					continue;
				case 6:
					if (a !== 2) break;
					o.config = N.Config.decode(e, e.uint32(), void 0, r + 1, o.config);
					continue;
				case 7:
					if (a !== 2) break;
					o.customTheme = N.CustomThemeConfig.decode(e, e.uint32(), void 0, r + 1, o.customTheme);
					continue;
				case 8:
					if (a !== 2) break;
					o.appPages && o.appPages.length || (o.appPages = []), o.appPages.push(N.AppPage.decode(e, e.uint32(), void 0, r + 1));
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.string()).length ? o.pageScriptHash = s : delete o.pageScriptHash;
					continue;
				case 10:
					if (a !== 2) break;
					o.fragmentIdsThisRun && o.fragmentIdsThisRun.length || (o.fragmentIdsThisRun = []), o.fragmentIdsThisRun.push(e.string());
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.string()).length ? o.mainScriptHash = s : delete o.mainScriptHash;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.NewSession) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.NewSession();
		if (e.initialize != null) {
			if (typeof e.initialize != "object") throw TypeError(".NewSession.initialize: object expected");
			n.initialize = N.Initialize.fromObject(e.initialize, t + 1);
		}
		if (e.scriptRunId != null && (typeof e.scriptRunId != "string" || e.scriptRunId.length) && (n.scriptRunId = String(e.scriptRunId)), e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = String(e.name)), e.mainScriptPath != null && (typeof e.mainScriptPath != "string" || e.mainScriptPath.length) && (n.mainScriptPath = String(e.mainScriptPath)), e.config != null) {
			if (typeof e.config != "object") throw TypeError(".NewSession.config: object expected");
			n.config = N.Config.fromObject(e.config, t + 1);
		}
		if (e.customTheme != null) {
			if (typeof e.customTheme != "object") throw TypeError(".NewSession.customTheme: object expected");
			n.customTheme = N.CustomThemeConfig.fromObject(e.customTheme, t + 1);
		}
		if (e.appPages) {
			if (!Array.isArray(e.appPages)) throw TypeError(".NewSession.appPages: array expected");
			n.appPages = Array(e.appPages.length);
			for (let r = 0; r < e.appPages.length; ++r) {
				if (typeof e.appPages[r] != "object") throw TypeError(".NewSession.appPages: object expected");
				n.appPages[r] = N.AppPage.fromObject(e.appPages[r], t + 1);
			}
		}
		if (e.pageScriptHash != null && (typeof e.pageScriptHash != "string" || e.pageScriptHash.length) && (n.pageScriptHash = String(e.pageScriptHash)), e.fragmentIdsThisRun) {
			if (!Array.isArray(e.fragmentIdsThisRun)) throw TypeError(".NewSession.fragmentIdsThisRun: array expected");
			n.fragmentIdsThisRun = Array(e.fragmentIdsThisRun.length);
			for (let t = 0; t < e.fragmentIdsThisRun.length; ++t) n.fragmentIdsThisRun[t] = String(e.fragmentIdsThisRun[t]);
		}
		return e.mainScriptHash != null && (typeof e.mainScriptHash != "string" || e.mainScriptHash.length) && (n.mainScriptHash = String(e.mainScriptHash)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.appPages = [], r.fragmentIdsThisRun = []), t.defaults && (r.initialize = null, r.scriptRunId = "", r.name = "", r.mainScriptPath = "", r.config = null, r.customTheme = null, r.pageScriptHash = "", r.mainScriptHash = ""), e.initialize != null && e.hasOwnProperty("initialize") && (r.initialize = N.Initialize.toObject(e.initialize, t, n + 1)), e.scriptRunId != null && e.hasOwnProperty("scriptRunId") && (r.scriptRunId = e.scriptRunId), e.name != null && e.hasOwnProperty("name") && (r.name = e.name), e.mainScriptPath != null && e.hasOwnProperty("mainScriptPath") && (r.mainScriptPath = e.mainScriptPath), e.config != null && e.hasOwnProperty("config") && (r.config = N.Config.toObject(e.config, t, n + 1)), e.customTheme != null && e.hasOwnProperty("customTheme") && (r.customTheme = N.CustomThemeConfig.toObject(e.customTheme, t, n + 1)), e.appPages && e.appPages.length) {
			r.appPages = Array(e.appPages.length);
			for (let i = 0; i < e.appPages.length; ++i) r.appPages[i] = N.AppPage.toObject(e.appPages[i], t, n + 1);
		}
		if (e.pageScriptHash != null && e.hasOwnProperty("pageScriptHash") && (r.pageScriptHash = e.pageScriptHash), e.fragmentIdsThisRun && e.fragmentIdsThisRun.length) {
			r.fragmentIdsThisRun = Array(e.fragmentIdsThisRun.length);
			for (let t = 0; t < e.fragmentIdsThisRun.length; ++t) r.fragmentIdsThisRun[t] = e.fragmentIdsThisRun[t];
		}
		return e.mainScriptHash != null && e.hasOwnProperty("mainScriptHash") && (r.mainScriptHash = e.mainScriptHash), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/NewSession";
	}, e;
})(), N.Initialize = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.userInfo = null, e.prototype.environmentInfo = null, e.prototype.sessionStatus = null, e.prototype.sessionId = "", e.prototype.isHello = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.userInfo != null && Object.hasOwnProperty.call(e, "userInfo") && N.UserInfo.encode(e.userInfo, t.uint32(10).fork(), n + 1).ldelim(), e.environmentInfo != null && Object.hasOwnProperty.call(e, "environmentInfo") && N.EnvironmentInfo.encode(e.environmentInfo, t.uint32(26).fork(), n + 1).ldelim(), e.sessionStatus != null && Object.hasOwnProperty.call(e, "sessionStatus") && N.SessionStatus.encode(e.sessionStatus, t.uint32(34).fork(), n + 1).ldelim(), e.sessionId != null && Object.hasOwnProperty.call(e, "sessionId") && t.uint32(50).string(e.sessionId), e.isHello != null && Object.hasOwnProperty.call(e, "isHello") && t.uint32(56).bool(e.isHello), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Initialize(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.userInfo = N.UserInfo.decode(e, e.uint32(), void 0, r + 1, o.userInfo);
					continue;
				case 3:
					if (a !== 2) break;
					o.environmentInfo = N.EnvironmentInfo.decode(e, e.uint32(), void 0, r + 1, o.environmentInfo);
					continue;
				case 4:
					if (a !== 2) break;
					o.sessionStatus = N.SessionStatus.decode(e, e.uint32(), void 0, r + 1, o.sessionStatus);
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.sessionId = s : delete o.sessionId;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.isHello = s : delete o.isHello;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Initialize) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Initialize();
		if (e.userInfo != null) {
			if (typeof e.userInfo != "object") throw TypeError(".Initialize.userInfo: object expected");
			n.userInfo = N.UserInfo.fromObject(e.userInfo, t + 1);
		}
		if (e.environmentInfo != null) {
			if (typeof e.environmentInfo != "object") throw TypeError(".Initialize.environmentInfo: object expected");
			n.environmentInfo = N.EnvironmentInfo.fromObject(e.environmentInfo, t + 1);
		}
		if (e.sessionStatus != null) {
			if (typeof e.sessionStatus != "object") throw TypeError(".Initialize.sessionStatus: object expected");
			n.sessionStatus = N.SessionStatus.fromObject(e.sessionStatus, t + 1);
		}
		return e.sessionId != null && (typeof e.sessionId != "string" || e.sessionId.length) && (n.sessionId = String(e.sessionId)), e.isHello != null && e.isHello && (n.isHello = !!e.isHello), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.userInfo = null, r.environmentInfo = null, r.sessionStatus = null, r.sessionId = "", r.isHello = !1), e.userInfo != null && e.hasOwnProperty("userInfo") && (r.userInfo = N.UserInfo.toObject(e.userInfo, t, n + 1)), e.environmentInfo != null && e.hasOwnProperty("environmentInfo") && (r.environmentInfo = N.EnvironmentInfo.toObject(e.environmentInfo, t, n + 1)), e.sessionStatus != null && e.hasOwnProperty("sessionStatus") && (r.sessionStatus = N.SessionStatus.toObject(e.sessionStatus, t, n + 1)), e.sessionId != null && e.hasOwnProperty("sessionId") && (r.sessionId = e.sessionId), e.isHello != null && e.hasOwnProperty("isHello") && (r.isHello = e.isHello), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Initialize";
	}, e;
})(), N.Config = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.gatherUsageStats = !1, e.prototype.maxCachedMessageAge = 0, e.prototype.allowRunOnSave = !1, e.prototype.hideTopBar = !1, e.prototype.hideSidebarNav = !1, e.prototype.toolbarMode = 0, e.prototype.showErrorLinks = 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.gatherUsageStats != null && Object.hasOwnProperty.call(e, "gatherUsageStats") && t.uint32(16).bool(e.gatherUsageStats), e.maxCachedMessageAge != null && Object.hasOwnProperty.call(e, "maxCachedMessageAge") && t.uint32(24).int32(e.maxCachedMessageAge), e.allowRunOnSave != null && Object.hasOwnProperty.call(e, "allowRunOnSave") && t.uint32(40).bool(e.allowRunOnSave), e.hideTopBar != null && Object.hasOwnProperty.call(e, "hideTopBar") && t.uint32(48).bool(e.hideTopBar), e.hideSidebarNav != null && Object.hasOwnProperty.call(e, "hideSidebarNav") && t.uint32(56).bool(e.hideSidebarNav), e.toolbarMode != null && Object.hasOwnProperty.call(e, "toolbarMode") && t.uint32(64).int32(e.toolbarMode), e.showErrorLinks != null && Object.hasOwnProperty.call(e, "showErrorLinks") && t.uint32(72).int32(e.showErrorLinks), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Config(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 2:
					if (a !== 0) break;
					(s = e.bool()) ? o.gatherUsageStats = s : delete o.gatherUsageStats;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.int32()) ? o.maxCachedMessageAge = s : delete o.maxCachedMessageAge;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.allowRunOnSave = s : delete o.allowRunOnSave;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.hideTopBar = s : delete o.hideTopBar;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.hideSidebarNav = s : delete o.hideSidebarNav;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.int32()) ? o.toolbarMode = s : delete o.toolbarMode;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.int32()) ? o.showErrorLinks = s : delete o.showErrorLinks;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Config) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Config();
		if (e.gatherUsageStats != null && e.gatherUsageStats && (n.gatherUsageStats = !!e.gatherUsageStats), e.maxCachedMessageAge != null && Number(e.maxCachedMessageAge) !== 0 && (n.maxCachedMessageAge = e.maxCachedMessageAge | 0), e.allowRunOnSave != null && e.allowRunOnSave && (n.allowRunOnSave = !!e.allowRunOnSave), e.hideTopBar != null && e.hideTopBar && (n.hideTopBar = !!e.hideTopBar), e.hideSidebarNav != null && e.hideSidebarNav && (n.hideSidebarNav = !!e.hideSidebarNav), e.toolbarMode !== 0 && (typeof e.toolbarMode != "string" || N.Config.ToolbarMode[e.toolbarMode] !== 0)) switch (e.toolbarMode) {
			default:
				if (typeof e.toolbarMode == "number") {
					n.toolbarMode = e.toolbarMode;
					break;
				}
				break;
			case "AUTO":
			case 0:
				n.toolbarMode = 0;
				break;
			case "DEVELOPER":
			case 1:
				n.toolbarMode = 1;
				break;
			case "VIEWER":
			case 2:
				n.toolbarMode = 2;
				break;
			case "MINIMAL":
			case 3:
				n.toolbarMode = 3;
				break;
		}
		if (e.showErrorLinks !== 0 && (typeof e.showErrorLinks != "string" || N.Config.ShowErrorLinks[e.showErrorLinks] !== 0)) switch (e.showErrorLinks) {
			default:
				if (typeof e.showErrorLinks == "number") {
					n.showErrorLinks = e.showErrorLinks;
					break;
				}
				break;
			case "SHOW_ERROR_LINKS_UNSPECIFIED":
			case 0:
				n.showErrorLinks = 0;
				break;
			case "SHOW_ERROR_LINKS_AUTO":
			case 1:
				n.showErrorLinks = 1;
				break;
			case "SHOW_ERROR_LINKS_TRUE":
			case 2:
				n.showErrorLinks = 2;
				break;
			case "SHOW_ERROR_LINKS_FALSE":
			case 3:
				n.showErrorLinks = 3;
				break;
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.gatherUsageStats = !1, r.maxCachedMessageAge = 0, r.allowRunOnSave = !1, r.hideTopBar = !1, r.hideSidebarNav = !1, r.toolbarMode = t.enums === String ? "AUTO" : 0, r.showErrorLinks = t.enums === String ? "SHOW_ERROR_LINKS_UNSPECIFIED" : 0), e.gatherUsageStats != null && e.hasOwnProperty("gatherUsageStats") && (r.gatherUsageStats = e.gatherUsageStats), e.maxCachedMessageAge != null && e.hasOwnProperty("maxCachedMessageAge") && (r.maxCachedMessageAge = e.maxCachedMessageAge), e.allowRunOnSave != null && e.hasOwnProperty("allowRunOnSave") && (r.allowRunOnSave = e.allowRunOnSave), e.hideTopBar != null && e.hasOwnProperty("hideTopBar") && (r.hideTopBar = e.hideTopBar), e.hideSidebarNav != null && e.hasOwnProperty("hideSidebarNav") && (r.hideSidebarNav = e.hideSidebarNav), e.toolbarMode != null && e.hasOwnProperty("toolbarMode") && (r.toolbarMode = t.enums === String ? N.Config.ToolbarMode[e.toolbarMode] === void 0 ? e.toolbarMode : N.Config.ToolbarMode[e.toolbarMode] : e.toolbarMode), e.showErrorLinks != null && e.hasOwnProperty("showErrorLinks") && (r.showErrorLinks = t.enums === String ? N.Config.ShowErrorLinks[e.showErrorLinks] === void 0 ? e.showErrorLinks : N.Config.ShowErrorLinks[e.showErrorLinks] : e.showErrorLinks), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Config";
	}, e.ToolbarMode = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "AUTO"] = 0, t[e[1] = "DEVELOPER"] = 1, t[e[2] = "VIEWER"] = 2, t[e[3] = "MINIMAL"] = 3, t;
	})(), e.ShowErrorLinks = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "SHOW_ERROR_LINKS_UNSPECIFIED"] = 0, t[e[1] = "SHOW_ERROR_LINKS_AUTO"] = 1, t[e[2] = "SHOW_ERROR_LINKS_TRUE"] = 2, t[e[3] = "SHOW_ERROR_LINKS_FALSE"] = 3, t;
	})(), e;
})(), N.CustomThemeConfig = (() => {
	function e(e) {
		if (this.fontFaces = [], this.fontSources = [], this.headingFontSizes = [], this.headingFontWeights = [], this.chartCategoricalColors = [], this.chartSequentialColors = [], this.chartDivergingColors = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.primaryColor = "", e.prototype.secondaryBackgroundColor = "", e.prototype.backgroundColor = "", e.prototype.textColor = "", e.prototype.base = 0, e.prototype.headingFont = "", e.prototype.bodyFont = "", e.prototype.codeFont = "", e.prototype.fontFaces = M.emptyArray, e.prototype.fontSources = M.emptyArray, e.prototype.baseRadius = null, e.prototype.buttonRadius = null, e.prototype.borderColor = null, e.prototype.dataframeBorderColor = null, e.prototype.showWidgetBorder = null, e.prototype.linkColor = null, e.prototype.linkUnderline = null, e.prototype.baseFontSize = null, e.prototype.baseFontWeight = null, e.prototype.codeFontWeight = null, e.prototype.codeFontSize = null, e.prototype.headingFontSizes = M.emptyArray, e.prototype.headingFontWeights = M.emptyArray, e.prototype.showSidebarBorder = null, e.prototype.codeTextColor = null, e.prototype.codeBackgroundColor = null, e.prototype.dataframeHeaderBackgroundColor = null, e.prototype.chartCategoricalColors = M.emptyArray, e.prototype.chartSequentialColors = M.emptyArray, e.prototype.chartDivergingColors = M.emptyArray, e.prototype.redColor = null, e.prototype.orangeColor = null, e.prototype.yellowColor = null, e.prototype.blueColor = null, e.prototype.greenColor = null, e.prototype.violetColor = null, e.prototype.grayColor = null, e.prototype.redBackgroundColor = null, e.prototype.orangeBackgroundColor = null, e.prototype.yellowBackgroundColor = null, e.prototype.blueBackgroundColor = null, e.prototype.greenBackgroundColor = null, e.prototype.violetBackgroundColor = null, e.prototype.grayBackgroundColor = null, e.prototype.redTextColor = null, e.prototype.orangeTextColor = null, e.prototype.yellowTextColor = null, e.prototype.blueTextColor = null, e.prototype.greenTextColor = null, e.prototype.violetTextColor = null, e.prototype.grayTextColor = null, e.prototype.metricValueFontSize = null, e.prototype.metricValueFontWeight = null, e.prototype.sidebar = null, e.prototype.light = null, e.prototype.dark = null;
	let t;
	return Object.defineProperty(e.prototype, "_baseRadius", {
		get: M.oneOfGetter(t = ["baseRadius"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_buttonRadius", {
		get: M.oneOfGetter(t = ["buttonRadius"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_borderColor", {
		get: M.oneOfGetter(t = ["borderColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_dataframeBorderColor", {
		get: M.oneOfGetter(t = ["dataframeBorderColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_showWidgetBorder", {
		get: M.oneOfGetter(t = ["showWidgetBorder"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_linkColor", {
		get: M.oneOfGetter(t = ["linkColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_linkUnderline", {
		get: M.oneOfGetter(t = ["linkUnderline"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_baseFontSize", {
		get: M.oneOfGetter(t = ["baseFontSize"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_baseFontWeight", {
		get: M.oneOfGetter(t = ["baseFontWeight"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_codeFontWeight", {
		get: M.oneOfGetter(t = ["codeFontWeight"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_codeFontSize", {
		get: M.oneOfGetter(t = ["codeFontSize"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_showSidebarBorder", {
		get: M.oneOfGetter(t = ["showSidebarBorder"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_codeTextColor", {
		get: M.oneOfGetter(t = ["codeTextColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_codeBackgroundColor", {
		get: M.oneOfGetter(t = ["codeBackgroundColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_dataframeHeaderBackgroundColor", {
		get: M.oneOfGetter(t = ["dataframeHeaderBackgroundColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_redColor", {
		get: M.oneOfGetter(t = ["redColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_orangeColor", {
		get: M.oneOfGetter(t = ["orangeColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_yellowColor", {
		get: M.oneOfGetter(t = ["yellowColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_blueColor", {
		get: M.oneOfGetter(t = ["blueColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_greenColor", {
		get: M.oneOfGetter(t = ["greenColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_violetColor", {
		get: M.oneOfGetter(t = ["violetColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_grayColor", {
		get: M.oneOfGetter(t = ["grayColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_redBackgroundColor", {
		get: M.oneOfGetter(t = ["redBackgroundColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_orangeBackgroundColor", {
		get: M.oneOfGetter(t = ["orangeBackgroundColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_yellowBackgroundColor", {
		get: M.oneOfGetter(t = ["yellowBackgroundColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_blueBackgroundColor", {
		get: M.oneOfGetter(t = ["blueBackgroundColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_greenBackgroundColor", {
		get: M.oneOfGetter(t = ["greenBackgroundColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_violetBackgroundColor", {
		get: M.oneOfGetter(t = ["violetBackgroundColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_grayBackgroundColor", {
		get: M.oneOfGetter(t = ["grayBackgroundColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_redTextColor", {
		get: M.oneOfGetter(t = ["redTextColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_orangeTextColor", {
		get: M.oneOfGetter(t = ["orangeTextColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_yellowTextColor", {
		get: M.oneOfGetter(t = ["yellowTextColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_blueTextColor", {
		get: M.oneOfGetter(t = ["blueTextColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_greenTextColor", {
		get: M.oneOfGetter(t = ["greenTextColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_violetTextColor", {
		get: M.oneOfGetter(t = ["violetTextColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_grayTextColor", {
		get: M.oneOfGetter(t = ["grayTextColor"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_metricValueFontSize", {
		get: M.oneOfGetter(t = ["metricValueFontSize"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_metricValueFontWeight", {
		get: M.oneOfGetter(t = ["metricValueFontWeight"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_sidebar", {
		get: M.oneOfGetter(t = ["sidebar"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_light", {
		get: M.oneOfGetter(t = ["light"]),
		set: M.oneOfSetter(t)
	}), Object.defineProperty(e.prototype, "_dark", {
		get: M.oneOfGetter(t = ["dark"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.primaryColor != null && Object.hasOwnProperty.call(e, "primaryColor") && t.uint32(10).string(e.primaryColor), e.secondaryBackgroundColor != null && Object.hasOwnProperty.call(e, "secondaryBackgroundColor") && t.uint32(18).string(e.secondaryBackgroundColor), e.backgroundColor != null && Object.hasOwnProperty.call(e, "backgroundColor") && t.uint32(26).string(e.backgroundColor), e.textColor != null && Object.hasOwnProperty.call(e, "textColor") && t.uint32(34).string(e.textColor), e.base != null && Object.hasOwnProperty.call(e, "base") && t.uint32(48).int32(e.base), e.headingFont != null && Object.hasOwnProperty.call(e, "headingFont") && t.uint32(98).string(e.headingFont), e.bodyFont != null && Object.hasOwnProperty.call(e, "bodyFont") && t.uint32(106).string(e.bodyFont), e.codeFont != null && Object.hasOwnProperty.call(e, "codeFont") && t.uint32(114).string(e.codeFont), e.fontFaces != null && e.fontFaces.length) for (let r = 0; r < e.fontFaces.length; ++r) N.FontFace.encode(e.fontFaces[r], t.uint32(122).fork(), n + 1).ldelim();
		if (e.baseRadius != null && Object.hasOwnProperty.call(e, "baseRadius") && t.uint32(146).string(e.baseRadius), e.borderColor != null && Object.hasOwnProperty.call(e, "borderColor") && t.uint32(154).string(e.borderColor), e.showWidgetBorder != null && Object.hasOwnProperty.call(e, "showWidgetBorder") && t.uint32(160).bool(e.showWidgetBorder), e.linkColor != null && Object.hasOwnProperty.call(e, "linkColor") && t.uint32(170).string(e.linkColor), e.baseFontSize != null && Object.hasOwnProperty.call(e, "baseFontSize") && t.uint32(176).int32(e.baseFontSize), e.showSidebarBorder != null && Object.hasOwnProperty.call(e, "showSidebarBorder") && t.uint32(184).bool(e.showSidebarBorder), e.sidebar != null && Object.hasOwnProperty.call(e, "sidebar") && N.CustomThemeConfig.encode(e.sidebar, t.uint32(194).fork(), n + 1).ldelim(), e.codeBackgroundColor != null && Object.hasOwnProperty.call(e, "codeBackgroundColor") && t.uint32(202).string(e.codeBackgroundColor), e.buttonRadius != null && Object.hasOwnProperty.call(e, "buttonRadius") && t.uint32(210).string(e.buttonRadius), e.dataframeBorderColor != null && Object.hasOwnProperty.call(e, "dataframeBorderColor") && t.uint32(218).string(e.dataframeBorderColor), e.codeFontSize != null && Object.hasOwnProperty.call(e, "codeFontSize") && t.uint32(226).string(e.codeFontSize), e.linkUnderline != null && Object.hasOwnProperty.call(e, "linkUnderline") && t.uint32(232).bool(e.linkUnderline), e.baseFontWeight != null && Object.hasOwnProperty.call(e, "baseFontWeight") && t.uint32(240).int32(e.baseFontWeight), e.dataframeHeaderBackgroundColor != null && Object.hasOwnProperty.call(e, "dataframeHeaderBackgroundColor") && t.uint32(250).string(e.dataframeHeaderBackgroundColor), e.codeFontWeight != null && Object.hasOwnProperty.call(e, "codeFontWeight") && t.uint32(256).int32(e.codeFontWeight), e.chartCategoricalColors != null && e.chartCategoricalColors.length) for (let n = 0; n < e.chartCategoricalColors.length; ++n) t.uint32(266).string(e.chartCategoricalColors[n]);
		if (e.headingFontWeights != null && e.headingFontWeights.length) {
			t.uint32(274).fork();
			for (let n = 0; n < e.headingFontWeights.length; ++n) t.int32(e.headingFontWeights[n]);
			t.ldelim();
		}
		if (e.headingFontSizes != null && e.headingFontSizes.length) for (let n = 0; n < e.headingFontSizes.length; ++n) t.uint32(282).string(e.headingFontSizes[n]);
		if (e.chartSequentialColors != null && e.chartSequentialColors.length) for (let n = 0; n < e.chartSequentialColors.length; ++n) t.uint32(290).string(e.chartSequentialColors[n]);
		if (e.fontSources != null && e.fontSources.length) for (let r = 0; r < e.fontSources.length; ++r) N.FontSource.encode(e.fontSources[r], t.uint32(298).fork(), n + 1).ldelim();
		if (e.redColor != null && Object.hasOwnProperty.call(e, "redColor") && t.uint32(306).string(e.redColor), e.orangeColor != null && Object.hasOwnProperty.call(e, "orangeColor") && t.uint32(314).string(e.orangeColor), e.yellowColor != null && Object.hasOwnProperty.call(e, "yellowColor") && t.uint32(322).string(e.yellowColor), e.blueColor != null && Object.hasOwnProperty.call(e, "blueColor") && t.uint32(330).string(e.blueColor), e.greenColor != null && Object.hasOwnProperty.call(e, "greenColor") && t.uint32(338).string(e.greenColor), e.violetColor != null && Object.hasOwnProperty.call(e, "violetColor") && t.uint32(346).string(e.violetColor), e.grayColor != null && Object.hasOwnProperty.call(e, "grayColor") && t.uint32(354).string(e.grayColor), e.redBackgroundColor != null && Object.hasOwnProperty.call(e, "redBackgroundColor") && t.uint32(362).string(e.redBackgroundColor), e.orangeBackgroundColor != null && Object.hasOwnProperty.call(e, "orangeBackgroundColor") && t.uint32(370).string(e.orangeBackgroundColor), e.yellowBackgroundColor != null && Object.hasOwnProperty.call(e, "yellowBackgroundColor") && t.uint32(378).string(e.yellowBackgroundColor), e.blueBackgroundColor != null && Object.hasOwnProperty.call(e, "blueBackgroundColor") && t.uint32(386).string(e.blueBackgroundColor), e.greenBackgroundColor != null && Object.hasOwnProperty.call(e, "greenBackgroundColor") && t.uint32(394).string(e.greenBackgroundColor), e.violetBackgroundColor != null && Object.hasOwnProperty.call(e, "violetBackgroundColor") && t.uint32(402).string(e.violetBackgroundColor), e.grayBackgroundColor != null && Object.hasOwnProperty.call(e, "grayBackgroundColor") && t.uint32(410).string(e.grayBackgroundColor), e.redTextColor != null && Object.hasOwnProperty.call(e, "redTextColor") && t.uint32(418).string(e.redTextColor), e.orangeTextColor != null && Object.hasOwnProperty.call(e, "orangeTextColor") && t.uint32(426).string(e.orangeTextColor), e.yellowTextColor != null && Object.hasOwnProperty.call(e, "yellowTextColor") && t.uint32(434).string(e.yellowTextColor), e.blueTextColor != null && Object.hasOwnProperty.call(e, "blueTextColor") && t.uint32(442).string(e.blueTextColor), e.greenTextColor != null && Object.hasOwnProperty.call(e, "greenTextColor") && t.uint32(450).string(e.greenTextColor), e.violetTextColor != null && Object.hasOwnProperty.call(e, "violetTextColor") && t.uint32(458).string(e.violetTextColor), e.grayTextColor != null && Object.hasOwnProperty.call(e, "grayTextColor") && t.uint32(466).string(e.grayTextColor), e.codeTextColor != null && Object.hasOwnProperty.call(e, "codeTextColor") && t.uint32(474).string(e.codeTextColor), e.light != null && Object.hasOwnProperty.call(e, "light") && N.CustomThemeConfig.encode(e.light, t.uint32(482).fork(), n + 1).ldelim(), e.dark != null && Object.hasOwnProperty.call(e, "dark") && N.CustomThemeConfig.encode(e.dark, t.uint32(490).fork(), n + 1).ldelim(), e.chartDivergingColors != null && e.chartDivergingColors.length) for (let n = 0; n < e.chartDivergingColors.length; ++n) t.uint32(498).string(e.chartDivergingColors[n]);
		if (e.metricValueFontSize != null && Object.hasOwnProperty.call(e, "metricValueFontSize") && t.uint32(514).string(e.metricValueFontSize), e.metricValueFontWeight != null && Object.hasOwnProperty.call(e, "metricValueFontWeight") && t.uint32(520).int32(e.metricValueFontWeight), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.CustomThemeConfig(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.primaryColor = s : delete o.primaryColor;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.secondaryBackgroundColor = s : delete o.secondaryBackgroundColor;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.backgroundColor = s : delete o.backgroundColor;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.textColor = s : delete o.textColor;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.int32()) ? o.base = s : delete o.base;
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.string()).length ? o.headingFont = s : delete o.headingFont;
					continue;
				case 13:
					if (a !== 2) break;
					(s = e.string()).length ? o.bodyFont = s : delete o.bodyFont;
					continue;
				case 14:
					if (a !== 2) break;
					(s = e.string()).length ? o.codeFont = s : delete o.codeFont;
					continue;
				case 15:
					if (a !== 2) break;
					o.fontFaces && o.fontFaces.length || (o.fontFaces = []), o.fontFaces.push(N.FontFace.decode(e, e.uint32(), void 0, r + 1));
					continue;
				case 37:
					if (a !== 2) break;
					o.fontSources && o.fontSources.length || (o.fontSources = []), o.fontSources.push(N.FontSource.decode(e, e.uint32(), void 0, r + 1));
					continue;
				case 18:
					if (a !== 2) break;
					o.baseRadius = e.string(), o._baseRadius = "baseRadius";
					continue;
				case 26:
					if (a !== 2) break;
					o.buttonRadius = e.string(), o._buttonRadius = "buttonRadius";
					continue;
				case 19:
					if (a !== 2) break;
					o.borderColor = e.string(), o._borderColor = "borderColor";
					continue;
				case 27:
					if (a !== 2) break;
					o.dataframeBorderColor = e.string(), o._dataframeBorderColor = "dataframeBorderColor";
					continue;
				case 20:
					if (a !== 0) break;
					o.showWidgetBorder = e.bool(), o._showWidgetBorder = "showWidgetBorder";
					continue;
				case 21:
					if (a !== 2) break;
					o.linkColor = e.string(), o._linkColor = "linkColor";
					continue;
				case 29:
					if (a !== 0) break;
					o.linkUnderline = e.bool(), o._linkUnderline = "linkUnderline";
					continue;
				case 22:
					if (a !== 0) break;
					o.baseFontSize = e.int32(), o._baseFontSize = "baseFontSize";
					continue;
				case 30:
					if (a !== 0) break;
					o.baseFontWeight = e.int32(), o._baseFontWeight = "baseFontWeight";
					continue;
				case 32:
					if (a !== 0) break;
					o.codeFontWeight = e.int32(), o._codeFontWeight = "codeFontWeight";
					continue;
				case 28:
					if (a !== 2) break;
					o.codeFontSize = e.string(), o._codeFontSize = "codeFontSize";
					continue;
				case 35:
					if (a !== 2) break;
					o.headingFontSizes && o.headingFontSizes.length || (o.headingFontSizes = []), o.headingFontSizes.push(e.string());
					continue;
				case 34:
					if (a === 2) {
						o.headingFontWeights && o.headingFontWeights.length || (o.headingFontWeights = []);
						let t = e.uint32() + e.pos;
						for (; e.pos < t;) o.headingFontWeights.push(e.int32());
						continue;
					}
					if (a !== 0) break;
					o.headingFontWeights && o.headingFontWeights.length || (o.headingFontWeights = []), o.headingFontWeights.push(e.int32());
					continue;
				case 23:
					if (a !== 0) break;
					o.showSidebarBorder = e.bool(), o._showSidebarBorder = "showSidebarBorder";
					continue;
				case 59:
					if (a !== 2) break;
					o.codeTextColor = e.string(), o._codeTextColor = "codeTextColor";
					continue;
				case 25:
					if (a !== 2) break;
					o.codeBackgroundColor = e.string(), o._codeBackgroundColor = "codeBackgroundColor";
					continue;
				case 31:
					if (a !== 2) break;
					o.dataframeHeaderBackgroundColor = e.string(), o._dataframeHeaderBackgroundColor = "dataframeHeaderBackgroundColor";
					continue;
				case 33:
					if (a !== 2) break;
					o.chartCategoricalColors && o.chartCategoricalColors.length || (o.chartCategoricalColors = []), o.chartCategoricalColors.push(e.string());
					continue;
				case 36:
					if (a !== 2) break;
					o.chartSequentialColors && o.chartSequentialColors.length || (o.chartSequentialColors = []), o.chartSequentialColors.push(e.string());
					continue;
				case 62:
					if (a !== 2) break;
					o.chartDivergingColors && o.chartDivergingColors.length || (o.chartDivergingColors = []), o.chartDivergingColors.push(e.string());
					continue;
				case 38:
					if (a !== 2) break;
					o.redColor = e.string(), o._redColor = "redColor";
					continue;
				case 39:
					if (a !== 2) break;
					o.orangeColor = e.string(), o._orangeColor = "orangeColor";
					continue;
				case 40:
					if (a !== 2) break;
					o.yellowColor = e.string(), o._yellowColor = "yellowColor";
					continue;
				case 41:
					if (a !== 2) break;
					o.blueColor = e.string(), o._blueColor = "blueColor";
					continue;
				case 42:
					if (a !== 2) break;
					o.greenColor = e.string(), o._greenColor = "greenColor";
					continue;
				case 43:
					if (a !== 2) break;
					o.violetColor = e.string(), o._violetColor = "violetColor";
					continue;
				case 44:
					if (a !== 2) break;
					o.grayColor = e.string(), o._grayColor = "grayColor";
					continue;
				case 45:
					if (a !== 2) break;
					o.redBackgroundColor = e.string(), o._redBackgroundColor = "redBackgroundColor";
					continue;
				case 46:
					if (a !== 2) break;
					o.orangeBackgroundColor = e.string(), o._orangeBackgroundColor = "orangeBackgroundColor";
					continue;
				case 47:
					if (a !== 2) break;
					o.yellowBackgroundColor = e.string(), o._yellowBackgroundColor = "yellowBackgroundColor";
					continue;
				case 48:
					if (a !== 2) break;
					o.blueBackgroundColor = e.string(), o._blueBackgroundColor = "blueBackgroundColor";
					continue;
				case 49:
					if (a !== 2) break;
					o.greenBackgroundColor = e.string(), o._greenBackgroundColor = "greenBackgroundColor";
					continue;
				case 50:
					if (a !== 2) break;
					o.violetBackgroundColor = e.string(), o._violetBackgroundColor = "violetBackgroundColor";
					continue;
				case 51:
					if (a !== 2) break;
					o.grayBackgroundColor = e.string(), o._grayBackgroundColor = "grayBackgroundColor";
					continue;
				case 52:
					if (a !== 2) break;
					o.redTextColor = e.string(), o._redTextColor = "redTextColor";
					continue;
				case 53:
					if (a !== 2) break;
					o.orangeTextColor = e.string(), o._orangeTextColor = "orangeTextColor";
					continue;
				case 54:
					if (a !== 2) break;
					o.yellowTextColor = e.string(), o._yellowTextColor = "yellowTextColor";
					continue;
				case 55:
					if (a !== 2) break;
					o.blueTextColor = e.string(), o._blueTextColor = "blueTextColor";
					continue;
				case 56:
					if (a !== 2) break;
					o.greenTextColor = e.string(), o._greenTextColor = "greenTextColor";
					continue;
				case 57:
					if (a !== 2) break;
					o.violetTextColor = e.string(), o._violetTextColor = "violetTextColor";
					continue;
				case 58:
					if (a !== 2) break;
					o.grayTextColor = e.string(), o._grayTextColor = "grayTextColor";
					continue;
				case 64:
					if (a !== 2) break;
					o.metricValueFontSize = e.string(), o._metricValueFontSize = "metricValueFontSize";
					continue;
				case 65:
					if (a !== 0) break;
					o.metricValueFontWeight = e.int32(), o._metricValueFontWeight = "metricValueFontWeight";
					continue;
				case 24:
					if (a !== 2) break;
					o.sidebar = N.CustomThemeConfig.decode(e, e.uint32(), void 0, r + 1, o.sidebar), o._sidebar = "sidebar";
					continue;
				case 60:
					if (a !== 2) break;
					o.light = N.CustomThemeConfig.decode(e, e.uint32(), void 0, r + 1, o.light), o._light = "light";
					continue;
				case 61:
					if (a !== 2) break;
					o.dark = N.CustomThemeConfig.decode(e, e.uint32(), void 0, r + 1, o.dark), o._dark = "dark";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.CustomThemeConfig) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.CustomThemeConfig();
		if (e.primaryColor != null && (typeof e.primaryColor != "string" || e.primaryColor.length) && (n.primaryColor = String(e.primaryColor)), e.secondaryBackgroundColor != null && (typeof e.secondaryBackgroundColor != "string" || e.secondaryBackgroundColor.length) && (n.secondaryBackgroundColor = String(e.secondaryBackgroundColor)), e.backgroundColor != null && (typeof e.backgroundColor != "string" || e.backgroundColor.length) && (n.backgroundColor = String(e.backgroundColor)), e.textColor != null && (typeof e.textColor != "string" || e.textColor.length) && (n.textColor = String(e.textColor)), e.base !== 0 && (typeof e.base != "string" || N.CustomThemeConfig.BaseTheme[e.base] !== 0)) switch (e.base) {
			default:
				if (typeof e.base == "number") {
					n.base = e.base;
					break;
				}
				break;
			case "LIGHT":
			case 0:
				n.base = 0;
				break;
			case "DARK":
			case 1:
				n.base = 1;
				break;
		}
		if (e.headingFont != null && (typeof e.headingFont != "string" || e.headingFont.length) && (n.headingFont = String(e.headingFont)), e.bodyFont != null && (typeof e.bodyFont != "string" || e.bodyFont.length) && (n.bodyFont = String(e.bodyFont)), e.codeFont != null && (typeof e.codeFont != "string" || e.codeFont.length) && (n.codeFont = String(e.codeFont)), e.fontFaces) {
			if (!Array.isArray(e.fontFaces)) throw TypeError(".CustomThemeConfig.fontFaces: array expected");
			n.fontFaces = Array(e.fontFaces.length);
			for (let r = 0; r < e.fontFaces.length; ++r) {
				if (typeof e.fontFaces[r] != "object") throw TypeError(".CustomThemeConfig.fontFaces: object expected");
				n.fontFaces[r] = N.FontFace.fromObject(e.fontFaces[r], t + 1);
			}
		}
		if (e.fontSources) {
			if (!Array.isArray(e.fontSources)) throw TypeError(".CustomThemeConfig.fontSources: array expected");
			n.fontSources = Array(e.fontSources.length);
			for (let r = 0; r < e.fontSources.length; ++r) {
				if (typeof e.fontSources[r] != "object") throw TypeError(".CustomThemeConfig.fontSources: object expected");
				n.fontSources[r] = N.FontSource.fromObject(e.fontSources[r], t + 1);
			}
		}
		if (e.baseRadius != null && (n.baseRadius = String(e.baseRadius)), e.buttonRadius != null && (n.buttonRadius = String(e.buttonRadius)), e.borderColor != null && (n.borderColor = String(e.borderColor)), e.dataframeBorderColor != null && (n.dataframeBorderColor = String(e.dataframeBorderColor)), e.showWidgetBorder != null && (n.showWidgetBorder = !!e.showWidgetBorder), e.linkColor != null && (n.linkColor = String(e.linkColor)), e.linkUnderline != null && (n.linkUnderline = !!e.linkUnderline), e.baseFontSize != null && (n.baseFontSize = e.baseFontSize | 0), e.baseFontWeight != null && (n.baseFontWeight = e.baseFontWeight | 0), e.codeFontWeight != null && (n.codeFontWeight = e.codeFontWeight | 0), e.codeFontSize != null && (n.codeFontSize = String(e.codeFontSize)), e.headingFontSizes) {
			if (!Array.isArray(e.headingFontSizes)) throw TypeError(".CustomThemeConfig.headingFontSizes: array expected");
			n.headingFontSizes = Array(e.headingFontSizes.length);
			for (let t = 0; t < e.headingFontSizes.length; ++t) n.headingFontSizes[t] = String(e.headingFontSizes[t]);
		}
		if (e.headingFontWeights) {
			if (!Array.isArray(e.headingFontWeights)) throw TypeError(".CustomThemeConfig.headingFontWeights: array expected");
			n.headingFontWeights = Array(e.headingFontWeights.length);
			for (let t = 0; t < e.headingFontWeights.length; ++t) n.headingFontWeights[t] = e.headingFontWeights[t] | 0;
		}
		if (e.showSidebarBorder != null && (n.showSidebarBorder = !!e.showSidebarBorder), e.codeTextColor != null && (n.codeTextColor = String(e.codeTextColor)), e.codeBackgroundColor != null && (n.codeBackgroundColor = String(e.codeBackgroundColor)), e.dataframeHeaderBackgroundColor != null && (n.dataframeHeaderBackgroundColor = String(e.dataframeHeaderBackgroundColor)), e.chartCategoricalColors) {
			if (!Array.isArray(e.chartCategoricalColors)) throw TypeError(".CustomThemeConfig.chartCategoricalColors: array expected");
			n.chartCategoricalColors = Array(e.chartCategoricalColors.length);
			for (let t = 0; t < e.chartCategoricalColors.length; ++t) n.chartCategoricalColors[t] = String(e.chartCategoricalColors[t]);
		}
		if (e.chartSequentialColors) {
			if (!Array.isArray(e.chartSequentialColors)) throw TypeError(".CustomThemeConfig.chartSequentialColors: array expected");
			n.chartSequentialColors = Array(e.chartSequentialColors.length);
			for (let t = 0; t < e.chartSequentialColors.length; ++t) n.chartSequentialColors[t] = String(e.chartSequentialColors[t]);
		}
		if (e.chartDivergingColors) {
			if (!Array.isArray(e.chartDivergingColors)) throw TypeError(".CustomThemeConfig.chartDivergingColors: array expected");
			n.chartDivergingColors = Array(e.chartDivergingColors.length);
			for (let t = 0; t < e.chartDivergingColors.length; ++t) n.chartDivergingColors[t] = String(e.chartDivergingColors[t]);
		}
		if (e.redColor != null && (n.redColor = String(e.redColor)), e.orangeColor != null && (n.orangeColor = String(e.orangeColor)), e.yellowColor != null && (n.yellowColor = String(e.yellowColor)), e.blueColor != null && (n.blueColor = String(e.blueColor)), e.greenColor != null && (n.greenColor = String(e.greenColor)), e.violetColor != null && (n.violetColor = String(e.violetColor)), e.grayColor != null && (n.grayColor = String(e.grayColor)), e.redBackgroundColor != null && (n.redBackgroundColor = String(e.redBackgroundColor)), e.orangeBackgroundColor != null && (n.orangeBackgroundColor = String(e.orangeBackgroundColor)), e.yellowBackgroundColor != null && (n.yellowBackgroundColor = String(e.yellowBackgroundColor)), e.blueBackgroundColor != null && (n.blueBackgroundColor = String(e.blueBackgroundColor)), e.greenBackgroundColor != null && (n.greenBackgroundColor = String(e.greenBackgroundColor)), e.violetBackgroundColor != null && (n.violetBackgroundColor = String(e.violetBackgroundColor)), e.grayBackgroundColor != null && (n.grayBackgroundColor = String(e.grayBackgroundColor)), e.redTextColor != null && (n.redTextColor = String(e.redTextColor)), e.orangeTextColor != null && (n.orangeTextColor = String(e.orangeTextColor)), e.yellowTextColor != null && (n.yellowTextColor = String(e.yellowTextColor)), e.blueTextColor != null && (n.blueTextColor = String(e.blueTextColor)), e.greenTextColor != null && (n.greenTextColor = String(e.greenTextColor)), e.violetTextColor != null && (n.violetTextColor = String(e.violetTextColor)), e.grayTextColor != null && (n.grayTextColor = String(e.grayTextColor)), e.metricValueFontSize != null && (n.metricValueFontSize = String(e.metricValueFontSize)), e.metricValueFontWeight != null && (n.metricValueFontWeight = e.metricValueFontWeight | 0), e.sidebar != null) {
			if (typeof e.sidebar != "object") throw TypeError(".CustomThemeConfig.sidebar: object expected");
			n.sidebar = N.CustomThemeConfig.fromObject(e.sidebar, t + 1);
		}
		if (e.light != null) {
			if (typeof e.light != "object") throw TypeError(".CustomThemeConfig.light: object expected");
			n.light = N.CustomThemeConfig.fromObject(e.light, t + 1);
		}
		if (e.dark != null) {
			if (typeof e.dark != "object") throw TypeError(".CustomThemeConfig.dark: object expected");
			n.dark = N.CustomThemeConfig.fromObject(e.dark, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.fontFaces = [], r.chartCategoricalColors = [], r.headingFontWeights = [], r.headingFontSizes = [], r.chartSequentialColors = [], r.fontSources = [], r.chartDivergingColors = []), t.defaults && (r.primaryColor = "", r.secondaryBackgroundColor = "", r.backgroundColor = "", r.textColor = "", r.base = t.enums === String ? "LIGHT" : 0, r.headingFont = "", r.bodyFont = "", r.codeFont = ""), e.primaryColor != null && e.hasOwnProperty("primaryColor") && (r.primaryColor = e.primaryColor), e.secondaryBackgroundColor != null && e.hasOwnProperty("secondaryBackgroundColor") && (r.secondaryBackgroundColor = e.secondaryBackgroundColor), e.backgroundColor != null && e.hasOwnProperty("backgroundColor") && (r.backgroundColor = e.backgroundColor), e.textColor != null && e.hasOwnProperty("textColor") && (r.textColor = e.textColor), e.base != null && e.hasOwnProperty("base") && (r.base = t.enums === String ? N.CustomThemeConfig.BaseTheme[e.base] === void 0 ? e.base : N.CustomThemeConfig.BaseTheme[e.base] : e.base), e.headingFont != null && e.hasOwnProperty("headingFont") && (r.headingFont = e.headingFont), e.bodyFont != null && e.hasOwnProperty("bodyFont") && (r.bodyFont = e.bodyFont), e.codeFont != null && e.hasOwnProperty("codeFont") && (r.codeFont = e.codeFont), e.fontFaces && e.fontFaces.length) {
			r.fontFaces = Array(e.fontFaces.length);
			for (let i = 0; i < e.fontFaces.length; ++i) r.fontFaces[i] = N.FontFace.toObject(e.fontFaces[i], t, n + 1);
		}
		if (e.baseRadius != null && e.hasOwnProperty("baseRadius") && (r.baseRadius = e.baseRadius), e.borderColor != null && e.hasOwnProperty("borderColor") && (r.borderColor = e.borderColor), e.showWidgetBorder != null && e.hasOwnProperty("showWidgetBorder") && (r.showWidgetBorder = e.showWidgetBorder), e.linkColor != null && e.hasOwnProperty("linkColor") && (r.linkColor = e.linkColor), e.baseFontSize != null && e.hasOwnProperty("baseFontSize") && (r.baseFontSize = e.baseFontSize), e.showSidebarBorder != null && e.hasOwnProperty("showSidebarBorder") && (r.showSidebarBorder = e.showSidebarBorder), e.sidebar != null && e.hasOwnProperty("sidebar") && (r.sidebar = N.CustomThemeConfig.toObject(e.sidebar, t, n + 1)), e.codeBackgroundColor != null && e.hasOwnProperty("codeBackgroundColor") && (r.codeBackgroundColor = e.codeBackgroundColor), e.buttonRadius != null && e.hasOwnProperty("buttonRadius") && (r.buttonRadius = e.buttonRadius), e.dataframeBorderColor != null && e.hasOwnProperty("dataframeBorderColor") && (r.dataframeBorderColor = e.dataframeBorderColor), e.codeFontSize != null && e.hasOwnProperty("codeFontSize") && (r.codeFontSize = e.codeFontSize), e.linkUnderline != null && e.hasOwnProperty("linkUnderline") && (r.linkUnderline = e.linkUnderline), e.baseFontWeight != null && e.hasOwnProperty("baseFontWeight") && (r.baseFontWeight = e.baseFontWeight), e.dataframeHeaderBackgroundColor != null && e.hasOwnProperty("dataframeHeaderBackgroundColor") && (r.dataframeHeaderBackgroundColor = e.dataframeHeaderBackgroundColor), e.codeFontWeight != null && e.hasOwnProperty("codeFontWeight") && (r.codeFontWeight = e.codeFontWeight), e.chartCategoricalColors && e.chartCategoricalColors.length) {
			r.chartCategoricalColors = Array(e.chartCategoricalColors.length);
			for (let t = 0; t < e.chartCategoricalColors.length; ++t) r.chartCategoricalColors[t] = e.chartCategoricalColors[t];
		}
		if (e.headingFontWeights && e.headingFontWeights.length) {
			r.headingFontWeights = Array(e.headingFontWeights.length);
			for (let t = 0; t < e.headingFontWeights.length; ++t) r.headingFontWeights[t] = e.headingFontWeights[t];
		}
		if (e.headingFontSizes && e.headingFontSizes.length) {
			r.headingFontSizes = Array(e.headingFontSizes.length);
			for (let t = 0; t < e.headingFontSizes.length; ++t) r.headingFontSizes[t] = e.headingFontSizes[t];
		}
		if (e.chartSequentialColors && e.chartSequentialColors.length) {
			r.chartSequentialColors = Array(e.chartSequentialColors.length);
			for (let t = 0; t < e.chartSequentialColors.length; ++t) r.chartSequentialColors[t] = e.chartSequentialColors[t];
		}
		if (e.fontSources && e.fontSources.length) {
			r.fontSources = Array(e.fontSources.length);
			for (let i = 0; i < e.fontSources.length; ++i) r.fontSources[i] = N.FontSource.toObject(e.fontSources[i], t, n + 1);
		}
		if (e.redColor != null && e.hasOwnProperty("redColor") && (r.redColor = e.redColor), e.orangeColor != null && e.hasOwnProperty("orangeColor") && (r.orangeColor = e.orangeColor), e.yellowColor != null && e.hasOwnProperty("yellowColor") && (r.yellowColor = e.yellowColor), e.blueColor != null && e.hasOwnProperty("blueColor") && (r.blueColor = e.blueColor), e.greenColor != null && e.hasOwnProperty("greenColor") && (r.greenColor = e.greenColor), e.violetColor != null && e.hasOwnProperty("violetColor") && (r.violetColor = e.violetColor), e.grayColor != null && e.hasOwnProperty("grayColor") && (r.grayColor = e.grayColor), e.redBackgroundColor != null && e.hasOwnProperty("redBackgroundColor") && (r.redBackgroundColor = e.redBackgroundColor), e.orangeBackgroundColor != null && e.hasOwnProperty("orangeBackgroundColor") && (r.orangeBackgroundColor = e.orangeBackgroundColor), e.yellowBackgroundColor != null && e.hasOwnProperty("yellowBackgroundColor") && (r.yellowBackgroundColor = e.yellowBackgroundColor), e.blueBackgroundColor != null && e.hasOwnProperty("blueBackgroundColor") && (r.blueBackgroundColor = e.blueBackgroundColor), e.greenBackgroundColor != null && e.hasOwnProperty("greenBackgroundColor") && (r.greenBackgroundColor = e.greenBackgroundColor), e.violetBackgroundColor != null && e.hasOwnProperty("violetBackgroundColor") && (r.violetBackgroundColor = e.violetBackgroundColor), e.grayBackgroundColor != null && e.hasOwnProperty("grayBackgroundColor") && (r.grayBackgroundColor = e.grayBackgroundColor), e.redTextColor != null && e.hasOwnProperty("redTextColor") && (r.redTextColor = e.redTextColor), e.orangeTextColor != null && e.hasOwnProperty("orangeTextColor") && (r.orangeTextColor = e.orangeTextColor), e.yellowTextColor != null && e.hasOwnProperty("yellowTextColor") && (r.yellowTextColor = e.yellowTextColor), e.blueTextColor != null && e.hasOwnProperty("blueTextColor") && (r.blueTextColor = e.blueTextColor), e.greenTextColor != null && e.hasOwnProperty("greenTextColor") && (r.greenTextColor = e.greenTextColor), e.violetTextColor != null && e.hasOwnProperty("violetTextColor") && (r.violetTextColor = e.violetTextColor), e.grayTextColor != null && e.hasOwnProperty("grayTextColor") && (r.grayTextColor = e.grayTextColor), e.codeTextColor != null && e.hasOwnProperty("codeTextColor") && (r.codeTextColor = e.codeTextColor), e.light != null && e.hasOwnProperty("light") && (r.light = N.CustomThemeConfig.toObject(e.light, t, n + 1)), e.dark != null && e.hasOwnProperty("dark") && (r.dark = N.CustomThemeConfig.toObject(e.dark, t, n + 1)), e.chartDivergingColors && e.chartDivergingColors.length) {
			r.chartDivergingColors = Array(e.chartDivergingColors.length);
			for (let t = 0; t < e.chartDivergingColors.length; ++t) r.chartDivergingColors[t] = e.chartDivergingColors[t];
		}
		return e.metricValueFontSize != null && e.hasOwnProperty("metricValueFontSize") && (r.metricValueFontSize = e.metricValueFontSize), e.metricValueFontWeight != null && e.hasOwnProperty("metricValueFontWeight") && (r.metricValueFontWeight = e.metricValueFontWeight), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/CustomThemeConfig";
	}, e.BaseTheme = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "LIGHT"] = 0, t[e[1] = "DARK"] = 1, t;
	})(), e;
})(), N.FontFace = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.url = "", e.prototype.family = "", e.prototype.weightRange = "", e.prototype.style = "", e.prototype.unicodeRange = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.url != null && Object.hasOwnProperty.call(e, "url") && t.uint32(10).string(e.url), e.family != null && Object.hasOwnProperty.call(e, "family") && t.uint32(18).string(e.family), e.style != null && Object.hasOwnProperty.call(e, "style") && t.uint32(34).string(e.style), e.weightRange != null && Object.hasOwnProperty.call(e, "weightRange") && t.uint32(42).string(e.weightRange), e.unicodeRange != null && Object.hasOwnProperty.call(e, "unicodeRange") && t.uint32(50).string(e.unicodeRange), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.FontFace(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.url = s : delete o.url;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.family = s : delete o.family;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.weightRange = s : delete o.weightRange;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.style = s : delete o.style;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.unicodeRange = s : delete o.unicodeRange;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.FontFace) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.FontFace();
		return e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = String(e.url)), e.family != null && (typeof e.family != "string" || e.family.length) && (n.family = String(e.family)), e.weightRange != null && (typeof e.weightRange != "string" || e.weightRange.length) && (n.weightRange = String(e.weightRange)), e.style != null && (typeof e.style != "string" || e.style.length) && (n.style = String(e.style)), e.unicodeRange != null && (typeof e.unicodeRange != "string" || e.unicodeRange.length) && (n.unicodeRange = String(e.unicodeRange)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.url = "", r.family = "", r.style = "", r.weightRange = "", r.unicodeRange = ""), e.url != null && e.hasOwnProperty("url") && (r.url = e.url), e.family != null && e.hasOwnProperty("family") && (r.family = e.family), e.style != null && e.hasOwnProperty("style") && (r.style = e.style), e.weightRange != null && e.hasOwnProperty("weightRange") && (r.weightRange = e.weightRange), e.unicodeRange != null && e.hasOwnProperty("unicodeRange") && (r.unicodeRange = e.unicodeRange), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/FontFace";
	}, e;
})(), N.FontSource = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.configName = "", e.prototype.sourceUrl = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.configName != null && Object.hasOwnProperty.call(e, "configName") && t.uint32(10).string(e.configName), e.sourceUrl != null && Object.hasOwnProperty.call(e, "sourceUrl") && t.uint32(18).string(e.sourceUrl), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.FontSource(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.configName = s : delete o.configName;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.sourceUrl = s : delete o.sourceUrl;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.FontSource) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.FontSource();
		return e.configName != null && (typeof e.configName != "string" || e.configName.length) && (n.configName = String(e.configName)), e.sourceUrl != null && (typeof e.sourceUrl != "string" || e.sourceUrl.length) && (n.sourceUrl = String(e.sourceUrl)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.configName = "", r.sourceUrl = ""), e.configName != null && e.hasOwnProperty("configName") && (r.configName = e.configName), e.sourceUrl != null && e.hasOwnProperty("sourceUrl") && (r.sourceUrl = e.sourceUrl), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/FontSource";
	}, e;
})(), N.UserInfo = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.installationId = "", e.prototype.installationIdV3 = "", e.prototype.installationIdV4 = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.installationId != null && Object.hasOwnProperty.call(e, "installationId") && t.uint32(10).string(e.installationId), e.installationIdV3 != null && Object.hasOwnProperty.call(e, "installationIdV3") && t.uint32(42).string(e.installationIdV3), e.installationIdV4 != null && Object.hasOwnProperty.call(e, "installationIdV4") && t.uint32(50).string(e.installationIdV4), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.UserInfo(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.installationId = s : delete o.installationId;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.string()).length ? o.installationIdV3 = s : delete o.installationIdV3;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.installationIdV4 = s : delete o.installationIdV4;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.UserInfo) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.UserInfo();
		return e.installationId != null && (typeof e.installationId != "string" || e.installationId.length) && (n.installationId = String(e.installationId)), e.installationIdV3 != null && (typeof e.installationIdV3 != "string" || e.installationIdV3.length) && (n.installationIdV3 = String(e.installationIdV3)), e.installationIdV4 != null && (typeof e.installationIdV4 != "string" || e.installationIdV4.length) && (n.installationIdV4 = String(e.installationIdV4)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.installationId = "", r.installationIdV3 = "", r.installationIdV4 = ""), e.installationId != null && e.hasOwnProperty("installationId") && (r.installationId = e.installationId), e.installationIdV3 != null && e.hasOwnProperty("installationIdV3") && (r.installationIdV3 = e.installationIdV3), e.installationIdV4 != null && e.hasOwnProperty("installationIdV4") && (r.installationIdV4 = e.installationIdV4), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/UserInfo";
	}, e;
})(), N.EnvironmentInfo = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.streamlitVersion = "", e.prototype.pythonVersion = "", e.prototype.serverOs = "", e.prototype.hasDisplay = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.streamlitVersion != null && Object.hasOwnProperty.call(e, "streamlitVersion") && t.uint32(10).string(e.streamlitVersion), e.pythonVersion != null && Object.hasOwnProperty.call(e, "pythonVersion") && t.uint32(18).string(e.pythonVersion), e.serverOs != null && Object.hasOwnProperty.call(e, "serverOs") && t.uint32(26).string(e.serverOs), e.hasDisplay != null && Object.hasOwnProperty.call(e, "hasDisplay") && t.uint32(32).bool(e.hasDisplay), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.EnvironmentInfo(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.streamlitVersion = s : delete o.streamlitVersion;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.pythonVersion = s : delete o.pythonVersion;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.serverOs = s : delete o.serverOs;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.hasDisplay = s : delete o.hasDisplay;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.EnvironmentInfo) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.EnvironmentInfo();
		return e.streamlitVersion != null && (typeof e.streamlitVersion != "string" || e.streamlitVersion.length) && (n.streamlitVersion = String(e.streamlitVersion)), e.pythonVersion != null && (typeof e.pythonVersion != "string" || e.pythonVersion.length) && (n.pythonVersion = String(e.pythonVersion)), e.serverOs != null && (typeof e.serverOs != "string" || e.serverOs.length) && (n.serverOs = String(e.serverOs)), e.hasDisplay != null && e.hasDisplay && (n.hasDisplay = !!e.hasDisplay), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.streamlitVersion = "", r.pythonVersion = "", r.serverOs = "", r.hasDisplay = !1), e.streamlitVersion != null && e.hasOwnProperty("streamlitVersion") && (r.streamlitVersion = e.streamlitVersion), e.pythonVersion != null && e.hasOwnProperty("pythonVersion") && (r.pythonVersion = e.pythonVersion), e.serverOs != null && e.hasOwnProperty("serverOs") && (r.serverOs = e.serverOs), e.hasDisplay != null && e.hasOwnProperty("hasDisplay") && (r.hasDisplay = e.hasDisplay), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/EnvironmentInfo";
	}, e;
})(), N.SessionStatus = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.runOnSave = !1, e.prototype.scriptIsRunning = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.runOnSave != null && Object.hasOwnProperty.call(e, "runOnSave") && t.uint32(8).bool(e.runOnSave), e.scriptIsRunning != null && Object.hasOwnProperty.call(e, "scriptIsRunning") && t.uint32(16).bool(e.scriptIsRunning), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.SessionStatus(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					(s = e.bool()) ? o.runOnSave = s : delete o.runOnSave;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.bool()) ? o.scriptIsRunning = s : delete o.scriptIsRunning;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.SessionStatus) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.SessionStatus();
		return e.runOnSave != null && e.runOnSave && (n.runOnSave = !!e.runOnSave), e.scriptIsRunning != null && e.scriptIsRunning && (n.scriptIsRunning = !!e.scriptIsRunning), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.runOnSave = !1, r.scriptIsRunning = !1), e.runOnSave != null && e.hasOwnProperty("runOnSave") && (r.runOnSave = e.runOnSave), e.scriptIsRunning != null && e.hasOwnProperty("scriptIsRunning") && (r.scriptIsRunning = e.scriptIsRunning), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/SessionStatus";
	}, e;
})(), N.PageConfig = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.title = "", e.prototype.favicon = "", e.prototype.layout = 0, e.prototype.initialSidebarState = 0, e.prototype.menuItems = null, e.prototype.initialSidebarWidth = null;
	let t;
	return Object.defineProperty(e.prototype, "_initialSidebarWidth", {
		get: M.oneOfGetter(t = ["initialSidebarWidth"]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.title != null && Object.hasOwnProperty.call(e, "title") && t.uint32(10).string(e.title), e.favicon != null && Object.hasOwnProperty.call(e, "favicon") && t.uint32(18).string(e.favicon), e.layout != null && Object.hasOwnProperty.call(e, "layout") && t.uint32(24).int32(e.layout), e.initialSidebarState != null && Object.hasOwnProperty.call(e, "initialSidebarState") && t.uint32(32).int32(e.initialSidebarState), e.menuItems != null && Object.hasOwnProperty.call(e, "menuItems") && N.PageConfig.MenuItems.encode(e.menuItems, t.uint32(42).fork(), n + 1).ldelim(), e.initialSidebarWidth != null && Object.hasOwnProperty.call(e, "initialSidebarWidth") && N.PageConfig.SidebarWidthConfig.encode(e.initialSidebarWidth, t.uint32(50).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.PageConfig(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.title = s : delete o.title;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.favicon = s : delete o.favicon;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.int32()) ? o.layout = s : delete o.layout;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.int32()) ? o.initialSidebarState = s : delete o.initialSidebarState;
					continue;
				case 5:
					if (a !== 2) break;
					o.menuItems = N.PageConfig.MenuItems.decode(e, e.uint32(), void 0, r + 1, o.menuItems);
					continue;
				case 6:
					if (a !== 2) break;
					o.initialSidebarWidth = N.PageConfig.SidebarWidthConfig.decode(e, e.uint32(), void 0, r + 1, o.initialSidebarWidth), o._initialSidebarWidth = "initialSidebarWidth";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.PageConfig) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.PageConfig();
		if (e.title != null && (typeof e.title != "string" || e.title.length) && (n.title = String(e.title)), e.favicon != null && (typeof e.favicon != "string" || e.favicon.length) && (n.favicon = String(e.favicon)), e.layout !== 0 && (typeof e.layout != "string" || N.PageConfig.Layout[e.layout] !== 0)) switch (e.layout) {
			default:
				if (typeof e.layout == "number") {
					n.layout = e.layout;
					break;
				}
				break;
			case "CENTERED":
			case 0:
				n.layout = 0;
				break;
			case "WIDE":
			case 1:
				n.layout = 1;
				break;
			case "LAYOUT_UNSET":
			case 2:
				n.layout = 2;
				break;
		}
		if (e.initialSidebarState !== 0 && (typeof e.initialSidebarState != "string" || N.PageConfig.SidebarState[e.initialSidebarState] !== 0)) switch (e.initialSidebarState) {
			default:
				if (typeof e.initialSidebarState == "number") {
					n.initialSidebarState = e.initialSidebarState;
					break;
				}
				break;
			case "AUTO":
			case 0:
				n.initialSidebarState = 0;
				break;
			case "EXPANDED":
			case 1:
				n.initialSidebarState = 1;
				break;
			case "COLLAPSED":
			case 2:
				n.initialSidebarState = 2;
				break;
			case "SIDEBAR_UNSET":
			case 3:
				n.initialSidebarState = 3;
				break;
		}
		if (e.menuItems != null) {
			if (typeof e.menuItems != "object") throw TypeError(".PageConfig.menuItems: object expected");
			n.menuItems = N.PageConfig.MenuItems.fromObject(e.menuItems, t + 1);
		}
		if (e.initialSidebarWidth != null) {
			if (typeof e.initialSidebarWidth != "object") throw TypeError(".PageConfig.initialSidebarWidth: object expected");
			n.initialSidebarWidth = N.PageConfig.SidebarWidthConfig.fromObject(e.initialSidebarWidth, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.title = "", r.favicon = "", r.layout = t.enums === String ? "CENTERED" : 0, r.initialSidebarState = t.enums === String ? "AUTO" : 0, r.menuItems = null), e.title != null && e.hasOwnProperty("title") && (r.title = e.title), e.favicon != null && e.hasOwnProperty("favicon") && (r.favicon = e.favicon), e.layout != null && e.hasOwnProperty("layout") && (r.layout = t.enums === String ? N.PageConfig.Layout[e.layout] === void 0 ? e.layout : N.PageConfig.Layout[e.layout] : e.layout), e.initialSidebarState != null && e.hasOwnProperty("initialSidebarState") && (r.initialSidebarState = t.enums === String ? N.PageConfig.SidebarState[e.initialSidebarState] === void 0 ? e.initialSidebarState : N.PageConfig.SidebarState[e.initialSidebarState] : e.initialSidebarState), e.menuItems != null && e.hasOwnProperty("menuItems") && (r.menuItems = N.PageConfig.MenuItems.toObject(e.menuItems, t, n + 1)), e.initialSidebarWidth != null && e.hasOwnProperty("initialSidebarWidth") && (r.initialSidebarWidth = N.PageConfig.SidebarWidthConfig.toObject(e.initialSidebarWidth, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/PageConfig";
	}, e.MenuItems = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.getHelpUrl = "", e.prototype.hideGetHelp = !1, e.prototype.reportABugUrl = "", e.prototype.hideReportABug = !1, e.prototype.aboutSectionMd = "", e.prototype.clearAboutMd = !1, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.getHelpUrl != null && Object.hasOwnProperty.call(e, "getHelpUrl") && t.uint32(10).string(e.getHelpUrl), e.hideGetHelp != null && Object.hasOwnProperty.call(e, "hideGetHelp") && t.uint32(16).bool(e.hideGetHelp), e.reportABugUrl != null && Object.hasOwnProperty.call(e, "reportABugUrl") && t.uint32(26).string(e.reportABugUrl), e.hideReportABug != null && Object.hasOwnProperty.call(e, "hideReportABug") && t.uint32(32).bool(e.hideReportABug), e.aboutSectionMd != null && Object.hasOwnProperty.call(e, "aboutSectionMd") && t.uint32(42).string(e.aboutSectionMd), e.clearAboutMd != null && Object.hasOwnProperty.call(e, "clearAboutMd") && t.uint32(48).bool(e.clearAboutMd), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.PageConfig.MenuItems(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.string()).length ? o.getHelpUrl = s : delete o.getHelpUrl;
						continue;
					case 2:
						if (a !== 0) break;
						(s = e.bool()) ? o.hideGetHelp = s : delete o.hideGetHelp;
						continue;
					case 3:
						if (a !== 2) break;
						(s = e.string()).length ? o.reportABugUrl = s : delete o.reportABugUrl;
						continue;
					case 4:
						if (a !== 0) break;
						(s = e.bool()) ? o.hideReportABug = s : delete o.hideReportABug;
						continue;
					case 5:
						if (a !== 2) break;
						(s = e.string()).length ? o.aboutSectionMd = s : delete o.aboutSectionMd;
						continue;
					case 6:
						if (a !== 0) break;
						(s = e.bool()) ? o.clearAboutMd = s : delete o.clearAboutMd;
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.PageConfig.MenuItems) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.PageConfig.MenuItems();
			return e.getHelpUrl != null && (typeof e.getHelpUrl != "string" || e.getHelpUrl.length) && (n.getHelpUrl = String(e.getHelpUrl)), e.hideGetHelp != null && e.hideGetHelp && (n.hideGetHelp = !!e.hideGetHelp), e.reportABugUrl != null && (typeof e.reportABugUrl != "string" || e.reportABugUrl.length) && (n.reportABugUrl = String(e.reportABugUrl)), e.hideReportABug != null && e.hideReportABug && (n.hideReportABug = !!e.hideReportABug), e.aboutSectionMd != null && (typeof e.aboutSectionMd != "string" || e.aboutSectionMd.length) && (n.aboutSectionMd = String(e.aboutSectionMd)), e.clearAboutMd != null && e.clearAboutMd && (n.clearAboutMd = !!e.clearAboutMd), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.getHelpUrl = "", r.hideGetHelp = !1, r.reportABugUrl = "", r.hideReportABug = !1, r.aboutSectionMd = "", r.clearAboutMd = !1), e.getHelpUrl != null && e.hasOwnProperty("getHelpUrl") && (r.getHelpUrl = e.getHelpUrl), e.hideGetHelp != null && e.hasOwnProperty("hideGetHelp") && (r.hideGetHelp = e.hideGetHelp), e.reportABugUrl != null && e.hasOwnProperty("reportABugUrl") && (r.reportABugUrl = e.reportABugUrl), e.hideReportABug != null && e.hasOwnProperty("hideReportABug") && (r.hideReportABug = e.hideReportABug), e.aboutSectionMd != null && e.hasOwnProperty("aboutSectionMd") && (r.aboutSectionMd = e.aboutSectionMd), e.clearAboutMd != null && e.hasOwnProperty("clearAboutMd") && (r.clearAboutMd = e.clearAboutMd), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/PageConfig.MenuItems";
		}, e;
	})(), e.Layout = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "CENTERED"] = 0, t[e[1] = "WIDE"] = 1, t[e[2] = "LAYOUT_UNSET"] = 2, t;
	})(), e.SidebarState = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "AUTO"] = 0, t[e[1] = "EXPANDED"] = 1, t[e[2] = "COLLAPSED"] = 2, t[e[3] = "SIDEBAR_UNSET"] = 3, t;
	})(), e.SidebarWidthConfig = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.pixelWidth = null;
		let t;
		return Object.defineProperty(e.prototype, "widthSpec", {
			get: M.oneOfGetter(t = ["pixelWidth"]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.pixelWidth != null && Object.hasOwnProperty.call(e, "pixelWidth") && t.uint32(8).uint32(e.pixelWidth), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.PageConfig.SidebarWidthConfig();
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						o.pixelWidth = e.uint32(), o.widthSpec = "pixelWidth";
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.PageConfig.SidebarWidthConfig) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.PageConfig.SidebarWidthConfig();
			return e.pixelWidth != null && (n.pixelWidth = e.pixelWidth >>> 0), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return e.pixelWidth != null && e.hasOwnProperty("pixelWidth") && (r.pixelWidth = e.pixelWidth, t.oneofs && (r.widthSpec = "pixelWidth")), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/PageConfig.SidebarWidthConfig";
		}, e;
	})(), e;
})(), N.PageInfo = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.queryString = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.queryString != null && Object.hasOwnProperty.call(e, "queryString") && t.uint32(10).string(e.queryString), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.PageInfo(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.queryString = s : delete o.queryString;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.PageInfo) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.PageInfo();
		return e.queryString != null && (typeof e.queryString != "string" || e.queryString.length) && (n.queryString = String(e.queryString)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.queryString = ""), e.queryString != null && e.hasOwnProperty("queryString") && (r.queryString = e.queryString), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/PageInfo";
	}, e;
})(), N.PageNotFound = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.pageName = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.pageName != null && Object.hasOwnProperty.call(e, "pageName") && t.uint32(10).string(e.pageName), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.PageNotFound(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.pageName = s : delete o.pageName;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.PageNotFound) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.PageNotFound();
		return e.pageName != null && (typeof e.pageName != "string" || e.pageName.length) && (n.pageName = String(e.pageName)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.pageName = ""), e.pageName != null && e.hasOwnProperty("pageName") && (r.pageName = e.pageName), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/PageNotFound";
	}, e;
})(), N.PageProfile = (() => {
	function e(e) {
		if (this.commands = [], this.config = [], this.attributions = [], this.installedSkills = [], this.installedAgents = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.commands = M.emptyArray, e.prototype.execTime = M.Long ? M.Long.fromBits(0, 0, !1) : 0, e.prototype.prepTime = M.Long ? M.Long.fromBits(0, 0, !1) : 0, e.prototype.config = M.emptyArray, e.prototype.uncaughtException = "", e.prototype.attributions = M.emptyArray, e.prototype.os = "", e.prototype.timezone = "", e.prototype.headless = !1, e.prototype.isFragmentRun = !1, e.prototype.serverMode = "", e.prototype.installedSkills = M.emptyArray, e.prototype.installedAgents = M.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.commands != null && e.commands.length) for (let r = 0; r < e.commands.length; ++r) N.Command.encode(e.commands[r], t.uint32(10).fork(), n + 1).ldelim();
		if (e.execTime != null && Object.hasOwnProperty.call(e, "execTime") && t.uint32(16).int64(e.execTime), e.prepTime != null && Object.hasOwnProperty.call(e, "prepTime") && t.uint32(24).int64(e.prepTime), e.config != null && e.config.length) for (let n = 0; n < e.config.length; ++n) t.uint32(42).string(e.config[n]);
		if (e.uncaughtException != null && Object.hasOwnProperty.call(e, "uncaughtException") && t.uint32(50).string(e.uncaughtException), e.attributions != null && e.attributions.length) for (let n = 0; n < e.attributions.length; ++n) t.uint32(58).string(e.attributions[n]);
		if (e.os != null && Object.hasOwnProperty.call(e, "os") && t.uint32(66).string(e.os), e.timezone != null && Object.hasOwnProperty.call(e, "timezone") && t.uint32(74).string(e.timezone), e.headless != null && Object.hasOwnProperty.call(e, "headless") && t.uint32(80).bool(e.headless), e.isFragmentRun != null && Object.hasOwnProperty.call(e, "isFragmentRun") && t.uint32(88).bool(e.isFragmentRun), e.serverMode != null && Object.hasOwnProperty.call(e, "serverMode") && t.uint32(98).string(e.serverMode), e.installedSkills != null && e.installedSkills.length) for (let n = 0; n < e.installedSkills.length; ++n) t.uint32(106).string(e.installedSkills[n]);
		if (e.installedAgents != null && e.installedAgents.length) for (let n = 0; n < e.installedAgents.length; ++n) t.uint32(114).string(e.installedAgents[n]);
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.PageProfile(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.commands && o.commands.length || (o.commands = []), o.commands.push(N.Command.decode(e, e.uint32(), void 0, r + 1));
					continue;
				case 2:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.execTime = s : delete o.execTime;
					continue;
				case 3:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.prepTime = s : delete o.prepTime;
					continue;
				case 5:
					if (a !== 2) break;
					o.config && o.config.length || (o.config = []), o.config.push(e.string());
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.uncaughtException = s : delete o.uncaughtException;
					continue;
				case 7:
					if (a !== 2) break;
					o.attributions && o.attributions.length || (o.attributions = []), o.attributions.push(e.string());
					continue;
				case 8:
					if (a !== 2) break;
					(s = e.string()).length ? o.os = s : delete o.os;
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.string()).length ? o.timezone = s : delete o.timezone;
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.bool()) ? o.headless = s : delete o.headless;
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.isFragmentRun = s : delete o.isFragmentRun;
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.string()).length ? o.serverMode = s : delete o.serverMode;
					continue;
				case 13:
					if (a !== 2) break;
					o.installedSkills && o.installedSkills.length || (o.installedSkills = []), o.installedSkills.push(e.string());
					continue;
				case 14:
					if (a !== 2) break;
					o.installedAgents && o.installedAgents.length || (o.installedAgents = []), o.installedAgents.push(e.string());
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.PageProfile) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.PageProfile();
		if (e.commands) {
			if (!Array.isArray(e.commands)) throw TypeError(".PageProfile.commands: array expected");
			n.commands = Array(e.commands.length);
			for (let r = 0; r < e.commands.length; ++r) {
				if (typeof e.commands[r] != "object") throw TypeError(".PageProfile.commands: object expected");
				n.commands[r] = N.Command.fromObject(e.commands[r], t + 1);
			}
		}
		if (e.execTime != null && (typeof e.execTime == "object" ? e.execTime.low || e.execTime.high : Number(e.execTime) !== 0) && (M.Long ? n.execTime = M.Long.fromValue(e.execTime, !1) : typeof e.execTime == "string" ? n.execTime = parseInt(e.execTime, 10) : typeof e.execTime == "number" ? n.execTime = e.execTime : typeof e.execTime == "object" && (n.execTime = new M.LongBits(e.execTime.low >>> 0, e.execTime.high >>> 0).toNumber())), e.prepTime != null && (typeof e.prepTime == "object" ? e.prepTime.low || e.prepTime.high : Number(e.prepTime) !== 0) && (M.Long ? n.prepTime = M.Long.fromValue(e.prepTime, !1) : typeof e.prepTime == "string" ? n.prepTime = parseInt(e.prepTime, 10) : typeof e.prepTime == "number" ? n.prepTime = e.prepTime : typeof e.prepTime == "object" && (n.prepTime = new M.LongBits(e.prepTime.low >>> 0, e.prepTime.high >>> 0).toNumber())), e.config) {
			if (!Array.isArray(e.config)) throw TypeError(".PageProfile.config: array expected");
			n.config = Array(e.config.length);
			for (let t = 0; t < e.config.length; ++t) n.config[t] = String(e.config[t]);
		}
		if (e.uncaughtException != null && (typeof e.uncaughtException != "string" || e.uncaughtException.length) && (n.uncaughtException = String(e.uncaughtException)), e.attributions) {
			if (!Array.isArray(e.attributions)) throw TypeError(".PageProfile.attributions: array expected");
			n.attributions = Array(e.attributions.length);
			for (let t = 0; t < e.attributions.length; ++t) n.attributions[t] = String(e.attributions[t]);
		}
		if (e.os != null && (typeof e.os != "string" || e.os.length) && (n.os = String(e.os)), e.timezone != null && (typeof e.timezone != "string" || e.timezone.length) && (n.timezone = String(e.timezone)), e.headless != null && e.headless && (n.headless = !!e.headless), e.isFragmentRun != null && e.isFragmentRun && (n.isFragmentRun = !!e.isFragmentRun), e.serverMode != null && (typeof e.serverMode != "string" || e.serverMode.length) && (n.serverMode = String(e.serverMode)), e.installedSkills) {
			if (!Array.isArray(e.installedSkills)) throw TypeError(".PageProfile.installedSkills: array expected");
			n.installedSkills = Array(e.installedSkills.length);
			for (let t = 0; t < e.installedSkills.length; ++t) n.installedSkills[t] = String(e.installedSkills[t]);
		}
		if (e.installedAgents) {
			if (!Array.isArray(e.installedAgents)) throw TypeError(".PageProfile.installedAgents: array expected");
			n.installedAgents = Array(e.installedAgents.length);
			for (let t = 0; t < e.installedAgents.length; ++t) n.installedAgents[t] = String(e.installedAgents[t]);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.commands = [], r.config = [], r.attributions = [], r.installedSkills = [], r.installedAgents = []), t.defaults) {
			if (M.Long) {
				let e = new M.Long(0, 0, !1);
				r.execTime = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
			} else r.execTime = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
			if (M.Long) {
				let e = new M.Long(0, 0, !1);
				r.prepTime = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
			} else r.prepTime = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
			r.uncaughtException = "", r.os = "", r.timezone = "", r.headless = !1, r.isFragmentRun = !1, r.serverMode = "";
		}
		if (e.commands && e.commands.length) {
			r.commands = Array(e.commands.length);
			for (let i = 0; i < e.commands.length; ++i) r.commands[i] = N.Command.toObject(e.commands[i], t, n + 1);
		}
		if (e.execTime != null && e.hasOwnProperty("execTime") && (typeof BigInt < "u" && t.longs === BigInt ? r.execTime = typeof e.execTime == "number" ? BigInt(e.execTime) : M.Long.fromBits(e.execTime.low >>> 0, e.execTime.high >>> 0, !1).toBigInt() : typeof e.execTime == "number" ? r.execTime = t.longs === String ? String(e.execTime) : e.execTime : r.execTime = t.longs === String ? M.Long.prototype.toString.call(e.execTime) : t.longs === Number ? new M.LongBits(e.execTime.low >>> 0, e.execTime.high >>> 0).toNumber() : e.execTime), e.prepTime != null && e.hasOwnProperty("prepTime") && (typeof BigInt < "u" && t.longs === BigInt ? r.prepTime = typeof e.prepTime == "number" ? BigInt(e.prepTime) : M.Long.fromBits(e.prepTime.low >>> 0, e.prepTime.high >>> 0, !1).toBigInt() : typeof e.prepTime == "number" ? r.prepTime = t.longs === String ? String(e.prepTime) : e.prepTime : r.prepTime = t.longs === String ? M.Long.prototype.toString.call(e.prepTime) : t.longs === Number ? new M.LongBits(e.prepTime.low >>> 0, e.prepTime.high >>> 0).toNumber() : e.prepTime), e.config && e.config.length) {
			r.config = Array(e.config.length);
			for (let t = 0; t < e.config.length; ++t) r.config[t] = e.config[t];
		}
		if (e.uncaughtException != null && e.hasOwnProperty("uncaughtException") && (r.uncaughtException = e.uncaughtException), e.attributions && e.attributions.length) {
			r.attributions = Array(e.attributions.length);
			for (let t = 0; t < e.attributions.length; ++t) r.attributions[t] = e.attributions[t];
		}
		if (e.os != null && e.hasOwnProperty("os") && (r.os = e.os), e.timezone != null && e.hasOwnProperty("timezone") && (r.timezone = e.timezone), e.headless != null && e.hasOwnProperty("headless") && (r.headless = e.headless), e.isFragmentRun != null && e.hasOwnProperty("isFragmentRun") && (r.isFragmentRun = e.isFragmentRun), e.serverMode != null && e.hasOwnProperty("serverMode") && (r.serverMode = e.serverMode), e.installedSkills && e.installedSkills.length) {
			r.installedSkills = Array(e.installedSkills.length);
			for (let t = 0; t < e.installedSkills.length; ++t) r.installedSkills[t] = e.installedSkills[t];
		}
		if (e.installedAgents && e.installedAgents.length) {
			r.installedAgents = Array(e.installedAgents.length);
			for (let t = 0; t < e.installedAgents.length; ++t) r.installedAgents[t] = e.installedAgents[t];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/PageProfile";
	}, e;
})(), N.Argument = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.k = "", e.prototype.t = "", e.prototype.m = "", e.prototype.p = 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.k != null && Object.hasOwnProperty.call(e, "k") && t.uint32(10).string(e.k), e.t != null && Object.hasOwnProperty.call(e, "t") && t.uint32(18).string(e.t), e.m != null && Object.hasOwnProperty.call(e, "m") && t.uint32(26).string(e.m), e.p != null && Object.hasOwnProperty.call(e, "p") && t.uint32(40).int32(e.p), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Argument(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.k = s : delete o.k;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.t = s : delete o.t;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.m = s : delete o.m;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.int32()) ? o.p = s : delete o.p;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Argument) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Argument();
		return e.k != null && (typeof e.k != "string" || e.k.length) && (n.k = String(e.k)), e.t != null && (typeof e.t != "string" || e.t.length) && (n.t = String(e.t)), e.m != null && (typeof e.m != "string" || e.m.length) && (n.m = String(e.m)), e.p != null && Number(e.p) !== 0 && (n.p = e.p | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.k = "", r.t = "", r.m = "", r.p = 0), e.k != null && e.hasOwnProperty("k") && (r.k = e.k), e.t != null && e.hasOwnProperty("t") && (r.t = e.t), e.m != null && e.hasOwnProperty("m") && (r.m = e.m), e.p != null && e.hasOwnProperty("p") && (r.p = e.p), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Argument";
	}, e;
})(), N.Command = (() => {
	function e(e) {
		if (this.args = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.name = "", e.prototype.args = M.emptyArray, e.prototype.time = M.Long ? M.Long.fromBits(0, 0, !1) : 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(10).string(e.name), e.args != null && e.args.length) for (let r = 0; r < e.args.length; ++r) N.Argument.encode(e.args[r], t.uint32(18).fork(), n + 1).ldelim();
		if (e.time != null && Object.hasOwnProperty.call(e, "time") && t.uint32(32).int64(e.time), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.Command(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.name = s : delete o.name;
					continue;
				case 2:
					if (a !== 2) break;
					o.args && o.args.length || (o.args = []), o.args.push(N.Argument.decode(e, e.uint32(), void 0, r + 1));
					continue;
				case 4:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.time = s : delete o.time;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.Command) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.Command();
		if (e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = String(e.name)), e.args) {
			if (!Array.isArray(e.args)) throw TypeError(".Command.args: array expected");
			n.args = Array(e.args.length);
			for (let r = 0; r < e.args.length; ++r) {
				if (typeof e.args[r] != "object") throw TypeError(".Command.args: object expected");
				n.args[r] = N.Argument.fromObject(e.args[r], t + 1);
			}
		}
		return e.time != null && (typeof e.time == "object" ? e.time.low || e.time.high : Number(e.time) !== 0) && (M.Long ? n.time = M.Long.fromValue(e.time, !1) : typeof e.time == "string" ? n.time = parseInt(e.time, 10) : typeof e.time == "number" ? n.time = e.time : typeof e.time == "object" && (n.time = new M.LongBits(e.time.low >>> 0, e.time.high >>> 0).toNumber())), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.args = []), t.defaults) if (r.name = "", M.Long) {
			let e = new M.Long(0, 0, !1);
			r.time = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
		} else r.time = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
		if (e.name != null && e.hasOwnProperty("name") && (r.name = e.name), e.args && e.args.length) {
			r.args = Array(e.args.length);
			for (let i = 0; i < e.args.length; ++i) r.args[i] = N.Argument.toObject(e.args[i], t, n + 1);
		}
		return e.time != null && e.hasOwnProperty("time") && (typeof BigInt < "u" && t.longs === BigInt ? r.time = typeof e.time == "number" ? BigInt(e.time) : M.Long.fromBits(e.time.low >>> 0, e.time.high >>> 0, !1).toBigInt() : typeof e.time == "number" ? r.time = t.longs === String ? String(e.time) : e.time : r.time = t.longs === String ? M.Long.prototype.toString.call(e.time) : t.longs === Number ? new M.LongBits(e.time.low >>> 0, e.time.high >>> 0).toNumber() : e.time), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/Command";
	}, e;
})(), N.ParentMessage = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.message = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.message != null && Object.hasOwnProperty.call(e, "message") && t.uint32(10).string(e.message), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.ParentMessage(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.message = s : delete o.message;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.ParentMessage) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.ParentMessage();
		return e.message != null && (typeof e.message != "string" || e.message.length) && (n.message = String(e.message)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.message = ""), e.message != null && e.hasOwnProperty("message") && (r.message = e.message), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/ParentMessage";
	}, e;
})(), N.SessionEvent = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	e.prototype.scriptChangedOnDisk = null, e.prototype.scriptWasManuallyStopped = null, e.prototype.scriptCompilationException = null;
	let t;
	return Object.defineProperty(e.prototype, "type", {
		get: M.oneOfGetter(t = [
			"scriptChangedOnDisk",
			"scriptWasManuallyStopped",
			"scriptCompilationException"
		]),
		set: M.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.scriptChangedOnDisk != null && Object.hasOwnProperty.call(e, "scriptChangedOnDisk") && t.uint32(8).bool(e.scriptChangedOnDisk), e.scriptWasManuallyStopped != null && Object.hasOwnProperty.call(e, "scriptWasManuallyStopped") && t.uint32(16).bool(e.scriptWasManuallyStopped), e.scriptCompilationException != null && Object.hasOwnProperty.call(e, "scriptCompilationException") && N.Exception.encode(e.scriptCompilationException, t.uint32(26).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.SessionEvent();
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					o.scriptChangedOnDisk = e.bool(), o.type = "scriptChangedOnDisk";
					continue;
				case 2:
					if (a !== 0) break;
					o.scriptWasManuallyStopped = e.bool(), o.type = "scriptWasManuallyStopped";
					continue;
				case 3:
					if (a !== 2) break;
					o.scriptCompilationException = N.Exception.decode(e, e.uint32(), void 0, r + 1, o.scriptCompilationException), o.type = "scriptCompilationException";
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.SessionEvent) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.SessionEvent();
		if (e.scriptChangedOnDisk != null && (n.scriptChangedOnDisk = !!e.scriptChangedOnDisk), e.scriptWasManuallyStopped != null && (n.scriptWasManuallyStopped = !!e.scriptWasManuallyStopped), e.scriptCompilationException != null) {
			if (typeof e.scriptCompilationException != "object") throw TypeError(".SessionEvent.scriptCompilationException: object expected");
			n.scriptCompilationException = N.Exception.fromObject(e.scriptCompilationException, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return e.scriptChangedOnDisk != null && e.hasOwnProperty("scriptChangedOnDisk") && (r.scriptChangedOnDisk = e.scriptChangedOnDisk, t.oneofs && (r.type = "scriptChangedOnDisk")), e.scriptWasManuallyStopped != null && e.hasOwnProperty("scriptWasManuallyStopped") && (r.scriptWasManuallyStopped = e.scriptWasManuallyStopped, t.oneofs && (r.type = "scriptWasManuallyStopped")), e.scriptCompilationException != null && e.hasOwnProperty("scriptCompilationException") && (r.scriptCompilationException = N.Exception.toObject(e.scriptCompilationException, t, n + 1), t.oneofs && (r.type = "scriptCompilationException")), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/SessionEvent";
	}, e;
})(), N.MetricsEvent = (() => {
	function e(e) {
		if (this.commands = [], this.config = [], this.attributions = [], this.installedSkills = [], this.installedAgents = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.event = "", e.prototype.anonymousId = "", e.prototype.machineIdV3 = "", e.prototype.machineIdV4 = "", e.prototype.reportHash = "", e.prototype.dev = !1, e.prototype.source = "", e.prototype.streamlitVersion = "", e.prototype.isHello = !1, e.prototype.appId = "", e.prototype.sessionId = "", e.prototype.pythonVersion = "", e.prototype.serverOs = "", e.prototype.hasDisplay = !1, e.prototype.isWebdriver = !1, e.prototype.hostedAt = "", e.prototype.owner = "", e.prototype.repo = "", e.prototype.branch = "", e.prototype.mainModule = "", e.prototype.creatorId = "", e.prototype.contextPageUrl = "", e.prototype.contextPageTitle = "", e.prototype.contextPagePath = "", e.prototype.contextPageReferrer = "", e.prototype.contextPageSearch = "", e.prototype.contextLocale = "", e.prototype.contextUserAgent = "", e.prototype.label = "", e.prototype.commands = M.emptyArray, e.prototype.execTime = M.Long ? M.Long.fromBits(0, 0, !1) : 0, e.prototype.prepTime = M.Long ? M.Long.fromBits(0, 0, !1) : 0, e.prototype.config = M.emptyArray, e.prototype.uncaughtException = "", e.prototype.attributions = M.emptyArray, e.prototype.os = "", e.prototype.timezone = "", e.prototype.headless = !1, e.prototype.isFragmentRun = !1, e.prototype.numPages = M.Long ? M.Long.fromBits(0, 0, !1) : 0, e.prototype.pageScriptHash = "", e.prototype.activeTheme = "", e.prototype.totalLoadTime = M.Long ? M.Long.fromBits(0, 0, !1) : 0, e.prototype.browserInfo = null, e.prototype.serverMode = "", e.prototype.installedSkills = M.emptyArray, e.prototype.installedAgents = M.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.event != null && Object.hasOwnProperty.call(e, "event") && t.uint32(10).string(e.event), e.anonymousId != null && Object.hasOwnProperty.call(e, "anonymousId") && t.uint32(18).string(e.anonymousId), e.machineIdV3 != null && Object.hasOwnProperty.call(e, "machineIdV3") && t.uint32(26).string(e.machineIdV3), e.reportHash != null && Object.hasOwnProperty.call(e, "reportHash") && t.uint32(34).string(e.reportHash), e.dev != null && Object.hasOwnProperty.call(e, "dev") && t.uint32(40).bool(e.dev), e.source != null && Object.hasOwnProperty.call(e, "source") && t.uint32(50).string(e.source), e.streamlitVersion != null && Object.hasOwnProperty.call(e, "streamlitVersion") && t.uint32(58).string(e.streamlitVersion), e.isHello != null && Object.hasOwnProperty.call(e, "isHello") && t.uint32(64).bool(e.isHello), e.hostedAt != null && Object.hasOwnProperty.call(e, "hostedAt") && t.uint32(74).string(e.hostedAt), e.owner != null && Object.hasOwnProperty.call(e, "owner") && t.uint32(82).string(e.owner), e.repo != null && Object.hasOwnProperty.call(e, "repo") && t.uint32(90).string(e.repo), e.branch != null && Object.hasOwnProperty.call(e, "branch") && t.uint32(98).string(e.branch), e.mainModule != null && Object.hasOwnProperty.call(e, "mainModule") && t.uint32(106).string(e.mainModule), e.creatorId != null && Object.hasOwnProperty.call(e, "creatorId") && t.uint32(114).string(e.creatorId), e.contextPageUrl != null && Object.hasOwnProperty.call(e, "contextPageUrl") && t.uint32(122).string(e.contextPageUrl), e.contextPageTitle != null && Object.hasOwnProperty.call(e, "contextPageTitle") && t.uint32(130).string(e.contextPageTitle), e.contextPagePath != null && Object.hasOwnProperty.call(e, "contextPagePath") && t.uint32(138).string(e.contextPagePath), e.contextPageReferrer != null && Object.hasOwnProperty.call(e, "contextPageReferrer") && t.uint32(146).string(e.contextPageReferrer), e.contextPageSearch != null && Object.hasOwnProperty.call(e, "contextPageSearch") && t.uint32(154).string(e.contextPageSearch), e.contextLocale != null && Object.hasOwnProperty.call(e, "contextLocale") && t.uint32(162).string(e.contextLocale), e.contextUserAgent != null && Object.hasOwnProperty.call(e, "contextUserAgent") && t.uint32(170).string(e.contextUserAgent), e.label != null && Object.hasOwnProperty.call(e, "label") && t.uint32(178).string(e.label), e.commands != null && e.commands.length) for (let r = 0; r < e.commands.length; ++r) N.Command.encode(e.commands[r], t.uint32(186).fork(), n + 1).ldelim();
		if (e.execTime != null && Object.hasOwnProperty.call(e, "execTime") && t.uint32(192).int64(e.execTime), e.prepTime != null && Object.hasOwnProperty.call(e, "prepTime") && t.uint32(200).int64(e.prepTime), e.config != null && e.config.length) for (let n = 0; n < e.config.length; ++n) t.uint32(210).string(e.config[n]);
		if (e.uncaughtException != null && Object.hasOwnProperty.call(e, "uncaughtException") && t.uint32(218).string(e.uncaughtException), e.attributions != null && e.attributions.length) for (let n = 0; n < e.attributions.length; ++n) t.uint32(226).string(e.attributions[n]);
		if (e.os != null && Object.hasOwnProperty.call(e, "os") && t.uint32(234).string(e.os), e.timezone != null && Object.hasOwnProperty.call(e, "timezone") && t.uint32(242).string(e.timezone), e.headless != null && Object.hasOwnProperty.call(e, "headless") && t.uint32(248).bool(e.headless), e.isFragmentRun != null && Object.hasOwnProperty.call(e, "isFragmentRun") && t.uint32(256).bool(e.isFragmentRun), e.appId != null && Object.hasOwnProperty.call(e, "appId") && t.uint32(266).string(e.appId), e.numPages != null && Object.hasOwnProperty.call(e, "numPages") && t.uint32(272).int64(e.numPages), e.sessionId != null && Object.hasOwnProperty.call(e, "sessionId") && t.uint32(282).string(e.sessionId), e.pythonVersion != null && Object.hasOwnProperty.call(e, "pythonVersion") && t.uint32(290).string(e.pythonVersion), e.pageScriptHash != null && Object.hasOwnProperty.call(e, "pageScriptHash") && t.uint32(298).string(e.pageScriptHash), e.activeTheme != null && Object.hasOwnProperty.call(e, "activeTheme") && t.uint32(306).string(e.activeTheme), e.totalLoadTime != null && Object.hasOwnProperty.call(e, "totalLoadTime") && t.uint32(312).int64(e.totalLoadTime), e.browserInfo != null && Object.hasOwnProperty.call(e, "browserInfo") && N.BrowserInfo.encode(e.browserInfo, t.uint32(322).fork(), n + 1).ldelim(), e.machineIdV4 != null && Object.hasOwnProperty.call(e, "machineIdV4") && t.uint32(330).string(e.machineIdV4), e.serverOs != null && Object.hasOwnProperty.call(e, "serverOs") && t.uint32(338).string(e.serverOs), e.hasDisplay != null && Object.hasOwnProperty.call(e, "hasDisplay") && t.uint32(344).bool(e.hasDisplay), e.isWebdriver != null && Object.hasOwnProperty.call(e, "isWebdriver") && t.uint32(352).bool(e.isWebdriver), e.serverMode != null && Object.hasOwnProperty.call(e, "serverMode") && t.uint32(362).string(e.serverMode), e.installedSkills != null && e.installedSkills.length) for (let n = 0; n < e.installedSkills.length; ++n) t.uint32(370).string(e.installedSkills[n]);
		if (e.installedAgents != null && e.installedAgents.length) for (let n = 0; n < e.installedAgents.length; ++n) t.uint32(378).string(e.installedAgents[n]);
		if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.MetricsEvent(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.event = s : delete o.event;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.anonymousId = s : delete o.anonymousId;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.machineIdV3 = s : delete o.machineIdV3;
					continue;
				case 41:
					if (a !== 2) break;
					(s = e.string()).length ? o.machineIdV4 = s : delete o.machineIdV4;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.reportHash = s : delete o.reportHash;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.dev = s : delete o.dev;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.string()).length ? o.source = s : delete o.source;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.string()).length ? o.streamlitVersion = s : delete o.streamlitVersion;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.isHello = s : delete o.isHello;
					continue;
				case 33:
					if (a !== 2) break;
					(s = e.string()).length ? o.appId = s : delete o.appId;
					continue;
				case 35:
					if (a !== 2) break;
					(s = e.string()).length ? o.sessionId = s : delete o.sessionId;
					continue;
				case 36:
					if (a !== 2) break;
					(s = e.string()).length ? o.pythonVersion = s : delete o.pythonVersion;
					continue;
				case 42:
					if (a !== 2) break;
					(s = e.string()).length ? o.serverOs = s : delete o.serverOs;
					continue;
				case 43:
					if (a !== 0) break;
					(s = e.bool()) ? o.hasDisplay = s : delete o.hasDisplay;
					continue;
				case 44:
					if (a !== 0) break;
					(s = e.bool()) ? o.isWebdriver = s : delete o.isWebdriver;
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.string()).length ? o.hostedAt = s : delete o.hostedAt;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.string()).length ? o.owner = s : delete o.owner;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.string()).length ? o.repo = s : delete o.repo;
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.string()).length ? o.branch = s : delete o.branch;
					continue;
				case 13:
					if (a !== 2) break;
					(s = e.string()).length ? o.mainModule = s : delete o.mainModule;
					continue;
				case 14:
					if (a !== 2) break;
					(s = e.string()).length ? o.creatorId = s : delete o.creatorId;
					continue;
				case 15:
					if (a !== 2) break;
					(s = e.string()).length ? o.contextPageUrl = s : delete o.contextPageUrl;
					continue;
				case 16:
					if (a !== 2) break;
					(s = e.string()).length ? o.contextPageTitle = s : delete o.contextPageTitle;
					continue;
				case 17:
					if (a !== 2) break;
					(s = e.string()).length ? o.contextPagePath = s : delete o.contextPagePath;
					continue;
				case 18:
					if (a !== 2) break;
					(s = e.string()).length ? o.contextPageReferrer = s : delete o.contextPageReferrer;
					continue;
				case 19:
					if (a !== 2) break;
					(s = e.string()).length ? o.contextPageSearch = s : delete o.contextPageSearch;
					continue;
				case 20:
					if (a !== 2) break;
					(s = e.string()).length ? o.contextLocale = s : delete o.contextLocale;
					continue;
				case 21:
					if (a !== 2) break;
					(s = e.string()).length ? o.contextUserAgent = s : delete o.contextUserAgent;
					continue;
				case 22:
					if (a !== 2) break;
					(s = e.string()).length ? o.label = s : delete o.label;
					continue;
				case 23:
					if (a !== 2) break;
					o.commands && o.commands.length || (o.commands = []), o.commands.push(N.Command.decode(e, e.uint32(), void 0, r + 1));
					continue;
				case 24:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.execTime = s : delete o.execTime;
					continue;
				case 25:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.prepTime = s : delete o.prepTime;
					continue;
				case 26:
					if (a !== 2) break;
					o.config && o.config.length || (o.config = []), o.config.push(e.string());
					continue;
				case 27:
					if (a !== 2) break;
					(s = e.string()).length ? o.uncaughtException = s : delete o.uncaughtException;
					continue;
				case 28:
					if (a !== 2) break;
					o.attributions && o.attributions.length || (o.attributions = []), o.attributions.push(e.string());
					continue;
				case 29:
					if (a !== 2) break;
					(s = e.string()).length ? o.os = s : delete o.os;
					continue;
				case 30:
					if (a !== 2) break;
					(s = e.string()).length ? o.timezone = s : delete o.timezone;
					continue;
				case 31:
					if (a !== 0) break;
					(s = e.bool()) ? o.headless = s : delete o.headless;
					continue;
				case 32:
					if (a !== 0) break;
					(s = e.bool()) ? o.isFragmentRun = s : delete o.isFragmentRun;
					continue;
				case 34:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.numPages = s : delete o.numPages;
					continue;
				case 37:
					if (a !== 2) break;
					(s = e.string()).length ? o.pageScriptHash = s : delete o.pageScriptHash;
					continue;
				case 38:
					if (a !== 2) break;
					(s = e.string()).length ? o.activeTheme = s : delete o.activeTheme;
					continue;
				case 39:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.totalLoadTime = s : delete o.totalLoadTime;
					continue;
				case 40:
					if (a !== 2) break;
					o.browserInfo = N.BrowserInfo.decode(e, e.uint32(), void 0, r + 1, o.browserInfo);
					continue;
				case 45:
					if (a !== 2) break;
					(s = e.string()).length ? o.serverMode = s : delete o.serverMode;
					continue;
				case 46:
					if (a !== 2) break;
					o.installedSkills && o.installedSkills.length || (o.installedSkills = []), o.installedSkills.push(e.string());
					continue;
				case 47:
					if (a !== 2) break;
					o.installedAgents && o.installedAgents.length || (o.installedAgents = []), o.installedAgents.push(e.string());
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.MetricsEvent) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.MetricsEvent();
		if (e.event != null && (typeof e.event != "string" || e.event.length) && (n.event = String(e.event)), e.anonymousId != null && (typeof e.anonymousId != "string" || e.anonymousId.length) && (n.anonymousId = String(e.anonymousId)), e.machineIdV3 != null && (typeof e.machineIdV3 != "string" || e.machineIdV3.length) && (n.machineIdV3 = String(e.machineIdV3)), e.machineIdV4 != null && (typeof e.machineIdV4 != "string" || e.machineIdV4.length) && (n.machineIdV4 = String(e.machineIdV4)), e.reportHash != null && (typeof e.reportHash != "string" || e.reportHash.length) && (n.reportHash = String(e.reportHash)), e.dev != null && e.dev && (n.dev = !!e.dev), e.source != null && (typeof e.source != "string" || e.source.length) && (n.source = String(e.source)), e.streamlitVersion != null && (typeof e.streamlitVersion != "string" || e.streamlitVersion.length) && (n.streamlitVersion = String(e.streamlitVersion)), e.isHello != null && e.isHello && (n.isHello = !!e.isHello), e.appId != null && (typeof e.appId != "string" || e.appId.length) && (n.appId = String(e.appId)), e.sessionId != null && (typeof e.sessionId != "string" || e.sessionId.length) && (n.sessionId = String(e.sessionId)), e.pythonVersion != null && (typeof e.pythonVersion != "string" || e.pythonVersion.length) && (n.pythonVersion = String(e.pythonVersion)), e.serverOs != null && (typeof e.serverOs != "string" || e.serverOs.length) && (n.serverOs = String(e.serverOs)), e.hasDisplay != null && e.hasDisplay && (n.hasDisplay = !!e.hasDisplay), e.isWebdriver != null && e.isWebdriver && (n.isWebdriver = !!e.isWebdriver), e.hostedAt != null && (typeof e.hostedAt != "string" || e.hostedAt.length) && (n.hostedAt = String(e.hostedAt)), e.owner != null && (typeof e.owner != "string" || e.owner.length) && (n.owner = String(e.owner)), e.repo != null && (typeof e.repo != "string" || e.repo.length) && (n.repo = String(e.repo)), e.branch != null && (typeof e.branch != "string" || e.branch.length) && (n.branch = String(e.branch)), e.mainModule != null && (typeof e.mainModule != "string" || e.mainModule.length) && (n.mainModule = String(e.mainModule)), e.creatorId != null && (typeof e.creatorId != "string" || e.creatorId.length) && (n.creatorId = String(e.creatorId)), e.contextPageUrl != null && (typeof e.contextPageUrl != "string" || e.contextPageUrl.length) && (n.contextPageUrl = String(e.contextPageUrl)), e.contextPageTitle != null && (typeof e.contextPageTitle != "string" || e.contextPageTitle.length) && (n.contextPageTitle = String(e.contextPageTitle)), e.contextPagePath != null && (typeof e.contextPagePath != "string" || e.contextPagePath.length) && (n.contextPagePath = String(e.contextPagePath)), e.contextPageReferrer != null && (typeof e.contextPageReferrer != "string" || e.contextPageReferrer.length) && (n.contextPageReferrer = String(e.contextPageReferrer)), e.contextPageSearch != null && (typeof e.contextPageSearch != "string" || e.contextPageSearch.length) && (n.contextPageSearch = String(e.contextPageSearch)), e.contextLocale != null && (typeof e.contextLocale != "string" || e.contextLocale.length) && (n.contextLocale = String(e.contextLocale)), e.contextUserAgent != null && (typeof e.contextUserAgent != "string" || e.contextUserAgent.length) && (n.contextUserAgent = String(e.contextUserAgent)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = String(e.label)), e.commands) {
			if (!Array.isArray(e.commands)) throw TypeError(".MetricsEvent.commands: array expected");
			n.commands = Array(e.commands.length);
			for (let r = 0; r < e.commands.length; ++r) {
				if (typeof e.commands[r] != "object") throw TypeError(".MetricsEvent.commands: object expected");
				n.commands[r] = N.Command.fromObject(e.commands[r], t + 1);
			}
		}
		if (e.execTime != null && (typeof e.execTime == "object" ? e.execTime.low || e.execTime.high : Number(e.execTime) !== 0) && (M.Long ? n.execTime = M.Long.fromValue(e.execTime, !1) : typeof e.execTime == "string" ? n.execTime = parseInt(e.execTime, 10) : typeof e.execTime == "number" ? n.execTime = e.execTime : typeof e.execTime == "object" && (n.execTime = new M.LongBits(e.execTime.low >>> 0, e.execTime.high >>> 0).toNumber())), e.prepTime != null && (typeof e.prepTime == "object" ? e.prepTime.low || e.prepTime.high : Number(e.prepTime) !== 0) && (M.Long ? n.prepTime = M.Long.fromValue(e.prepTime, !1) : typeof e.prepTime == "string" ? n.prepTime = parseInt(e.prepTime, 10) : typeof e.prepTime == "number" ? n.prepTime = e.prepTime : typeof e.prepTime == "object" && (n.prepTime = new M.LongBits(e.prepTime.low >>> 0, e.prepTime.high >>> 0).toNumber())), e.config) {
			if (!Array.isArray(e.config)) throw TypeError(".MetricsEvent.config: array expected");
			n.config = Array(e.config.length);
			for (let t = 0; t < e.config.length; ++t) n.config[t] = String(e.config[t]);
		}
		if (e.uncaughtException != null && (typeof e.uncaughtException != "string" || e.uncaughtException.length) && (n.uncaughtException = String(e.uncaughtException)), e.attributions) {
			if (!Array.isArray(e.attributions)) throw TypeError(".MetricsEvent.attributions: array expected");
			n.attributions = Array(e.attributions.length);
			for (let t = 0; t < e.attributions.length; ++t) n.attributions[t] = String(e.attributions[t]);
		}
		if (e.os != null && (typeof e.os != "string" || e.os.length) && (n.os = String(e.os)), e.timezone != null && (typeof e.timezone != "string" || e.timezone.length) && (n.timezone = String(e.timezone)), e.headless != null && e.headless && (n.headless = !!e.headless), e.isFragmentRun != null && e.isFragmentRun && (n.isFragmentRun = !!e.isFragmentRun), e.numPages != null && (typeof e.numPages == "object" ? e.numPages.low || e.numPages.high : Number(e.numPages) !== 0) && (M.Long ? n.numPages = M.Long.fromValue(e.numPages, !1) : typeof e.numPages == "string" ? n.numPages = parseInt(e.numPages, 10) : typeof e.numPages == "number" ? n.numPages = e.numPages : typeof e.numPages == "object" && (n.numPages = new M.LongBits(e.numPages.low >>> 0, e.numPages.high >>> 0).toNumber())), e.pageScriptHash != null && (typeof e.pageScriptHash != "string" || e.pageScriptHash.length) && (n.pageScriptHash = String(e.pageScriptHash)), e.activeTheme != null && (typeof e.activeTheme != "string" || e.activeTheme.length) && (n.activeTheme = String(e.activeTheme)), e.totalLoadTime != null && (typeof e.totalLoadTime == "object" ? e.totalLoadTime.low || e.totalLoadTime.high : Number(e.totalLoadTime) !== 0) && (M.Long ? n.totalLoadTime = M.Long.fromValue(e.totalLoadTime, !1) : typeof e.totalLoadTime == "string" ? n.totalLoadTime = parseInt(e.totalLoadTime, 10) : typeof e.totalLoadTime == "number" ? n.totalLoadTime = e.totalLoadTime : typeof e.totalLoadTime == "object" && (n.totalLoadTime = new M.LongBits(e.totalLoadTime.low >>> 0, e.totalLoadTime.high >>> 0).toNumber())), e.browserInfo != null) {
			if (typeof e.browserInfo != "object") throw TypeError(".MetricsEvent.browserInfo: object expected");
			n.browserInfo = N.BrowserInfo.fromObject(e.browserInfo, t + 1);
		}
		if (e.serverMode != null && (typeof e.serverMode != "string" || e.serverMode.length) && (n.serverMode = String(e.serverMode)), e.installedSkills) {
			if (!Array.isArray(e.installedSkills)) throw TypeError(".MetricsEvent.installedSkills: array expected");
			n.installedSkills = Array(e.installedSkills.length);
			for (let t = 0; t < e.installedSkills.length; ++t) n.installedSkills[t] = String(e.installedSkills[t]);
		}
		if (e.installedAgents) {
			if (!Array.isArray(e.installedAgents)) throw TypeError(".MetricsEvent.installedAgents: array expected");
			n.installedAgents = Array(e.installedAgents.length);
			for (let t = 0; t < e.installedAgents.length; ++t) n.installedAgents[t] = String(e.installedAgents[t]);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.commands = [], r.config = [], r.attributions = [], r.installedSkills = [], r.installedAgents = []), t.defaults) {
			if (r.event = "", r.anonymousId = "", r.machineIdV3 = "", r.reportHash = "", r.dev = !1, r.source = "", r.streamlitVersion = "", r.isHello = !1, r.hostedAt = "", r.owner = "", r.repo = "", r.branch = "", r.mainModule = "", r.creatorId = "", r.contextPageUrl = "", r.contextPageTitle = "", r.contextPagePath = "", r.contextPageReferrer = "", r.contextPageSearch = "", r.contextLocale = "", r.contextUserAgent = "", r.label = "", M.Long) {
				let e = new M.Long(0, 0, !1);
				r.execTime = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
			} else r.execTime = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
			if (M.Long) {
				let e = new M.Long(0, 0, !1);
				r.prepTime = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
			} else r.prepTime = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
			if (r.uncaughtException = "", r.os = "", r.timezone = "", r.headless = !1, r.isFragmentRun = !1, r.appId = "", M.Long) {
				let e = new M.Long(0, 0, !1);
				r.numPages = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
			} else r.numPages = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
			if (r.sessionId = "", r.pythonVersion = "", r.pageScriptHash = "", r.activeTheme = "", M.Long) {
				let e = new M.Long(0, 0, !1);
				r.totalLoadTime = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
			} else r.totalLoadTime = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
			r.browserInfo = null, r.machineIdV4 = "", r.serverOs = "", r.hasDisplay = !1, r.isWebdriver = !1, r.serverMode = "";
		}
		if (e.event != null && e.hasOwnProperty("event") && (r.event = e.event), e.anonymousId != null && e.hasOwnProperty("anonymousId") && (r.anonymousId = e.anonymousId), e.machineIdV3 != null && e.hasOwnProperty("machineIdV3") && (r.machineIdV3 = e.machineIdV3), e.reportHash != null && e.hasOwnProperty("reportHash") && (r.reportHash = e.reportHash), e.dev != null && e.hasOwnProperty("dev") && (r.dev = e.dev), e.source != null && e.hasOwnProperty("source") && (r.source = e.source), e.streamlitVersion != null && e.hasOwnProperty("streamlitVersion") && (r.streamlitVersion = e.streamlitVersion), e.isHello != null && e.hasOwnProperty("isHello") && (r.isHello = e.isHello), e.hostedAt != null && e.hasOwnProperty("hostedAt") && (r.hostedAt = e.hostedAt), e.owner != null && e.hasOwnProperty("owner") && (r.owner = e.owner), e.repo != null && e.hasOwnProperty("repo") && (r.repo = e.repo), e.branch != null && e.hasOwnProperty("branch") && (r.branch = e.branch), e.mainModule != null && e.hasOwnProperty("mainModule") && (r.mainModule = e.mainModule), e.creatorId != null && e.hasOwnProperty("creatorId") && (r.creatorId = e.creatorId), e.contextPageUrl != null && e.hasOwnProperty("contextPageUrl") && (r.contextPageUrl = e.contextPageUrl), e.contextPageTitle != null && e.hasOwnProperty("contextPageTitle") && (r.contextPageTitle = e.contextPageTitle), e.contextPagePath != null && e.hasOwnProperty("contextPagePath") && (r.contextPagePath = e.contextPagePath), e.contextPageReferrer != null && e.hasOwnProperty("contextPageReferrer") && (r.contextPageReferrer = e.contextPageReferrer), e.contextPageSearch != null && e.hasOwnProperty("contextPageSearch") && (r.contextPageSearch = e.contextPageSearch), e.contextLocale != null && e.hasOwnProperty("contextLocale") && (r.contextLocale = e.contextLocale), e.contextUserAgent != null && e.hasOwnProperty("contextUserAgent") && (r.contextUserAgent = e.contextUserAgent), e.label != null && e.hasOwnProperty("label") && (r.label = e.label), e.commands && e.commands.length) {
			r.commands = Array(e.commands.length);
			for (let i = 0; i < e.commands.length; ++i) r.commands[i] = N.Command.toObject(e.commands[i], t, n + 1);
		}
		if (e.execTime != null && e.hasOwnProperty("execTime") && (typeof BigInt < "u" && t.longs === BigInt ? r.execTime = typeof e.execTime == "number" ? BigInt(e.execTime) : M.Long.fromBits(e.execTime.low >>> 0, e.execTime.high >>> 0, !1).toBigInt() : typeof e.execTime == "number" ? r.execTime = t.longs === String ? String(e.execTime) : e.execTime : r.execTime = t.longs === String ? M.Long.prototype.toString.call(e.execTime) : t.longs === Number ? new M.LongBits(e.execTime.low >>> 0, e.execTime.high >>> 0).toNumber() : e.execTime), e.prepTime != null && e.hasOwnProperty("prepTime") && (typeof BigInt < "u" && t.longs === BigInt ? r.prepTime = typeof e.prepTime == "number" ? BigInt(e.prepTime) : M.Long.fromBits(e.prepTime.low >>> 0, e.prepTime.high >>> 0, !1).toBigInt() : typeof e.prepTime == "number" ? r.prepTime = t.longs === String ? String(e.prepTime) : e.prepTime : r.prepTime = t.longs === String ? M.Long.prototype.toString.call(e.prepTime) : t.longs === Number ? new M.LongBits(e.prepTime.low >>> 0, e.prepTime.high >>> 0).toNumber() : e.prepTime), e.config && e.config.length) {
			r.config = Array(e.config.length);
			for (let t = 0; t < e.config.length; ++t) r.config[t] = e.config[t];
		}
		if (e.uncaughtException != null && e.hasOwnProperty("uncaughtException") && (r.uncaughtException = e.uncaughtException), e.attributions && e.attributions.length) {
			r.attributions = Array(e.attributions.length);
			for (let t = 0; t < e.attributions.length; ++t) r.attributions[t] = e.attributions[t];
		}
		if (e.os != null && e.hasOwnProperty("os") && (r.os = e.os), e.timezone != null && e.hasOwnProperty("timezone") && (r.timezone = e.timezone), e.headless != null && e.hasOwnProperty("headless") && (r.headless = e.headless), e.isFragmentRun != null && e.hasOwnProperty("isFragmentRun") && (r.isFragmentRun = e.isFragmentRun), e.appId != null && e.hasOwnProperty("appId") && (r.appId = e.appId), e.numPages != null && e.hasOwnProperty("numPages") && (typeof BigInt < "u" && t.longs === BigInt ? r.numPages = typeof e.numPages == "number" ? BigInt(e.numPages) : M.Long.fromBits(e.numPages.low >>> 0, e.numPages.high >>> 0, !1).toBigInt() : typeof e.numPages == "number" ? r.numPages = t.longs === String ? String(e.numPages) : e.numPages : r.numPages = t.longs === String ? M.Long.prototype.toString.call(e.numPages) : t.longs === Number ? new M.LongBits(e.numPages.low >>> 0, e.numPages.high >>> 0).toNumber() : e.numPages), e.sessionId != null && e.hasOwnProperty("sessionId") && (r.sessionId = e.sessionId), e.pythonVersion != null && e.hasOwnProperty("pythonVersion") && (r.pythonVersion = e.pythonVersion), e.pageScriptHash != null && e.hasOwnProperty("pageScriptHash") && (r.pageScriptHash = e.pageScriptHash), e.activeTheme != null && e.hasOwnProperty("activeTheme") && (r.activeTheme = e.activeTheme), e.totalLoadTime != null && e.hasOwnProperty("totalLoadTime") && (typeof BigInt < "u" && t.longs === BigInt ? r.totalLoadTime = typeof e.totalLoadTime == "number" ? BigInt(e.totalLoadTime) : M.Long.fromBits(e.totalLoadTime.low >>> 0, e.totalLoadTime.high >>> 0, !1).toBigInt() : typeof e.totalLoadTime == "number" ? r.totalLoadTime = t.longs === String ? String(e.totalLoadTime) : e.totalLoadTime : r.totalLoadTime = t.longs === String ? M.Long.prototype.toString.call(e.totalLoadTime) : t.longs === Number ? new M.LongBits(e.totalLoadTime.low >>> 0, e.totalLoadTime.high >>> 0).toNumber() : e.totalLoadTime), e.browserInfo != null && e.hasOwnProperty("browserInfo") && (r.browserInfo = N.BrowserInfo.toObject(e.browserInfo, t, n + 1)), e.machineIdV4 != null && e.hasOwnProperty("machineIdV4") && (r.machineIdV4 = e.machineIdV4), e.serverOs != null && e.hasOwnProperty("serverOs") && (r.serverOs = e.serverOs), e.hasDisplay != null && e.hasOwnProperty("hasDisplay") && (r.hasDisplay = e.hasDisplay), e.isWebdriver != null && e.hasOwnProperty("isWebdriver") && (r.isWebdriver = e.isWebdriver), e.serverMode != null && e.hasOwnProperty("serverMode") && (r.serverMode = e.serverMode), e.installedSkills && e.installedSkills.length) {
			r.installedSkills = Array(e.installedSkills.length);
			for (let t = 0; t < e.installedSkills.length; ++t) r.installedSkills[t] = e.installedSkills[t];
		}
		if (e.installedAgents && e.installedAgents.length) {
			r.installedAgents = Array(e.installedAgents.length);
			for (let t = 0; t < e.installedAgents.length; ++t) r.installedAgents[t] = e.installedAgents[t];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/MetricsEvent";
	}, e;
})(), N.BrowserInfo = (() => {
	function e(e) {
		if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	}
	return e.prototype.browserName = "", e.prototype.browserVersion = "", e.prototype.deviceType = "", e.prototype.os = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		if (e.browserName != null && Object.hasOwnProperty.call(e, "browserName") && t.uint32(10).string(e.browserName), e.browserVersion != null && Object.hasOwnProperty.call(e, "browserVersion") && t.uint32(18).string(e.browserVersion), e.deviceType != null && Object.hasOwnProperty.call(e, "deviceType") && t.uint32(26).string(e.deviceType), e.os != null && Object.hasOwnProperty.call(e, "os") && t.uint32(34).string(e.os), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
		let a = t === void 0 ? e.len : e.pos + t, o = i || new N.BrowserInfo(), s;
		for (; e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = void 0;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.string()).length ? o.browserName = s : delete o.browserName;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.string()).length ? o.browserVersion = s : delete o.browserVersion;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.string()).length ? o.deviceType = s : delete o.deviceType;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.string()).length ? o.os = s : delete o.os;
					continue;
			}
			e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
		}
		if (n !== void 0) throw Error("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof N.BrowserInfo) return e;
		if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
		let n = new N.BrowserInfo();
		return e.browserName != null && (typeof e.browserName != "string" || e.browserName.length) && (n.browserName = String(e.browserName)), e.browserVersion != null && (typeof e.browserVersion != "string" || e.browserVersion.length) && (n.browserVersion = String(e.browserVersion)), e.deviceType != null && (typeof e.deviceType != "string" || e.deviceType.length) && (n.deviceType = String(e.deviceType)), e.os != null && (typeof e.os != "string" || e.os.length) && (n.os = String(e.os)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
		let r = {};
		return t.defaults && (r.browserName = "", r.browserVersion = "", r.deviceType = "", r.os = ""), e.browserName != null && e.hasOwnProperty("browserName") && (r.browserName = e.browserName), e.browserVersion != null && e.hasOwnProperty("browserVersion") && (r.browserVersion = e.browserVersion), e.deviceType != null && e.hasOwnProperty("deviceType") && (r.deviceType = e.deviceType), e.os != null && e.hasOwnProperty("os") && (r.os = e.os), r;
	}, e.prototype.toJSON = function() {
		return this.constructor.toObject(this, k.default.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === void 0 && (e = "type.googleapis.com"), e + "/BrowserInfo";
	}, e;
})(), N.openmetrics = (() => {
	let e = {};
	return e.MetricSet = (function() {
		function e(e) {
			if (this.metricFamilies = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.metricFamilies = M.emptyArray, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.metricFamilies != null && e.metricFamilies.length) for (let r = 0; r < e.metricFamilies.length; ++r) N.openmetrics.MetricFamily.encode(e.metricFamilies[r], t.uint32(10).fork(), n + 1).ldelim();
			if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.MetricSet();
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						o.metricFamilies && o.metricFamilies.length || (o.metricFamilies = []), o.metricFamilies.push(N.openmetrics.MetricFamily.decode(e, e.uint32(), void 0, r + 1));
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.openmetrics.MetricSet) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.openmetrics.MetricSet();
			if (e.metricFamilies) {
				if (!Array.isArray(e.metricFamilies)) throw TypeError(".openmetrics.MetricSet.metricFamilies: array expected");
				n.metricFamilies = Array(e.metricFamilies.length);
				for (let r = 0; r < e.metricFamilies.length; ++r) {
					if (typeof e.metricFamilies[r] != "object") throw TypeError(".openmetrics.MetricSet.metricFamilies: object expected");
					n.metricFamilies[r] = N.openmetrics.MetricFamily.fromObject(e.metricFamilies[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.metricFamilies = []), e.metricFamilies && e.metricFamilies.length) {
				r.metricFamilies = Array(e.metricFamilies.length);
				for (let i = 0; i < e.metricFamilies.length; ++i) r.metricFamilies[i] = N.openmetrics.MetricFamily.toObject(e.metricFamilies[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.MetricSet";
		}, e;
	})(), e.MetricFamily = (function() {
		function e(e) {
			if (this.metrics = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.name = "", e.prototype.type = 0, e.prototype.unit = "", e.prototype.help = "", e.prototype.metrics = M.emptyArray, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(10).string(e.name), e.type != null && Object.hasOwnProperty.call(e, "type") && t.uint32(16).int32(e.type), e.unit != null && Object.hasOwnProperty.call(e, "unit") && t.uint32(26).string(e.unit), e.help != null && Object.hasOwnProperty.call(e, "help") && t.uint32(34).string(e.help), e.metrics != null && e.metrics.length) for (let r = 0; r < e.metrics.length; ++r) N.Metric.encode(e.metrics[r], t.uint32(42).fork(), n + 1).ldelim();
			if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.MetricFamily(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.string()).length ? o.name = s : delete o.name;
						continue;
					case 2:
						if (a !== 0) break;
						(s = e.int32()) ? o.type = s : delete o.type;
						continue;
					case 3:
						if (a !== 2) break;
						(s = e.string()).length ? o.unit = s : delete o.unit;
						continue;
					case 4:
						if (a !== 2) break;
						(s = e.string()).length ? o.help = s : delete o.help;
						continue;
					case 5:
						if (a !== 2) break;
						o.metrics && o.metrics.length || (o.metrics = []), o.metrics.push(N.Metric.decode(e, e.uint32(), void 0, r + 1));
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.openmetrics.MetricFamily) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.openmetrics.MetricFamily();
			if (e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = String(e.name)), e.type !== 0 && (typeof e.type != "string" || N.openmetrics.MetricType[e.type] !== 0)) switch (e.type) {
				default:
					if (typeof e.type == "number") {
						n.type = e.type;
						break;
					}
					break;
				case "UNKNOWN":
				case 0:
					n.type = 0;
					break;
				case "GAUGE":
				case 1:
					n.type = 1;
					break;
				case "COUNTER":
				case 2:
					n.type = 2;
					break;
				case "STATE_SET":
				case 3:
					n.type = 3;
					break;
				case "INFO":
				case 4:
					n.type = 4;
					break;
				case "HISTOGRAM":
				case 5:
					n.type = 5;
					break;
				case "GAUGE_HISTOGRAM":
				case 6:
					n.type = 6;
					break;
				case "SUMMARY":
				case 7:
					n.type = 7;
					break;
			}
			if (e.unit != null && (typeof e.unit != "string" || e.unit.length) && (n.unit = String(e.unit)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = String(e.help)), e.metrics) {
				if (!Array.isArray(e.metrics)) throw TypeError(".openmetrics.MetricFamily.metrics: array expected");
				n.metrics = Array(e.metrics.length);
				for (let r = 0; r < e.metrics.length; ++r) {
					if (typeof e.metrics[r] != "object") throw TypeError(".openmetrics.MetricFamily.metrics: object expected");
					n.metrics[r] = N.Metric.fromObject(e.metrics[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.metrics = []), t.defaults && (r.name = "", r.type = t.enums === String ? "UNKNOWN" : 0, r.unit = "", r.help = ""), e.name != null && e.hasOwnProperty("name") && (r.name = e.name), e.type != null && e.hasOwnProperty("type") && (r.type = t.enums === String ? N.openmetrics.MetricType[e.type] === void 0 ? e.type : N.openmetrics.MetricType[e.type] : e.type), e.unit != null && e.hasOwnProperty("unit") && (r.unit = e.unit), e.help != null && e.hasOwnProperty("help") && (r.help = e.help), e.metrics && e.metrics.length) {
				r.metrics = Array(e.metrics.length);
				for (let i = 0; i < e.metrics.length; ++i) r.metrics[i] = N.Metric.toObject(e.metrics[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.MetricFamily";
		}, e;
	})(), e.MetricType = (function() {
		let e = {}, t = Object.create(e);
		return t[e[0] = "UNKNOWN"] = 0, t[e[1] = "GAUGE"] = 1, t[e[2] = "COUNTER"] = 2, t[e[3] = "STATE_SET"] = 3, t[e[4] = "INFO"] = 4, t[e[5] = "HISTOGRAM"] = 5, t[e[6] = "GAUGE_HISTOGRAM"] = 6, t[e[7] = "SUMMARY"] = 7, t;
	})(), e.Metric = (function() {
		function e(e) {
			if (this.labels = [], this.metricPoints = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.labels = M.emptyArray, e.prototype.metricPoints = M.emptyArray, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.labels != null && e.labels.length) for (let r = 0; r < e.labels.length; ++r) N.openmetrics.Label.encode(e.labels[r], t.uint32(10).fork(), n + 1).ldelim();
			if (e.metricPoints != null && e.metricPoints.length) for (let r = 0; r < e.metricPoints.length; ++r) N.openmetrics.MetricPoint.encode(e.metricPoints[r], t.uint32(18).fork(), n + 1).ldelim();
			if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.Metric();
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						o.labels && o.labels.length || (o.labels = []), o.labels.push(N.openmetrics.Label.decode(e, e.uint32(), void 0, r + 1));
						continue;
					case 2:
						if (a !== 2) break;
						o.metricPoints && o.metricPoints.length || (o.metricPoints = []), o.metricPoints.push(N.openmetrics.MetricPoint.decode(e, e.uint32(), void 0, r + 1));
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.openmetrics.Metric) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.openmetrics.Metric();
			if (e.labels) {
				if (!Array.isArray(e.labels)) throw TypeError(".openmetrics.Metric.labels: array expected");
				n.labels = Array(e.labels.length);
				for (let r = 0; r < e.labels.length; ++r) {
					if (typeof e.labels[r] != "object") throw TypeError(".openmetrics.Metric.labels: object expected");
					n.labels[r] = N.openmetrics.Label.fromObject(e.labels[r], t + 1);
				}
			}
			if (e.metricPoints) {
				if (!Array.isArray(e.metricPoints)) throw TypeError(".openmetrics.Metric.metricPoints: array expected");
				n.metricPoints = Array(e.metricPoints.length);
				for (let r = 0; r < e.metricPoints.length; ++r) {
					if (typeof e.metricPoints[r] != "object") throw TypeError(".openmetrics.Metric.metricPoints: object expected");
					n.metricPoints[r] = N.openmetrics.MetricPoint.fromObject(e.metricPoints[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.labels = [], r.metricPoints = []), e.labels && e.labels.length) {
				r.labels = Array(e.labels.length);
				for (let i = 0; i < e.labels.length; ++i) r.labels[i] = N.openmetrics.Label.toObject(e.labels[i], t, n + 1);
			}
			if (e.metricPoints && e.metricPoints.length) {
				r.metricPoints = Array(e.metricPoints.length);
				for (let i = 0; i < e.metricPoints.length; ++i) r.metricPoints[i] = N.openmetrics.MetricPoint.toObject(e.metricPoints[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.Metric";
		}, e;
	})(), e.Label = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.name = "", e.prototype.value = "", e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(10).string(e.name), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(18).string(e.value), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.Label(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.string()).length ? o.name = s : delete o.name;
						continue;
					case 2:
						if (a !== 2) break;
						(s = e.string()).length ? o.value = s : delete o.value;
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.openmetrics.Label) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.openmetrics.Label();
			return e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = String(e.name)), e.value != null && (typeof e.value != "string" || e.value.length) && (n.value = String(e.value)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.name = "", r.value = ""), e.name != null && e.hasOwnProperty("name") && (r.name = e.name), e.value != null && e.hasOwnProperty("value") && (r.value = e.value), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.Label";
		}, e;
	})(), e.MetricPoint = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.unknownValue = null, e.prototype.gaugeValue = null, e.prototype.counterValue = null, e.prototype.histogramValue = null, e.prototype.stateSetValue = null, e.prototype.infoValue = null, e.prototype.summaryValue = null, e.prototype.timestamp = null;
		let t;
		return Object.defineProperty(e.prototype, "value", {
			get: M.oneOfGetter(t = [
				"unknownValue",
				"gaugeValue",
				"counterValue",
				"histogramValue",
				"stateSetValue",
				"infoValue",
				"summaryValue"
			]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.unknownValue != null && Object.hasOwnProperty.call(e, "unknownValue") && N.openmetrics.UnknownValue.encode(e.unknownValue, t.uint32(10).fork(), n + 1).ldelim(), e.gaugeValue != null && Object.hasOwnProperty.call(e, "gaugeValue") && N.openmetrics.GaugeValue.encode(e.gaugeValue, t.uint32(18).fork(), n + 1).ldelim(), e.counterValue != null && Object.hasOwnProperty.call(e, "counterValue") && N.openmetrics.CounterValue.encode(e.counterValue, t.uint32(26).fork(), n + 1).ldelim(), e.histogramValue != null && Object.hasOwnProperty.call(e, "histogramValue") && N.openmetrics.HistogramValue.encode(e.histogramValue, t.uint32(34).fork(), n + 1).ldelim(), e.stateSetValue != null && Object.hasOwnProperty.call(e, "stateSetValue") && N.openmetrics.StateSetValue.encode(e.stateSetValue, t.uint32(42).fork(), n + 1).ldelim(), e.infoValue != null && Object.hasOwnProperty.call(e, "infoValue") && N.openmetrics.InfoValue.encode(e.infoValue, t.uint32(50).fork(), n + 1).ldelim(), e.summaryValue != null && Object.hasOwnProperty.call(e, "summaryValue") && N.openmetrics.SummaryValue.encode(e.summaryValue, t.uint32(58).fork(), n + 1).ldelim(), e.timestamp != null && Object.hasOwnProperty.call(e, "timestamp") && N.google.protobuf.Timestamp.encode(e.timestamp, t.uint32(66).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.MetricPoint();
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						o.unknownValue = N.openmetrics.UnknownValue.decode(e, e.uint32(), void 0, r + 1, o.unknownValue), o.value = "unknownValue";
						continue;
					case 2:
						if (a !== 2) break;
						o.gaugeValue = N.openmetrics.GaugeValue.decode(e, e.uint32(), void 0, r + 1, o.gaugeValue), o.value = "gaugeValue";
						continue;
					case 3:
						if (a !== 2) break;
						o.counterValue = N.openmetrics.CounterValue.decode(e, e.uint32(), void 0, r + 1, o.counterValue), o.value = "counterValue";
						continue;
					case 4:
						if (a !== 2) break;
						o.histogramValue = N.openmetrics.HistogramValue.decode(e, e.uint32(), void 0, r + 1, o.histogramValue), o.value = "histogramValue";
						continue;
					case 5:
						if (a !== 2) break;
						o.stateSetValue = N.openmetrics.StateSetValue.decode(e, e.uint32(), void 0, r + 1, o.stateSetValue), o.value = "stateSetValue";
						continue;
					case 6:
						if (a !== 2) break;
						o.infoValue = N.openmetrics.InfoValue.decode(e, e.uint32(), void 0, r + 1, o.infoValue), o.value = "infoValue";
						continue;
					case 7:
						if (a !== 2) break;
						o.summaryValue = N.openmetrics.SummaryValue.decode(e, e.uint32(), void 0, r + 1, o.summaryValue), o.value = "summaryValue";
						continue;
					case 8:
						if (a !== 2) break;
						o.timestamp = N.google.protobuf.Timestamp.decode(e, e.uint32(), void 0, r + 1, o.timestamp);
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.openmetrics.MetricPoint) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.openmetrics.MetricPoint();
			if (e.unknownValue != null) {
				if (typeof e.unknownValue != "object") throw TypeError(".openmetrics.MetricPoint.unknownValue: object expected");
				n.unknownValue = N.openmetrics.UnknownValue.fromObject(e.unknownValue, t + 1);
			}
			if (e.gaugeValue != null) {
				if (typeof e.gaugeValue != "object") throw TypeError(".openmetrics.MetricPoint.gaugeValue: object expected");
				n.gaugeValue = N.openmetrics.GaugeValue.fromObject(e.gaugeValue, t + 1);
			}
			if (e.counterValue != null) {
				if (typeof e.counterValue != "object") throw TypeError(".openmetrics.MetricPoint.counterValue: object expected");
				n.counterValue = N.openmetrics.CounterValue.fromObject(e.counterValue, t + 1);
			}
			if (e.histogramValue != null) {
				if (typeof e.histogramValue != "object") throw TypeError(".openmetrics.MetricPoint.histogramValue: object expected");
				n.histogramValue = N.openmetrics.HistogramValue.fromObject(e.histogramValue, t + 1);
			}
			if (e.stateSetValue != null) {
				if (typeof e.stateSetValue != "object") throw TypeError(".openmetrics.MetricPoint.stateSetValue: object expected");
				n.stateSetValue = N.openmetrics.StateSetValue.fromObject(e.stateSetValue, t + 1);
			}
			if (e.infoValue != null) {
				if (typeof e.infoValue != "object") throw TypeError(".openmetrics.MetricPoint.infoValue: object expected");
				n.infoValue = N.openmetrics.InfoValue.fromObject(e.infoValue, t + 1);
			}
			if (e.summaryValue != null) {
				if (typeof e.summaryValue != "object") throw TypeError(".openmetrics.MetricPoint.summaryValue: object expected");
				n.summaryValue = N.openmetrics.SummaryValue.fromObject(e.summaryValue, t + 1);
			}
			if (e.timestamp != null) {
				if (typeof e.timestamp != "object") throw TypeError(".openmetrics.MetricPoint.timestamp: object expected");
				n.timestamp = N.google.protobuf.Timestamp.fromObject(e.timestamp, t + 1);
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.timestamp = null), e.unknownValue != null && e.hasOwnProperty("unknownValue") && (r.unknownValue = N.openmetrics.UnknownValue.toObject(e.unknownValue, t, n + 1), t.oneofs && (r.value = "unknownValue")), e.gaugeValue != null && e.hasOwnProperty("gaugeValue") && (r.gaugeValue = N.openmetrics.GaugeValue.toObject(e.gaugeValue, t, n + 1), t.oneofs && (r.value = "gaugeValue")), e.counterValue != null && e.hasOwnProperty("counterValue") && (r.counterValue = N.openmetrics.CounterValue.toObject(e.counterValue, t, n + 1), t.oneofs && (r.value = "counterValue")), e.histogramValue != null && e.hasOwnProperty("histogramValue") && (r.histogramValue = N.openmetrics.HistogramValue.toObject(e.histogramValue, t, n + 1), t.oneofs && (r.value = "histogramValue")), e.stateSetValue != null && e.hasOwnProperty("stateSetValue") && (r.stateSetValue = N.openmetrics.StateSetValue.toObject(e.stateSetValue, t, n + 1), t.oneofs && (r.value = "stateSetValue")), e.infoValue != null && e.hasOwnProperty("infoValue") && (r.infoValue = N.openmetrics.InfoValue.toObject(e.infoValue, t, n + 1), t.oneofs && (r.value = "infoValue")), e.summaryValue != null && e.hasOwnProperty("summaryValue") && (r.summaryValue = N.openmetrics.SummaryValue.toObject(e.summaryValue, t, n + 1), t.oneofs && (r.value = "summaryValue")), e.timestamp != null && e.hasOwnProperty("timestamp") && (r.timestamp = N.google.protobuf.Timestamp.toObject(e.timestamp, t, n + 1)), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.MetricPoint";
		}, e;
	})(), e.UnknownValue = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.doubleValue = null, e.prototype.intValue = null;
		let t;
		return Object.defineProperty(e.prototype, "value", {
			get: M.oneOfGetter(t = ["doubleValue", "intValue"]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(9).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(16).int64(e.intValue), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.UnknownValue();
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						o.doubleValue = e.double(), o.value = "doubleValue";
						continue;
					case 2:
						if (a !== 0) break;
						o.intValue = e.int64(), o.value = "intValue";
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.openmetrics.UnknownValue) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.openmetrics.UnknownValue();
			return e.doubleValue != null && (n.doubleValue = Number(e.doubleValue)), e.intValue != null && (M.Long ? n.intValue = M.Long.fromValue(e.intValue, !1) : typeof e.intValue == "string" ? n.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? n.intValue = e.intValue : typeof e.intValue == "object" && (n.intValue = new M.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return e.doubleValue != null && e.hasOwnProperty("doubleValue") && (r.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (r.value = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof BigInt < "u" && t.longs === BigInt ? r.intValue = typeof e.intValue == "number" ? BigInt(e.intValue) : M.Long.fromBits(e.intValue.low >>> 0, e.intValue.high >>> 0, !1).toBigInt() : typeof e.intValue == "number" ? r.intValue = t.longs === String ? String(e.intValue) : e.intValue : r.intValue = t.longs === String ? M.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new M.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (r.value = "intValue")), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.UnknownValue";
		}, e;
	})(), e.GaugeValue = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.doubleValue = null, e.prototype.intValue = null;
		let t;
		return Object.defineProperty(e.prototype, "value", {
			get: M.oneOfGetter(t = ["doubleValue", "intValue"]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(9).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(16).int64(e.intValue), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.GaugeValue();
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						o.doubleValue = e.double(), o.value = "doubleValue";
						continue;
					case 2:
						if (a !== 0) break;
						o.intValue = e.int64(), o.value = "intValue";
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.openmetrics.GaugeValue) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.openmetrics.GaugeValue();
			return e.doubleValue != null && (n.doubleValue = Number(e.doubleValue)), e.intValue != null && (M.Long ? n.intValue = M.Long.fromValue(e.intValue, !1) : typeof e.intValue == "string" ? n.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? n.intValue = e.intValue : typeof e.intValue == "object" && (n.intValue = new M.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return e.doubleValue != null && e.hasOwnProperty("doubleValue") && (r.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (r.value = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof BigInt < "u" && t.longs === BigInt ? r.intValue = typeof e.intValue == "number" ? BigInt(e.intValue) : M.Long.fromBits(e.intValue.low >>> 0, e.intValue.high >>> 0, !1).toBigInt() : typeof e.intValue == "number" ? r.intValue = t.longs === String ? String(e.intValue) : e.intValue : r.intValue = t.longs === String ? M.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new M.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (r.value = "intValue")), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.GaugeValue";
		}, e;
	})(), e.CounterValue = (function() {
		function e(e) {
			if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.doubleValue = null, e.prototype.intValue = null, e.prototype.created = null, e.prototype.exemplar = null;
		let t;
		return Object.defineProperty(e.prototype, "total", {
			get: M.oneOfGetter(t = ["doubleValue", "intValue"]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(9).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(16).uint64(e.intValue), e.created != null && Object.hasOwnProperty.call(e, "created") && N.google.protobuf.Timestamp.encode(e.created, t.uint32(26).fork(), n + 1).ldelim(), e.exemplar != null && Object.hasOwnProperty.call(e, "exemplar") && N.openmetrics.Exemplar.encode(e.exemplar, t.uint32(34).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.CounterValue();
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						o.doubleValue = e.double(), o.total = "doubleValue";
						continue;
					case 2:
						if (a !== 0) break;
						o.intValue = e.uint64(), o.total = "intValue";
						continue;
					case 3:
						if (a !== 2) break;
						o.created = N.google.protobuf.Timestamp.decode(e, e.uint32(), void 0, r + 1, o.created);
						continue;
					case 4:
						if (a !== 2) break;
						o.exemplar = N.openmetrics.Exemplar.decode(e, e.uint32(), void 0, r + 1, o.exemplar);
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.openmetrics.CounterValue) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.openmetrics.CounterValue();
			if (e.doubleValue != null && (n.doubleValue = Number(e.doubleValue)), e.intValue != null && (M.Long ? n.intValue = M.Long.fromValue(e.intValue, !0) : typeof e.intValue == "string" ? n.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? n.intValue = e.intValue : typeof e.intValue == "object" && (n.intValue = new M.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber(!0))), e.created != null) {
				if (typeof e.created != "object") throw TypeError(".openmetrics.CounterValue.created: object expected");
				n.created = N.google.protobuf.Timestamp.fromObject(e.created, t + 1);
			}
			if (e.exemplar != null) {
				if (typeof e.exemplar != "object") throw TypeError(".openmetrics.CounterValue.exemplar: object expected");
				n.exemplar = N.openmetrics.Exemplar.fromObject(e.exemplar, t + 1);
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			return t.defaults && (r.created = null, r.exemplar = null), e.doubleValue != null && e.hasOwnProperty("doubleValue") && (r.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (r.total = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof BigInt < "u" && t.longs === BigInt ? r.intValue = typeof e.intValue == "number" ? BigInt(e.intValue) : M.Long.fromBits(e.intValue.low >>> 0, e.intValue.high >>> 0, !0).toBigInt() : typeof e.intValue == "number" ? r.intValue = t.longs === String ? String(e.intValue) : e.intValue : r.intValue = t.longs === String ? M.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new M.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber(!0) : e.intValue, t.oneofs && (r.total = "intValue")), e.created != null && e.hasOwnProperty("created") && (r.created = N.google.protobuf.Timestamp.toObject(e.created, t, n + 1)), e.exemplar != null && e.hasOwnProperty("exemplar") && (r.exemplar = N.openmetrics.Exemplar.toObject(e.exemplar, t, n + 1)), r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.CounterValue";
		}, e;
	})(), e.HistogramValue = (function() {
		function e(e) {
			if (this.buckets = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.doubleValue = null, e.prototype.intValue = null, e.prototype.count = M.Long ? M.Long.fromBits(0, 0, !0) : 0, e.prototype.created = null, e.prototype.buckets = M.emptyArray;
		let t;
		return Object.defineProperty(e.prototype, "sum", {
			get: M.oneOfGetter(t = ["doubleValue", "intValue"]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(9).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(16).int64(e.intValue), e.count != null && Object.hasOwnProperty.call(e, "count") && t.uint32(24).uint64(e.count), e.created != null && Object.hasOwnProperty.call(e, "created") && N.google.protobuf.Timestamp.encode(e.created, t.uint32(34).fork(), n + 1).ldelim(), e.buckets != null && e.buckets.length) for (let r = 0; r < e.buckets.length; ++r) N.openmetrics.HistogramValue.Bucket.encode(e.buckets[r], t.uint32(42).fork(), n + 1).ldelim();
			if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.HistogramValue(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						o.doubleValue = e.double(), o.sum = "doubleValue";
						continue;
					case 2:
						if (a !== 0) break;
						o.intValue = e.int64(), o.sum = "intValue";
						continue;
					case 3:
						if (a !== 0) break;
						(typeof (s = e.uint64()) == "object" ? s.low || s.high : s !== 0) ? o.count = s : delete o.count;
						continue;
					case 4:
						if (a !== 2) break;
						o.created = N.google.protobuf.Timestamp.decode(e, e.uint32(), void 0, r + 1, o.created);
						continue;
					case 5:
						if (a !== 2) break;
						o.buckets && o.buckets.length || (o.buckets = []), o.buckets.push(N.openmetrics.HistogramValue.Bucket.decode(e, e.uint32(), void 0, r + 1));
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.openmetrics.HistogramValue) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.openmetrics.HistogramValue();
			if (e.doubleValue != null && (n.doubleValue = Number(e.doubleValue)), e.intValue != null && (M.Long ? n.intValue = M.Long.fromValue(e.intValue, !1) : typeof e.intValue == "string" ? n.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? n.intValue = e.intValue : typeof e.intValue == "object" && (n.intValue = new M.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), e.count != null && (typeof e.count == "object" ? e.count.low || e.count.high : Number(e.count) !== 0) && (M.Long ? n.count = M.Long.fromValue(e.count, !0) : typeof e.count == "string" ? n.count = parseInt(e.count, 10) : typeof e.count == "number" ? n.count = e.count : typeof e.count == "object" && (n.count = new M.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.created != null) {
				if (typeof e.created != "object") throw TypeError(".openmetrics.HistogramValue.created: object expected");
				n.created = N.google.protobuf.Timestamp.fromObject(e.created, t + 1);
			}
			if (e.buckets) {
				if (!Array.isArray(e.buckets)) throw TypeError(".openmetrics.HistogramValue.buckets: array expected");
				n.buckets = Array(e.buckets.length);
				for (let r = 0; r < e.buckets.length; ++r) {
					if (typeof e.buckets[r] != "object") throw TypeError(".openmetrics.HistogramValue.buckets: object expected");
					n.buckets[r] = N.openmetrics.HistogramValue.Bucket.fromObject(e.buckets[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.buckets = []), t.defaults) {
				if (M.Long) {
					let e = new M.Long(0, 0, !0);
					r.count = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
				} else r.count = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
				r.created = null;
			}
			if (e.doubleValue != null && e.hasOwnProperty("doubleValue") && (r.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (r.sum = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof BigInt < "u" && t.longs === BigInt ? r.intValue = typeof e.intValue == "number" ? BigInt(e.intValue) : M.Long.fromBits(e.intValue.low >>> 0, e.intValue.high >>> 0, !1).toBigInt() : typeof e.intValue == "number" ? r.intValue = t.longs === String ? String(e.intValue) : e.intValue : r.intValue = t.longs === String ? M.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new M.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (r.sum = "intValue")), e.count != null && e.hasOwnProperty("count") && (typeof BigInt < "u" && t.longs === BigInt ? r.count = typeof e.count == "number" ? BigInt(e.count) : M.Long.fromBits(e.count.low >>> 0, e.count.high >>> 0, !0).toBigInt() : typeof e.count == "number" ? r.count = t.longs === String ? String(e.count) : e.count : r.count = t.longs === String ? M.Long.prototype.toString.call(e.count) : t.longs === Number ? new M.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.created != null && e.hasOwnProperty("created") && (r.created = N.google.protobuf.Timestamp.toObject(e.created, t, n + 1)), e.buckets && e.buckets.length) {
				r.buckets = Array(e.buckets.length);
				for (let i = 0; i < e.buckets.length; ++i) r.buckets[i] = N.openmetrics.HistogramValue.Bucket.toObject(e.buckets[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.HistogramValue";
		}, e.Bucket = (function() {
			function e(e) {
				if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
			}
			return e.prototype.count = M.Long ? M.Long.fromBits(0, 0, !0) : 0, e.prototype.upperBound = 0, e.prototype.exemplar = null, e.create = function(t) {
				return new e(t);
			}, e.encode = function(e, t, n) {
				if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
				if (e.count != null && Object.hasOwnProperty.call(e, "count") && t.uint32(8).uint64(e.count), e.upperBound != null && Object.hasOwnProperty.call(e, "upperBound") && t.uint32(17).double(e.upperBound), e.exemplar != null && Object.hasOwnProperty.call(e, "exemplar") && N.openmetrics.Exemplar.encode(e.exemplar, t.uint32(26).fork(), n + 1).ldelim(), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
				return t;
			}, e.decode = function(e, t, n, r, i) {
				if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
				let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.HistogramValue.Bucket(), s;
				for (; e.pos < a;) {
					let t = e.pos, i = e.tag();
					if (i === n) {
						n = void 0;
						break;
					}
					let a = i & 7;
					switch (i >>>= 3) {
						case 1:
							if (a !== 0) break;
							(typeof (s = e.uint64()) == "object" ? s.low || s.high : s !== 0) ? o.count = s : delete o.count;
							continue;
						case 2:
							if (a !== 1) break;
							(s = e.double()) === 0 ? delete o.upperBound : o.upperBound = s;
							continue;
						case 3:
							if (a !== 2) break;
							o.exemplar = N.openmetrics.Exemplar.decode(e, e.uint32(), void 0, r + 1, o.exemplar);
							continue;
					}
					e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
				}
				if (n !== void 0) throw Error("missing end group");
				return o;
			}, e.fromObject = function(e, t) {
				if (e instanceof N.openmetrics.HistogramValue.Bucket) return e;
				if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
				let n = new N.openmetrics.HistogramValue.Bucket();
				if (e.count != null && (typeof e.count == "object" ? e.count.low || e.count.high : Number(e.count) !== 0) && (M.Long ? n.count = M.Long.fromValue(e.count, !0) : typeof e.count == "string" ? n.count = parseInt(e.count, 10) : typeof e.count == "number" ? n.count = e.count : typeof e.count == "object" && (n.count = new M.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.upperBound != null && Number(e.upperBound) !== 0 && (n.upperBound = Number(e.upperBound)), e.exemplar != null) {
					if (typeof e.exemplar != "object") throw TypeError(".openmetrics.HistogramValue.Bucket.exemplar: object expected");
					n.exemplar = N.openmetrics.Exemplar.fromObject(e.exemplar, t + 1);
				}
				return n;
			}, e.toObject = function(e, t, n) {
				if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
				let r = {};
				if (t.defaults) {
					if (M.Long) {
						let e = new M.Long(0, 0, !0);
						r.count = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
					} else r.count = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
					r.upperBound = 0, r.exemplar = null;
				}
				return e.count != null && e.hasOwnProperty("count") && (typeof BigInt < "u" && t.longs === BigInt ? r.count = typeof e.count == "number" ? BigInt(e.count) : M.Long.fromBits(e.count.low >>> 0, e.count.high >>> 0, !0).toBigInt() : typeof e.count == "number" ? r.count = t.longs === String ? String(e.count) : e.count : r.count = t.longs === String ? M.Long.prototype.toString.call(e.count) : t.longs === Number ? new M.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.upperBound != null && e.hasOwnProperty("upperBound") && (r.upperBound = t.json && !isFinite(e.upperBound) ? String(e.upperBound) : e.upperBound), e.exemplar != null && e.hasOwnProperty("exemplar") && (r.exemplar = N.openmetrics.Exemplar.toObject(e.exemplar, t, n + 1)), r;
			}, e.prototype.toJSON = function() {
				return this.constructor.toObject(this, k.default.util.toJSONOptions);
			}, e.getTypeUrl = function(e) {
				return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.HistogramValue.Bucket";
			}, e;
		})(), e;
	})(), e.Exemplar = (function() {
		function e(e) {
			if (this.label = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.value = 0, e.prototype.timestamp = null, e.prototype.label = M.emptyArray, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(9).double(e.value), e.timestamp != null && Object.hasOwnProperty.call(e, "timestamp") && N.google.protobuf.Timestamp.encode(e.timestamp, t.uint32(18).fork(), n + 1).ldelim(), e.label != null && e.label.length) for (let r = 0; r < e.label.length; ++r) N.openmetrics.Label.encode(e.label[r], t.uint32(26).fork(), n + 1).ldelim();
			if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.Exemplar(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						(s = e.double()) === 0 ? delete o.value : o.value = s;
						continue;
					case 2:
						if (a !== 2) break;
						o.timestamp = N.google.protobuf.Timestamp.decode(e, e.uint32(), void 0, r + 1, o.timestamp);
						continue;
					case 3:
						if (a !== 2) break;
						o.label && o.label.length || (o.label = []), o.label.push(N.openmetrics.Label.decode(e, e.uint32(), void 0, r + 1));
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.openmetrics.Exemplar) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.openmetrics.Exemplar();
			if (e.value != null && Number(e.value) !== 0 && (n.value = Number(e.value)), e.timestamp != null) {
				if (typeof e.timestamp != "object") throw TypeError(".openmetrics.Exemplar.timestamp: object expected");
				n.timestamp = N.google.protobuf.Timestamp.fromObject(e.timestamp, t + 1);
			}
			if (e.label) {
				if (!Array.isArray(e.label)) throw TypeError(".openmetrics.Exemplar.label: array expected");
				n.label = Array(e.label.length);
				for (let r = 0; r < e.label.length; ++r) {
					if (typeof e.label[r] != "object") throw TypeError(".openmetrics.Exemplar.label: object expected");
					n.label[r] = N.openmetrics.Label.fromObject(e.label[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.label = []), t.defaults && (r.value = 0, r.timestamp = null), e.value != null && e.hasOwnProperty("value") && (r.value = t.json && !isFinite(e.value) ? String(e.value) : e.value), e.timestamp != null && e.hasOwnProperty("timestamp") && (r.timestamp = N.google.protobuf.Timestamp.toObject(e.timestamp, t, n + 1)), e.label && e.label.length) {
				r.label = Array(e.label.length);
				for (let i = 0; i < e.label.length; ++i) r.label[i] = N.openmetrics.Label.toObject(e.label[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.Exemplar";
		}, e;
	})(), e.StateSetValue = (function() {
		function e(e) {
			if (this.states = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.states = M.emptyArray, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.states != null && e.states.length) for (let r = 0; r < e.states.length; ++r) N.openmetrics.StateSetValue.State.encode(e.states[r], t.uint32(10).fork(), n + 1).ldelim();
			if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.StateSetValue();
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						o.states && o.states.length || (o.states = []), o.states.push(N.openmetrics.StateSetValue.State.decode(e, e.uint32(), void 0, r + 1));
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.openmetrics.StateSetValue) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.openmetrics.StateSetValue();
			if (e.states) {
				if (!Array.isArray(e.states)) throw TypeError(".openmetrics.StateSetValue.states: array expected");
				n.states = Array(e.states.length);
				for (let r = 0; r < e.states.length; ++r) {
					if (typeof e.states[r] != "object") throw TypeError(".openmetrics.StateSetValue.states: object expected");
					n.states[r] = N.openmetrics.StateSetValue.State.fromObject(e.states[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.states = []), e.states && e.states.length) {
				r.states = Array(e.states.length);
				for (let i = 0; i < e.states.length; ++i) r.states[i] = N.openmetrics.StateSetValue.State.toObject(e.states[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.StateSetValue";
		}, e.State = (function() {
			function e(e) {
				if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
			}
			return e.prototype.enabled = !1, e.prototype.name = "", e.create = function(t) {
				return new e(t);
			}, e.encode = function(e, t, n) {
				if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
				if (e.enabled != null && Object.hasOwnProperty.call(e, "enabled") && t.uint32(8).bool(e.enabled), e.name != null && Object.hasOwnProperty.call(e, "name") && t.uint32(18).string(e.name), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
				return t;
			}, e.decode = function(e, t, n, r, i) {
				if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
				let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.StateSetValue.State(), s;
				for (; e.pos < a;) {
					let t = e.pos, i = e.tag();
					if (i === n) {
						n = void 0;
						break;
					}
					let a = i & 7;
					switch (i >>>= 3) {
						case 1:
							if (a !== 0) break;
							(s = e.bool()) ? o.enabled = s : delete o.enabled;
							continue;
						case 2:
							if (a !== 2) break;
							(s = e.string()).length ? o.name = s : delete o.name;
							continue;
					}
					e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
				}
				if (n !== void 0) throw Error("missing end group");
				return o;
			}, e.fromObject = function(e, t) {
				if (e instanceof N.openmetrics.StateSetValue.State) return e;
				if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
				let n = new N.openmetrics.StateSetValue.State();
				return e.enabled != null && e.enabled && (n.enabled = !!e.enabled), e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = String(e.name)), n;
			}, e.toObject = function(e, t, n) {
				if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
				let r = {};
				return t.defaults && (r.enabled = !1, r.name = ""), e.enabled != null && e.hasOwnProperty("enabled") && (r.enabled = e.enabled), e.name != null && e.hasOwnProperty("name") && (r.name = e.name), r;
			}, e.prototype.toJSON = function() {
				return this.constructor.toObject(this, k.default.util.toJSONOptions);
			}, e.getTypeUrl = function(e) {
				return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.StateSetValue.State";
			}, e;
		})(), e;
	})(), e.InfoValue = (function() {
		function e(e) {
			if (this.info = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		return e.prototype.info = M.emptyArray, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.info != null && e.info.length) for (let r = 0; r < e.info.length; ++r) N.openmetrics.Label.encode(e.info[r], t.uint32(10).fork(), n + 1).ldelim();
			if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.InfoValue();
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						o.info && o.info.length || (o.info = []), o.info.push(N.openmetrics.Label.decode(e, e.uint32(), void 0, r + 1));
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.openmetrics.InfoValue) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.openmetrics.InfoValue();
			if (e.info) {
				if (!Array.isArray(e.info)) throw TypeError(".openmetrics.InfoValue.info: array expected");
				n.info = Array(e.info.length);
				for (let r = 0; r < e.info.length; ++r) {
					if (typeof e.info[r] != "object") throw TypeError(".openmetrics.InfoValue.info: object expected");
					n.info[r] = N.openmetrics.Label.fromObject(e.info[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.info = []), e.info && e.info.length) {
				r.info = Array(e.info.length);
				for (let i = 0; i < e.info.length; ++i) r.info[i] = N.openmetrics.Label.toObject(e.info[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.InfoValue";
		}, e;
	})(), e.SummaryValue = (function() {
		function e(e) {
			if (this.quantile = [], e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		}
		e.prototype.doubleValue = null, e.prototype.intValue = null, e.prototype.count = M.Long ? M.Long.fromBits(0, 0, !0) : 0, e.prototype.created = null, e.prototype.quantile = M.emptyArray;
		let t;
		return Object.defineProperty(e.prototype, "sum", {
			get: M.oneOfGetter(t = ["doubleValue", "intValue"]),
			set: M.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			if (e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && t.uint32(9).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && t.uint32(16).int64(e.intValue), e.count != null && Object.hasOwnProperty.call(e, "count") && t.uint32(24).uint64(e.count), e.created != null && Object.hasOwnProperty.call(e, "created") && N.google.protobuf.Timestamp.encode(e.created, t.uint32(34).fork(), n + 1).ldelim(), e.quantile != null && e.quantile.length) for (let r = 0; r < e.quantile.length; ++r) N.openmetrics.SummaryValue.Quantile.encode(e.quantile[r], t.uint32(42).fork(), n + 1).ldelim();
			if (e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
			let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.SummaryValue(), s;
			for (; e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = void 0;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						o.doubleValue = e.double(), o.sum = "doubleValue";
						continue;
					case 2:
						if (a !== 0) break;
						o.intValue = e.int64(), o.sum = "intValue";
						continue;
					case 3:
						if (a !== 0) break;
						(typeof (s = e.uint64()) == "object" ? s.low || s.high : s !== 0) ? o.count = s : delete o.count;
						continue;
					case 4:
						if (a !== 2) break;
						o.created = N.google.protobuf.Timestamp.decode(e, e.uint32(), void 0, r + 1, o.created);
						continue;
					case 5:
						if (a !== 2) break;
						o.quantile && o.quantile.length || (o.quantile = []), o.quantile.push(N.openmetrics.SummaryValue.Quantile.decode(e, e.uint32(), void 0, r + 1));
						continue;
				}
				e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
			}
			if (n !== void 0) throw Error("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof N.openmetrics.SummaryValue) return e;
			if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
			let n = new N.openmetrics.SummaryValue();
			if (e.doubleValue != null && (n.doubleValue = Number(e.doubleValue)), e.intValue != null && (M.Long ? n.intValue = M.Long.fromValue(e.intValue, !1) : typeof e.intValue == "string" ? n.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? n.intValue = e.intValue : typeof e.intValue == "object" && (n.intValue = new M.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), e.count != null && (typeof e.count == "object" ? e.count.low || e.count.high : Number(e.count) !== 0) && (M.Long ? n.count = M.Long.fromValue(e.count, !0) : typeof e.count == "string" ? n.count = parseInt(e.count, 10) : typeof e.count == "number" ? n.count = e.count : typeof e.count == "object" && (n.count = new M.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.created != null) {
				if (typeof e.created != "object") throw TypeError(".openmetrics.SummaryValue.created: object expected");
				n.created = N.google.protobuf.Timestamp.fromObject(e.created, t + 1);
			}
			if (e.quantile) {
				if (!Array.isArray(e.quantile)) throw TypeError(".openmetrics.SummaryValue.quantile: array expected");
				n.quantile = Array(e.quantile.length);
				for (let r = 0; r < e.quantile.length; ++r) {
					if (typeof e.quantile[r] != "object") throw TypeError(".openmetrics.SummaryValue.quantile: object expected");
					n.quantile[r] = N.openmetrics.SummaryValue.Quantile.fromObject(e.quantile[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.quantile = []), t.defaults) {
				if (M.Long) {
					let e = new M.Long(0, 0, !0);
					r.count = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
				} else r.count = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
				r.created = null;
			}
			if (e.doubleValue != null && e.hasOwnProperty("doubleValue") && (r.doubleValue = t.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, t.oneofs && (r.sum = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof BigInt < "u" && t.longs === BigInt ? r.intValue = typeof e.intValue == "number" ? BigInt(e.intValue) : M.Long.fromBits(e.intValue.low >>> 0, e.intValue.high >>> 0, !1).toBigInt() : typeof e.intValue == "number" ? r.intValue = t.longs === String ? String(e.intValue) : e.intValue : r.intValue = t.longs === String ? M.Long.prototype.toString.call(e.intValue) : t.longs === Number ? new M.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (r.sum = "intValue")), e.count != null && e.hasOwnProperty("count") && (typeof BigInt < "u" && t.longs === BigInt ? r.count = typeof e.count == "number" ? BigInt(e.count) : M.Long.fromBits(e.count.low >>> 0, e.count.high >>> 0, !0).toBigInt() : typeof e.count == "number" ? r.count = t.longs === String ? String(e.count) : e.count : r.count = t.longs === String ? M.Long.prototype.toString.call(e.count) : t.longs === Number ? new M.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.created != null && e.hasOwnProperty("created") && (r.created = N.google.protobuf.Timestamp.toObject(e.created, t, n + 1)), e.quantile && e.quantile.length) {
				r.quantile = Array(e.quantile.length);
				for (let i = 0; i < e.quantile.length; ++i) r.quantile[i] = N.openmetrics.SummaryValue.Quantile.toObject(e.quantile[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return this.constructor.toObject(this, k.default.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.SummaryValue";
		}, e.Quantile = (function() {
			function e(e) {
				if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
			}
			return e.prototype.quantile = 0, e.prototype.value = 0, e.create = function(t) {
				return new e(t);
			}, e.encode = function(e, t, n) {
				if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
				if (e.quantile != null && Object.hasOwnProperty.call(e, "quantile") && t.uint32(9).double(e.quantile), e.value != null && Object.hasOwnProperty.call(e, "value") && t.uint32(17).double(e.value), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
				return t;
			}, e.decode = function(e, t, n, r, i) {
				if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
				let a = t === void 0 ? e.len : e.pos + t, o = i || new N.openmetrics.SummaryValue.Quantile(), s;
				for (; e.pos < a;) {
					let t = e.pos, i = e.tag();
					if (i === n) {
						n = void 0;
						break;
					}
					let a = i & 7;
					switch (i >>>= 3) {
						case 1:
							if (a !== 1) break;
							(s = e.double()) === 0 ? delete o.quantile : o.quantile = s;
							continue;
						case 2:
							if (a !== 1) break;
							(s = e.double()) === 0 ? delete o.value : o.value = s;
							continue;
					}
					e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
				}
				if (n !== void 0) throw Error("missing end group");
				return o;
			}, e.fromObject = function(e, t) {
				if (e instanceof N.openmetrics.SummaryValue.Quantile) return e;
				if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
				let n = new N.openmetrics.SummaryValue.Quantile();
				return e.quantile != null && Number(e.quantile) !== 0 && (n.quantile = Number(e.quantile)), e.value != null && Number(e.value) !== 0 && (n.value = Number(e.value)), n;
			}, e.toObject = function(e, t, n) {
				if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
				let r = {};
				return t.defaults && (r.quantile = 0, r.value = 0), e.quantile != null && e.hasOwnProperty("quantile") && (r.quantile = t.json && !isFinite(e.quantile) ? String(e.quantile) : e.quantile), e.value != null && e.hasOwnProperty("value") && (r.value = t.json && !isFinite(e.value) ? String(e.value) : e.value), r;
			}, e.prototype.toJSON = function() {
				return this.constructor.toObject(this, k.default.util.toJSONOptions);
			}, e.getTypeUrl = function(e) {
				return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.SummaryValue.Quantile";
			}, e;
		})(), e;
	})(), e;
})(), N.google = (() => {
	let e = {};
	return e.protobuf = (function() {
		let e = {};
		return e.Timestamp = (function() {
			function e(e) {
				if (e) for (let t = Object.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
			}
			return e.prototype.seconds = M.Long ? M.Long.fromBits(0, 0, !1) : 0, e.prototype.nanos = 0, e.create = function(t) {
				return new e(t);
			}, e.encode = function(e, t, n) {
				if (t ||= j.create(), n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
				if (e.seconds != null && Object.hasOwnProperty.call(e, "seconds") && t.uint32(8).int64(e.seconds), e.nanos != null && Object.hasOwnProperty.call(e, "nanos") && t.uint32(16).int32(e.nanos), e.$unknowns != null && Object.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
				return t;
			}, e.decode = function(e, t, n, r, i) {
				if (e instanceof A || (e = A.create(e)), r === void 0 && (r = 0), r > A.recursionLimit) throw Error("max depth exceeded");
				let a = t === void 0 ? e.len : e.pos + t, o = i || new N.google.protobuf.Timestamp(), s;
				for (; e.pos < a;) {
					let t = e.pos, i = e.tag();
					if (i === n) {
						n = void 0;
						break;
					}
					let a = i & 7;
					switch (i >>>= 3) {
						case 1:
							if (a !== 0) break;
							(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.seconds = s : delete o.seconds;
							continue;
						case 2:
							if (a !== 0) break;
							(s = e.int32()) ? o.nanos = s : delete o.nanos;
							continue;
					}
					e.skipType(a, r, i), M.makeProp(o, "$unknowns", !1), (o.$unknowns ||= []).push(e.raw(t, e.pos));
				}
				if (n !== void 0) throw Error("missing end group");
				return o;
			}, e.fromObject = function(e, t) {
				if (e instanceof N.google.protobuf.Timestamp) return e;
				if (t === void 0 && (t = 0), t > M.recursionLimit) throw Error("max depth exceeded");
				let n = new N.google.protobuf.Timestamp();
				return e.seconds != null && (typeof e.seconds == "object" ? e.seconds.low || e.seconds.high : Number(e.seconds) !== 0) && (M.Long ? n.seconds = M.Long.fromValue(e.seconds, !1) : typeof e.seconds == "string" ? n.seconds = parseInt(e.seconds, 10) : typeof e.seconds == "number" ? n.seconds = e.seconds : typeof e.seconds == "object" && (n.seconds = new M.LongBits(e.seconds.low >>> 0, e.seconds.high >>> 0).toNumber())), e.nanos != null && Number(e.nanos) !== 0 && (n.nanos = e.nanos | 0), n;
			}, e.toObject = function(e, t, n) {
				if (t ||= {}, n === void 0 && (n = 0), n > M.recursionLimit) throw Error("max depth exceeded");
				let r = {};
				if (t.defaults) {
					if (M.Long) {
						let e = new M.Long(0, 0, !1);
						r.seconds = t.longs === String ? e.toString() : t.longs === Number ? e.toNumber() : typeof BigInt < "u" && t.longs === BigInt ? e.toBigInt() : e;
					} else r.seconds = t.longs === String ? "0" : typeof BigInt < "u" && t.longs === BigInt ? BigInt("0") : 0;
					r.nanos = 0;
				}
				return e.seconds != null && e.hasOwnProperty("seconds") && (typeof BigInt < "u" && t.longs === BigInt ? r.seconds = typeof e.seconds == "number" ? BigInt(e.seconds) : M.Long.fromBits(e.seconds.low >>> 0, e.seconds.high >>> 0, !1).toBigInt() : typeof e.seconds == "number" ? r.seconds = t.longs === String ? String(e.seconds) : e.seconds : r.seconds = t.longs === String ? M.Long.prototype.toString.call(e.seconds) : t.longs === Number ? new M.LongBits(e.seconds.low >>> 0, e.seconds.high >>> 0).toNumber() : e.seconds), e.nanos != null && e.hasOwnProperty("nanos") && (r.nanos = e.nanos), r;
			}, e.prototype.toJSON = function() {
				return this.constructor.toObject(this, k.default.util.toJSONOptions);
			}, e.getTypeUrl = function(e) {
				return e === void 0 && (e = "type.googleapis.com"), e + "/google.protobuf.Timestamp";
			}, e;
		})(), e;
	})(), e;
})(), N.RootContainer = (() => {
	let e = {}, t = Object.create(e);
	return t[e[0] = "MAIN"] = 0, t[e[1] = "SIDEBAR"] = 1, t[e[2] = "EVENT"] = 2, t[e[3] = "BOTTOM"] = 3, t;
})(), Promise.withResolvers === void 0 && (Promise.withResolvers = () => {
	let e, t, n = new Promise((n, r) => {
		e = n, t = r;
	});
	return {
		resolve: e,
		reject: t,
		promise: n
	};
});
function fe(e) {
	let t = document.cookie.match(`\\b${e}=([^;]*)\\b`);
	return t ? t[1] : void 0;
}
function pe() {
	let e = "testData";
	try {
		let { localStorage: t } = window;
		t.setItem(e, e), t.getItem(e), t.removeItem(e);
	} catch {
		return !1;
	}
	return !0;
}
function me(e) {
	return Array.isArray(e) && e.length > 0 && e.every((e) => typeof e == "string" && e.trim().length > 0);
}
function he(e) {
	return typeof structuredClone == "function" ? structuredClone(e) : JSON.parse(JSON.stringify(e));
}
function F(e) {
	return Object.freeze(e), Array.isArray(e) ? e.forEach((e) => {
		typeof e == "object" && e && !Object.isFrozen(e) && F(e);
	}) : Object.values(e).forEach((e) => {
		typeof e == "object" && e && !Object.isFrozen(e) && F(e);
	}), e;
}
var I = (() => {
	let e = window.__streamlit;
	if (e) return F(he(e));
})(), L = {
	get BACKEND_BASE_URL() {
		return I?.BACKEND_BASE_URL;
	},
	get HOST_CONFIG_BASE_URL() {
		return I?.HOST_CONFIG_BASE_URL;
	},
	get DOWNLOAD_ASSETS_BASE_URL() {
		return I?.DOWNLOAD_ASSETS_BASE_URL;
	},
	get MAIN_PAGE_BASE_URL() {
		return I?.MAIN_PAGE_BASE_URL;
	},
	get CUSTOM_COMPONENT_CLIENT_ID() {
		return I?.CUSTOM_COMPONENT_CLIENT_ID;
	},
	get LIGHT_THEME() {
		return I?.LIGHT_THEME;
	},
	get DARK_THEME() {
		return I?.DARK_THEME;
	},
	get ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION() {
		return I?.ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION;
	},
	get HOST_CONFIG() {
		return I?.HOST_CONFIG;
	}
};
function R(e) {
	return e != null;
}
function z(e) {
	return e == null;
}
var ge = /\/+$/, _e = /^\/+/;
function B({ hostname: e, port: t, pathname: n, protocol: r }, i) {
	let a = V(n, i);
	return `${r}//${e}${t ? `:${t}` : ""}/${a}`;
}
function V(e, t) {
	return e = e.replace(ge, "").replace(_e, ""), t = t.replace(ge, "").replace(_e, ""), e.length === 0 ? t : `${e}/${t}`;
}
//#endregion
//#region src/StaticConnection.tsx
var ve = "https://data.streamlit.io/static.json", H = (0, d.getLogger)("StaticConnection");
async function ye() {
	let e = pe(), t = "";
	if (e) {
		let e = window.localStorage.getItem("stStaticAssetUrl");
		if (e) return e;
	}
	try {
		let n = await fetch(ve, { signal: AbortSignal.timeout(5e3) });
		n.ok ? (t = (await n.json()).static_url ?? void 0, e && t && window.localStorage.setItem("stStaticAssetUrl", t)) : H.error("Failed to fetch static config url: ", n.status);
	} catch (e) {
		H.error("Failed to fetch static config url:", e);
	}
	return t;
}
async function be(e, t) {
	let n = `${t}/${e}/protos.pb`, r = await fetch(n, { signal: AbortSignal.timeout(5e3) });
	if (!r.ok) H.error(`Failed to fetch static app protos for id: ${e}`, r.status);
	else return r.arrayBuffer();
	return null;
}
async function xe(e, t, n, r) {
	let i = await be(e, t);
	if (!i) {
		H.error("Failed to retrieve static app protos"), r({ message: `Failed to retrieve static app protos. Please confirm the id is correct and try again. Given static app id: ${e}` });
		return;
	}
	de.decode(new Uint8Array(i)).messages.forEach((e) => {
		n(e);
	});
}
async function Se(e, t, n, r, i) {
	t(f.STATIC_CONNECTING);
	let a = await ye();
	i.setStaticConfigUrl(a), xe(e, a, n, r), t(f.STATIC_CONNECTED);
}
//#endregion
//#region src/utils.ts
var Ce = /\/+$/, we = /^\/+/;
function Te() {
	let e = L.HOST_CONFIG;
	if (!e) return !1;
	let { allowedOrigins: t, useExternalAuthToken: n } = e, r = !!L.BACKEND_BASE_URL, i = me(t);
	return r && i && typeof n == "boolean";
}
function U(e) {
	let t = new URL(window.location.href === "about:blank" ? "" : window.location.href);
	return t.pathname = t.pathname.replace(Ce, "").replace(we, ""), t;
}
function Ee() {
	let e = U(L.BACKEND_BASE_URL), { pathname: t } = e;
	if (t === "/") return [e];
	let n = t.split("/"), r = [];
	for (; n.length > 0;) {
		let t = new URL(e);
		t.pathname = n.join("/"), r.push(t), n.pop();
	}
	return r.length <= 2 ? r : r.slice(0, 2);
}
function De({ hostname: e, port: t, pathname: n, protocol: r }, i) {
	return `${r === "https:" ? "wss" : "ws"}://${e}:${t}/${V(n, i)}`;
}
function Oe(e) {
	if (e != null) switch (typeof e) {
		case "object": return JSON.stringify(e, null, 2);
		case "string":
		case "number":
		case "boolean": return String(e);
		default: return;
	}
}
var W = class extends Error {
	constructor(e, t, n = {}) {
		super(e), this.name = "FetchError", this.url = t, this.isTimeout = n.isTimeout ?? !1, this.isNetworkError = n.isNetworkError ?? !1, this.response = n.response;
	}
};
async function ke(e, t) {
	let n = new AbortController(), r = setTimeout(() => n.abort(), t);
	try {
		let t = await fetch(e, { signal: n.signal });
		if (clearTimeout(r), !t.ok) {
			let n;
			try {
				n = await t.json();
			} catch {
				try {
					n = await t.text();
				} catch {
					n = null;
				}
			}
			throw new W(`Request failed with status ${t.status}`, e, { response: {
				status: t.status,
				statusText: t.statusText,
				data: n
			} });
		}
		let i = await t.text();
		try {
			return {
				data: JSON.parse(i),
				url: e
			};
		} catch {
			return {
				data: i,
				url: e
			};
		}
	} catch (t) {
		throw clearTimeout(r), t instanceof W ? t : t instanceof DOMException && t.name === "AbortError" ? new W("Connection timed out", e, { isTimeout: !0 }) : t instanceof TypeError ? new W(t.message || "Network error", e, { isNetworkError: !0 }) : new W(t instanceof Error ? t.message : "Unknown error", e);
	}
}
//#endregion
//#region src/DoInitPings.tsx
var G = (0, d.getLogger)("DoInitPings"), K = class extends Error {
	constructor() {
		super("Ping cancelled");
	}
};
function q(e, t, n, r, i, a) {
	let { promise: o, resolve: s, reject: c } = Promise.withResolvers(), l = 0, u = 0, d, f = () => {}, m = () => {
		u++, u >= e.length && (u = 0), f();
	}, _ = (e) => {
		let i = Math.random() * .4 - .2, a = l === 1 ? t : t * 2 ** (l - 1) * (1 + i), o = Math.min(n, a);
		r(l, e, o), !(typeof window > "u") && (d = globalThis.setTimeout(m, o));
	}, v = () => {
		let t = e[u];
		new URL(B(t, "")).hostname === "localhost" ? _({
			message: "Is Streamlit still running? If you accidentally stopped Streamlit, just restart it in your terminal:",
			codeBlock: "streamlit run yourscript.py"
		}) : _({ message: "Streamlit server is not responding. Are you connected to the internet?" });
	}, b = () => {
		_({ message: `Cannot connect to Streamlit (HTTP status: 403).

If you are trying to access a Streamlit app running on another server, this could be due to the app's [CORS](${p}) settings.` });
	}, x = (e) => {
		let t = "DoInitPings";
		if (e) try {
			t = new URL(e).pathname;
		} catch {
			G.error(`unrecognized url: ${e}`);
		}
		return t;
	};
	return f = () => {
		let t = e[u], n = B(t, h), r = L.HOST_CONFIG_BASE_URL, o = B(r ? U(r) : t, g);
		G.info(`Attempting to connect to ${n}.`), u === 0 && l++, Promise.all([ke(n, y), ke(o, y)]).then(([e, t]) => {
			a(t.data), s(u);
		}).catch((e) => {
			let t = l >= 6;
			if (e.isTimeout) {
				if (t) {
					let t = x(e.url);
					G.error("Client error: DoInitPings timed out"), i("DoInitPings timed out", "Connection timed out - ECONNABORTED", t);
				}
				return _({ message: "Connection timed out." });
			}
			if (e.response) {
				let { data: n, status: r, statusText: a } = e.response, o = x(e.url);
				if (r === 0) return t && (G.error(`Client Error: response received with status ${r} when attempting to reach ${o}`), i(`Response received with status ${r}`, a, o)), v();
				if (r === 403) return t && (G.error(`Client Error: response received with status ${r} when attempting to reach ${o}`), i(r, a, o)), b();
				t && (G.error(`Client Error: response received with status ${r} when attempting to reach ${o}`), i(r, a, o));
				let s = Oe(n);
				return _({
					message: `Connection failed with status ${r}${s ? ", and response:" : "."}`,
					...s && { codeBlock: s }
				});
			}
			if (e.isNetworkError) {
				if (t) {
					let t = x(e.url);
					G.error(`Client Error in reaching server endpoint - No response received when attempting to reach ${t}`), i("No response received from server", "Network error", t);
				}
				return v();
			}
			if (t) {
				let t = x(e.url);
				G.error(`Client Error in reaching server endpoint - error in setting up request when attempting to reach ${t}`), i("Error setting up request to server", e.message ?? "", t);
			}
			return _({ message: e.message });
		});
	}, f(), {
		promise: o,
		cancel: () => {
			R(d) && globalThis.clearTimeout(d), c(new K());
		}
	};
}
//#endregion
//#region src/ForwardMessageCache.ts
var J = (0, d.getLogger)("ForwardMessageCache"), Ae = class {
	getAge(e) {
		return e - this.scriptRunCount;
	}
	constructor(e, t, n) {
		this.scriptRunCount = 0, this.encodedMsg = e, this.scriptRunCount = t, this.fragmentId = n;
	}
}, je = class {
	constructor() {
		this.messages = /* @__PURE__ */ new Map(), this.scriptRunCount = 0;
	}
	incrementRunCount(e, t) {
		this.scriptRunCount += 1, this.messages.forEach((n, r) => {
			t.length > 0 && (!n.fragmentId || !t.includes(n.fragmentId)) || n.getAge(this.scriptRunCount) > e && (J.info(`Removing expired ForwardMsg [hash=${r}]`), this.messages.delete(r));
		});
	}
	getCachedMessageHashes() {
		return Array.from(this.messages.keys());
	}
	async processMessagePayload(e, t) {
		if (this.maybeCacheMessage(e, t), e.type !== "refHash") return e;
		let n = this.getCachedMessage(e.refHash, !0);
		if (R(n)) J.info(`Cached ForwardMsg HIT [hash=${e.refHash}]`);
		else throw Error(`Cached ForwardMsg MISS [hash=${e.refHash}]. This is not expected to happen. Please [report this bug](https://github.com/streamlit/streamlit/issues).`);
		if (!e.metadata) throw Error("Reference ForwardMsg has no metadata. This is not expected to happen. Please [report this bug](https://github.com/streamlit/streamlit/issues).");
		return n.metadata = P.decode(t).metadata, n;
	}
	maybeCacheMessage(e, t) {
		if (e.type !== "refHash" && e.metadata?.cacheable) {
			if (!e.hash) {
				J.error("ForwardMsg has no hash. This is not expected to happen, please report this bug.", e);
				return;
			}
			this.getCachedMessage(e.hash, !0) === void 0 && (J.info(`Caching ForwardMsg [hash=${e.hash}]`), this.messages.set(e.hash, new Ae(t, this.scriptRunCount, e.delta?.fragmentId ?? void 0)));
		}
	}
	getCachedMessage(e, t) {
		let n = this.messages.get(e);
		if (!z(n)) return t && (n.scriptRunCount = this.scriptRunCount), P.decode(n.encodedMsg);
	}
}, Y = (0, d.getLogger)("WebsocketConnection"), X = class {
	constructor(e) {
		this.uriIndex = 0, this.lastDispatchedMessageIndex = -1, this.nextMessageIndex = 0, this.messageQueue = {}, this.state = f.INITIAL, this.args = e, this.cache = new je(), this.stepFsm("INITIALIZED");
	}
	getBaseUriParts() {
		if (this.state === f.CONNECTED) return this.args.baseUriPartsList[this.uriIndex];
	}
	disconnect() {
		this.setFsmState(f.DISCONNECTED_FOREVER);
	}
	reconnect() {
		this.state === f.CONNECTED && (this.closeConnection(), this.stepFsm("CONNECTION_CLOSED"));
	}
	setFsmState(e, t) {
		switch (Y.info(`New state: ${e}`), this.state = e, this.state) {
			case f.PINGING_SERVER:
				this.pingServer();
				break;
			default: break;
		}
		switch (this.args.onConnectionStateChange(e, t), this.state) {
			case f.CONNECTING:
				this.connectToWebSocket();
				break;
			case f.DISCONNECTED_FOREVER:
				this.closeConnection();
				break;
			default: break;
		}
	}
	stepFsm(e, t) {
		if (Y.info(`State: ${this.state}; Event: ${e}`), e === "FATAL_ERROR" && this.state !== f.DISCONNECTED_FOREVER) {
			Y.error(`Client Error: Websocket connection encountered fatal error - ${t}`), this.args.sendClientError("Websocket connection fatal error encountered", t, "Websocket Connection"), this.setFsmState(f.DISCONNECTED_FOREVER, { message: t || "Unknown error" });
			return;
		}
		switch (this.state) {
			case f.INITIAL:
				if (e === "INITIALIZED") {
					this.args.enableBypass ? (this.setFsmState(f.CONNECTING), this.pingServerInBackground()) : this.setFsmState(f.PINGING_SERVER);
					return;
				}
				break;
			case f.CONNECTING:
				if (e === "CONNECTION_SUCCEEDED") {
					this.setFsmState(f.CONNECTED);
					return;
				}
				if (e === "CONNECTION_TIMED_OUT" || e === "CONNECTION_ERROR" || e === "CONNECTION_CLOSED") {
					this.setFsmState(f.PINGING_SERVER);
					return;
				}
				break;
			case f.CONNECTED:
				if (e === "CONNECTION_CLOSED" || e === "CONNECTION_ERROR") {
					this.setFsmState(f.PINGING_SERVER);
					return;
				}
				break;
			case f.PINGING_SERVER:
				if (e === "SERVER_PING_SUCCEEDED") {
					this.setFsmState(f.CONNECTING);
					return;
				}
				break;
			case f.DISCONNECTED_FOREVER:
				Y.warn(`Discarding ${e} while in ${f.DISCONNECTED_FOREVER}`);
				return;
			default: break;
		}
		throw Error(`Unsupported state transition.
State: ${this.state}\nEvent: ${e}`);
	}
	async pingServer() {
		let e = q(this.args.baseUriPartsList, 100, _, this.args.onRetry, this.args.sendClientError, this.args.onHostConfigResp);
		this.pingRequest = e;
		try {
			this.uriIndex = await e.promise, this.pingRequest === e && (this.pingRequest = void 0), this.stepFsm("SERVER_PING_SUCCEEDED");
		} catch (e) {
			e instanceof K ? Y.info("Ping cancelled") : this.stepFsm("FATAL_ERROR", e instanceof Error ? e.message : String(e));
		} finally {
			this.pingRequest === e && (this.pingRequest = void 0);
		}
	}
	async pingServerInBackground() {
		let e = q(this.args.baseUriPartsList, 100, _, this.args.onRetry, this.args.sendClientError, this.args.onHostConfigResp);
		this.pingRequest = e;
		try {
			let t = await e.promise;
			this.uriIndex = t, Y.info("Background pings completed successfully");
		} catch (e) {
			e instanceof K ? Y.info("Background pings cancelled") : this.stepFsm("FATAL_ERROR", e instanceof Error ? e.message : String(e));
		} finally {
			this.pingRequest === e && (this.pingRequest = void 0);
		}
	}
	async getSessionTokens() {
		let e = await this.args.claimHostAuthToken(), t = fe("_streamlit_xsrf");
		this.args.resetHostAuthToken();
		let n = this.args.getLastSessionId();
		return [e ?? t ?? "PLACEHOLDER_AUTH_TOKEN", ...n ? [n] : []];
	}
	async connectToWebSocket() {
		let e = De(this.args.baseUriPartsList[this.uriIndex], m);
		if (R(this.websocket)) throw Error("Websocket already exists");
		Y.info("creating WebSocket");
		let t = await this.getSessionTokens();
		this.websocket = new WebSocket(e, ["streamlit", ...t]), this.websocket.binaryType = "arraybuffer", this.setConnectionTimeout(e);
		let n = this.websocket, r = () => n === this.websocket;
		this.websocket.addEventListener("message", (e) => {
			r() && this.handleMessage(e.data).catch((e) => {
				let t = `Failed to process a Websocket message. ${e}`;
				Y.error(t), this.stepFsm("FATAL_ERROR", t);
			});
		}), this.websocket.addEventListener("open", () => {
			r() && (Y.info("WebSocket onopen"), this.stepFsm("CONNECTION_SUCCEEDED"));
		}), this.websocket.addEventListener("close", () => {
			r() && (Y.warn("WebSocket onclose"), this.closeConnection(), this.stepFsm("CONNECTION_CLOSED"));
		}), this.websocket.addEventListener("error", (e) => {
			r() && (Y.error("Client Error: WebSocket onerror"), this.args.sendClientError("Websocket connection onerror triggered", `Error: ${e}`, "Websocket Connection"), this.closeConnection(), this.stepFsm("CONNECTION_ERROR"));
		});
	}
	setConnectionTimeout(e) {
		if (R(this.wsConnectionTimeout)) throw Error("WS timeout is already set");
		let t = this.websocket;
		this.wsConnectionTimeout = globalThis.setTimeout(() => {
			if (t === this.websocket) {
				if (z(this.wsConnectionTimeout)) {
					Y.warn("Timeout fired after cancellation");
					return;
				}
				if (z(this.websocket)) {
					this.closeConnection(), this.stepFsm("FATAL_ERROR", "Null Websocket in setConnectionTimeout");
					return;
				}
				this.websocket.readyState === 0 && (Y.info(`Client error: ${e} timed out`), this.args.sendClientError("Websocket connection timed out", `${e} timed out`, "Websocket Connection"), this.closeConnection(), this.stepFsm("CONNECTION_TIMED_OUT"));
			}
		}, v), Y.info(`Set WS timeout ${Number(this.wsConnectionTimeout)}`);
	}
	closeConnection() {
		this.websocket &&= (this.websocket.close(), void 0), R(this.wsConnectionTimeout) && (Y.info(`Clearing WS timeout ${Number(this.wsConnectionTimeout)}`), globalThis.clearTimeout(this.wsConnectionTimeout), this.wsConnectionTimeout = void 0), this.pingRequest &&= (this.pingRequest.cancel(), void 0);
	}
	sendMessage(e) {
		if (!this.websocket) return;
		let t = ue.create(e), n = ue.encode(t).finish(), r = new Uint8Array(n.buffer, n.byteOffset, n.byteLength);
		this.websocket.send(r);
	}
	incrementMessageCacheRunCount(e, t) {
		this.cache.incrementRunCount(e, t);
	}
	getCachedMessageHashes() {
		return this.cache.getCachedMessageHashes();
	}
	async handleMessage(e) {
		let t = this.nextMessageIndex;
		this.nextMessageIndex += 1;
		let n = new Uint8Array(e), r = P.decode(n);
		for (this.messageQueue[t] = await this.cache.processMessagePayload(r, n); this.lastDispatchedMessageIndex + 1 in this.messageQueue;) {
			let e = this.lastDispatchedMessageIndex + 1;
			this.args.onMessage(this.messageQueue[e]), delete this.messageQueue[e], this.lastDispatchedMessageIndex = e;
		}
	}
}, Z = (0, d.getLogger)("ConnectionManager"), Me = class {
	constructor(e) {
		this.connectionState = f.INITIAL, this.setConnectionState = (e, t) => {
			this.connectionState !== e && (this.connectionState === f.CONNECTED && e !== f.CONNECTED && this.clearHeartbeatAckTimeout(), this.connectionState = e, this.props.connectionStateChanged(e)), t && this.props.onConnectionError(t);
		}, this.showRetryError = (e, t, n) => {
			e >= 6 && this.props.onConnectionError(t);
		}, this.props = e, this.connect();
	}
	isConnected() {
		return this.connectionState === f.CONNECTED;
	}
	getBaseUriParts() {
		if (this.websocketConnection instanceof X) return this.websocketConnection.getBaseUriParts();
	}
	sendMessage(e) {
		this.websocketConnection instanceof X && this.isConnected() ? this.websocketConnection.sendMessage(e) : Z.error(`Cannot send message when server is disconnected: ${e}`);
	}
	incrementMessageCacheRunCount(e, t) {
		this.websocketConnection instanceof X && this.websocketConnection.incrementMessageCacheRunCount(e, t);
	}
	getCachedMessageHashes() {
		return this.websocketConnection instanceof X ? this.websocketConnection?.getCachedMessageHashes() ?? [] : [];
	}
	checkStaticConnection() {
		return new URLSearchParams(document.location.search).get("staticAppId");
	}
	async connect() {
		let e = this.checkStaticConnection();
		if (e) Se(e, this.setConnectionState, this.props.onMessage, this.props.onConnectionError, this.props.endpoints), this.websocketConnection = null;
		else try {
			this.websocketConnection = await this.connectToRunningServer();
		} catch (e) {
			let t = e instanceof Error ? e : /* @__PURE__ */ Error(`${e}`);
			Z.error(`Client Error: Websocket connection - ${t.message}`), this.props.sendClientError("Failed to establish websocket connection", t.message, "Connection Manager"), this.setConnectionState(f.DISCONNECTED_FOREVER, { message: t.message });
		}
	}
	disconnect() {
		this.clearHeartbeatAckTimeout(), this.websocketConnection?.disconnect();
	}
	onHeartbeatSent(e) {
		this.clearHeartbeatAckTimeout(), e && (this.heartbeatAckTimeoutId = setTimeout(() => {
			Z.warn("Heartbeat ack not received within timeout, connection may be unhealthy"), this.heartbeatAckTimeoutId = void 0, this.isConnected() && this.reconnect();
		}, e));
	}
	reconnect() {
		this.clearHeartbeatAckTimeout(), this.websocketConnection?.reconnect();
	}
	onHeartbeatAckReceived() {
		this.clearHeartbeatAckTimeout();
	}
	clearHeartbeatAckTimeout() {
		this.heartbeatAckTimeoutId !== void 0 && (clearTimeout(this.heartbeatAckTimeoutId), this.heartbeatAckTimeoutId = void 0);
	}
	connectToRunningServer() {
		let e = Ee(), t = Te();
		return new X({
			getLastSessionId: this.props.getLastSessionId,
			endpoints: this.props.endpoints,
			baseUriPartsList: e,
			onMessage: this.props.onMessage,
			onConnectionStateChange: this.setConnectionState,
			onRetry: this.showRetryError,
			claimHostAuthToken: this.props.claimHostAuthToken,
			resetHostAuthToken: this.props.resetHostAuthToken,
			sendClientError: this.props.sendClientError,
			onHostConfigResp: this.props.onHostConfigResp,
			enableBypass: t
		});
	}
}, Q = (0, d.getLogger)("DefaultStreamlitEndpoints"), $ = "/media", Ne = "/app/static/", Pe = "/_stcore/upload_file", Fe = "/component", Ie = "/_stcore/bidi-components", Le = class {
	constructor(e) {
		this.getServerUri = e.getServerUri, this.csrfEnabled = e.csrfEnabled, this.sendClientError = e.sendClientError, this.staticConfigUrl = null;
	}
	setStaticConfigUrl(e) {
		this.staticConfigUrl = e;
	}
	sendClientErrorToHost(e, t, n, r, i) {
		this.sendClientError(e, t, n, r, i);
	}
	async checkSourceUrlResponse(e, t, n) {
		let r = n ? `${t} ${n}` : t;
		try {
			let i = await fetch(e);
			i.ok || (Q.error(`Client Error: ${r} source error - ${i.status}`), this.sendClientErrorToHost(t, i.status, i.statusText, e, n));
		} catch (i) {
			let a = i instanceof Error ? i.message : "Unknown Error";
			Q.error(`Client Error: ${r} fetch error - ${a}`), this.sendClientErrorToHost(t, "Error fetching source", a, e, n);
		}
	}
	buildComponentURL(e, t) {
		return B(this.requireServerUri(), `${Fe}/${e}/${t}`);
	}
	buildBidiComponentURL(e, t) {
		return B(this.requireServerUri(), `${Ie}/${e}/${t}`);
	}
	setFileUploadClientConfig({ prefix: e, headers: t }) {
		this.fileUploadClientConfig = {
			prefix: e,
			headers: t
		};
	}
	buildStaticUrl(e) {
		let t = new URLSearchParams(document.location.search).get("staticAppId");
		return `${this.staticConfigUrl}/${t}${e}`;
	}
	buildMediaURL(e) {
		return this.staticConfigUrl && (e.startsWith($) || e.startsWith(Ne)) ? this.buildStaticUrl(e) : e.startsWith($) || e.startsWith(Ne) ? B(this.requireServerUri(), e) : e;
	}
	buildDownloadUrl(e) {
		if (!e.startsWith($)) return e;
		let t = L.DOWNLOAD_ASSETS_BASE_URL;
		return B(t ? U(t) : this.requireServerUri(), e);
	}
	buildFileUploadURL(e) {
		return this.fileUploadClientConfig ? V(this.fileUploadClientConfig.prefix, e) : e.startsWith(Pe) ? B(this.requireServerUri(), e) : e;
	}
	buildAppPageURL(e, t) {
		let n = t.urlPathname, r = t.isDefault ? "" : n;
		if (typeof e == "string" && e.length > 0) return `${e}/${r}`;
		let { port: i, protocol: a } = window.location, { pathname: o, hostname: s } = this.requireServerUri();
		return `${a}//${s}${i ? `:${i}` : ""}${o === "/" ? "/" : `${o}/`}${r}`;
	}
	async uploadFileUploaderFile(e, t, n, r, i) {
		let a = new FormData(), { name: o, webkitRelativePath: s } = t, c = s || o;
		a.append(o, t, c);
		let l = this.getAdditionalHeaders(), u = this.buildFileUploadURL(e);
		try {
			await this.csrfRequest(u, {
				signal: i,
				method: "PUT",
				data: a,
				responseType: "text",
				headers: l,
				onUploadProgress: r
			});
		} catch (e) {
			Q.error(`Client Error: File uploader error on file upload - ${e}`);
			let t = e instanceof Error ? e.message : "Unknown Error";
			throw this.sendClientErrorToHost("File Uploader", "Error uploading file", t, u), e;
		}
	}
	getAdditionalHeaders() {
		let e = {};
		return this.fileUploadClientConfig && (e = {
			...e,
			...this.fileUploadClientConfig.headers
		}), e;
	}
	async deleteFileAtURL(e, t) {
		let n = this.getAdditionalHeaders(), r = this.buildFileUploadURL(e);
		try {
			await this.csrfRequest(r, {
				method: "DELETE",
				data: { sessionId: t },
				headers: n
			});
		} catch (e) {
			Q.error(`Client Error: File uploader error on file delete - ${e}`);
			let t = e instanceof Error ? e.message : "Unknown Error";
			throw this.sendClientErrorToHost("File Uploader", "Error deleting file", t, r), e;
		}
	}
	requireServerUri() {
		let e = this.getServerUri();
		if (R(e)) return this.cachedServerUri = e, e;
		if (R(this.cachedServerUri)) return this.cachedServerUri;
		throw Error("not connected to a server!");
	}
	async csrfRequest(e, t) {
		if (t.url = e, this.csrfEnabled) {
			let e = fe("_streamlit_xsrf");
			R(e) && (t.headers = {
				"X-Xsrftoken": e,
				...t.headers
			}, t.withCredentials = !0);
		}
		let { default: n } = await import("./axios-C4XF0fXF.js");
		return n.request(t);
	}
};
//#endregion
//#region src/testUtils.ts
function Re(e = {}) {
	return {
		setStaticConfigUrl: vi.fn(),
		sendClientErrorToHost: vi.fn(),
		checkSourceUrlResponse: vi.fn(),
		buildComponentURL: vi.fn(),
		buildBidiComponentURL: vi.fn(),
		buildMediaURL: vi.fn(),
		buildDownloadUrl: vi.fn(),
		buildFileUploadURL: vi.fn(),
		buildAppPageURL: vi.fn().mockImplementation((e, t, n) => `http://mock/app/page/${t.pageName}.${n}`),
		uploadFileUploaderFile: vi.fn().mockRejectedValue(/* @__PURE__ */ Error("unimplemented mock endpoint")),
		deleteFileAtURL: vi.fn().mockRejectedValue(/* @__PURE__ */ Error("unimplemented mock endpoint")),
		...e
	};
}
//#endregion
export { Me as ConnectionManager, f as ConnectionState, Le as DefaultStreamlitEndpoints, b as IS_DEV_ENV, Te as isHostConfigBypassEnabled, Re as mockEndpoints, U as parseUriIntoBaseParts, s as t };
